webpackJsonp([1],{

/***/ "+55Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_workerorderindex_vue__ = __webpack_require__("aFUI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d261437_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_workerorderindex_vue__ = __webpack_require__("GpRe");
function injectStyle (ssrContext) {
  __webpack_require__("x4wq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d261437"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_workerorderindex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d261437_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_workerorderindex_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+bWh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__im_IMTop_vue__ = __webpack_require__("dU9P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ImDirectory',
  components: {
    imTop: __WEBPACK_IMPORTED_MODULE_1__im_IMTop_vue__["a" /* default */]
  },
  data: function data() {
    return {
      //allquestion:["账号类","充值类","被盗类","咨询类"],
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    entranceList: 'getEntranceList'
  })),
  mounted: function mounted() {
    var gois = true;
    var userAgent = navigator.userAgent;
    if (userAgent.indexOf("Windows") > -1) {
      if (/Safari/.test(navigator.userAgent) && !/Chrome/.test(userAgent)) {
        console.log(userAgent);
        gois = false;
      }
    }
    if (gois) {
      this.renderPage();
    } else {
      this.$router.push('/beatis');
    }
  },

  methods: {
    renderPage: function renderPage() {
      var vm = this;
      var visitorMd5Code = sessionStorage.md5; //
      this.$store.dispatch({
        type: 'entrance',
        router: vm.$router,
        visitorMd5Code: visitorMd5Code
      });
    },
    setEntrance: function setEntrance(entranceId) {
      //alert("1213")
      this.$store.commit('setEntranceId', entranceId);
      sessionStorage.setItem("entranceId", entranceId);
      this.$router.replace({ path: '/imLineUp' });
    }
  }
});

/***/ }),

/***/ "+cQD":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "+p5I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "seviceErr"
  }, [_c('im-top'), _vm._v(" "), _c('img', {
    staticClass: "errImg",
    attrs: {
      "src": _vm.imgUrl + 'im_err.png',
      "alt": "服务器忙"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("您使用浏览器版本太低，请更换浏览器后再访问")])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/16w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_question__ = __webpack_require__("Ozlq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_url_js__ = __webpack_require__("vpRr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




//  import {mapGetters} from 'vuex'
var vm = {};
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    vm = this;
    return {
      basicUrl: __WEBPACK_IMPORTED_MODULE_2__components_url_js__["a" /* baseurl */],
      visitorMd5Code: '',
      imEntranceMode: '',
      boxBodyColor: '',
      logoUrl: '',
      companyName: '',
      activeName: '0',
      displayMode: '',
      imgUrl: '/pc/static/assets/',
      hotArr: [],
      spiritSession: [],
      chatTopFive: {},
      chatContent: '',
      gainObj: {},
      turnToIm: false,
      //        isEvaluate:false,
      //        trigger:'',

      tripleMiss: false,
      times: 3,
      notSatisfied: false,
      vip: false,

      num: '',
      evaArr: [],
      customPicture: '',
      defaultPictureNo: '',
      headPictureUrl: '',
      spiritSrc: '/pc/static/assets/spirit1.png',
      questions: [],
      callis: false,
      limitVipLevel: '',
      visitorVipLevel: '',

      imgMasksrc: '',
      showImgMask: false,
      params: {
        zoomVal: 1,
        left: 0,
        top: 0,
        currentX: 0,
        currentY: 0,
        flag: false
      },
      geen: navigator.userAgent.indexOf('Firefox'),
      homeType: -1
    };
  },

  computed: {
    chatType: function chatType() {
      return this.$route.query.chatType == 'true' || this.$route.query.chatType == true ? true : false;
    }
  },
  /**
   * 离开精灵会话时会触发此钩子
   */
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // 结束会话
    next();
  },
  mounted: function mounted() {
    // 取得浏览器的userAgent字符串
    var userAgent = navigator.userAgent;

    vm.visitorMd5Code = sessionStorage.getItem('md5');
    vm.boxBodyColor = sessionStorage.getItem('boxBodyColor');
    vm.companyName = sessionStorage.getItem('companyName');

    vm.logoUrl = sessionStorage.getItem('logoUrl');
    vm.displayMode = sessionStorage.getItem('displayMode');

    vm.customPicture = sessionStorage.getItem('customPicture');
    vm.defaultPictureNo = sessionStorage.getItem('defaultPictureNo');
    vm.headPictureUrl = sessionStorage.getItem('headPictureUrl');
    vm.homeType = sessionStorage.getItem('redirectTarget');
    if (vm.customPicture == 'true') {
      vm.spiritSrc = vm.headPictureUrl;
    } else {
      if (vm.defaultPictureNo == 2) {
        vm.spiritSrc = '/pc/static/assets/spirit2.png';
      } else if (vm.defaultPictureNo == 3) {
        vm.spiritSrc = '/pc/static/assets/spirit3.png';
      } else {
        vm.spiritSrc = '/pc/static/assets/spirit1.png';
      }
    }
    if (sessionStorage.getItem('callCenterEnable') == 'true') {

      this.callis = true;
    }
    vm.num = 0;
    if (this.$route.query.source == 'type') {
      this.getType();
    } else if (this.$route.query.source == 'hot') {
      this.getHot();
    }
  },

  methods: {
    handleClick: function handleClick() {
      var url = sessionStorage.getItem('indexUrl');
      var md5 = sessionStorage.getItem('md5');
      if (!url) {
        return;
      }
      this.$router.push({
        path: url,
        query: {
          v: md5
        }
      });
    },
    getType: function getType() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__api_question__["a" /* default */].getTypeDetails({ visitorMd5Code: this.visitorMd5Code, id: this.$route.query.id }, function (res) {
        if (res.code === 1) {
          _this.readQuestion(res.data);
        }
      });
    },
    getHot: function getHot() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__api_question__["a" /* default */].getHotIssue({ visitorMd5Code: this.visitorMd5Code, id: this.$route.query.id }, function (res) {
        if (res.code === 1) {
          _this2.readQuestion(res.data);
        }
      });
    },
    readQuestion: function readQuestion(info) {
      var firstReplyAndTop5 = {};
      firstReplyAndTop5.type = 2;
      firstReplyAndTop5.content = (info.question || info.questionName || '').split('\n');
      firstReplyAndTop5.relativeQuestions = [];
      firstReplyAndTop5.evaluateShow = false;
      this.spiritSession.push(firstReplyAndTop5);
      var answerObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, firstReplyAndTop5, { type: 1, content: info.answer || info.faq });
      this.spiritSession.push(answerObj);
      this.scrollToBottom();
    },

    /**
     * 监听用户离开事件
     */
    // listenrerBeforeUnload () {
    //   window.onbeforeunload = function (e) {
    //     let str = '确定要关闭浏览器吗？'
    //     vm.unSolved() // 生成一个会话记录
    //     e.returnValue = str
    //     return str
    //   }
    // },
    stopImg: function stopImg() {},
    bbimg2: function bbimg2() {

      var v = event.wheelDelta || event.detail,
          vm = this;

      vm.params.zoomVal -= v / 20;

      if (vm.params.zoomVal >= 0.2) {
        vm.$refs.img.style.transform = "scale(" + vm.params.zoomVal + ")";
      } else {
        vm.params.zoomVal = 0.2;
        vm.$refs.img.style.transform = "scale(" + vm.params.zoomVal + ")";
        return false;
      }
    },
    bbimg: function bbimg() {

      var event = event || window.event,
          vm = this;

      vm.params.zoomVal += event.wheelDelta / 600;

      vm.$refs.img.style.transform = "scale(" + vm.params.zoomVal + ")";

      if (vm.params.zoomVal >= 0.2) {
        vm.$refs.img.style.transform = "scale(" + vm.params.zoomVal + ")";
      } else {
        vm.params.zoomVal = 0.2;
        vm.$refs.img.style.transform = "scale(" + vm.params.zoomVal + ")";
        return false;
      }
    },
    magnify: function magnify(src) {
      this.imgMasksrc = src;
      this.showImgMask = !this.showImgMask;

      if (!this.showImgMask) {
        this.params = {
          zoomVal: 1,
          left: 0,
          top: 0,
          currentX: 0,
          currentY: 0,
          flag: false
        };
      }

      var vm = this;

      var getCss = function getCss(o, key) {
        return o.currentStyle ? o.currentStyle[key] : document.defaultView.getComputedStyle(o, false)[key];
      };
      //拖拽的实现
      var startDrag = function startDrag(bar, target, callback) {
        if (getCss(target, "left") !== "auto") {
          vm.params.left = getCss(target, "left");
        }
        if (getCss(target, "top") !== "auto") {
          vm.params.top = getCss(target, "top");
        }
        //o是移动对象


        bar.onmousedown = function (event) {

          vm.params.flag = true;

          if (!event) {
            event = window.event;
            //防止IE文字选中
            bar.onselectstart = function () {
              return false;
            };
          }

          var e = event ? event : window.event;

          e.stopPropagation();
          e.preventDefault();
          vm.params.currentX = e.clientX;
          vm.params.currentY = e.clientY;
        };

        document.onmouseup = function () {
          vm.params.flag = false;

          if (getCss(target, "left") !== "auto") {
            vm.params.left = getCss(target, "left");
          }
          if (getCss(target, "top") !== "auto") {
            vm.params.top = getCss(target, "top");
          }
        };
        document.onmousemove = function (event) {

          var e = event ? event : window.event;

          if (vm.params.flag) {
            var nowX = e.clientX,
                nowY = e.clientY;
            var disX = nowX - vm.params.currentX,
                disY = nowY - vm.params.currentY;
            target.style.left = parseInt(vm.params.left) + disX + "px";
            target.style.top = parseInt(vm.params.top) + disY + "px";
            if (typeof callback == "function") {
              callback((parseInt(vm.params.left) || 0) + disX, (parseInt(vm.params.top) || 0) + disY);
            }
            if (e.preventDefault) {
              e.preventDefault();
            }
            return false;
          }
        };
      };

      if (vm.$refs.img) {
        startDrag(vm.$refs.img, vm.$refs.img);
      } else {
        var time = setInterval(function () {
          if (vm.$refs.img) {
            startDrag(vm.$refs.img, vm.$refs.img);
            clearInterval(time);
          } else {
            time();
          }
        }, 500);
      }
    },
    callgo: function callgo() {

      var userAgent = checkBrowser();
      var changeis = true;
      if (userAgent == '谷歌') {
        changeis = true;
        var banben = getChromeVersion();
        console.log('浏览器版本：' + banben);
        if (banben < 52) {
          changeis = false;
        }
      } else {
        changeis = false;
      }
      if (changeis) {
        window.location.href = '#/callcenter';
      } else {
        if (userAgent != "Safari") {
          this.$message({
            message: '目前呼叫只支持Chrome浏览器，版本号 52以上~',
            type: 'warning'
          });
        } else {
          alert('目前呼叫只支持Chrome浏览器，版本号 52以上~');
        }
      }
    },
    workOrder: function workOrder() {
      vm.$router.replace({ path: 'myorder' });
    },

    /*top5*/
    getTopFive: function getTopFive(val) {
      /*追问记录*/
      if (!val.trim()) {
        vm.$message({
          message: '请输入要询问的内容',
          type: 'warning'
        });
      }
      // 用户发起会话日志埋点
      // if (this.homeType == 5) {
      //   if (this.$route.query.source == 'type') {
      //     this.$Points.point({code: '1002', type: '3'});
      //   } else if (this.$route.query.source == 'hot') {
      //     this.$Points.point({code: '1002', type: '2'});
      //   }
      // }

      if (this.chatType) {
        this.$router.replace({
          path: '/imSession',
          query: {
            v: this.$route.query.v
          }
        });
      } else {
        this.$router.replace({ path: '/imLineUp', query: { v: this.visitorMd5Code } });
      }
    },
    sendMsg: function sendMsg(val, e) {

      if (document.getElementsByTagName('textarea')[0].value.length == 140 && e.keyCode != 8) {
        this.$message({
          type: 'warning',
          message: '您输入超过上限了~'
        });
      }
      if (e.keyCode === 13 && !e.ctrlKey) {
        vm.getTopFive(val);
        e.preventDefault();
        return false;
      } else if (e.ctrlKey && e.keyCode === 13) {
        document.getElementsByTagName('textarea')[0].value = document.getElementsByTagName('textarea')[0].value + '\r';
        return false;
      }
    },
    scrollToBottom: function scrollToBottom() {
      var chat = document.getElementsByClassName('chat')[0];
      if (chat.scrollHeight) {
        setTimeout(function () {

          chat.scrollTop = chat.scrollHeight;
        }, 100);
      }
    },

    /*定位到最新的消息位置*/
    intoIm: function intoIm() {
      var vm = this;
      vm.axios.get(vm.basicUrl + '/api/visitor/product/conf/redirectToOnlineService?visitorMd5Code=' + vm.visitorMd5Code).then(function (response) {
        //console.log(response)
        if (response.data.code == 1) {
          var obj = response.data.data;

          if (obj.imStatus == "waiting") {
            vm.$router.replace({ path: 'imDirectory' });
            //window.location.href="#/imLineUp";
          } else if (obj.imStatus == "chatting") {
            vm.$router.replace({ path: 'imSession' });
            //window.location.href="#/imSession";
          } else {
            if (vm.imEntranceMode == 1) {
              //window.location.href="#/spirit";
              vm.$router.replace({ path: 'imLineUp' });
            }
            if (vm.imEntranceMode == 2) {
              vm.$router.replace({ path: 'imDirectory' });
              //window.location.href="#/imDirectory";
            }
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "/HIr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_workdetail_vue__ = __webpack_require__("KQ62");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed4fa752_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_workdetail_vue__ = __webpack_require__("Ua5X");
function injectStyle (ssrContext) {
  __webpack_require__("qRQU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ed4fa752"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_workdetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed4fa752_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_workdetail_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/PuE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_workOrder_vue__ = __webpack_require__("PIXh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b770256_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_workOrder_vue__ = __webpack_require__("84oC");
function injectStyle (ssrContext) {
  __webpack_require__("CR08")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8b770256"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_workOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b770256_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_workOrder_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0g43":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workerorderindex"
  }, [_c('top'), _vm._v(" "), _c('div', {
    staticClass: "nav"
  }, [_c('router-link', {
    staticStyle: {
      "color": "rgb(31, 55, 61)"
    },
    attrs: {
      "to": {
        path: _vm.indexUrl
      }
    }
  }, [_c('span', [_vm._v("首页")])]), _vm._v(" "), _vm._l((_vm.questionclass), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "navbread"
    }, [_vm._v(_vm._s('>' + item))])
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btna color",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "to": {
        path: '/myorder'
      }
    }
  }, [_vm._v("我的工单")])], 2), _vm._v(" "), _vm._l((_vm.showdata), function(item, index1) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.contentis),
        expression: "contentis"
      }],
      key: index1,
      staticClass: "content"
    }, [(item.typeId == 12) ? _c('div', [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-select', {
      staticClass: "wid",
      on: {
        "visible-change": function($event) {
          _vm.changedata(item, _vm.gamearea[item.id])
        },
        "change": function($event) {
          _vm.datacommit(_vm.gamevalue[item.id], item)
        }
      },
      model: {
        value: (_vm.gamevalue[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.gamevalue, item.id, $$v)
        },
        expression: "gamevalue[item.id]"
      }
    }, _vm._l((_vm.gamearea[item.id]), function(item, i) {
      return _c('el-option', {
        key: i,
        attrs: {
          "label": item.label,
          "value": item.value
        }
      })
    }))], 1) : (item.typeId == 1) ? _c('div', {
      staticClass: "dns"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.dns[item.id], item)
        }
      },
      model: {
        value: (_vm.dns[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.dns, item.id, $$v)
        },
        expression: "dns[item.id]"
      }
    })], 1) : (item.typeId == 5) ? _c('div', {
      staticClass: "dns"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.phonenumver[item.id], item)
        }
      },
      model: {
        value: (_vm.phonenumver[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.phonenumver, item.id, $$v)
        },
        expression: "phonenumver[item.id]"
      }
    })], 1) : (item.typeId == 6) ? _c('div', {
      staticClass: "dns"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.number[item.id], item)
        }
      },
      model: {
        value: (_vm.number[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.number, item.id, $$v)
        },
        expression: "number[item.id]"
      }
    })], 1) : (item.typeId == 7) ? _c('div', {
      staticClass: "dns"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.idcard[item.id], item)
        }
      },
      model: {
        value: (_vm.idcard[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.idcard, item.id, $$v)
        },
        expression: "idcard[item.id]"
      }
    })], 1) : (item.typeId == 8) ? _c('div', {
      staticClass: "dns"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.email[item.id], item)
        }
      },
      model: {
        value: (_vm.email[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.email, item.id, $$v)
        },
        expression: "email[item.id]"
      }
    })], 1) : (item.typeId == 2) ? _c('div', {
      staticClass: "explain"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "type": "textarea",
        "rows": 4,
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.explain[item.id], item)
        }
      },
      model: {
        value: (_vm.explain[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.explain, item.id, $$v)
        },
        expression: "explain[item.id]"
      }
    })], 1) : (item.typeId == 13) ? _c('div', {
      staticClass: "sex"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-radio-group', {
      staticClass: "radio",
      on: {
        "change": function($event) {
          _vm.datacommit(_vm.sex[item.id], item)
        }
      },
      model: {
        value: (_vm.sex[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.sex, item.id, $$v)
        },
        expression: "sex[item.id]"
      }
    }, _vm._l((_vm.sexlabel[item.id]), function(ele, index2) {
      return _c('el-radio', {
        key: index2,
        attrs: {
          "label": ele.value
        }
      }, [_vm._v(_vm._s(ele.value))])
    }))], 1) : (item.typeId == 9) ? _c('div', {
      staticClass: "picture"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('p', {
      staticClass: "pictureclass",
      staticStyle: {
        "width": "300px",
        "float": "left"
      }
    }, [_vm._v("为了帮助您更好的解决问题,请上传相关描述的图片。每张不超过9M，支持jpg、png、bmp、gif")]), _vm._v(" "), _c('el-upload', {
      staticClass: "upload-demo wid",
      attrs: {
        "action": _vm.action,
        "on-success": _vm.handlePreview,
        "on-remove": _vm.handleRemove,
        "before-upload": _vm.beforeload,
        "file-list": _vm.fileList2[item.name],
        "list-type": "picture",
        "withCredentials": true
      }
    }, [(_vm.picid[item.id] == true) ? _c('el-button', {
      staticClass: "color",
      staticStyle: {
        "margin-top": "10px"
      },
      style: ({
        backgroundColor: _vm.boxBodyColor
      }),
      attrs: {
        "id": item.spanid + 'a',
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.datacommit(_vm.fileList2[item.name], item)
        }
      }
    }, [_vm._v(" 添加文件 ")]) : _vm._e()], 1)], 1) : (item.typeId == 14) ? _c('div', {
      staticClass: "city"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-checkbox-group', {
      staticClass: "cityclass",
      on: {
        "change": function($event) {
          _vm.datacommit(_vm.checkedCities1[item.id], item)
        }
      },
      model: {
        value: (_vm.checkedCities1[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.checkedCities1, item.id, $$v)
        },
        expression: "checkedCities1[item.id]"
      }
    }, _vm._l((_vm.cities[item.id]), function(city, j) {
      return _c('el-checkbox', {
        key: j,
        attrs: {
          "label": city
        }
      }, [_vm._v(_vm._s(city))])
    }))], 1) : (item.typeId == 15) ? _c('div', {
      staticClass: "picture"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('p', {
      staticClass: "pictureclass",
      staticStyle: {
        "width": "300px",
        "float": "left"
      }
    }, [_vm._v("为了帮助您更好的解决问题,请上传相关描述的视频。视频大小不超过500M")]), _vm._v(" "), _c('el-upload', {
      staticClass: "upload-demo wid",
      attrs: {
        "action": _vm.action,
        "on-success": _vm.handleVideoPreview,
        "on-remove": _vm.handleVideoRemove,
        "before-upload": _vm.videoBeforeload,
        "file-list": _vm.fileVideoList[item.id],
        "list-type": "picture",
        "accept": "video/*",
        "withCredentials": true
      }
    }, [(_vm.picid[item.id] == true) ? _c('el-button', {
      staticClass: "color",
      staticStyle: {
        "margin-top": "10px"
      },
      style: ({
        backgroundColor: _vm.boxBodyColor
      }),
      attrs: {
        "id": item.spanid + 'a',
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.datacommit(_vm.fileVideoList[item.id], item)
        }
      }
    }, [_vm._v(" 添加文件 ")]) : _vm._e()], 1)], 1) : (item.typeId == 16) ? _c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('div', {
      staticClass: "block"
    }, [_c('el-date-picker', {
      staticClass: "time",
      attrs: {
        "type": "datetime",
        "placeholder": item.defaultContent || '选择日期时间'
      },
      on: {
        "change": function($event) {
          _vm.datacommit(_vm.datetimes[item.id], item)
        }
      },
      model: {
        value: (_vm.datetimes[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.datetimes, item.id, $$v)
        },
        expression: "datetimes[item.id]"
      }
    })], 1)]) : (item.typeId == 3) ? _c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('div', {
      staticClass: "block"
    }, [_c('el-date-picker', {
      staticClass: "time",
      attrs: {
        "type": "date",
        "picker-options": _vm.pickerOptions0,
        "placeholder": item.defaultContent
      },
      on: {
        "change": function($event) {
          _vm.datacommit(_vm.datetime[item.id], item)
        }
      },
      model: {
        value: (_vm.datetime[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.datetime, item.id, $$v)
        },
        expression: "datetime[item.id]"
      }
    })], 1)]) : (item.typeId == 4) ? _c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('div', {
      staticClass: "block"
    }, [_c('el-time-picker', {
      staticClass: "time",
      attrs: {
        "type": "date",
        "format": "HH:mm",
        "placeholder": item.defaultContent
      },
      on: {
        "change": function($event) {
          _vm.datacommit(_vm.hourtime[item.id], item)
        }
      },
      model: {
        value: (_vm.hourtime[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.hourtime, item.id, $$v)
        },
        expression: "hourtime[item.id]"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), ((item.required == true && (item.typeId == 12 || item.typeId == 13 || item.typeId == 14) && item.defaultContent == '') || (item.required == true && !(item.typeId == 12 || item.typeId == 13 || item.typeId == 14))) ? _c('span', {
      staticClass: "error1",
      attrs: {
        "id": item.spanid
      }
    }, [_vm._v("*必填项")]) : _c('span', {
      staticClass: "error1",
      attrs: {
        "id": item.spanid
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "clear": "both"
      }
    })])
  }), _vm._v(" "), (_vm.contentis == true && _vm.btnclass == 1) ? _c('div', {
    staticClass: "btn"
  }, [_c('el-button', {
    staticClass: "color",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.commit
    }
  }, [_vm._v("提交")])], 1) : (_vm.contentis == true && _vm.btnclass == 2) ? _c('div', {
    staticClass: "btn"
  }, [_c('el-button', {
    staticClass: "color",
    staticStyle: {
      "background": "#ccc"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("提交")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.downloadis),
      expression: "downloadis"
    }],
    staticClass: "download"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("J/XN")
    }
  }), _vm._v(" "), _c('p', [_vm._v("正在提交...")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successis),
      expression: "successis"
    }],
    staticClass: "success"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("IjaA")
    }
  }), _vm._v(" "), _c('h4', [_vm._v("提交成功,感谢您的反馈！")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.jishi + '秒之后返回首页'))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.erroris),
      expression: "erroris"
    }],
    staticClass: "success"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("JEjz")
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "error"
  }, [_vm._v("问题反馈失败,请稍后再试！")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.jishi + '秒之后返回首页'))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginis),
      expression: "loginis"
    }],
    staticClass: "login"
  }, [_c('p', [_vm._v("手机号为查看单据处理结果的依据")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("手机号")]), _vm._v(" "), _c('el-input', {
    staticClass: "phonenumber",
    attrs: {
      "placeholder": "请输入手机号码"
    },
    on: {
      "blur": _vm.phonego
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.phoneis))])], 1), _vm._v(" "), _c('div', {
    staticClass: "mat"
  }, [_c('span', [_vm._v("随机码")]), _vm._v(" "), _c('el-input', {
    staticClass: "verify",
    attrs: {
      "placeholder": "短信随机码"
    },
    model: {
      value: (_vm.verify),
      callback: function($$v) {
        _vm.verify = $$v
      },
      expression: "verify"
    }
  }), _vm._v(" "), (_vm.verifyis) ? _c('span', {
    staticClass: "verifybtn",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    on: {
      "click": _vm.verifygo
    }
  }, [_vm._v("获取随机码")]) : _c('span', {
    staticClass: "verifybtn",
    style: ({
      backgroundColor: _vm.boxBodyColor
    })
  }, [_vm._v(_vm._s(_vm.timesecond + "s"))]), _vm._v(".\n         "), _c('p', [_vm._v(_vm._s(_vm.veris))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "color verbtn",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.verifyconfirm
    }
  }, [_vm._v("下一步")])], 1)], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0lWQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__im_IMTop_vue__ = __webpack_require__("dU9P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__maskEvaluation_maskEvaluation__ = __webpack_require__("2SmV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    imTop: __WEBPACK_IMPORTED_MODULE_0__im_IMTop_vue__["a" /* default */],
    maskEvaluation: __WEBPACK_IMPORTED_MODULE_1__maskEvaluation_maskEvaluation__["a" /* default */]
  },
  name: 'LoginMobile',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "0oZO":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABr0lEQVRIia3VsWsUURDH8cnBRQQ1JJ2NSBBsBJGzCWkEGyGFEa4IBqwEEYJdLKwkdiIExcLGRv0DUpiAYJcmWIiVgjYiNho0QcTCXPKxcE43gbvb29w0uzvvN9/f7Nv33kb0CJzBI3zAb3/jK57jMoZ7MTqBj+AJthN2FRNo4CIeYANvcbZf+BjeZHGji24Ej/ELF8rCh/ASrzFSsmYBP3CijHgmOzpeqqP/Tb3AchnxGu6VhRfqTucC6P4WKTrfr0HWfsZ0MVfroN2uYhARrb2JTgYDi38GGMetfByryDscEU2M78piLnfpK6zgWBU6vhV2/Fw7OYUWZip2XTT4iOlc6i1MtZfl4n7hRYO8X8RaLSIaEbFUEN3F0QH4LUVEoxYROxFRLwzMR8TJARjUI2KnFhGrETE7AODemI2I1cAktnATtdzJ56oQ8xtcStYWJtsDTWzi0z4NNrGe1+bewVFcwe1+TtJC/aH8OS1gtEqDvQyu4QvqvdX9w0/hO25UBQzjIZ5ivj2FOJjHzAaeYaiqwYTdsY5l/MxpuV4ZngZ13Me7/JDvcSfPsQPdav8ABar58fEhhoAAAAAASUVORK5CYII="

/***/ }),

/***/ "0snm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_workacconnt_vue__ = __webpack_require__("Fy+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4057e960_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_workacconnt_vue__ = __webpack_require__("vHcp");
function injectStyle (ssrContext) {
  __webpack_require__("kqno")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4057e960"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_workacconnt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4057e960_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_workacconnt_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0xDb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/**
 * time: Date
 * cFormat: 时间格式
 */

function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }

  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date = void 0;
  if ((typeof time === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(time)) === 'object') {
    date = time;
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1qBm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("XSa7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bef4e44_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("ihcS");
function injectStyle (ssrContext) {
  __webpack_require__("QFDR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bef4e44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bef4e44_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2SmV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_maskEvaluation_vue__ = __webpack_require__("jnP+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ff339bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_maskEvaluation_vue__ = __webpack_require__("vzNC");
function injectStyle (ssrContext) {
  __webpack_require__("GKiq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ff339bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_maskEvaluation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ff339bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_maskEvaluation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3XGK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_top_vue__ = __webpack_require__("lLIs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b116bf0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_top_vue__ = __webpack_require__("ul0r");
function injectStyle (ssrContext) {
  __webpack_require__("DwWh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b116bf0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_top_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b116bf0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_top_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3bJ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "4L8C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4Vh3":
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ "4pyB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_beatis_vue__ = __webpack_require__("ft5R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0237a410_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_beatis_vue__ = __webpack_require__("+p5I");
function injectStyle (ssrContext) {
  __webpack_require__("maGq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0237a410"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_beatis_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0237a410_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_beatis_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "6JJR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6Qys":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "seviceErr"
  }, [_c('im-top'), _vm._v(" "), (_vm.errType === 'costomerErr') ? _c('img', {
    staticClass: "errImg",
    attrs: {
      "src": _vm.imgUrl + 'im_sorry.png',
      "alt": "无客服"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.errType === 'serviceErr') ? _c('img', {
    staticClass: "errImg",
    attrs: {
      "src": _vm.imgUrl + 'im_err.png',
      "alt": "服务器忙"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.errType === 'costomerErr') ? _c('div', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.msgService)
    }
  }) : _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.msgErr))])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6ZSt":
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ "7LOf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_question__ = __webpack_require__("Ozlq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_url_js__ = __webpack_require__("vpRr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




//  import {mapGetters} from 'vuex'
var vm = {};
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    vm = this;
    return {
      basicUrl: __WEBPACK_IMPORTED_MODULE_2__components_url_js__["a" /* baseurl */],
      visitorMd5Code: '',
      imEntranceMode: '',
      boxBodyColor: '',
      logoUrl: '',
      companyName: '',
      displayMode: '',
      imgUrl: '/pc/static/assets/',
      hotArr: [],
      spiritSession: [],
      chatTopFive: {},
      chatContent: '',
      gainObj: {},
      turnToIm: false,
      activeName: '0',
      //        isEvaluate:false,
      //        trigger:'',

      tripleMiss: false,
      times: 3,
      notSatisfied: false,
      vip: false,

      num: '',
      evaArr: [],
      customPicture: '',
      defaultPictureNo: '',
      headPictureUrl: '',
      spiritSrc: '/pc/static/assets/spirit1.png',
      lenovoShow: false,
      questions: [],
      callis: false,
      limitVipLevel: '',
      visitorVipLevel: '',

      imgMasksrc: '',
      showImgMask: false,
      params: {
        zoomVal: 1,
        left: 0,
        top: 0,
        currentX: 0,
        currentY: 0,
        flag: false
      },
      firstPage: false,
      geen: navigator.userAgent.indexOf('Firefox'),
      homeType: -1
    };
  },

  computed: {
    source: function source() {
      return this.$route.query.source;
    },
    chatType: function chatType() {
      return this.$route.query.chatType == 'true' || this.$route.query.chatType == true ? true : false;
    }
  },
  /**
   * 离开精灵会话时会触发此钩子
   */
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // 点击我的单据日志埋点
    if (this.homeType == 5) {
      // 跳转到人工
      if (to.name == 'IMLineUp' || to.name == 'ImSession' || to.name == 'ImDirectory') {
        this.$Points.point({ code: '1004', type: '1' });
        // 点击右上角跳转到我的工单
      } else if (to.name == 'myorder') {
        this.$Points.point({ code: '1004', type: '3' });
        // 玩家退出
      } else if (to.name !== 'workinformation' && to.name !== 'workcommit') {
        this.$Points.point({ code: '1004', type: '2' });
      }
    }
    // 结束会话
    if (to.path == '/imLineUp' || to.path == '/imDirectory') {
      vm.unSolved();
      next();
    } else {
      vm.solved();
      next();
    }
  },
  mounted: function mounted() {
    // 监听 `onbeforeunload` 事件
    // 访客离开精灵页面（点击返回、刷新、点击首页、直接点击在线客服，直接关闭浏览器等等导致离开），
    // 精灵会话结束，在历史会话能看到此条会话记录。
    function addOnBeforeUnload(e) {
      //        vm.unSolved() // 生成一个会话记录
      vm.solved();
    }

    if (window.attachEvent) {
      //window.attachEvent('onbeforeunload', addOnBeforeUnload);
    } else {
      window.addEventListener('beforeunload', addOnBeforeUnload, false);
    }
    // 取得浏览器的userAgent字符串
    var userAgent = navigator.userAgent;

    vm.visitorMd5Code = sessionStorage.getItem('md5');
    vm.boxBodyColor = sessionStorage.getItem('boxBodyColor');
    vm.companyName = sessionStorage.getItem('companyName');

    vm.logoUrl = sessionStorage.getItem('logoUrl');
    vm.displayMode = sessionStorage.getItem('displayMode');

    vm.customPicture = sessionStorage.getItem('customPicture');
    vm.defaultPictureNo = sessionStorage.getItem('defaultPictureNo');
    vm.headPictureUrl = sessionStorage.getItem('headPictureUrl');
    vm.homeType = sessionStorage.getItem('redirectTarget');
    if (vm.customPicture == 'true') {
      vm.spiritSrc = vm.headPictureUrl;
    } else {
      if (vm.defaultPictureNo == 2) {
        vm.spiritSrc = '/pc/static/assets/spirit2.png';
      } else if (vm.defaultPictureNo == 3) {
        vm.spiritSrc = '/pc/static/assets/spirit3.png';
      } else {
        vm.spiritSrc = '/pc/static/assets/spirit1.png';
      }
    }
    if (sessionStorage.getItem('callCenterEnable') == 'true') {

      this.callis = true;
    }

    vm.num = 0;
    vm.initialize();
    vm.axios.get(vm.basicUrl + "/api/visitor/im/entrance?visitorMd5Code=" + vm.visitorMd5Code).then(function (response) {
      if (response.data.code == 1) {
        vm.imEntranceMode = response.data.data.mode;
      } else {}
    }, function (response) {
      console.info(response);
    });
    if (this.source) {
      if (this.source == 'type') {
        this.getType();
      } else if (this.source == 'hot') {
        this.getHot();
      }
    }
  },

  //    computed: {
  //      ...mapGetters({
  //        companyName: 'getCompanyName'
  //      })
  //
  //    },
  methods: {
    handleClick: function handleClick() {
      var url = sessionStorage.getItem('indexUrl');
      var md5 = sessionStorage.getItem('md5');
      if (!url) {
        return;
      }
      this.$router.push({
        path: url,
        query: {
          v: md5
        }
      });
    },

    /**
     * 监听用户离开事件
     */
    // listenrerBeforeUnload () {
    //   window.onbeforeunload = function (e) {
    //     let str = '确定要关闭浏览器吗？'
    //     vm.unSolved() // 生成一个会话记录
    //     e.returnValue = str
    //     return str
    //   }
    // },
    getType: function getType() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__api_question__["a" /* default */].getTypeDetails({ visitorMd5Code: this.visitorMd5Code, id: this.$route.query.id }, function (res) {
        if (res.code === 1) {
          _this.readQuestion(res.data);
        }
      });
    },
    getHot: function getHot() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__api_question__["a" /* default */].getHotIssue({ visitorMd5Code: this.visitorMd5Code, id: this.$route.query.id }, function (res) {
        if (res.code === 1) {
          _this2.readQuestion(res.data);
        }
      });
    },
    readQuestion: function readQuestion(info) {
      var firstReplyAndTop5 = {};
      firstReplyAndTop5.type = 2;
      firstReplyAndTop5.content = (info.question || info.questionName || '').split('\n');
      firstReplyAndTop5.relativeQuestions = [];
      firstReplyAndTop5.evaluateShow = false;
      this.spiritSession.push(firstReplyAndTop5);
      var answerObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, firstReplyAndTop5, { type: 1, content: info.answer || info.faq });
      this.spiritSession.push(answerObj);
      this.scrollToBottom();
    },
    goForm: function goForm(obj) {
      if (this.homeType == 5) {
        this.$Points.point({ code: '1004', type: '3', id: obj.id });
      }
      sessionStorage.setItem("navname", obj.name);
      if (obj.showNote) {
        this.$router.push({
          path: '/workinformation',
          query: {
            id: obj.id,
            source: this.homeType == 5 ? 'ai' : ''
            // name: obj.name
          }
        });
      } else {
        this.$router.push({
          path: '/workcommit',
          query: {
            id: obj.id,
            source: this.source ? 'ai' : ''
            // name: obj.name
          }
        });
      }
    },
    stopImg: function stopImg() {},
    bbimg2: function bbimg2() {

      var v = event.wheelDelta || event.detail,
          vm = this;

      vm.params.zoomVal -= v / 20;

      if (vm.params.zoomVal >= 0.2) {
        vm.$refs.img.style.transform = "scale(" + vm.params.zoomVal + ")";
      } else {
        vm.params.zoomVal = 0.2;
        vm.$refs.img.style.transform = "scale(" + vm.params.zoomVal + ")";
        return false;
      }
    },
    bbimg: function bbimg() {

      var event = event || window.event,
          vm = this;

      vm.params.zoomVal += event.wheelDelta / 600;

      vm.$refs.img.style.transform = "scale(" + vm.params.zoomVal + ")";

      if (vm.params.zoomVal >= 0.2) {
        vm.$refs.img.style.transform = "scale(" + vm.params.zoomVal + ")";
      } else {
        vm.params.zoomVal = 0.2;
        vm.$refs.img.style.transform = "scale(" + vm.params.zoomVal + ")";
        return false;
      }
    },
    magnify: function magnify(src) {
      this.imgMasksrc = src;
      this.showImgMask = !this.showImgMask;

      if (!this.showImgMask) {
        this.params = {
          zoomVal: 1,
          left: 0,
          top: 0,
          currentX: 0,
          currentY: 0,
          flag: false
        };
      }

      var vm = this;

      var getCss = function getCss(o, key) {
        return o.currentStyle ? o.currentStyle[key] : document.defaultView.getComputedStyle(o, false)[key];
      };
      //拖拽的实现
      var startDrag = function startDrag(bar, target, callback) {
        if (getCss(target, "left") !== "auto") {
          vm.params.left = getCss(target, "left");
        }
        if (getCss(target, "top") !== "auto") {
          vm.params.top = getCss(target, "top");
        }
        //o是移动对象


        bar.onmousedown = function (event) {

          vm.params.flag = true;

          if (!event) {
            event = window.event;
            //防止IE文字选中
            bar.onselectstart = function () {
              return false;
            };
          }

          var e = event ? event : window.event;

          e.stopPropagation();
          e.preventDefault();
          vm.params.currentX = e.clientX;
          vm.params.currentY = e.clientY;
        };

        document.onmouseup = function () {
          vm.params.flag = false;

          if (getCss(target, "left") !== "auto") {
            vm.params.left = getCss(target, "left");
          }
          if (getCss(target, "top") !== "auto") {
            vm.params.top = getCss(target, "top");
          }
        };
        document.onmousemove = function (event) {

          var e = event ? event : window.event;

          if (vm.params.flag) {
            var nowX = e.clientX,
                nowY = e.clientY;
            var disX = nowX - vm.params.currentX,
                disY = nowY - vm.params.currentY;
            target.style.left = parseInt(vm.params.left) + disX + "px";
            target.style.top = parseInt(vm.params.top) + disY + "px";
            if (typeof callback == "function") {
              callback((parseInt(vm.params.left) || 0) + disX, (parseInt(vm.params.top) || 0) + disY);
            }
            if (e.preventDefault) {
              e.preventDefault();
            }
            return false;
          }
        };
      };

      if (vm.$refs.img) {
        startDrag(vm.$refs.img, vm.$refs.img);
      } else {
        var time = setInterval(function () {
          if (vm.$refs.img) {
            startDrag(vm.$refs.img, vm.$refs.img);
            clearInterval(time);
          } else {
            time();
          }
        }, 500);
      }
    },
    callgo: function callgo() {

      var userAgent = checkBrowser();
      var changeis = true;
      if (userAgent == '谷歌') {
        changeis = true;
        var banben = getChromeVersion();
        console.log('浏览器版本：' + banben);
        if (banben < 52) {
          changeis = false;
        }
      } else {
        changeis = false;
      }
      if (changeis) {
        window.location.href = '#/callcenter';
      } else {
        if (userAgent != "Safari") {
          this.$message({
            message: '目前呼叫只支持Chrome浏览器，版本号 52以上~',
            type: 'warning'
          });
        } else {
          alert('目前呼叫只支持Chrome浏览器，版本号 52以上~');
        }
      }
    },
    workOrder: function workOrder() {
      vm.$router.replace({ path: 'myorder' });
    },

    /*初始化问题*/
    initialize: function initialize() {
      vm.axios.get(vm.basicUrl + "/api/visitor/spirit/spiritInit?visitorMd5Code=" + vm.visitorMd5Code).then(function (response) {
        if (response.data.code === 1) {
          vm.chatTopFive.type = 1;
          vm.chatTopFive.content = response.data.data.content;
          vm.chatTopFive.relativeQuestions = response.data.data.relativeQuestions;
          vm.chatTopFive.evaluateShow = false;
          vm.chatTopFive.workOrders = response.data.data.workOrders;
          vm.hotArr = response.data.data.relativeQuestions;

          vm.turnToIm = response.data.data.turnToIm;

          if (response.data.data.spiritImEntranceCfgs) {
            response.data.data.spiritImEntranceCfgs.forEach(function (item, index) {
              if (item.triggers == 1) {
                vm.tripleMiss = true;
                vm.times = item.times;
              }

              if (item.triggers == 2) {
                vm.notSatisfied = true;
              }

              if (item.triggers == 3) {
                vm.vip = true;
                vm.limitVipLevel = item.vipLevel;
              }

              vm.visitorVipLevel = response.data.data.visitorVipLevel;
            });
          }
          // 不是来源于热点问题或者问题分类
          if (!vm.source) {
            vm.spiritSession.push(vm.chatTopFive);
          }
          vm.$nextTick(function () {

            var arr = document.querySelectorAll('body .sessionDiv a');

            var _loop = function _loop(i) {

              arr[i].onclick = function (e) {

                if (arr[i].href == 'about:blank' || arr[i].href == 'javascript:void(0);' || arr[i].href == 'http://about:blank/') {
                  e.preventDefault();
                  vm.getTopFive(arr[i].innerText);
                }
              };
            };

            for (var i = 0; i < arr.length; i++) {
              _loop(i);
            }

            var imgArr = document.querySelectorAll('body .sessionDiv img');

            for (var i = 0; i < imgArr.length; i++) {

              imgArr[i].onclick = function (e) {

                vm.magnify(this.src);
              };
            }
          });
        } else {
          vm.$message({
            message: response.data.message || '获取问题列表失败',
            type: 'warning'
          });
        }
      }, function (response) {
        console.info(response);
      });
    },

    /*top5*/
    getTopFive: function getTopFive(val) {
      /*追问记录*/
      if (!val.trim()) {
        vm.$message({
          message: '请输入要询问的内容',
          type: 'warning'
        });
      } else {
        var questionObj = {
          content: val.split('\n'),
          type: 2
        };
        vm.spiritSession.push(questionObj);
        vm.scrollToBottom();

        vm.chatContent = '';
        vm.lenovoShow = false;
        var source = '';
        if (vm.homeType == 5) {
          if (vm.source == 'type') {
            source = '3';
            // vm.$Points.point({code: '1002', type: '3'});
          } else if (vm.source == 'hot') {
            source = '2';
            // vm.$Points.point({code: '1002', type: '2'});
          } else {
            source = '1';
            // vm.$Points.point({code: '1002', type: '1'});
          }
        }
        //var url = encodeURI(vm.basicUrl + '/api/visitor/spirit/question?question='+encodeURIComponent(val)+'&visitorMd5Code='+vm.visitorMd5Code);
        var url = vm.basicUrl + '/api/visitor/spirit/question?question=' + encodeURIComponent(val) + '&visitorMd5Code=' + vm.visitorMd5Code + '&talkId=' + vm.$Points.talkId + '&source=' + source;
        vm.axios.post(url).then(function (response) {
          if (response.data.code == 1) {
            var answerObj = {
              content: response.data.data.text,
              relativeQuestions: response.data.data.relateQuestions,
              type: 1,
              evaluateShow: true,
              isEvaluate: false,
              questionId: response.data.data.questionId,
              relatedId: response.data.data.relatedId,
              workOrders: response.data.data.workOrders
            };

            vm.gainObj = {
              relatedId: response.data.data.relatedId
            };
            vm.evaArr.push(vm.gainObj);
            vm.spiritSession.push(answerObj);
            vm.scrollToBottom();

            if (answerObj.questionId == '0') {
              vm.num += 1;
              if (vm.turnToIm && vm.num >= vm.times && vm.tripleMiss) {
                vm.unSolved();
                // im不在会话中才可以跳转
                if (!vm.chatType) {
                  if (vm.imEntranceMode == 2) {
                    vm.$router.replace({ path: 'imDirectory' });
                  } else if (vm.imEntranceMode == 1) {
                    vm.$router.replace({ path: 'imLineUp' });
                  }
                }
              }
            }

            //
            //            vm.gainObj = {
            //              catalogId:response.data.data.catalogId,
            //              feedBackId:response.data.data.id,
            //              isAssociate:response.data.data.sameTopCount > 0? 1 :0,
            //              question:val,
            //              questionId:response.data.data.questionId,
            //              msgId:response.data.data.answerSeq,
            //            }
            //
            //            vm.evaArr.push(vm.gainObj)
            //
            //            let evaluateObj = {
            //              type: 3,
            //              isEvaluate: false,
            //              questionId: response.data.data.questionId,
            //            }
            //
            //           // vm.isEvaluate = false
            //
            //            vm.spiritSession.push(evaluateObj)


            vm.$nextTick(function () {

              var arr = document.querySelectorAll('body .sessionDiv a');

              var _loop2 = function _loop2(i) {

                arr[i].onclick = function (e) {

                  if (arr[i].href == 'about:blank' || arr[i].href == 'javascript:void(0);' || arr[i].href == 'http://about:blank/') {
                    e.preventDefault();
                    vm.getTopFive(arr[i].innerText);
                  }
                };
              };

              for (var i = 0; i < arr.length; i++) {
                _loop2(i);
              }

              var imgArr = document.querySelectorAll('body .sessionDiv img');

              for (var i = 0; i < imgArr.length; i++) {

                imgArr[i].onclick = function (e) {

                  vm.magnify(this.src);
                };
              }
            });
          } else if (response.data.code == 4103) {
            vm.$message({
              message: '机器人会话不存在',
              type: 'warning'
            });
            window.location.reload();
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },

    /*发送消息*/
    sendMsg: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.throttle(function (val, e) {
      if (vm.chatContent.trim() != '') {
        val = val.replace(/ /g, '');
        var url = encodeURI(vm.basicUrl + '/api/visitor/spirit/think?question=' + val + '&visitorMd5Code=' + vm.visitorMd5Code);
        vm.axios.post(url).then(function (response) {
          if (response.data.code == 1) {
            response.data.data.forEach(function (element, index) {
              if (val == '.') {
                element.html = element.content.replace(eval('/\\' + val + '/g'), "<span  style='color:red'>" + val + "</span>");
              } else {
                element.html = element.content.replace(eval('/' + val + '/g'), "<span  style='color:red'>" + val + "</span>");
              }
            });
            console.log(response.data.data);
            vm.questions = response.data.data;

            if (!document.getElementsByClassName('chatContent')[0].value.trim()) {
              vm.lenovoShow = false;
            } else if (vm.questions.length > 0) {
              vm.lenovoShow = true;
            } else {
              vm.lenovoShow = false;
            }

            vm.scrollToBottom();
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        vm.lenovoShow = false;
      }
    }, 500),
    sendMsg1: function sendMsg1(val, e) {

      if (document.getElementsByTagName('textarea')[0].value.length == 140 && e.keyCode != 8) {
        this.$message({
          type: 'warning',
          message: '您输入超过上限了~'
        });
      }
      if (e.keyCode === 13 && !e.ctrlKey) {
        vm.getTopFive(val);
        e.preventDefault();
        return false;
      } else if (e.ctrlKey && e.keyCode === 13) {
        document.getElementsByTagName('textarea')[0].value = document.getElementsByTagName('textarea')[0].value + '\r';
        return false;
      }
    },

    /*发送评价*/
    getEvaluate: function getEvaluate(val, indexS) {

      for (var i = 0; i < vm.evaArr.length; i++) {
        for (var j = 0; j < vm.spiritSession.length; j++) {
          if (vm.spiritSession[j].relatedId == vm.evaArr[i].relatedId && j == indexS) {

            vm.evaArr[i].score = val;

            vm.axios.post(vm.basicUrl + '/api/visitor/spirit/feedBack?visitorMd5Code=' + vm.visitorMd5Code, vm.evaArr[i]).then(function (response) {
              if (response.data.code == 1) {

                if (vm.turnToIm && val == 1 && vm.notSatisfied) {
                  vm.unSolved();
                  // im不在会话中才可以跳转
                  if (!vm.chatType) {
                    if (vm.imEntranceMode == 2) {
                      vm.$router.replace({ path: 'imDirectory' });
                    } else if (vm.imEntranceMode == 1) {
                      vm.$router.replace({ path: 'imLineUp' });
                    }
                  }
                }
              }
            }).catch(function (error) {
              console.log(error);
            });

            vm.spiritSession[j].isEvaluate = true;
          }
        }
      }
    },
    scrollToBottom: function scrollToBottom() {
      var chat = document.getElementsByClassName('chat')[0];
      if (chat.scrollHeight) {
        setTimeout(function () {

          chat.scrollTop = chat.scrollHeight;
        }, 100);
      }
    },
    unSolved: function unSolved() {
      vm.axios.get(vm.basicUrl + "/api/visitor/spirit/unSolved?visitorMd5Code=" + vm.visitorMd5Code).then(function (response) {
        if (response.data.code === 1) {} else {}
      }, function (response) {
        console.info(response);
      });
    },
    solved: function solved() {
      vm.axios.get(vm.basicUrl + "/api/visitor/spirit/solved?visitorMd5Code=" + vm.visitorMd5Code).then(function (response) {
        if (response.data.code === 1) {} else {}
      }, function (response) {
        console.info(response);
      });
    },

    /*定位到最新的消息位置*/
    intoIm: function intoIm() {
      var vm = this;
      vm.axios.get(vm.basicUrl + '/api/visitor/product/conf/redirectToOnlineService?visitorMd5Code=' + vm.visitorMd5Code).then(function (response) {
        //console.log(response)
        if (response.data.code == 1) {
          var obj = response.data.data;

          if (obj.imStatus == "waiting") {
            vm.$router.replace({ path: 'imDirectory' });
            //window.location.href="#/imLineUp";
          } else if (obj.imStatus == "chatting") {
            vm.$router.replace({ path: 'imSession' });
            //window.location.href="#/imSession";
          } else {
            if (vm.imEntranceMode == 1) {
              //window.location.href="#/spirit";
              vm.$router.replace({ path: 'imLineUp' });
            }
            if (vm.imEntranceMode == 2) {
              vm.$router.replace({ path: 'imDirectory' });
              //window.location.href="#/imDirectory";
            }
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "7xIN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "84oC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workerorderindex"
  }, [_vm._l((_vm.showdata), function(item, index1) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.contentis),
        expression: "contentis"
      }],
      key: index1,
      staticClass: "content"
    }, [(item.typeId == 12) ? _c('div', [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-select', {
      staticClass: "wid",
      on: {
        "visible-change": function($event) {
          _vm.changedata(item, _vm.gamearea[item.id])
        },
        "change": function($event) {
          _vm.datacommit(_vm.gamevalue[item.id], item)
        }
      },
      model: {
        value: (_vm.gamevalue[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.gamevalue, item.id, $$v)
        },
        expression: "gamevalue[item.id]"
      }
    }, _vm._l((_vm.gamearea[item.id]), function(item) {
      return _c('el-option', {
        key: item.label,
        attrs: {
          "label": item.label,
          "value": item.value
        }
      })
    }))], 1) : (item.typeId == 1) ? _c('div', {
      staticClass: "dns"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.dns[item.id], item)
        }
      },
      model: {
        value: (_vm.dns[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.dns, item.id, $$v)
        },
        expression: "dns[item.id]"
      }
    })], 1) : (item.typeId == 5) ? _c('div', {
      staticClass: "dns"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.phonenumver[item.id], item)
        }
      },
      model: {
        value: (_vm.phonenumver[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.phonenumver, item.id, $$v)
        },
        expression: "phonenumver[item.id]"
      }
    })], 1) : (item.typeId == 6) ? _c('div', {
      staticClass: "dns"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.number[item.id], item, $event)
        }
      },
      model: {
        value: (_vm.number[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.number, item.id, $$v)
        },
        expression: "number[item.id]"
      }
    })], 1) : (item.typeId == 7) ? _c('div', {
      staticClass: "dns"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.idcard[item.id], item)
        }
      },
      model: {
        value: (_vm.idcard[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.idcard, item.id, $$v)
        },
        expression: "idcard[item.id]"
      }
    })], 1) : (item.typeId == 8) ? _c('div', {
      staticClass: "dns"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.email[item.id], item)
        }
      },
      model: {
        value: (_vm.email[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.email, item.id, $$v)
        },
        expression: "email[item.id]"
      }
    })], 1) : (item.typeId == 2) ? _c('div', {
      staticClass: "explain"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "type": "textarea",
        "rows": 4,
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.explain[item.id], item)
        }
      },
      model: {
        value: (_vm.explain[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.explain, item.id, $$v)
        },
        expression: "explain[item.id]"
      }
    })], 1) : (item.typeId == 13) ? _c('div', {
      staticClass: "sex"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-radio-group', {
      staticClass: "radio",
      on: {
        "change": function($event) {
          _vm.datacommit(_vm.sex[item.id], item)
        }
      },
      model: {
        value: (_vm.sex[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.sex, item.id, $$v)
        },
        expression: "sex[item.id]"
      }
    }, _vm._l((_vm.sexlabel[item.id]), function(ele, index2) {
      return _c('el-radio', {
        key: index2,
        attrs: {
          "label": ele.value
        }
      }, [_vm._v(_vm._s(ele.value))])
    }))], 1) : (item.typeId == 9) ? _c('div', {
      staticClass: "picture"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('p', {
      staticClass: "pictureclass",
      staticStyle: {
        "width": "250px",
        "float": "left",
        "line-height": "23px"
      }
    }, [_vm._v("为了帮助您更好的解决问题,请上传相关描述的图片。每张不超过9M，支持jpg、png、bmp、gif")]), _vm._v(" "), _c('el-upload', {
      staticClass: "upload-demo wid",
      attrs: {
        "action": _vm.action,
        "on-success": _vm.handlePreview,
        "on-remove": _vm.handleRemove,
        "before-upload": _vm.beforeload,
        "file-list": _vm.fileList2[item.name],
        "list-type": "picture",
        "withCredentials": true
      }
    }, [(_vm.picid[item.id] == true) ? _c('el-button', {
      staticClass: "color",
      staticStyle: {
        "margin-top": "80px",
        "margin-left": "-430px"
      },
      style: ({
        backgroundColor: _vm.boxBodyColor
      }),
      attrs: {
        "id": item.spanid + 'a',
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.datacommit(_vm.fileList2[item.name], item)
        }
      }
    }, [_vm._v(" 添加文件 ")]) : _vm._e()], 1)], 1) : (item.typeId == 14) ? _c('div', {
      staticClass: "city"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-checkbox-group', {
      staticClass: "cityclass",
      on: {
        "change": function($event) {
          _vm.datacommit(_vm.checkedCities1[item.id], item)
        }
      },
      model: {
        value: (_vm.checkedCities1[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.checkedCities1, item.id, $$v)
        },
        expression: "checkedCities1[item.id]"
      }
    }, _vm._l((_vm.cities[item.id]), function(city) {
      return _c('el-checkbox', {
        key: city,
        attrs: {
          "label": city
        }
      }, [_vm._v(_vm._s(city))])
    }))], 1) : (item.typeId == 15) ? _c('div', {
      staticClass: "picture"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('p', {
      staticClass: "pictureclass",
      staticStyle: {
        "width": "250px",
        "float": "left",
        "line-height": "23px"
      }
    }, [_vm._v("为了帮助您更好的解决问题,请上传相关描述的视频。视频大小不超过500M")]), _vm._v(" "), _c('el-upload', {
      staticClass: "upload-demo wid",
      attrs: {
        "action": _vm.action,
        "on-success": _vm.handleVideoPreview,
        "on-remove": _vm.handleVideoRemove,
        "before-upload": _vm.videoBeforeload,
        "file-list": _vm.fileVideoList[item.name],
        "list-type": "picture",
        "accept": "video/*",
        "withCredentials": true
      }
    }, [(_vm.picid[item.id] == true) ? _c('el-button', {
      staticClass: "color",
      staticStyle: {
        "margin-top": "80px",
        "margin-left": "-430px"
      },
      style: ({
        backgroundColor: _vm.boxBodyColor
      }),
      attrs: {
        "id": item.spanid + 'a',
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.datacommit(_vm.fileVideoList[item.name], item)
        }
      }
    }, [_vm._v(" 添加文件 ")]) : _vm._e()], 1)], 1) : (item.typeId == 16) ? _c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('div', {
      staticClass: "block"
    }, [_c('el-date-picker', {
      staticClass: "time",
      attrs: {
        "type": "datetime",
        "placeholder": item.defaultContent || '选择日期时间'
      },
      on: {
        "change": function($event) {
          _vm.datacommit(_vm.datetimes[item.id], item)
        }
      },
      model: {
        value: (_vm.datetimes[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.datetimes, item.id, $$v)
        },
        expression: "datetimes[item.id]"
      }
    })], 1)]) : (item.typeId == 3) ? _c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('div', {
      staticClass: "block"
    }, [_c('el-date-picker', {
      staticClass: "time",
      attrs: {
        "type": "date",
        "picker-options": _vm.pickerOptions0,
        "placeholder": item.defaultContent
      },
      on: {
        "change": function($event) {
          _vm.datacommit(_vm.datetime[item.id], item)
        }
      },
      model: {
        value: (_vm.datetime[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.datetime, item.id, $$v)
        },
        expression: "datetime[item.id]"
      }
    })], 1)]) : (item.typeId == 4) ? _c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('div', {
      staticClass: "block"
    }, [_c('el-time-picker', {
      staticClass: "time",
      attrs: {
        "type": "date",
        "format": "HH:mm",
        "placeholder": item.defaultContent
      },
      on: {
        "change": function($event) {
          _vm.datacommit(_vm.hourtime[item.id], item, $event)
        }
      },
      model: {
        value: (_vm.hourtime[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.hourtime, item.id, $$v)
        },
        expression: "hourtime[item.id]"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), ((item.required == true && (item.typeId == 12 || item.typeId == 13 || item.typeId == 14) && item.defaultContent == '') || (item.required == true && !(item.typeId == 12 || item.typeId == 13 || item.typeId == 14))) ? _c('span', {
      staticClass: "error1",
      attrs: {
        "id": item.spanid
      }
    }, [_vm._v("*必填项")]) : _c('span', {
      staticClass: "error1",
      attrs: {
        "id": item.spanid
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "clear": "both"
      }
    })])
  }), _vm._v(" "), (_vm.contentis == true && _vm.btnclass == 1) ? _c('div', {
    staticClass: "btn"
  }, [_c('el-button', {
    staticClass: "color",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "type": "primary",
      "loading": _vm.commitLoading
    },
    on: {
      "click": _vm.commit
    }
  }, [_vm._v("提交")])], 1) : (_vm.contentis == true && _vm.btnclass == 2) ? _c('div', {
    staticClass: "btn"
  }, [_c('el-button', {
    staticClass: "color",
    staticStyle: {
      "background": "#ccc"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("提交")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.downloadis),
      expression: "downloadis"
    }],
    staticClass: "download"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("J/XN")
    }
  }), _vm._v(" "), _c('p', [_vm._v("正在提交...")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successis),
      expression: "successis"
    }],
    staticClass: "success"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("IjaA")
    }
  }), _vm._v(" "), _c('h4', [_vm._v("提交成功,感谢您的反馈！")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.erroris),
      expression: "erroris"
    }],
    staticClass: "success"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("JEjz")
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "error"
  }, [_vm._v("问题反馈失败,请稍后再试！")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.jishi + '秒之后重试'))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginis),
      expression: "loginis"
    }],
    staticClass: "login"
  }, [_c('p', [_vm._v("手机号为查看单据处理结果的依据")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("手机号")]), _vm._v(" "), _c('el-input', {
    staticClass: "phonenumber",
    attrs: {
      "placeholder": "请输入手机号码"
    },
    on: {
      "blur": _vm.phonego
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.phoneis))])], 1), _vm._v(" "), _c('div', {
    staticClass: "mat"
  }, [_c('span', [_vm._v("随机码")]), _vm._v(" "), _c('el-input', {
    staticClass: "verify",
    attrs: {
      "placeholder": "短信随机码"
    },
    model: {
      value: (_vm.verify),
      callback: function($$v) {
        _vm.verify = $$v
      },
      expression: "verify"
    }
  }), _vm._v(" "), (_vm.verifyis) ? _c('span', {
    staticClass: "verifybtn",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    on: {
      "click": _vm.verifygo
    }
  }, [_vm._v("获取随机码")]) : _c('span', {
    staticClass: "verifybtn",
    style: ({
      backgroundColor: _vm.boxBodyColor
    })
  }, [_vm._v(_vm._s(_vm.timesecond + "s"))]), _vm._v(".\n         "), _c('p', [_vm._v(_vm._s(_vm.veris))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "color verbtn",
    staticStyle: {
      "margin-left": "140px"
    },
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.verifyconfirm
    }
  }, [_vm._v("下一步")])], 1)], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8YCc":
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ "8nZP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__im_IMTop_vue__ = __webpack_require__("dU9P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Constants__ = __webpack_require__("E3qV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__maskEvaluation_maskEvaluation__ = __webpack_require__("2SmV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_VideoModel__ = __webpack_require__("AOEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_ImagePreview__ = __webpack_require__("1qBm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__workOrder__ = __webpack_require__("/PuE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__url_js__ = __webpack_require__("vpRr");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











Date.prototype.format = function (format) {
  var o = {
    "M+": this.getMonth() + 1, //month
    "d+": this.getDate(), //day
    "h+": this.getHours(), //hour
    "m+": this.getMinutes(), //minute
    "s+": this.getSeconds(), //second
    "q+": Math.floor((this.getMonth() + 3) / 3), //quarter
    "S": this.getMilliseconds() //millisecond
  };

  if (/(y+)/i.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }

  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return format;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    imTop: __WEBPACK_IMPORTED_MODULE_2__im_IMTop_vue__["a" /* default */],
    maskEvaluation: __WEBPACK_IMPORTED_MODULE_5__maskEvaluation_maskEvaluation__["a" /* default */],
    workOrder: __WEBPACK_IMPORTED_MODULE_8__workOrder__["a" /* default */],
    VideoModel: __WEBPACK_IMPORTED_MODULE_6__common_VideoModel__["a" /* default */],
    ImagePreview: __WEBPACK_IMPORTED_MODULE_7__common_ImagePreview__["a" /* default */]
  },
  name: 'ImSession',
  data: function data() {
    return {
      // showSatisfySettingFlag:false,
      videoUrl: '',
      isVideoShow: false,
      isIE: false,
      showImgMask: false,
      imgMasksrc: '',
      boxBodyColor: '',
      msgValue: '',
      imgUrl: '/pc/static/assets/',
      //emoticons: '../../../static/Emotion'
      Emotion: [{ src: '/pc/static/Emotion/weixiao.png', code: '[wx]', text: "🙂", reg: /\[wx\]/g, num: 1 }, { src: '/pc/static/Emotion/daxiao.png', code: '[dx]', text: "😄", reg: /\[dx\]/g, num: 2 }, { src: '/pc/static/Emotion/tiaopi.png', code: '[tp]', text: "😜", reg: /\[tp\]/g, num: 3 }, { src: '/pc/static/Emotion/se.png', code: '[se]', text: "😍", reg: /\[se\]/g, num: 4 }, { src: '/pc/static/Emotion/haixiu.png', code: '[hx]', text: "😳", reg: /\[hx\]/g, num: 5 }, { src: '/pc/static/Emotion/piezui.png', code: '[pz]', text: "😖", reg: /\[pz\]/g, num: 6 }, { src: '/pc/static/Emotion/fadai.png', code: '[fd]', text: "🙄", reg: /\[fd\]/g, num: 7 }, { src: '/pc/static/Emotion/yiwen.png', code: '[yw]', text: "🤔", reg: /\[yw\]/g, num: 8 }, { src: '/pc/static/Emotion/bizui.png', code: '[bz]', text: "🤐", reg: /\[bz\]/g, num: 9 }, { src: '/pc/static/Emotion/nanguo.png', code: '[ng]', text: "☹️", reg: /\[ng\]/g, num: 10 }, { src: '/pc/static/Emotion/liulei.png', code: '[ll]', text: "😢", reg: /\[ll\]/g, num: 11 }, { src: '/pc/static/Emotion/daku.png', code: '[dk]', text: "😭", reg: /\[dk\]/g, num: 12 }, { src: '/pc/static/Emotion/jingya.png', code: '[jy]', text: "😲", reg: /\[jy\]/g, num: 13 }, { src: '/pc/static/Emotion/deyi.png', code: '[dy]', text: "😏", reg: /\[dy\]/g, num: 14 }, { src: '/pc/static/Emotion/liuhan.png', code: '[lh]', text: "😓", reg: /\[lh\]/g, num: 15 }, { src: '/pc/static/Emotion/ganga.png', code: '[gg]', text: "😒", reg: /\[gg\]/g, num: 16 }, { src: '/pc/static/Emotion/zhiyi.png', code: '[zy]', text: "😐", reg: /\[zy\]/g, num: 17 }, { src: '/pc/static/Emotion/shui.png', code: '[s]', text: "😴", reg: /\[s\]/g, num: 18 }, { src: '/pc/static/Emotion/kun.png', code: '[k]', text: "😫", reg: /\[k\]/g, num: 19 }, { src: '/pc/static/Emotion/jingkong.png', code: '[jk]', text: "😱", reg: /\[jk\]/g, num: 20 }, { src: '/pc/static/Emotion/fanu.png', code: '[fn]', text: "😡", reg: /\[fn\]/g, num: 21 }, { src: '/pc/static/Emotion/meigui.png', code: '[mg]', text: "🌹", reg: /\[mg\]/g, num: 22 }, { src: '/pc/static/Emotion/zuicun.png', code: '[zc]', text: "💋", reg: /\[zc\]/g, num: 23 }, { src: '/pc/static/Emotion/aixin.png', code: '[ax]', text: "❤️", reg: /\[ax\]/g, num: 24 }],
      emotionFlag: false,
      basurl: __WEBPACK_IMPORTED_MODULE_10__url_js__["a" /* baseurl */],
      imEntranceMode: ''
    };
  },
  created: function created() {
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      this.isIE = true;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
    messageList: 'messageList',
    satisfyMode: 'satisfyMode',
    showSatisfySettingFlag: 'showSatisfySettingFlag',
    messageContent: 'messageContent',
    endis: 'endclass'
  }), {
    visitorMd5Code: function visitorMd5Code() {
      return sessionStorage.md5;
      //return "ae9773de040b64454b319389a64a3389"
    }
  }),
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    var vm = this;
    var obj = {
      id: vm.visitorMd5Code,
      time: vm.$store.state.im.userTime
    };
    var obj2 = {
      id: vm.visitorMd5Code,
      time: vm.$store.state.im.visitTime
    };
    var obj3 = {
      id: vm.visitorMd5Code,
      time: vm.$store.state.im.sessionTime
    };

    vm.$store.state.im.userTimeYes = false;
    vm.$store.state.im.visitTimeYes = false;
    // 结束会话
    clearInterval(vm.$store.state.im.userFun);
    clearInterval(vm.$store.state.im.visitorFun);

    clearInterval(vm.$store.state.im.visitorNoReplyTimer);
    clearInterval(vm.$store.state.im.sessionNoReplyTimer);
    clearInterval(vm.$store.state.im.userNoReplyTimer);

    clearTimeout(vm.$store.state.im.userNoReplyTimerOut);
    clearTimeout(vm.$store.state.im.visitorNoReplyTimerOut);

    localStorage.setItem('userTime', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
    localStorage.setItem('visitTime', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj2));
    localStorage.setItem('sessionTime', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj3));
    vm.$store.dispatch({
      type: 'getEnable',
      visitorMd5Code: vm.visitorMd5Code
    });
    next();
  },
  mounted: function mounted() {
    var vm = this;
    var obj = {
      id: vm.visitorMd5Code,
      time: localStorage.getItem('user')
    };
    var obj2 = {
      id: vm.visitorMd5Code,
      time: localStorage.getItem('visit')
    };
    var obj3 = {
      id: vm.visitorMd5Code,
      time: localStorage.getItem('session')
    };

    vm.$store.state.im.userTimeYes = false;
    vm.$store.state.im.visitTimeYes = false;

    localStorage.setItem('userTime', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
    localStorage.setItem('visitTime', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj2));
    localStorage.setItem('sessionTime', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj3));

    this.boxBodyColor = sessionStorage.getItem('boxBodyColor');
    this.renderPage();
    this.scrollToBottom();
    console.log('当前会话状态');
    console.log(vm.$store.state.im.endis);
    if (sessionStorage.getItem("addtime")) {
      clearInterval(sessionStorage.getItem("addtime"));
    }
    var title1 = document.getElementsByTagName('title')[0];
    title1.innerHTML = 'customer-service';
    vm.axios.get(vm.basurl + "/api/visitor/im/entrance?visitorMd5Code=" + vm.visitorMd5Code).then(function (response) {
      if (response.data.code == 1) {
        vm.imEntranceMode = response.data.data.mode;
      }
    }, function (response) {
      console.log(response);
    });
  },

  watch: {

    // '$route': 'getSatisfySetting'
  },
  methods: {
    // 打开视频
    openVideo: function openVideo(data) {
      if (!data.data) {
        return;
      }
      if (data.status == 'loading') {
        return;
      }
      this.videoUrl = data.data;
      this.isVideoShow = true;
    },

    // 关闭视频
    closeVideo: function closeVideo() {
      this.videoUrl = '';
      this.isVideoShow = false;
      this.$refs.videoModel.puse();
    },
    setTime: function setTime(time) {
      var go = new Date(time * 1).format("yyyy-MM-dd hh:mm:ss");
      return go;
    },
    handleBack: function handleBack() {
      var vm = this;
      vm.$store.state.im.endis = true;
      if (vm.imEntranceMode == 2) {
        vm.$router.replace({ path: 'imDirectory' });
      } else if (vm.imEntranceMode == 1) {
        vm.$router.replace({ path: 'imLineUp' });
      }
    },

    renderPage: function renderPage() {
      // 获取入口
      var vm = this;
      var path = this.$route.path;
      this.$store.state.im.messageList = [];
      clearInterval(this.$store.state.im.timer);

      // 获取公司的所有客服
      vm.$store.dispatch({
        type: 'initUserPool',
        visitorMd5Code: visitorMd5Code
      });

      // 创建socket

      this.$store.dispatch({
        type: 'createSocket',
        router: vm.$router,
        path: path,
        visitorMd5Code: sessionStorage.md5
      });

      var seq = this.$store.state.im.messageList[0] ? this.$store.state.im.messageList[0].seq : null;
      var sessionId = this.$store.state.im.messageList[0] ? this.$store.state.im.messageList[0].sessionId : null;
      var visitorMd5Code = sessionStorage.md5;

      this.$store.dispatch({
        type: 'getLastMessage',
        visitorMd5Code: sessionStorage.md5,
        router: vm.$router,
        offsetSeq: seq,
        sessionId: sessionId
      }).then(function () {
        // 获取到聊天记录之后获取自动回复配置
        console.log("去获取自动聊天消息");
        vm.$store.dispatch({
          type: 'getAutoReply',
          router: vm.$router,
          visitorMd5Code: sessionStorage.md5
        });

        vm.$store.dispatch({
          type: 'getHttp',
          visitorMd5Code: sessionStorage.md5
        });
      }).catch(function () {});
    },
    magnify: function magnify(data) {
      if (!data.data) {
        return;
      }
      if (data.status == 'loading') {
        return;
      }
      this.imgMasksrc = data.data;
      this.showImgMask = !this.showImgMask;
    },
    scrollToBottom: function scrollToBottom() {
      setTimeout(function () {
        var chat = document.getElementsByClassName('sessionContent')[0];
        chat.scrollTop = chat.scrollHeight;
      }, 100);
    },
    showEmotion: function showEmotion() {
      this.emotionFlag = !this.emotionFlag;
    },
    chooseEmotion: function chooseEmotion(item, index) {
      var vm = this;
      console.log(item);
      this.emotionFlag = !this.emotionFlag;
      //this.msgValue = item.code;
      //this.msgValue = this.replaceFace(item.code);
      // this.$store.dispatch({
      //   type: 'sendMessage',
      //   content: this.msgValue,
      //   contentType: Constants.TEXT_TYPE,
      //   visitorMd5Code: sessionStorage.md5
      // })

      // vm.msgValue = this.msgValue+item.code;
      vm.msgValue = this.msgValue + item.text;
    },

    //替换表情代码
    replaceFace: function replaceFace(con, isRelace) {
      // 如果是用户自己发的先把关键字符转义后再去匹配表情头像
      // console.log('con before replace',con.replace(/</g, '&lt;').replace(/>/g, '&gt;'))
      if (isRelace) {
        con = con.replace(/</g, '&lt;').replace(/>/g, '&gt;');
      }
      var _this = this;
      var exps = _this.Emotion;
      for (var i = 0; i < exps.length; i++) {
        con = con.replace(exps[i].reg, '<img class="faceImg1" src="' + exps[i].src + '" style="vertical-align: middle" alt=""  />');
      }
      console.log(con, 333);
      return con;
    },
    sendMsg: function sendMsg(value, event) {
      var vm = this;
      //console.log(this.msgValue,event)
      // 直接发送消息
      if (event.keyCode === 13 && !event.ctrlKey) {
        event.preventDefault();
        this.$store.dispatch({
          type: 'sendMessage',
          content: this.msgValue.replace(/\n/g, '<br>'),
          contentType: __WEBPACK_IMPORTED_MODULE_3__common_Constants__["a" /* TEXT_TYPE */],
          visitorMd5Code: sessionStorage.md5
        });
        vm.msgValue = '';
      } else if (event.keyCode === 13 && event.ctrlKey) {
        console.log(document.getElementsByTagName('textarea')[0], "document.getElementsByTagName('textarea')[0]");
        document.getElementsByTagName('textarea')[0].value = document.getElementsByTagName('textarea')[0].value + '\r';
        console.log(this.msgValue, "this.msgValue");
        return false;
        // this.$store.dispatch({
        //     type: 'sendMessage',
        //     content: this.msgValue.replace(/\n/g,'<br>'),
        //     contentType: Constants.TEXT_TYPE,
        //     visitorMd5Code: sessionStorage.md5
        //   })
      }
    },
    sendMsg2: function sendMsg2(value, event) {
      this.$store.dispatch({
        type: 'sendMessage',
        content: this.msgValue.replace(/\n/g, '<br>'),
        contentType: __WEBPACK_IMPORTED_MODULE_3__common_Constants__["a" /* TEXT_TYPE */],
        visitorMd5Code: sessionStorage.md5
      });
      this.msgValue = '';
    },
    showsatisfySetting: function showsatisfySetting() {
      this.$store.commit("setShowSatisfySettingFlag", true);
      this.$store.dispatch({
        type: 'getSatisfySettting',
        visitorMd5Code: sessionStorage.md5
      });
    },
    msgChange: function msgChange(newMsg) {
      var vm = this;
      vm.$store.dispatch({
        type: 'sendTransientMessage',
        contentType: __WEBPACK_IMPORTED_MODULE_3__common_Constants__["a" /* TEXT_TYPE */],
        content: '对方正在输入: ' + vm.replaceFace(newMsg),
        visitorMd5Code: sessionStorage.md5
      });
    },
    sendImgMsg: function sendImgMsg(event) {
      var vm = this;
      // console.log(event)
      var files = event.target.files;
      //console.log(files,"files")
      if (files.length > 3) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_element_ui__["Message"])({
          type: 'warning',
          message: '最多上传三个图片或视频'
        });
      }
      for (var index = 0; index < files.length; index++) {
        var ctm = new Date().getTime();
        var signId = '' + ctm + index;
        this.$store.dispatch({
          type: 'sendImgMsg',
          file: files[index],
          visitorMd5Code: sessionStorage.md5,
          signId: signId,
          status: 'load',
          ctm: ctm,
          callback: function callback() {
            console.log('-----callback');
            // 清空image选择框的值
            vm.$refs.imgfile.value = "";
          }
        });
      }
    },
    scorllTop: function scorllTop(event) {
      var event = event || window.event;
      //console.log(event.target.scrollTop,"event")
      //console.log(this.$store.state.im)
      if (event.target.scrollTop === 0) this.getHistorySession();
    },
    getHistorySession: function getHistorySession() {
      var vm = this;
      var seq = this.$store.state.im.messageList[0].seq;
      var sessionId = this.$store.state.im.messageList[0].sessionId;
      var visitorMd5Code = sessionStorage.md5;
      console.log(sessionId, seq, "ss", this.$store.state.im.messageList);
      if (sessionId && seq) {
        this.$store.dispatch({
          type: 'getLastMessage',
          visitorMd5Code: sessionStorage.md5,
          router: vm.$router,
          offsetSeq: seq,
          sessionId: sessionId
        });
      }
      //   axios.post(imUrl + '/confirmEvent/'+msgId+'?visitorMd5Code='+visitorMd5Code,obj).then((response) => {
      //         console.log(response, "向后台发送自动消息");
      //     }, (err) => {
      //         console.log(err)
      //     })
    }
  }
});

/***/ }),

/***/ "8nuq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9CKP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_question__ = __webpack_require__("Ozlq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_top_vue__ = __webpack_require__("CWUh");
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Top: __WEBPACK_IMPORTED_MODULE_1__common_top_vue__["a" /* default */]
  },
  data: function data() {
    return {
      content: ''
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      if (this.$route.query.type == 'swipe') {
        this.getSwipe();
      } else {
        this.getType();
      }
    },

    // 轮播图
    getSwipe: function getSwipe() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__api_question__["a" /* default */].getCrouselDetails({ visitorMd5Code: this.$route.query.v, id: this.$route.query.id }, function (res) {
        if (res.code === 1) {
          _this.content = res.data.replyContent;
        }
      });
    },

    // 问题类型
    getType: function getType() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__api_question__["a" /* default */].getTypeDetails({ visitorMd5Code: this.$route.query.v, id: this.$route.query.id }, function (res) {
        if (res.code === 1) {
          _this2.content = res.data.faq;
        }
      });
    }
  }
});

/***/ }),

/***/ "9Nd4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workerorderindex",
    on: {
      "scroll": _vm.scorllBottom
    }
  }, [_c('top'), _vm._v(" "), _c('div', {
    staticClass: "nav"
  }, [_c('router-link', {
    staticStyle: {
      "color": "rgb(31, 55, 61)"
    },
    attrs: {
      "to": _vm.urlb
    }
  }, [_c('span', {
    on: {
      "click": _vm.hisback
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('span', {
    staticClass: "navbread"
  }, [_vm._v(_vm._s('>' + _vm.questionclass))]), _vm._v(" "), _c('router-link', {
    staticClass: "btna color",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "to": {
        path: '/myorder'
      }
    }
  }, [_vm._v("我的工单")])], 1), _vm._v(" "), (_vm.orderdata.length == 0 && _vm.contentis && _vm.noGetListShow) ? _c('div', {
    staticClass: "noGetList"
  }, [_vm._v("\n    您还未提交工单哦~\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contentis),
      expression: "contentis"
    }],
    staticClass: "content"
  }, _vm._l((_vm.orderdata), function(item, index) {
    return _c('p', [_c('span', {
      staticClass: "tishi",
      attrs: {
        "id": 'd' + index
      }
    }, [_c('span', [_vm._v(_vm._s(item.orderName))]), _vm._v(" "), _c('a')]), _vm._v(" "), (item.orderName.length >= 6) ? _c('span', {
      staticStyle: {
        "width": "100px"
      },
      on: {
        "mouseenter": function($event) {
          $event.stopPropagation();
          _vm.block(index)
        },
        "mouseleave": function($event) {
          $event.stopPropagation();
          _vm.none(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.reversedMessage(item.orderName)))]) : _c('span', {
      staticStyle: {
        "width": "100px"
      }
    }, [_vm._v(_vm._s(item.orderName))]), _vm._v(" "), _c('span', {
      staticClass: "number"
    }, [_vm._v(_vm._s(item.processInstanceId))]), _vm._v(" "), (item.status == 10) ? _c('span', {
      staticClass: "cls"
    }, [_vm._v("已完成")]) : _c('span', {
      staticClass: "cls orange"
    }, [_vm._v("处理中")]), _vm._v(" "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.startTime))]), _vm._v(" "), _c('span', {
      staticClass: "im",
      on: {
        "click": function($event) {
          _vm.sessitem(item.orderName)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/workdetail?',
          query: {
            'id': item.processInstanceId
          }
        }
      }
    }, [_c('img', {
      staticStyle: {
        "display": "block",
        "margin-top": "15px"
      },
      attrs: {
        "src": __webpack_require__("PH0M")
      }
    })])], 1)])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginis),
      expression: "loginis"
    }],
    staticClass: "login"
  }, [_c('p', [_vm._v("手机号为查看单据处理结果的依据")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("手机号")]), _vm._v(" "), _c('el-input', {
    staticClass: "phonenumber",
    attrs: {
      "placeholder": "请输入手机号码"
    },
    on: {
      "blur": _vm.phonego
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.phoneis))])], 1), _vm._v(" "), _c('div', {
    staticClass: "mat"
  }, [_c('span', [_vm._v("随机码")]), _vm._v(" "), _c('el-input', {
    staticClass: "verify",
    attrs: {
      "placeholder": "短信随机码"
    },
    model: {
      value: (_vm.verify),
      callback: function($$v) {
        _vm.verify = $$v
      },
      expression: "verify"
    }
  }), _vm._v(" "), (_vm.verifyis) ? _c('span', {
    staticClass: "verifybtn",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    on: {
      "click": _vm.verifygo
    }
  }, [_vm._v("获取随机码")]) : _c('span', {
    staticClass: "verifybtn",
    style: ({
      backgroundColor: _vm.boxBodyColor
    })
  }, [_vm._v(_vm._s(_vm.timesecond + "s"))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.veris))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "color verbtn",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.verifyconfirm
    }
  }, [_vm._v("下一步")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9Xsi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "imSession"
  }, [_c('ImagePreview', {
    attrs: {
      "visible": _vm.showImgMask,
      "imagePreviewUrl": _vm.imgMasksrc
    },
    on: {
      "update:visible": function($event) {
        _vm.showImgMask = $event
      },
      "close": function($event) {
        _vm.showImgMask = false
      }
    }
  }), _vm._v(" "), (_vm.showSatisfySettingFlag) ? _c('mask-evaluation') : _vm._e(), _vm._v(" "), _c('im-top'), _vm._v(" "), _c('div', {
    staticClass: "sessionContent chat",
    on: {
      "scroll": _vm.scorllTop
    }
  }, [_c('ul', {
    staticClass: "chatUl"
  }, _vm._l((_vm.messageList), function(item, index) {
    return _c('div', {
      key: index
    }, [(item.type != 'EVENT' && !item.revoked) ? _c('div', {
      staticClass: "createtime"
    }, [_vm._v(_vm._s(_vm.setTime(item.time)))]) : _vm._e(), _vm._v(" "), (item.type != 'EVENT' && item.revoked) ? _c('div', {
      staticClass: "createtime",
      staticStyle: {
        "margin-bottom": "10px",
        "color": "#009688"
      }
    }, [_vm._v(_vm._s(_vm.setTime(item.time) + '  ' + '消息已被撤回'))]) : _vm._e(), _vm._v(" "), (item.sendFrom != _vm.visitorMd5Code && item.type != 'EVENT' && !item.revoked) ? _c('li', {
      staticClass: "chat-mine"
    }, [_c('div', {
      staticClass: "chat-user"
    }, [_c('img', {
      staticClass: "headerImg",
      attrs: {
        "src": item.head
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wraper"
    }, [_c('span', {
      staticClass: "userNickName",
      domProps: {
        "textContent": _vm._s(item.userNickName)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "chatContent",
      class: {
        'nobg': item.type === 'IMAGE' || item.type === 'VIDEO'
      }
    }, [(item.type !== 'WORK_ORDER') ? _c('div', {
      staticClass: "chat-text",
      class: {
        'nobg': item.type === 'IMAGE' || item.type === 'VIDEO'
      }
    }, [(item.type === 'TEXT') ? _c('div', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (_vm.replaceFace(item.data)),
        expression: "replaceFace(item.data)"
      }],
      staticClass: "chat-text-Con"
    }) : (item.type === 'IMAGE') ? _c('img', {
      staticClass: "imgP",
      attrs: {
        "src": item.data
      },
      on: {
        "click": function($event) {
          _vm.magnify(item)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.type === 'WORK_ORDER') ? _c('div', {
      staticClass: "chat-text1"
    }, [_c('div', {
      ref: "wraporder",
      refInFor: true
    }, [_c('div', {
      staticClass: "order"
    }, [(!item.toDo) ? _c('work-order', {
      attrs: {
        "msgId": item.msgId,
        "workOrderId": item.data
      }
    }) : _vm._e()], 1)])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (item.sendFrom == _vm.visitorMd5Code) ? _c('li', {
      staticClass: "chat-mine2"
    }, [_c('div', {
      staticClass: "chatContent2",
      class: {
        'nobg': item.type === 'IMAGE' || item.type === 'VIDEO'
      }
    }, [_c('div', {
      staticClass: "chat-text2",
      class: {
        'imgEmpty': (item.type === 'IMAGE' || item.type === 'VIDEO') && !item.data, 'nobg': item.type === 'IMAGE' || item.type === 'VIDEO'
      }
    }, [(item.type === 'TEXT') ? _c('div', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (_vm.replaceFace(item.data, true)),
        expression: "replaceFace(item.data, true)"
      }],
      staticClass: "chat-Con"
    }) : (item.type === 'IMAGE') ? _c('div', {
      staticClass: "img-box"
    }, [(item.status == 'loading') ? _c('i', {
      staticClass: "el-icon-loading loading-icon"
    }) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "imgP",
      attrs: {
        "src": item.data
      },
      on: {
        "click": function($event) {
          _vm.magnify(item)
        }
      }
    })]) : (item.type == 'VIDEO') ? _c('div', [_c('div', {
      staticClass: "more-dialog video-container"
    }, [(item.status == 'loading') ? _c('i', {
      staticClass: "el-icon-loading loading-icon"
    }) : (item.data) ? _c('i', {
      staticClass: "player-icon icon iconfont icon-bofang"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "masking-out",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.openVideo(item)
        }
      }
    }), _vm._v(" "), (item.status == 'loading') ? _c('img', {
      attrs: {
        "src": item.data,
        "width": "100%",
        "height": "100%",
        "alt": ""
      }
    }) : (item.data) ? _c('img', {
      attrs: {
        "src": item.data.split('?')[0] + '?x-oss-process=video/snapshot,t_1,f_jpg,m_fast,ar_auto',
        "width": "100%",
        "height": "100%",
        "alt": ""
      }
    }) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "chat-user2"
    }, [_c('img', {
      staticClass: "headerImg",
      attrs: {
        "src": _vm.imgUrl + 'user_pic@2x.png'
      }
    })])]) : _vm._e()])
  })), _vm._v(" "), (_vm.emotionFlag) ? _c('div', {
    staticClass: "emotions"
  }, [_c('div', {
    staticClass: "imgwraper"
  }, _vm._l((_vm.Emotion), function(imgItem, imgIndex) {
    return _c('div', {
      key: imgIndex,
      staticClass: "emotion"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(imgItem.text)
      },
      on: {
        "click": function($event) {
          _vm.chooseEmotion(imgItem, imgIndex)
        }
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "triangle"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.endis),
      expression: "endis"
    }],
    staticClass: "sessionInput"
  }, [_c('div', {
    staticClass: "img_icon_box"
  }, [_c('img', {
    staticClass: "img_icon_btn",
    class: {
      'hidden': _vm.isIE
    },
    attrs: {
      "src": _vm.imgUrl + 'hh_icon_bq.png',
      "alt": "表情icon"
    },
    on: {
      "click": _vm.showEmotion
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img_icon_btn",
    attrs: {
      "src": _vm.imgUrl + 'hh_icon_tp.png',
      "alt": "表情icon"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img_icon_btn",
    attrs: {
      "src": _vm.imgUrl + 'hh_icon_pj.png',
      "alt": "表情icon"
    },
    on: {
      "click": _vm.showsatisfySetting
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "a-upload",
    class: {
      'a-upload-left': _vm.isIE
    }
  }, [_c('input', {
    ref: "imgfile",
    attrs: {
      "type": "file",
      "name": "file",
      "id": "file",
      "accept": "image/gif,image/jpeg,image/jpg,image/png,image/svg, video/*",
      "multiple": ""
    },
    on: {
      "change": _vm.sendImgMsg
    }
  })])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msgValue),
      expression: "msgValue"
    }],
    staticClass: "input_content",
    staticStyle: {
      "height": "50px",
      "width": "97%",
      "resize": "none"
    },
    attrs: {
      "maxlength": "140"
    },
    domProps: {
      "value": (_vm.msgValue)
    },
    on: {
      "keydown": function($event) {
        _vm.sendMsg(_vm.msgValue, $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.msgValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "CtrEnt"
  }, [_vm._v("按下Ctrl+Enter换行")]), _vm._v(" "), _c('span', {
    staticClass: "sendMsg",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    on: {
      "click": function($event) {
        _vm.sendMsg2(_vm.msgValue, $event)
      }
    }
  }, [_vm._v("发送")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.endis == false),
      expression: "endis==false"
    }],
    staticClass: "sessionInput endclass"
  }, [_vm._v("\n          对话已结束，您可以点击 "), _c('a', {
    staticStyle: {
      "color": "#319bf3",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.handleBack
    }
  }, [_vm._v(" 开始新的会话")])]), _vm._v(" "), (_vm.isVideoShow) ? _c('div', {
    staticClass: "video-dialog"
  }, [_c('div', {
    staticClass: "video-close",
    on: {
      "click": _vm.closeVideo
    }
  }, [_c('i', {
    staticClass: "el-icon-close"
  })]), _vm._v(" "), _c('div', {
    staticClass: "video-content"
  }, [_c('VideoModel', {
    attrs: {
      "src": _vm.videoUrl
    }
  })], 1)]) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9fQ6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9isF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AKmP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AOEC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("nu1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45bd1e9f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Rxg0");
function injectStyle (ssrContext) {
  __webpack_require__("sSub")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45bd1e9f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AW1S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C8UV":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAaCAYAAACtv5zzAAACYklEQVRIibXVTYiNURgH8N/cueQjM4bxeYVmoXzkK2mahIWMUiSxkShfccNdsrGWjevjCrMhIcpKyeRrQQoLEwrZUK6FhRgWQ74W573N63Xv7Y6uf90653nu+f/Pec5z/m/Dx64xBoAWHMRZ3Id8MVt1QWoA5IvwDNvRV+uiWgXW4zYmRvNR9RRYjvMYFIvNrpfAKFxAOhFvr7QglymMHYjAAYwuE1+pv1xJXM5lCqsrCRwSOgWasK0CyTB0448WzGUK87AEXblMoaWcQAeuCiXZEBFVwizcyGUKgyPykcJdiYT3QkPiHbzDhCi5BkurCJSwFm9wDtNj8feYGL+8mRE5bFJ7pxxBBg2J+Fh0xAV2x8Zz1f5GJlXJLSuRLMCWWGIgL7wa5qQwFJf83ev1wPQUNqPtP5BDaxrrEsEHeCt0B5wU7KINd3BTeOEbcTf6bwmTYuugOYX5CYHrOB6b78dTHEYnXgh2PQ/XcC1fzOaicU+CqzGN5jJH+45P0fgXvgm2cQQ78QMzMDmKT8VpTEnwfErjM0YkEvcwMjZ/hy9YXNqZ0MqvymwujgcpPC6TaMfr6Nck1DwtfHBKeBmdoBoupXEltrMShug/bioS2SWU5yGeC/awowr5e1xs3Ldq+DPBGpqixFeMx8Jo3is45EbBxJ5E4l1CZ/1qb3r0Vei0oTGBrflitqdkdp1CF9TrBZ/IF7NZMcJuoQQ/60B+EntKk7g9nBIu9SzG/QNxL/bmi9kz8WCyJN2CbR8T7qIW9OEopiXJ+fuDE0erYCMrhJ7PCP3/TTjpY9zClXwx+6ESyW+VEH7d2Z6A6gAAAABJRU5ErkJggg=="

/***/ }),

/***/ "CR08":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CWUh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_top_vue__ = __webpack_require__("InYd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_078819b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_top_vue__ = __webpack_require__("Xm1c");
function injectStyle (ssrContext) {
  __webpack_require__("yV2n")
  __webpack_require__("9fQ6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-078819b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_top_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_078819b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_top_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Cvyk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__url_js__ = __webpack_require__("vpRr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_request_js__ = __webpack_require__("vLgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__workorder_top_vue__ = __webpack_require__("3XGK");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'workcommit',
  components: {
    top: __WEBPACK_IMPORTED_MODULE_4__workorder_top_vue__["a" /* default */]
  },
  data: function data() {
    return {
      paixu: [],
      boxBodyColor: '',
      logoUrl: '',
      companyName: '',
      displayMode: '',
      btnclass: 2,
      btnis: false,
      urlbridge: "",
      videobridge: "",
      jishi: 5,
      kefuis: false,
      action: '',
      phone: "",
      phoneis: "",
      veris: '',
      verify: "",
      verifyis: true,
      timesecond: 60,
      basurl: __WEBPACK_IMPORTED_MODULE_2__url_js__["a" /* baseurl */],
      md5: "",
      href: "",
      showdata: [],
      erroris: false,
      successis: false,
      downloadis: false,
      loginis: false,
      contentis: false,
      pickerOptions0: {
        // disabledDate(time) {
        //   return time.getTime() < Date.now() - 8.64e7;
        // }
      },
      indexUrl: '',
      commitis: false,
      datetime: {},
      datetimes: {},
      hourtime: {},
      phonenumver: {},
      number: {},
      idcard: {},
      email: {},
      fileList2: {},
      fileVideoList: {},
      allquestion: [],
      questionclass: [],
      gamearea: {},
      gamevalue: {},
      dns: {},
      explain: {},
      sex: {},
      sexlabel: {},
      hobbys: [{ value: "运动", is: false }, { value: "宅", is: false }, { value: "电影", is: false }, { value: "美食", is: false }, { value: "DIY", is: false }],
      checkedCities1: {},
      cities: {},
      parmas: [],
      submittable: {},
      picid: {},
      homeType: -1
    };
  },
  mounted: function mounted() {
    var vm = this;
    vm.boxBodyColor = sessionStorage.getItem('boxBodyColor');
    vm.companyName = sessionStorage.getItem('companyName');
    vm.md5 = sessionStorage.getItem('md5');
    vm.logoUrl = sessionStorage.getItem('logoUrl');
    vm.displayMode = sessionStorage.getItem('displayMode');
    this.questionclass = [];

    setTimeout(function () {
      console.log(sessionStorage.getItem("navname"));
      var navname = sessionStorage.getItem("navname");
      navname && vm.questionclass.push(navname);
      vm.questionclass.push("单据提交");
    }, 100);

    this.homeType = sessionStorage.getItem('redirectTarget');
    this.href = this.$route.query.id;
    if (this.href == "butianinfor") {
      this.butianinfor();
    } else {
      this.showis();
    }

    this.indexUrl = sessionStorage.getItem('indexUrl');
    if (this.indexUrl) {
      vm.indexUrl += '?v=' + this.md5;
    }
    //判断客服是否显示
    __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.formFields + '/api/visitor/product/conf/showOnlineService?visitorMd5Code=' + this.md5).then(function (response) {
      if (response.data.code == 1) {
        vm.kefuis = true;
      }
    });
    // const workOrder = JSON.parse(sessionStorage.getItem('butianinfor'))
    if (this.homeType == 5) {
      if (this.$route.query.source == 'type') {
        this.$Points.point({ code: '1005', type: '3', id: this.$route.query.id });
      } else if (this.$route.query.source == 'ai') {
        this.$Points.point({ code: '1005', type: '1', id: this.$route.query.id });
      }
    }
  },

  methods: {
    //判断跳转页面
    kefugo: function kefugo() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/product/conf/redirectToOnlineService?visitorMd5Code=' + this.md5).then(function (response) {

        if (response.data.code == 1) {
          var obj = response.data.data;

          if (obj.imStatus == "waiting") {
            vm.$router.replace({ path: 'imLineUp' });
            //window.location.href="#/imLineUp";
          } else if (obj.imStatus == "chatting") {
            vm.$router.replace({ path: 'imSession' });
            //window.location.href="#/imSession";
          } else {
            if (obj.target == 1) {
              //window.location.href="#/spirit";
              vm.$router.replace({ path: 'spirit' });
              console.log('已经跳转了');
            }
            if (obj.target == 2) {
              vm.$router.replace({ path: 'imDirectory' });
              //window.location.href="#/imDirectory";
            }
          }
        }
      });
    },

    //加入判断是否已经添加
    datacommitis: function datacommitis(name, value, id) {
      var vm = this;
      var is = true;
      // console.log(name,value,id, this.parmas, '66666')
      this.parmas.forEach(function (item, index) {
        if (item.id == name) {
          item.value = value;
          //vm.commitis=true;
          vm.submittable[id] = true;
          document.getElementById(id).innerHTML = " ";
        }
      });
      console.log('is：', is);
      return is;
    },

    //改变级联的值
    changedata: function changedata(item, id) {
      var vm = this;
      if (item.parentId != null && item.parentId != "" && item.parentId != undefined && item.parentId != " ") {
        //vm.$set( vm.gamearea,obj.id,arr);
        //vm.$set( vm.gamevalue,obj.id,obj.defaultContent);
        console.log(vm.gamevalue[item.parentId]);
        if (vm.gamevalue[item.parentId] != "") {
          __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/dataDicList/' + item.id + '?visitorMd5Code=' + this.md5 + "&parentId=" + vm.gamevalue[item.parentId]).then(function (response) {
            if (response.data.code == 1) {
              console.log(response);
              // console.log(vm.gamearea[obj.id])
              // console.log(vm.gamearea)
              var arrdata = response.data.data;
              //console.log(arrdata)
              var arr = [];
              arrdata.forEach(function (element, index) {
                var obj = {};
                obj.value = element.id;
                obj.label = element.content;
                arr.push(obj);
              });
              //console.log(arr)
              vm.gamearea[item.id] = [];
              vm.$set(vm.gamearea, item.id, arr);
              vm.$set(vm.gamevalue, item.id, vm.gamevalue[item.id]);
              // console.log(vm.gamevalue)
            }
          });
        }
      }
    },

    //清空父节点
    clearparnt: function clearparnt(item) {
      var vm = this;
      //console.log(item.id);
      this.showdata.forEach(function (element, index) {
        if (element.parentId == item.id) {
          //console.log(element);
          var arr = [];
          //vm.gamearea[element.id]=arr;
          vm.$set(vm.gamearea, element.id, arr);
          vm.$set(vm.gamevalue, element.id, "");
          //console.log(vm.gamearea)
        }
      });
    },

    //收集这个值
    datacommit: function datacommit(value, item) {
      var typeid = item.typeId;
      //console.log(item.maxLength)
      var length = item.maxLength;
      var require = item.required;
      var name = item.name;
      var spanid = item.spanid;
      if (typeid == 3) {
        var _now = new Date(value);
        var year = _now.getFullYear();
        var month = (_now.getMonth() + 1).toString();
        var day = _now.getDate().toString();
        if (month.length == 1) {
          month = "0" + month;
        }
        if (day.length == 1) {
          day = "0" + day;
        }
        value = year + "-" + month + "-" + day;
        //console.log(value)
      }
      if (typeid == 16) {
        var _now2 = new Date(value);
        var _year = _now2.getFullYear();
        var _month = (_now2.getMonth() + 1).toString();
        var _day = _now2.getDate().toString();
        var hours = _now2.getHours();
        var minutes = _now2.getMinutes();
        if (_month.length == 1) {
          _month = "0" + _month;
        }
        if (_day.length == 1) {
          _day = "0" + _day;
        }
        if (hours.length == 1) {
          hours = "0" + hours;
        }
        if (minutes.length == 1) {
          minutes = "0" + minutes;
        }
        value = _year + "-" + _month + "-" + _day + " " + hours + ":" + minutes;
        //console.log(value)
      }
      if (typeid == 4) {
        var now = new Date(value);
        var hour = now.getHours();
        var minute = now.getMinutes();
        if (hour < 10) {
          hour = "0" + hour;
        }
        if (minute < 10) {
          minute = "0" + minute;
        }
        value = hour + ":" + minute;
        //console.log(value)
      }
      //console.log(value+"/"+typeid);
      var valueis = false;
      var obj = {};
      //单选和多选框
      if (typeid == 1 || typeid == 2) {
        //console.log(value.replace(/(^s*)|(s*$)/g, ""))
        if (value.length > length || value == undefined || value == '' || value.match(/^[ ]+$/)) {
          valueis = false;
        } else {
          valueis = true;
        }
        console.log(value);
        if (require == false && (value == undefined || value == '' || value == ' ' || value.match(/^[ ]+$/))) {
          valueis = true;
        }
        if (valueis == false) {
          var message = '请输入长度为1~' + length + '字符';
          document.getElementById(spanid).innerHTML = message;
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.id = item.id;
            this.parmas.push(obj);
          }
          this.submittable[spanid] = true;
          document.getElementById(spanid).innerHTML = " ";
        }
      }
      //日期框
      if (typeid == 3) {

        if (value == "NaN-NaN-NaN") {
          valueis = false;
        } else {
          valueis = true;
        }
        if (require == false && value == "NaN-NaN-NaN") {
          valueis = true;
        }

        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "*必填项";
          this.submittable[spanid] = false;
          valueis = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.id = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = " ";
          }
          valueis = true;
        }
      }
      if (typeid == 16) {
        if (value == "NaN-NaN-NaN NaN:NaN") {
          valueis = false;
        } else {
          valueis = true;
        }
        if (require == false && value == "NaN-NaN-NaN NaN:NaN") {
          valueis = true;
        }

        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "*必填项";
          this.submittable[spanid] = false;
          valueis = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          console.log(value, is, '=========222==========');
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.id = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = "";
          }
          //  valueis=true;
        }
      }
      //时间框判断
      if (typeid == 4) {

        if (value == "NaN:NaN") {
          valueis = false;
        } else {
          valueis = true;
        }
        if (require == false && value == "NaN:NaN") {
          valueis = true;
        }

        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "*必填项";
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.id = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = " ";
          }
        }
      }
      // 手机号验证
      if (typeid == 5) {
        var phoneis = /^1\d{10}$/.test(value);
        if (phoneis == false) {
          valueis = false;
        } else {
          valueis = true;
        }
        console.log(value);
        if (require == false && (value == undefined || value == '')) {
          valueis = true;
        }
        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "请输入正确的手机号";
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.id = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = " ";
          }
        }
      }
      // 数字文本框
      if (typeid == 6) {
        var numberis = /^\d+$/.test(value);
        if (numberis == false) {
          valueis = false;
        } else {
          if (value.length > length) {
            valueis = false;
          } else {
            valueis = true;
          }
        }

        if (require == false && (value == undefined || value == '')) {
          valueis = true;
        }
        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "请输入长度为1~" + length + "的数字";
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.id = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = " ";
          }
        }
      }
      // 身份证文本框

      if (typeid == 7) {
        var idcardis = /^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/.test(value);
        if (idcardis == false) {
          valueis = false;
        } else {
          valueis = true;
        }
        if (require == false && (value == undefined || value == '')) {
          valueis = true;
        }
        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "请输入正确的身份证号";
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.id = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = " ";
          }
        }
      }

      //邮箱地址
      if (typeid == 8) {
        var emlis = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/.test(value);
        if (emlis == false) {

          valueis = false;
        } else {
          if (value != undefined) {
            if (value.length > length) {
              valueis = false;
            } else {
              valueis = true;
            }
          }
        }
        console.log(value);
        if (require == false && (value == undefined || value == '')) {
          valueis = true;
        }
        if (length != null) {
          var text = "请输入" + length + "位以内正确的邮箱地址";
        } else {
          var text = "请输入正确的邮箱地址";
        }

        if (valueis == false) {
          document.getElementById(spanid).innerHTML = text;
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.id = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = " ";
          }
        }
      }
      //文件上传
      if (typeid == 9) {
        this.urlbridge = item;
        //obj[name]=value;
        //this.parmas.push(obj)
      }
      if (typeid == 15) {
        this.videobridge = item;
      }

      //下拉框
      if (typeid == 12) {
        var vname = "";
        console.log(value, '呵呵哒3', this.gamearea[item.id]);
        this.gamearea[item.id].forEach(function (element, index) {
          if (element.value == value) {
            vname = element.label;
            value = vname;
          }
        });
        if (value != undefined && value != '') {
          valueis = true;
        } else {
          valueis = false;
        }

        if (require == false) {
          valueis = true;
        }

        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "*必填项";
          this.submittable[spanid] = false;
        } else {
          this.clearparnt(item);
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.id = item.id;
            this.parmas.push(obj);
            console.log(this.parmas, 'ca');
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = " ";
          }
        }
      }
      //单选框
      if (typeid == 13) {
        console.log(value, "单选");
        if (value != undefined && value != '') {
          valueis = true;
        } else {
          valueis = false;
        }
        if (require == false) {
          valueis = true;
        }
        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "*必填项";
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.id = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = " ";
          }
        }
      }
      //多选框
      if (typeid == 14) {
        console.log(value, '多选框2222222');
        if (value.length > 0) {
          valueis = true;
        } else {
          valueis = false;
        }
        if (require == false) {
          valueis = true;
        }
        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "*必填项";
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          console.log(this.parmas, '多选的东怀牛膝啊', is);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.id = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = " ";
          }
        }
      }
      var comit = true;
      var dataobj = this.submittable;
      //console.log(dataobj)
      for (var key in dataobj) {

        if (dataobj[key] == false) {
          comit = false;
        }
      }
      if (comit == true) {
        this.btnclass = 1;
      }
      // if(valueis==false){

      //   this.commitis=false;
      // }else{
      //   this.commitis=true;
      // }
      //console.log(this.commitis)
    },
    heightlight: function heightlight(index) {
      var is = this.hobbys[index].is;
      if (is) {
        this.hobbys[index].is = false;
      } else {
        this.hobbys[index].is = true;
      }
    },
    videoBeforeload: function videoBeforeload(file) {
      console.log(file);
      var typeis = false;

      // var arr=file.name.split(".");
      var type = file.type;
      //console.log(type)
      if (/^video\/.*$/.test(type)) {
        typeis = true;
      }
      if (typeis == false) {
        this.$message.error('文件格式不正确');
        return false;
      }
      if (file.size / 1024 > 1024 * 500) {
        this.$message.error('文件大于500M');
        return false;
      }
    },
    beforeload: function beforeload(file) {
      console.log(file);
      var typeis = false;

      // var arr=file.name.split(".");
      var type = file.type;
      //console.log(type)
      if (/(gif|jpg|jpeg|bmp|png)$/.test(type)) {
        typeis = true;
      }
      if (typeis == false) {
        this.$message.error('文件格式不正确');
        return false;
      }
      if (file.size / 1024 > 1024 * 9) {
        this.$message.error('文件大于9M');
        return false;
      }
    },
    handleRemove: function handleRemove() {
      var vm = this;
      //alert(1)
      //console.log(this.urlbridge)
      // if(this.urlbridge==""){
      //   this.urlbridge=obj;
      // }
      vm.$set(vm.picid, this.urlbridge.id, true);
      //console.log( this.picid)
      //document.getElementById(this.urlbridge.spanid+"a").style.display ="block";
      if (this.urlbridge.required == true) {
        document.getElementById(this.urlbridge.spanid).innerHTML = "*必填项";
        this.submittable[this.urlbridge.spanid] = false;
      }
      this.urlbridge = " ";
    },
    handleVideoRemove: function handleVideoRemove() {
      var vm = this;
      vm.$set(vm.picid, this.videobridge.id, true);
      //console.log( this.picid)
      //document.getElementById(this.videobridge.spanid+"a").style.display ="block";
      this.$set(this.fileVideoList, this.videobridge.id, []);
      if (this.videobridge.required == true) {
        document.getElementById(this.videobridge.spanid).innerHTML = "*必填项";
        this.submittable[this.videobridge.spanid] = false;
      }
      this.videobridge = " ";
    },
    handlePreview: function handlePreview(response, file, fileList) {
      console.log(response, file, fileList);
      if (response.code == 1) {
        var vm = this;
        //document.getElementById(this.urlbridge.spanid+"a").style.display ="none";
        vm.$set(vm.picid, this.urlbridge.id, false);
        //this.picid[this.urlbridge.id]=false;
        console.log(this.picid);
        document.getElementById(this.urlbridge.spanid).innerHTML = " ";
        var is = this.datacommitis(this.urlbridge.id, response.data, this.urlbridge.spanid);
        if (is) {
          this.submittable[this.urlbridge.spanid] = true;
          var obj = {};
          obj.name = this.urlbridge.name;
          obj.id = this.urlbridge.id;
          obj.value = response.data;
          this.parmas.push(obj);
          var comit = true;
          var dataobj = this.submittable;
          console.log(dataobj);
          for (var key in dataobj) {

            if (dataobj[key] == false) {
              comit = false;
            }
          }
          if (comit == true) {
            this.btnclass = 1;
          }
        }
      }
    },
    handleVideoPreview: function handleVideoPreview(response, file, fileList) {
      console.log(this.picid[this.videobridge.id]);
      console.log(response);
      if (response.code == 1) {
        var vm = this;
        //document.getElementById(this.videobridge.spanid+"a").style.display ="none";
        vm.$set(vm.picid, this.videobridge.id, false);
        //this.picid[this.videobridge.id]=false;
        console.log(this.picid);
        document.getElementById(this.videobridge.spanid).innerHTML = " ";
        var is = this.datacommitis(this.videobridge.id, response.data, this.videobridge.spanid);
        var obj = {};
        obj.name = this.videobridge.name;
        obj.id = this.videobridge.id;
        obj.value = response.data;
        obj.url = response.data && response.data.split('?') ? response.data.split('?')[0] + '?x-oss-process=video/snapshot,t_1,f_jpg,m_fast,ar_auto' : '';
        this.$set(this.fileVideoList, this.videobridge.id, [obj]);
        if (is) {
          this.submittable[this.videobridge.spanid] = true;
          this.parmas.push(obj);
          var comit = true;
          var dataobj = this.submittable;
          for (var key in dataobj) {

            if (dataobj[key] == false) {
              comit = false;
            }
          }
          if (comit == true) {
            this.btnclass = 1;
          }
        }
      }
    },
    commit: function commit() {
      var vm = this;
      var comit = true;
      var dataobj = this.submittable;

      for (var key in dataobj) {

        if (dataobj[key] == false) {
          comit = false;
        }
      }

      if (comit == true) {
        var obj = {};
        obj.orderId = this.href;
        var arr = [];

        this.parmas.forEach(function (element, index) {
          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(element.value) == "object") {
            var str = element.value.join(",");
            element.value = str;
          }
        });
        //排序
        var l = this.parmas.length;

        this.paixu.forEach(function (element, index) {
          var haveis = false;
          for (var i = 0; i < l; i++) {
            if (vm.parmas[i].id == element.id) {
              var obj = {};
              obj.fieldId = vm.parmas[i].id;
              obj.name = vm.parmas[i].name;
              obj.value = vm.parmas[i].value;
              haveis = true;
              arr.push(obj);
            }
          }
          if (haveis == false) {
            if (element.typeId == 14) {
              var obj2 = {};
              obj2.fieldId = element.id;
              obj2.name = element.name;
              obj2.value = element.defaultContent;
              arr.push(obj2);
            } else {
              var obj = {};
              obj.fieldId = element.id;
              obj.name = element.name;
              obj.value = "";
              arr.push(obj);
            }
          }
        });

        obj.variables = arr;
        // console.log(this.parmas)
        // console.log(this.paixu)
        console.log(obj.variables, '提交的东西');
        __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].post(this.basurl + '/api/visitor/wo/submitOrder?visitorMd5Code=' + this.md5, obj).then(function (response) {
          //console.log(response)
          if (response.data.code == 1) {
            if (vm.homeType == 5) {
              if (vm.$route.query.source == 'type') {
                vm.$Points.point({ code: '1005', type: '4', id: vm.$route.query.id });
              } else if (vm.$route.query.source == 'ai') {
                vm.$Points.point({ code: '1005', type: '2', id: vm.$route.query.id });
              }
            }
            if (response.data.message == "OK") {
              vm.successis = true;
              vm.contentis = false;
              var tme = setInterval(function () {
                vm.jishi = vm.jishi - 1;
                if (vm.jishi == 0) {
                  if (vm.homeType == 5) {
                    vm.$router.replace({ path: 'aiInteractive', query: { v: vm.md5 } });
                  } else {
                    vm.$router.replace({ path: 'workerorderindex' });
                  }
                  //window.location.href="#/workerorderindex";
                  clearInterval(tme);
                }
              }, 1000);
            } else {
              vm.erroris = true;
              vm.contentis = false;
              var tme = setInterval(function () {
                vm.jishi = vm.jishi - 1;
                if (vm.jishi == 0) {
                  if (vm.homeType == 5) {
                    vm.$router.replace({ path: 'aiInteractive', query: { v: vm.md5 } });
                  } else {
                    vm.$router.replace({ path: 'workerorderindex' });
                  }
                  clearInterval(tme);
                }
              }, 1000);
            };
          } else if (response.data.code == 400) {
            vm.erroris = true;
            vm.contentis = false;
            var tme = setInterval(function () {
              vm.jishi = vm.jishi - 1;
              if (vm.jishi == 0) {
                if (vm.homeType == 5) {
                  vm.$router.replace({ path: 'aiInteractive', query: { v: vm.md5 } });
                } else {
                  vm.$router.replace({ path: 'workerorderindex' });
                }
                clearInterval(tme);
              }
            }, 1000);
          }
        });
      } else {
        this.$message({
          message: '数据填写错误',
          type: 'warning'
        });
      }

      // window.location.href="/#/workdetail"
    },

    //
    butianinfor: function butianinfor() {
      var vm = this;
      var obj = JSON.parse(sessionStorage.getItem('butianinfor'));
      __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/processInstanceFields/' + obj.processInstanceId + '?visitorMd5Code=' + this.md5).then(function (response) {
        if (response.data.code = 1) {
          vm.show(response.data, 2);
        };
      });
      //console.log(obj)
    },

    //展示数据
    show: function show(data, index) {
      var arrda = data.data;
      var vm = this;
      console.log(arrda, '展示数据');
      arrda.forEach(function (item, index) {
        vm.paixu.push(item);
        item.spanid = 'ziduan' + index;
        if (item.typeId == 9 || item.typeId == 15) {
          vm.$set(vm.picid, item.id, true);
          //console.log(vm.picid)
        }
        // 用来判断对应数据是否有值  控制提交按钮的能用与否
        if (item.required == true && (item.typeId == 12 || item.typeId == 13 || item.typeId == 14) && item.defaultContent == '' || item.required == true && !(item.typeId == 12 || item.typeId == 13 || item.typeId == 14) && !item.enteredValue) {
          vm.submittable[item.spanid] = false;
        } else {
          vm.submittable[item.spanid] = true;
        }

        vm.showdata.push(item);
        vm.datacollect(item);
      });
      //console.log(this.submittable)
      //console.log(arrda,"555")
      //console.log(vm.paixu)
    },

    // 本地测试用的一个表单数据
    getDataJson: function getDataJson() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (r) {
        r({
          data: { "code": 1, "message": "OK", "timestamp": "1636358735165", "data": [{ "id": "416", "name": "手机号", "comId": "1029", "formId": "211", "typeId": "5", "sort": 0, "required": true, "defaultContent": "", "maxLength": 11, "gmtCreate": 1504090685000, "gmtModified": 1504090685000, "parentId": null, "cloudLocalId": null, "enteredValue": null }, { "id": "415", "name": "姓名", "comId": "1029", "formId": "211", "typeId": "1", "sort": 1, "required": true, "defaultContent": "", "maxLength": 5, "gmtCreate": 1504090676000, "gmtModified": 1504090676000, "parentId": null, "cloudLocalId": null, "enteredValue": null }, { "id": "2041", "name": "请输入需要修改的账号", "comId": "1029", "formId": "211", "typeId": "1", "sort": 2, "required": false, "defaultContent": "账号", "maxLength": 20, "gmtCreate": 1541389678000, "gmtModified": 1541389678000, "parentId": null, "cloudLocalId": null, "enteredValue": null }, { "id": "1834", "name": "地址", "comId": "1029", "formId": "211", "typeId": "1", "sort": 3, "required": false, "defaultContent": "", "maxLength": 50, "gmtCreate": 1523185695000, "gmtModified": 1523185695000, "parentId": null, "cloudLocalId": null, "enteredValue": null }, { "id": "1964", "name": "上传图片", "comId": "1029", "formId": "211", "typeId": "9", "sort": 4, "required": false, "defaultContent": "", "maxLength": 1, "gmtCreate": 1529397616000, "gmtModified": 1529397616000, "parentId": null, "cloudLocalId": null, "enteredValue": null }, { "id": "2169", "name": "服务器ID", "comId": "1029", "formId": "211", "typeId": "1", "sort": 5, "required": true, "defaultContent": "", "maxLength": 30, "gmtCreate": 1636094694000, "gmtModified": 1636094694000, "parentId": null, "cloudLocalId": null, "enteredValue": "1999" }, { "id": "2171", "name": "服务器名称", "comId": "1029", "formId": "211", "typeId": "1", "sort": 6, "required": true, "defaultContent": "", "maxLength": 30, "gmtCreate": 1636094751000, "gmtModified": 1636094751000, "parentId": null, "cloudLocalId": null, "enteredValue": "华北网通一区-痘痘龙" }, { "id": "2170", "name": "角色ID", "comId": "1029", "formId": "211", "typeId": "1", "sort": 7, "required": true, "defaultContent": "", "maxLength": 30, "gmtCreate": 1636094731000, "gmtModified": 1636094731000, "parentId": null, "cloudLocalId": null, "enteredValue": "17855444" }, { "id": "2172", "name": "角色名称", "comId": "1029", "formId": "211", "typeId": "1", "sort": 8, "required": true, "defaultContent": "", "maxLength": 30, "gmtCreate": 1636094775000, "gmtModified": 1636094775000, "parentId": null, "cloudLocalId": null, "enteredValue": "小宝贝" }] }
        });
      });
    },

    //判断是否授权
    showis: function showis() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/formFields/' + this.href + '?visitorMd5Code=' + this.md5).then(function (response) {
        // this.getDataJson().then(function(response){
        var da = response.data;
        if (da.code == 1) {
          vm.loginis = false;
          vm.contentis = true;
          vm.show(da, 1);
        } else if (da.code == 401) {
          vm.contentis = false;
          vm.loginis = true;
        }
      });
    },

    //手机验证
    verifyconfirm: function verifyconfirm() {
      //console.log( this.verify)
      var vm = this;
      vm.veris = "";
      if (this.verify != "" && this.btnis == true) {
        __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].post(this.basurl + '/api/visitor/wo/msgCaptchaValid?visitorMd5Code=' + this.md5 + "&phoneNum=" + this.phone + "&code=" + this.verify).then(function (response) {
          if (response.data.code == 1) {
            vm.showis();
            vm.veris = "";
          } else if (response.data.code == 0) {
            vm.veris = "验证码已过期请重新获取";
          } else if (response.data.code == 4032) {
            this.$message.error('获取验证码过于频繁');
          } else {

            vm.veris = "验证码填写错误";
          }
        });
      } else {
        vm.veris = "请获取验证码";
      }
    },
    verifygo: function verifygo() {
      var vm = this;
      if (this.phone == '') {
        this.phoneis = "手机号不能为空";
      }
      if (this.phoneis != "手机号格式错误" && this.phoneis != "手机号不能为空") {
        this.btnis = true;
        __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/msgCaptcha?visitorMd5Code=' + this.md5 + "&phoneNum=" + this.phone).then(function (response) {
          //console.log(response)
          if (response.data.code == 1) {
            vm.verifyis = false;
            var timer = setInterval(function () {
              vm.timesecond = vm.timesecond - 1;
              if (vm.timesecond == 0) {
                clearInterval(timer);
                vm.verifyis = true;
                vm.timesecond = 60;
              }
            }, 1000);
          } else if (response.data.code == 4032) {
            vm.$message.error('验证码获取过于频繁');
          } else if (response.data.code == 4504) {
            vm.$message.error('验证码已过期请重新获取');
          }
        });
      }
    },
    phonego: function phonego() {
      var phonenumis = /^1\d{10}$/.test(this.phone);
      //console.log(phonenumis)
      if (phonenumis == false) {
        this.phoneis = "手机号格式错误";
      } else {
        this.phoneis = "";
      }
    },

    // 设置相关的数据值，并且有值的时候更新一下提示语
    setMapData: function setMapData(data, key, value, dataObj) {
      var _this = this;

      this.$set(data, key, value);
      console.log('=========================================');
      console.log(data, key, value, dataObj);
      if (value != null && value != undefined && value != '') {
        setTimeout(function () {
          _this.datacommit(value, dataObj);
        }, 0);
      }
    },
    datacollect: function datacollect(obj) {
      var vm = this;
      if (obj.parentId == null) {
        obj.parentId = " ";
      }
      if (obj.typeId == 12) {
        __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/dataDicList/' + obj.id + '?visitorMd5Code=' + this.md5 + "&parentId=" + obj.parentId).then(function (response) {
          if (response.data.code == 1) {

            // console.log(vm.gamearea[obj.id])
            // console.log(vm.gamearea)
            var arrdata = response.data.data;
            var arr = [];
            //console.log(arrdata)
            arrdata.forEach(function (element, index) {
              var obj = {};
              obj.value = element.id;
              obj.label = element.content;
              arr.push(obj);
            });
            //console.log(arr)
            vm.$set(vm.gamearea, obj.id, arr);
            // vm.$set( vm.gamevalue,obj.id,obj.defaultContent);
            vm.setMapData(vm.gamevalue, obj.id, obj.enteredValue || obj.defaultContent, obj);
            console.log(vm.gamevalue, 'lalala');
            //console.log(vm.gamearea);
            //console.log(vm.gamevalue)
          } else {
            console.log('拉取数据失败');
          }
        });
      } else if (obj.typeId == 1) {
        __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/dataDicList/' + obj.id + '?visitorMd5Code=' + this.md5 + "&parentId=" + obj.parentId).then(function (response) {
          if (response.data.code == 1) {

            //  var arrdata=response.data.data;
            //  console.log(arrdata)
            //  var arr=[];
            // arrdata.forEach( function(element, index) {
            //   var obj={};
            //   arr.push(obj)
            // });
            //console.log(arr)
            //console.log(vm.gamevalue)
            //vm.$set( vm.dns,obj.id,obj.defaultContent);
            vm.setMapData(vm.dns, obj.id, obj.enteredValue || obj.defaultContent, obj);
          } else {
            console.log('拉取数据失败');
          }
        });
      } else if (obj.typeId == 2) {
        //vm.$set( vm.explain,obj.id,obj.defaultContent);
        vm.setMapData(vm.explain, obj.id, obj.enteredValue || obj.defaultContent, obj);
      } else if (obj.typeId == 3) {
        var timeVal = '';
        if (/^\d{4}-\d{1,2}-\d{1,2}/.test(obj.enteredValue || obj.defaultContent)) {
          timeVal = obj.enteredValue || obj.defaultContent;
        }
        vm.setMapData(vm.datetime, obj.id, timeVal, obj);
      } else if (obj.typeId == 4) {
        //console.log(obj.defaultContent+":00")
        //vm.$set( vm.hourtime,obj.id,"");
      } else if (obj.typeId == 5) {

        //vm.$set( vm.phonenumver,obj.id,obj.defaultContent);
        vm.setMapData(vm.phonenumver, obj.id, obj.enteredValue || obj.defaultContent, obj);
      } else if (obj.typeId == 6) {
        vm.setMapData(vm.number, obj.id, obj.enteredValue || obj.defaultContent, obj);
        //vm.$set( vm.number,obj.id,obj.defaultContent);
      } else if (obj.typeId == 7) {
        vm.setMapData(vm.idcard, obj.id, obj.enteredValue || obj.defaultContent, obj);
        // vm.$set( vm.idcard,obj.id,obj.defaultContent);
      } else if (obj.typeId == 8) {
        vm.setMapData(vm.email, obj.id, obj.enteredValue || obj.defaultContent, obj);
        // vm.$set( vm.email,obj.id,obj.defaultContent);
      } else if (obj.typeId == 14) {
        __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/dataDicList/' + obj.id + '?visitorMd5Code=' + this.md5 + "&parentId=" + obj.parentId).then(function (response) {
          if (response.data.code == 1) {

            var arrdata = response.data.data;
            //返回数据有问题
            console.log(obj.defaultContent, 'ssssss', arrdata);

            if (obj.defaultContent.split(",").length > 1) {
              var arrd = obj.defaultContent.split(",");
            } else {
              var arrd = [];
              arrd.push(obj.defaultContent.split(",")[0]);
            }
            console.log(arrd, 'smyisi');
            var arr = [];
            var arr1 = [];
            var defaultContentid = true;
            var l = arrdata.length;
            arrd.forEach(function (element, index) {

              var addis = false;
              for (var i = 0; i < l; i++) {
                if (arrdata[i].content == element) {
                  addis = true;
                }
              }
              if (addis == false) {
                defaultContentid = false;
              }
              arr1.push(element);
            });
            if (defaultContentid == false) {
              arr1 = [];
            }
            arrdata.forEach(function (element, index) {
              arr.push(element.content);
            });
            vm.$set(vm.checkedCities1, obj.id, arr1);
            console.log(vm.checkedCities1, 'sss22222');
            vm.$set(vm.cities, obj.id, arr);
          } else {
            console.log('拉取数据失败');
          }
        });
      } else if (obj.typeId == 13) {

        __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/dataDicList/' + obj.id + '?visitorMd5Code=' + this.md5 + "&parentId=" + obj.parentId).then(function (response) {
          if (response.data.code == 1) {

            var arrdata = response.data.data;
            //console.log(arrdata);
            var arr = [];
            var defaultContentid = false;
            //console.log(obj.defaultContent,8989)
            arrdata.forEach(function (element, index) {
              var obj1 = {};
              obj1.value = element.content;
              obj1.label = element.content;
              arr.push(obj1);
              //console.log(element.content)
              if (obj.defaultContent == element.content) {
                defaultContentid = true;
              }
            });
            //console.log(arr)
            if (defaultContentid == false) {
              obj.defaultContent = "";
            }
            //console.log(obj.defaultContent,39)
            vm.$set(vm.sexlabel, obj.id, arr);
            vm.$set(vm.sex, obj.id, obj.defaultContent);
          } else {
            console.log('拉取数据失败');
          }
        });
      } else if (obj.typeId == 9 || obj.typeId == 15) {
        var arr = [];
        this.action = this.basurl + '/api/visitor/wo/fileUpload?visitorMd5Code=' + this.md5;
        var arro = {};
        arro.url = obj.defaultContent;
        if (arro.url != "") {
          this.picid[obj.id] = false;
        } else {
          this.picid[obj.id] = true;
        }
        if (obj.typeId == 9) {
          arro.name = 'file.jpg';
        } else {
          arro.name = 'file.mp4';
        }
        if (arro.url != "") {
          arr.push(arro);
        }
        if (obj.typeId == 9) {
          vm.$set(vm.fileList2, obj.name, arr);
        } else {
          vm.$set(vm.fileVideoList, obj.name, arr);
        }

        //console.log(vm.fileList2)
      } else if (obj.typeId == 16) {
        var _timeVal = '';
        if (/^\d{4}-\d{1,2}-\d{1,2} \d{1,2}:\d{1,2}/.test(obj.enteredValue || obj.defaultContent)) {
          _timeVal = obj.enteredValue || obj.defaultContent;
        }
        vm.setMapData(vm.datetimes, obj.id, _timeVal, obj);
      }
    }
  }
});

/***/ }),

/***/ "D7uF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spirit"
  }, [_c('header', {
    style: ({
      backgroundColor: _vm.boxBodyColor
    })
  }, [(_vm.displayMode == 2) ? _c('img', {
    attrs: {
      "src": _vm.logoUrl,
      "alt": "公司logo"
    }
  }) : _c('p', {
    staticClass: "companyName"
  }, [(_vm.companyName == '') ? _c('span') : (_vm.companyName.length > 10) ? _c('el-tooltip', {
    attrs: {
      "content": _vm.companyName,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.companyName.substring(0, 10) + '...'))])]) : _c('span', [_vm._v(_vm._s(_vm.companyName))])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "首页",
      "name": "0"
    }
  }, [_vm._v("首页")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "orderAndService"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.callis),
      expression: "callis"
    }],
    attrs: {
      "src": _vm.imgUrl + 'callbtn.png',
      "alt": "客服电话logo"
    },
    on: {
      "click": _vm.callgo
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.callis),
      expression: "callis"
    }],
    staticClass: "order",
    on: {
      "click": _vm.callgo
    }
  }, [_vm._v("客服电话")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imgUrl + 'im_logo.png',
      "alt": "单据logo"
    },
    on: {
      "click": _vm.workOrder
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "order",
    on: {
      "click": _vm.workOrder
    }
  }, [_vm._v("我的单据")]), _vm._v(" "), (_vm.vip && _vm.turnToIm && _vm.visitorVipLevel != null && _vm.limitVipLevel != null && _vm.visitorVipLevel >= _vm.limitVipLevel) ? _c('img', {
    attrs: {
      "src": _vm.imgUrl + 'im_service.png',
      "alt": "在线客服logo"
    },
    on: {
      "click": _vm.intoIm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vip && _vm.turnToIm && _vm.visitorVipLevel != null && _vm.limitVipLevel != null && _vm.visitorVipLevel >= _vm.limitVipLevel) ? _c('span', {
    staticClass: "order",
    on: {
      "click": _vm.intoIm
    }
  }, [_vm._v("在线客服")]) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "chat"
  }, [_vm._l((_vm.spiritSession), function(item, index) {
    return [(item.type == 1) ? _c('div', {
      staticClass: "service"
    }, [_c('div', {
      staticClass: "serviceImg"
    }, [_c('img', {
      attrs: {
        "src": _vm.spiritSrc,
        "alt": "系统头像"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "serviceSession"
    }, [_c('span', {
      staticClass: "sessionSpan"
    }), _vm._v(" "), _c('div', {
      staticClass: "chatText"
    }, [_c('div', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (item.content),
        expression: "item.content"
      }],
      staticClass: "sessionDiv"
    }), _vm._v(" "), (item.workOrders && item.workOrders.length > 0) ? _c('div', {
      staticClass: "workOrder-box"
    }, _vm._l((item.workOrders), function(obj) {
      return _c('div', {
        key: obj.id,
        staticClass: "workOrder-item"
      }, [_c('p', {
        staticClass: "workOrder-btn",
        on: {
          "click": function($event) {
            _vm.goForm(obj)
          }
        }
      }, [_vm._v(_vm._s(obj.name))])])
    })) : _vm._e(), _vm._v(" "), (item.evaluateShow) ? _c('p', {
      staticClass: "sessionBar"
    }) : _vm._e(), _vm._v(" "), (item.evaluateShow && item.questionId != '0') ? _c('div', {
      staticClass: "evaluateDiv"
    }, [(!item.isEvaluate) ? _c('p', {
      staticClass: "evalP"
    }, [_vm._v("评价有惊喜哦~~")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "evaluate"
    }, [(!item.isEvaluate) ? _c('div', {
      staticClass: "evalDiv"
    }, [_c('div', {
      staticClass: "evaluateP",
      style: ({
        backgroundColor: _vm.boxBodyColor,
        borderColor: _vm.boxBodyColor
      }),
      on: {
        "click": function($event) {
          _vm.getEvaluate(3, index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.imgUrl + 'zanT.png',
        "alt": ""
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "getP"
    }, [_vm._v("解决")])])]) : _vm._e(), _vm._v(" "), (!item.isEvaluate) ? _c('p', {
      staticClass: "bar"
    }) : _vm._e(), _vm._v(" "), (!item.isEvaluate) ? _c('div', {
      staticClass: "evalDiv"
    }, [_c('div', {
      staticClass: "evaluateP",
      style: ({
        backgroundColor: _vm.boxBodyColor,
        borderColor: _vm.boxBodyColor
      }),
      on: {
        "click": function($event) {
          _vm.getEvaluate(1, index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.imgUrl + 'zan.png',
        "alt": ""
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "getP"
    }, [_vm._v("未解决")])])]) : _c('p', {
      staticClass: "evaluated",
      staticStyle: {
        "padding-top": "20px"
      }
    }, [_vm._v("感谢您的评价")])]), _vm._v(" "), (item.relativeQuestions && item.relativeQuestions.length > 0) ? _c('p', {
      staticClass: "evaluateBar"
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.relativeQuestions && item.relativeQuestions.length > 0 && item.evaluateShow) ? _c('p', {
      staticClass: "topFiveP"
    }, [_vm._v("相关问题推荐")]) : _vm._e(), _vm._v(" "), _c('ul', {
      staticClass: "topFive"
    }, _vm._l((item.relativeQuestions), function(relativeQ, indexF) {
      return _c('li', [_c('a', {
        attrs: {
          "href": "javaScript:void(0)"
        },
        on: {
          "click": function($event) {
            _vm.getTopFive(relativeQ)
          }
        }
      }, [_vm._v(_vm._s(relativeQ))])])
    }))])])]) : _vm._e(), _vm._v(" "), (item.type == 2) ? _c('div', {
      staticClass: "user"
    }, [_c('span', {
      staticClass: "sessionUser"
    }), _vm._v(" "), _c('div', {
      staticClass: "userSession"
    }, [_c('div', {
      staticClass: "userText"
    }, _vm._l((item.content), function(i) {
      return _c('p', [_vm._v(_vm._s(i))])
    }))]), _vm._v(" "), _vm._m(0, true)]) : _vm._e()]
  })], 2), _vm._v(" "), _c('footer', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chatContent),
      expression: "chatContent"
    }],
    staticClass: "chatContent",
    attrs: {
      "maxlength": "140"
    },
    domProps: {
      "value": (_vm.chatContent)
    },
    on: {
      "keyup": function($event) {
        _vm.sendMsg(_vm.chatContent, $event)
      },
      "keydown": function($event) {
        _vm.sendMsg1(_vm.chatContent, $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.chatContent = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "send"
  }, [_c('span', [_vm._v("按下Ctrl+Enter换行")]), _vm._v(" "), _c('el-button', {
    staticClass: "sendBtn",
    style: ({
      backgroundColor: _vm.boxBodyColor,
      borderColor: _vm.boxBodyColor
    }),
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.getTopFive(_vm.chatContent)
      }
    }
  }, [_vm._v("发送")])], 1), _vm._v(" "), (_vm.lenovoShow) ? _c('div', {
    staticClass: "lenovo"
  }, _vm._l((_vm.questions), function(relativeQ, indexF) {
    return _c('div', [_c('a', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (relativeQ.html),
        expression: "relativeQ.html"
      }],
      attrs: {
        "href": "javaScript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.getTopFive(relativeQ.content)
        }
      }
    })])
  })) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._m(1), _vm._v(" "), _c('nav', [_c('ul', _vm._l((_vm.hotArr), function(hotItem, index) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "javaScript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.getTopFive(hotItem)
        }
      }
    }, [_vm._v(_vm._s(hotItem))])])
  }))])])]), _vm._v(" "), (_vm.showImgMask && (_vm.geen == -1)) ? _c('div', {
    staticClass: "imgMask",
    on: {
      "click": function($event) {
        _vm.magnify(_vm.imgMasksrc)
      },
      "mousewheel": function($event) {
        _vm.bbimg()
      }
    }
  }, [_c('img', {
    ref: "img",
    attrs: {
      "src": _vm.imgMasksrc,
      "alt": "放大图"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.stopImg($event)
      }
    }
  })]) : (_vm.showImgMask && (_vm.geen > -1)) ? _c('div', {
    staticClass: "imgMask",
    on: {
      "click": function($event) {
        _vm.magnify(_vm.imgMasksrc)
      },
      "DOMMouseScroll": function($event) {
        _vm.bbimg2()
      }
    }
  }, [_c('img', {
    ref: "img",
    attrs: {
      "src": _vm.imgMasksrc,
      "alt": "放大图"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.stopImg($event)
      }
    }
  })]) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "userImg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("TQb4"),
      "alt": "用户头像"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hotTitle"
  }, [_c('p', [_vm._v("热点问题")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DYJm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_video_recorder__ = __webpack_require__("WJAN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_video_recorder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_video_recorder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_socket_io_client__ = __webpack_require__("DmT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_socket_io_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_request_js__ = __webpack_require__("vLgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_url__ = __webpack_require__("vpRr");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      boxBodyColor: '',
      satisfyMode: 1,
      //visitor.one.cn:8083
      baseVisitorUrl: __WEBPACK_IMPORTED_MODULE_6__components_url__["a" /* baseurl */] + '/api',
      callis: true,
      //每一层的开始语音
      callvideo: '',
      audio: "",
      callstyle: '通话中',
      calltime: "00:00:00",
      callnum: '',
      //满意度语音
      modevoicevideo: '',
      //非服务时间语音
      noservicevideo: '',
      //排队时语音 
      linevideo: '',
      //排队时间
      linetime: '',
      //排队次数
      linemmax: '',
      //排队播放语音定时器
      linetimer: '',
      //等待是语音
      waitvideo: '',
      //错误是语音
      errorvideo: '',
      //播放的语音
      quesvideo: '',
      callvideosrc: '',
      //上一层
      callkey: [{ "key": 1, "action": "error", "id": "", "teamId": "" }, { "key": 2, "action": "error", "id": "", "teamId": "" }, { "key": 3, "action": "error", "id": "", "teamId": "" }, { "key": 4, "action": "error", "id": "", "teamId": "" }, { "key": 5, "action": "error", "id": "", "teamId": "" }, { "key": 6, "action": "error", "id": "", "teamId": "" }, { "key": 7, "action": "error", "id": "", "teamId": "" }, { "key": 8, "action": "error", "id": "", "teamId": "" }, { "key": 9, "action": "error", "id": "", "teamId": "" }, { "key": '*', "action": "error", "id": "", "teamId": "" }, { "key": 0, "action": "error", "id": "", "teamId": "" }, { "key": "#", "action": "error", "id": "", "teamId": "" }],
      //层数轨迹给返回上一层使用
      callkeyarr: [],
      videohisarr: [],
      timer: '',
      status: 'ivr',
      callid: '',
      queuetimer: '',
      rtc: '',
      md5: '',
      //会话数据
      rtcobj: {},
      evaluateType: '',
      socket: '',
      evaluis: '',
      statuslevel: 'ivr',
      createtime: '',
      nowproid: '',
      nowteamid: '',
      recorder: '',
      wrongtimes: 0,
      keyris: false,
      linestyle: 1
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    'endis': 'endclass',
    'getsocket': 'getsocket'
  })),
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.linetimer);
    clearInterval(this.queuetimer);
    if (this.socket != "") {
      this.socket.disconnect();
    }
    if (this.timer != '') {
      console.log("清除定时器");
      clearInterval(this.timer);
    }
  },
  methods: {
    recordstart: function recordstart() {
      this.listreload("record");
      var vm = this;
      this.recorder = new Recorder({
        sampleRate: 16000, //采样频率，默认为44100Hz(标准MP3采样率)
        bitRate: 16, //比特率，默认为128kbps(标准MP3质量)
        success: function success() {//成功回调函数

        },
        error: function error(msg) {
          //失败回调函数
          alert(msg);
        },
        fix: function fix(msg) {
          //不支持H5录音回调函数
          alert(msg);
        }
      });
    },
    rtcend: function rtcend() {
      console.log("-----------关闭推流");
      this.rtc.stopRTC({}, function (data) {

        //成功
        console.log("成功");
      }, function () {
        //失败
        console.log("失败");
      });
    },
    rtcgo: function rtcgo() {
      console.log("打开推流");
      this.rtc.startRTC({}, function () {

        //成功
        console.log("打开成功");
      }, function () {
        //失败
        console.log("失败");
      });
    },
    getSatisfySetting: function getSatisfySetting() {
      var vm = this;
      var visitorMd5Code = vm.$route.query.v;
      api.getSatisfySetting(visitorMd5Code, function (body) {
        if (body.code === 1) {
          vm.satisfyMode = body.data.mode;
        }
      });
    },
    cresocket: function cresocket() {
      var vm = this;
      if (vm.$store.state.im.socket instanceof __WEBPACK_IMPORTED_MODULE_4_socket_io_client__["Socket"]) {
        // 如果已经存在了就断开原来的链接

        vm.$store.state.im.socket.disconnect();
        console.log("存在连接");
      }

      var locdat = '';
      var websocktUrl = "https://mc.one.cn?username=";
      if (sessionStorage.getItem("locdat")) {
        console.log("有uuid");
        locdat = sessionStorage.getItem("locdat");
      } else {
        locdat = new Date();
        console.log("无uuid");
        locdat = locdat.getTime();
        sessionStorage.setItem("locdat", locdat);
      }

      this.socket = __WEBPACK_IMPORTED_MODULE_4_socket_io_client__["connect"](websocktUrl + vm.md5 + "&uuid=" + locdat, { forceNew: true }, { reconnectionDelay: 100 }, { reconnection: true }, { reconnectionAttempts: 50 }, { autoConnect: true });

      this.socket.on(this.md5, function (data) {
        if (data.imMsgHeader) {
          var imMsgHeader = data.imMsgHeader;
          if (imMsgHeader.applicationType[0] === 'imChatAppType' && imMsgHeader.applicationType[1] === 'EVALUATE_NOTIFY' && imMsgHeader.sessionType == 4) {
            //推送评价
            console.log("推送评价");
            var line1 = document.getElementById("modevoice");
            setTimeout(function () {
              console.log(line1);
              line1.currentTime = 0;
              line1.play();
            }, 10);

            vm.listreload("notify");
            vm.callcut("evalute");
          } else if (imMsgHeader.applicationType[0] === 'imChatAppType' && imMsgHeader.applicationType[1] === 'FORCE_HANG' && imMsgHeader.sessionType == 4) {
            //收到关闭会话
            console.log("强制挂断");
            vm.callcut('cut');
          } else if (imMsgHeader.applicationType[0] === 'imChatAppType' && imMsgHeader.applicationType[1] === 'TRANSTER_NOTIFY' && imMsgHeader.sessionType == 4) {
            console.log("收到转接通知");
            var wait = document.getElementById("waitvideo");
            wait.currentTime = 0;
            wait.play();
          } else if (imMsgHeader.applicationType[0] === 'imChatAppType' && imMsgHeader.applicationType[1] === 'TRANSTER_CONFIRM' && imMsgHeader.sessionType == 4) {
            console.log("收到转接确认");
            var wait = document.getElementById("waitvideo");
            wait.pause();
          } else if (imMsgHeader.applicationType[0] === 'imChatAppType' && imMsgHeader.applicationType[1] === 'PUSH_STREAM_NOTIFY' && imMsgHeader.sessionType == 4) {
            console.log("收到重新推流");
            //location.reload()
          }
        }
      });
    },
    callback: function callback() {
      // if (window.rampage) {
      //   window.rampage.actionClose();
      // } else {
      console.warn('window.rampage对象不存在 即将调用返回方法');
      window.history.back();

      //}
    },
    keygo: function keygo(path, key, action, id, teamid, item) {
      var vm = this;
      console.log(item);
      if (vm.statuslevel == 'ivr' && id && id != "") {
        console.log('当前操作id为：' + id);
        __WEBPACK_IMPORTED_MODULE_5__utils_request_js__["a" /* default */].get(vm.baseVisitorUrl + '/visitor/call-center/ivr/flow/session/opt?visitorMd5Code=' + vm.md5 + '&flowCfgDetailId=' + id).then(function (resp) {
          console.log('传到生成会话记录');
          console.log(resp);
        });
      }

      this.callnum = this.callnum + key;
      this.audio.play();
      vm.callvideo.load();
      var dom = document.getElementById('errorvideo');
      dom.load();
      var quesvideo = document.getElementById('quesvideo');
      quesvideo.load();
      var callvideov = document.getElementById('callvideov');
      callvideov.load();
      var answerwrong = document.getElementById('answerwrong');
      answerwrong.load();
      var phoneanswer = document.getElementById('phoneanswer');
      phoneanswer.load();
      var vid = document.getElementById("robotreplace");
      vid.load();
      if (action == "error") {
        console.log('播放错误语音');
        var dom = document.getElementById('errorvideo');
        dom.currentTime = 0;
        dom.play();
      } else if (action == "4") {
        console.log('重新播放语音');
        this.callvideo.currentTime = 0;
        this.callvideo.play();
      } else if (action == "3") {
        console.log('播放语音');
        this.quesvideo = path;

        var quesvideo = document.getElementById('quesvideo');
        console.log(quesvideo);
        setTimeout(function () {
          quesvideo.currentTime = 0;
          quesvideo.play();
        }, 10);
      } else if (action == "1") {
        console.log('进入下级导航');
        console.log(id);
        //存入菜单缓存
        this.callkeyarr.push(this.callkey);
        this.videohisarr.push(this.callvideosrc);

        this.callvideosrc = path;
        //console.log(path);

        setTimeout(function () {
          vm.callvideo.currentTime = 0;
          vm.callvideo.play();
        }, 10);

        this.listreload();
        this.getbtnlist(id);

        //进入下级导航
      } else if (action == "5") {
        //进入上级导航
        console.log('进入上级导航');

        this.callkey = this.callkeyarr[this.callkeyarr.length - 1];

        this.callkeyarr.splice(this.callkeyarr.length - 1, 1);

        this.callvideosrc = this.videohisarr[this.videohisarr.length - 1];
        this.videohisarr.splice(this.videohisarr.length - 1, 1);
        setTimeout(function () {
          vm.callvideo.currentTime = 0;
          vm.callvideo.play();
        }, 10);
      } else if (action == "2") {
        console.log('分配客服');
        console.log(teamid);
        vm.listreload();
        __WEBPACK_IMPORTED_MODULE_5__utils_request_js__["a" /* default */].get(vm.baseVisitorUrl + '/visitor/call-center/ivr/flow/session/close?visitorMd5Code=' + vm.md5).then(function (resp) {
          console.log('进入会话结束ivr');
          console.log(resp.data);
        });
        if (item.productId && item.productId != '') {

          this.nowproid = item.productId;
          this.nowteamid = teamid;
          var vid = document.getElementById("robotreplace");
          //vid.volume = 0.2;
          vid.currentTime = 0;
          vid.play();
          this.recordstart();
        } else {
          this.linestyle = 1;
          this.linego(teamid);
        }
      } else if (action == "notify") {
        console.log("评价会话");
        console.log(key);
        var obj = {};
        obj.mode = 3;
        obj.basicLevel = key;
        __WEBPACK_IMPORTED_MODULE_5__utils_request_js__["a" /* default */].post(vm.baseVisitorUrl + '/visitor/call-center/runtime/call/evaluate?visitorMd5Code=' + vm.md5 + '&sessionId=' + vm.callid, obj).then(function (resp) {
          if (resp.data.code == 1) {
            vm.$message.success('评价成功！');
            vm.listreload();
            vm.callback();
          }
        }, function (errorMessage) {
          vm.$message.error('网络异常，请稍后再试');
        });
      } else if (action == "6") {
        this.callvideo.pause();
        window.open(item.url);
      } else if (action == "recordgo") {
        // this.nowvideoid.pause();
        this.keyris = true;
        this.recorder.start();
      } else if (action == "recordend") {
        if (this.keyris) {

          this.recorder.stop();
          this.recorder.getBlob(function (blob) {
            var formData = new FormData();
            // var file = document.getElementById("record0").files[0];
            // formData.append('file', file)
            formData.append('file', blob);
            console.log(blob);
            console.log('--------------------------------');
            __WEBPACK_IMPORTED_MODULE_5__utils_request_js__["a" /* default */].post(vm.baseVisitorUrl + '/visitor/call-center/ivr/spirit/speech?productId=' + vm.nowproid + '&visitorMd5Code=' + vm.md5, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }

            }).then(function (res) {
              console.log(res);
              var data = res.data;
              if (data.code == 1 && data.data.questionId != '0') {
                console.log('问题命中了ok');
                vm.videospritis(1);
                if (data.data.answerRecordUrl) {
                  console.log('问题命中了');
                  vm.reurl(data.data.answerRecordUrl);
                }
              } else if (data.code == 70505) {
                if (vm.wrongtimes < 1) {
                  console.log('播放质量过差音频！');
                  var vid = document.getElementById("answerwrong");
                  vid.currentTime = 0;
                  vid.play();
                  vm.wrongtimes++;
                } else {
                  console.log('进入人工');
                  vm.videospritis(2);
                  vm.linestyle = 2;
                  vm.linego(vm.nowteamid);
                }
              } else {
                console.log('进入人工');
                vm.linestyle = 2;
                vm.videospritis(2);
                vm.linego(vm.nowteamid);
              }
            });
          });
          this.keyris = false;
        } else {
          var dom = document.getElementById('errorvideo');
          dom.currentTime = 0;
          dom.play();
        }
      }
    },

    //通知精灵是否解决问题 1:解决 2，未解决
    videospritis: function videospritis(sty) {
      if (sty == 1) {
        var url = this.baseVisitorUrl + '/visitor/spirit/solved?visitorMd5Code=' + this.md5;
      } else {
        var url = this.baseVisitorUrl + '/visitor/spirit/unSolved?visitorMd5Code=' + this.md5;
      }
      __WEBPACK_IMPORTED_MODULE_5__utils_request_js__["a" /* default */].get(url).then(function (resp) {}, function (errorMessage) {
        alert('提示', '网络异常，请稍后再试');
      });
    },

    // 获取音频url
    reurl: function reurl(url) {
      var vm = this;
      //Vue.http.get().then(function(res){

      var res = '//visitor.one.cn/api/visitor/call-center/ivr/spirit/speech/download?answerRecordUrl=' + url + '&visitorMd5Code=' + vm.md5;
      console.log(res);
      var phoneanswer = document.getElementById("phoneanswer");
      phoneanswer.src = res;

      //phoneanswer.onloadedmetadata =function(){
      console.log('开始播放！');
      phoneanswer.currentTime = 0;
      phoneanswer.play();
      //}
    },
    cdown: function cdown(id) {
      var dom = document.getElementById(id);
      dom.style = 'background: #808080;color: #fff;';
    },
    cup: function cup(id) {
      var dom = document.getElementById(id);
      dom.style = 'background: #b4dad9;color: #3f686f;';
    },

    //挂断电话
    callcut: function callcut(cls) {
      var vm = this;
      if (cls == "cut") {
        if (this.rtc != "") {
          this.rtcend();
          this.rtc.quit({
            roomid: vm.rtcobj.audioRoomId,
            role: "user",
            privateMapKey: vm.rtcobj.privateMapKey
          }, function () {
            //退出成功
            __WEBPACK_IMPORTED_MODULE_5__utils_request_js__["a" /* default */].get(vm.baseVisitorUrl + '/visitor/call-center/runtime/call/ended?sessionId=' + vm.callid + '&reason=visitorcut' + "&visitorMd5Code=" + vm.md5 + "&closeType=0").then(function (resp) {
              var data = resp.data;
              if (data.code == 1) {
                vm.callback();
                console.log('发送结束会话成功');
              }
            });
          }, function () {
            //退出失败
          });
        } else {
          if (vm.callid != '') {
            __WEBPACK_IMPORTED_MODULE_5__utils_request_js__["a" /* default */].get(vm.baseVisitorUrl + '/visitor/call-center/runtime/call/cancel?sessionId=' + vm.callid + '&reason=visitorcut' + "&visitorMd5Code=" + vm.md5).then(function (resp) {
              var data = resp.data;
              if (data.code == 1) {
                vm.callback();
                console.log('发送取消排队成功');
              }
            });
          }

          this.callback();
        }

        if (vm.statuslevel == 'ivr') {
          __WEBPACK_IMPORTED_MODULE_5__utils_request_js__["a" /* default */].get(vm.baseVisitorUrl + '/visitor/call-center/ivr/flow/session/close?visitorMd5Code=' + vm.md5).then(function (resp) {
            console.log('结束ivr');
            console.log(resp);
          });
        } else {
          console.log('session结束ivr');
        }
      } else if (cls == "evalute") {
        console.log('满意度结束');
        if (this.rtc != "") {
          this.rtcend();
          this.rtc.quit({
            roomid: vm.rtcobj.audioRoomId,
            role: "user",
            privateMapKey: vm.rtcobj.privateMapKey
          }, function () {
            //退出成功
            __WEBPACK_IMPORTED_MODULE_5__utils_request_js__["a" /* default */].get(vm.baseVisitorUrl + '/visitor/call-center/runtime/call/ended?sessionId=' + vm.callid + '&reason=visitorcut' + "&visitorMd5Code=" + vm.md5 + "&closeType=3").then(function (resp) {
              var data = resp.data;
              if (data.code == 1) {
                console.log('发送满意度结束会话成功');
                vm.rtc = '';
              }
            });
          }, function () {
            //退出失败
          });
        }
      }
    },
    timechange: function timechange(time) {
      var h = parseInt(time / 3600);
      var m = parseInt(time % 3600 / 60);
      var s = time % 3600 % 60;
      if (h < 10) {
        h = "0" + h;
      }
      if (m < 10) {
        m = "0" + m;
      }
      if (s < 10) {
        s = "0" + s;
      }
      console.log(this.calltime);
      this.calltime = h + ":" + m + ":" + s;
    },

    //定时器计时时间
    alltime: function alltime() {
      var vm = this;
      this.timer = setInterval(function () {
        //console.log(vm.calltime);
        var alltime = vm.calltime.split(":");
        var h = alltime[0] - 0;
        var m = alltime[1] - 0;
        var s = alltime[2] - 0;
        s = s + 1;
        if (s == 60) {
          s = 0;
          m = m + 1;
        }
        if (m == 60) {
          m = 0;
          h = h + 1;
        }
        if (h < 10) {
          h = "0" + h;
        }
        if (m < 10) {
          m = "0" + m;
        }
        if (s < 10) {
          s = "0" + s;
        }
        vm.calltime = h + ":" + m + ":" + s;
      }, 1000);
    },

    //链接通话
    callconnect: function callconnect() {
      var vm = this;
      vm.callvideo = document.getElementById("callvideov");
      vm.audio = document.getElementById("ding");

      __WEBPACK_IMPORTED_MODULE_5__utils_request_js__["a" /* default */].get(vm.baseVisitorUrl + '/visitor/call-center/runtime/session/find?sessionId=' + vm.callid + "&visitorMd5Code=" + this.md5 + "&ivrStartTime=" + this.createtime).then(function (resp) {
        var data = resp.data;
        if (data.code == 1) {
          var obj = data.data;
          vm.callid = obj.sessionId;
          vm.rtcobj = obj;

          vm.callid = obj.sessionId;
          if (vm.createtime != "") {
            if (vm.timer != '') {
              console.log("清除定时器");
              clearInterval(vm.timer);
            }
            vm.timechange(obj.callDuration / 1000);
            vm.alltime();
          }

          vm.cresocket();
          //console.log(obj);
          vm.rtc = new WebRTCAPI({
            userId: obj.visitorAudioId,
            sdkAppId: obj.sdkAppId,
            accountType: obj.accountType,
            userSig: obj.visitorAudioSig,
            closeLocalMedia: true,
            video: false
          }, function () {
            //初始化化成功回调
            console.log(' 初始化化成功回调 ');
            //进入房间
            vm.rtc.createRoom({
              roomid: obj.audioRoomId,
              role: "user",
              privateMapKey: obj.visitorPrivateMapKey,
              pureAudioPushMod: 2,
              recordid: obj.audioRoomId
            }, function (data) {
              console.log(' 进房房间成功 ', data);
              vm.rtcgo();
              vm.callstyle = "通话中";
              //发送开始通话
              __WEBPACK_IMPORTED_MODULE_5__utils_request_js__["a" /* default */].get(vm.baseVisitorUrl + '/visitor/call-center/runtime/call/start?sessionId=' + vm.callid + '&reason=ok' + "&visitorMd5Code=" + vm.md5).then(function (resp) {
                var data = resp.data;
                if (data.code == 1) {
                  console.log('发送通话开始成功');
                }
              });
            }, function (error) {
              console.log(' 进入房间失败 ', error);
            });

            // //本地流 新增
            // vm.rtc.on("onLocalStreamAdd", function(data){
            //     if( data && data.stream){

            //          document.querySelector("#localAudioMedia").srcObject = data.stream;
            //     }
            // });
            //远端流 新增/更新
            vm.rtc.on("onRemoteStreamUpdate", function (data) {
              console.log("videoId为：" + data.videoId);
              if (data && data.stream) {

                document.querySelector("#remoteAudioMedia").srcObject = data.stream;
              }
            });
            //var errorCodeMap = WebRTCAPI.fn.getErrorCode();
            //监听错误事件通知
            vm.rtc.on('onErrorNotify', function (info) {
              console.log(info);
            });
          }, function (error) {
            //alert(error)
            console.log(error);
          });
        } else {
          vm.listreload();
          vm.getbtnlist(0);
        }
      }, function (errorMessage) {
        vm.$message.error('网络异常，请稍后再试');
      });
    },


    //定时获取排队状态
    calltimer: function calltimer() {
      var vm = this;
      this.queuetimer = setInterval(function () {
        __WEBPACK_IMPORTED_MODULE_5__utils_request_js__["a" /* default */].get(vm.baseVisitorUrl + '/visitor/call-center/runtime/call/queue-position?sessionId=' + vm.callid + "&visitorMd5Code=" + vm.md5).then(function (resp) {
          var data = resp.data;
          vm.callstyle = "正在呼叫客服";
          if (data.code == 1) {
            if (data.data.sessionStatus == "chatting") {
              clearInterval(vm.queuetimer);
              clearInterval(vm.linetimer);
              vm.callstyle = "通话中";
              vm.callconnect();
            } else if (data.data.sessionStatus == "ended") {
              clearInterval(vm.queuetimer);
            }
          } else {
            vm.$message.error('排队失败');
          }
        }, function (errorMessage) {
          vm.$message.error('网络异常，请稍后再试');
        });
      }, 3000);
      var rime = 1;
      if (vm.linestyle == 1) {
        var line = document.getElementById("linevideo");
      } else {
        var line = document.getElementById("noanswer");
      }

      line.currentTime = 0;
      line.play();
      this.linetimer = setInterval(function () {

        console.log("等待次数:" + rime);
        console.log(vm.linemmax);
        console.log((vm.linetime * 1 + 3) * 1000);
        if (rime <= vm.linemmax) {
          line.play();
          rime++;
        } else {
          clearInterval(vm.linetimer);
          vm.callcut('cut');
        }
      }, (vm.linetime * 1 + 3) * 1000);
    },

    //排队ok
    linego: function linego(teamid) {
      var vm = this;
      var visitorinfo = JSON.parse(sessionStorage.getItem("thisuserinfo"));
      var obj = {};
      obj.teamId = teamid;
      obj.entranceId = '';
      if (visitorinfo) {
        obj.os = visitorinfo.os;
        obj.platform = 5;
        obj.pushId = '';
        obj.vipLevel = visitorinfo.vip;
        obj.account = visitorinfo.account;
        console.log("解码码的账号信息:", obj.account);
      }
      __WEBPACK_IMPORTED_MODULE_5__utils_request_js__["a" /* default */].post(vm.baseVisitorUrl + '/visitor/call-center/runtime/call/enqueue?visitorMd5Code=' + this.md5, obj).then(function (resp) {
        var data = resp.data;
        if (data.code == 1) {
          vm.callid = data.data.sessionId;
          console.log(vm.callid);
          vm.calltimer();
        } else {
          vm.$message.error('排队失败');
        }
      }, function (errorMessage) {
        vm.$message.error('网络异常，请稍后再试');
      });
    },

    //
    getbtnlist: function getbtnlist(id) {
      var vm = this;
      //获取语音列表
      __WEBPACK_IMPORTED_MODULE_5__utils_request_js__["a" /* default */].get(this.baseVisitorUrl + '/visitor/call-center/ivr/flow/detail?visitorMd5Code=' + this.md5 + "&id=" + id).then(function (resp) {
        var data = resp.data;
        if (data.code == 1) {
          //alert(1)
          if (id == 0) {
            //初始化
            vm.$message('拨打客服电话时如有电话进入则通话将被挂断！');
            //vm.alltime();
            var obj = data.data;
            vm.callvideosrc = obj[0].voicePath;
            if (obj[0].action != "2") {
              setTimeout(function () {
                var dom = document.getElementById("callvideov");
                __WEBPACK_IMPORTED_MODULE_5__utils_request_js__["a" /* default */].get(vm.baseVisitorUrl + '/visitor/call-center/ivr/flow/session/opt?visitorMd5Code=' + vm.md5 + '&flowCfgDetailId=' + obj[0].id).then(function (resp) {
                  console.log('生成会话记录');
                });
                dom.currentTime = 0;
                dom.play();
              }, 500);
            }

            var arr = obj[0].list;
            if (obj[0].action == "2") {
              setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_5__utils_request_js__["a" /* default */].get(vm.baseVisitorUrl + '/visitor/call-center/ivr/flow/session/opt?visitorMd5Code=' + vm.md5 + '&flowCfgDetailId=' + obj[0].id).then(function (resp) {
                  console.log('生成会话记录');
                });
                if (obj[0].productId && obj[0].productId != '') {
                  // console.log( this.nowvideoid)
                  // vm.nowvideoid.pause();
                  vm.nowproid = obj[0].productId;
                  vm.nowteamid = obj[0].teamId;
                  var vid = document.getElementById("robotreplace");
                  //vm.nowvideoid = vid;
                  //vid.volume = 0.2;
                  vid.currentTime = 0;
                  vid.play();
                  vm.recordstart();
                } else {
                  vm.linestyle = 1;
                  vm.linego(obj[0].teamId);
                }
              }, 500);
            }
          } else {
            var arr = data.data;
          }
          //console.log(data.data);
          clearInterval(vm.timer);
          vm.createtime = data.createTime;
          vm.timechange(data.startTime * 1);
          //console.log('时间为：'+data.startTime)
          vm.alltime();

          arr.forEach(function (element, index) {

            if (element.presskey == "*") {
              vm.callkey[9].action = element.action;
              vm.callkey[9].voicePath = element.voicePath;
              vm.callkey[9].id = element.id;
              if (element.action == "1") {
                //console.log(vm.callkey[element.presskey-1])
                vm.callkey[9].id = element.id;
              }
              if (element.action == "2") {
                vm.callkey[9].teamId = element.teamId;
                if (element.hasRobot) {
                  vm.callkey[9].productId = element.productId;
                }
              }
              if (element.action == "6") {
                vm.callkey[9].url = element.url;
              }
            } else if (element.presskey == "#") {
              vm.callkey[11].action = element.action;
              vm.callkey[11].voicePath = element.voicePath;
              vm.callkey[11].id = element.id;
              if (element.action == "1") {
                //console.log(vm.callkey[element.presskey-1])
                vm.callkey[11].id = element.id;
              }
              if (element.action == "2") {
                vm.callkey[11].teamId = element.teamId;
                if (element.hasRobot) {
                  vm.callkey[11].productId = element.productId;
                }
              }
              if (element.action == "6") {
                vm.callkey[11].url = element.url;
              }
            } else if (element.presskey == "0") {
              vm.callkey[10].action = element.action;
              vm.callkey[10].voicePath = element.voicePath;
              vm.callkey[10].id = element.id;
              if (element.action == "1") {
                //console.log(vm.callkey[element.presskey-1])
                vm.callkey[10].id = element.id;
              }

              if (element.action == "2") {
                vm.callkey[10].teamId = element.teamId;
                if (element.hasRobot) {
                  vm.callkey[10].productId = element.productId;
                }
              }
              if (element.action == "6") {
                vm.callkey[10].url = element.url;
              }
            } else {

              vm.callkey[element.presskey - 1].action = element.action;
              vm.callkey[element.presskey - 1].voicePath = element.voicePath;
              vm.callkey[element.presskey - 1].id = element.id;
              if (element.action == "1") {
                //console.log(vm.callkey[element.presskey-1])
                vm.callkey[element.presskey - 1].id = element.id;
              }
              if (element.action == "2") {
                vm.callkey[element.presskey - 1].teamId = element.teamId;
                if (element.hasRobot) {
                  vm.callkey[element.presskey - 1].productId = element.productId;
                }
              }
              if (element.action == "6") {
                vm.callkey[element.presskey - 1].url = element.url;
              }
            }
          });
          //console.log(vm.callkey)
        } else if (data.code == 70109) {

          setTimeout(function () {
            var noservice = document.getElementById('noservice');
            console.log(noservice);
            noservice.currentTime = 0;
            noservice.play();
          }, 100);
          vm.callstyle = "非服务时间";

          __WEBPACK_IMPORTED_MODULE_5__utils_request_js__["a" /* default */].get(vm.baseVisitorUrl + '/visitor/call-center/ivr/flow/session/opt?visitorMd5Code=' + vm.md5 + '&flowCfgDetailId=-2').then(function (resp) {
            console.log('生成结束会话记录');
            console.log(resp);
            __WEBPACK_IMPORTED_MODULE_5__utils_request_js__["a" /* default */].get(vm.baseVisitorUrl + '/visitor/call-center/ivr/flow/session/close?visitorMd5Code=' + vm.md5).then(function (resp) {
              console.log('非服务时间直接结束会话');
              console.log(resp);
            });
          });
        } else {
          console.log('提示请求code码为' + data.code);
          vm.callstyle = "服务未开启";
          var noservice = document.getElementById('noservice');
          console.log(noservice);
          setTimeout(function () {
            noservice.currentTime = 0;
            noservice.play();
          }, 100);
          __WEBPACK_IMPORTED_MODULE_5__utils_request_js__["a" /* default */].get(vm.baseVisitorUrl + '/visitor/call-center/ivr/flow/session/opt?visitorMd5Code=' + vm.md5 + '&flowCfgDetailId=-2').then(function (resp) {
            console.log('生成结束会话记录');
            console.log(resp);
            __WEBPACK_IMPORTED_MODULE_5__utils_request_js__["a" /* default */].get(vm.baseVisitorUrl + '/visitor/call-center/ivr/flow/session/close?visitorMd5Code=' + vm.md5).then(function (resp) {
              console.log('非服务时间直接结束会话');
              console.log(resp);
            });
          });
        }
      }, function (errorMessage) {
        vm.$message.error('网络异常，请稍后再试');
      });
    },
    listreload: function listreload(id) {
      if (id == "notify") {
        this.callkey = [{ "key": 1, "action": "notify", "id": "", "teamId": "" }, { "key": 2, "action": "notify", "id": "", "teamId": "" }, { "key": 3, "action": "notify", "id": "", "teamId": "" }, { "key": 4, "action": "error", "id": "", "teamId": "" }, { "key": 5, "action": "error", "id": "", "teamId": "" }, { "key": 6, "action": "error", "id": "", "teamId": "" }, { "key": 7, "action": "error", "id": "", "teamId": "" }, { "key": 8, "action": "error", "id": "", "teamId": "" }, { "key": 9, "action": "error", "id": "", "teamId": "" }, { "key": '*', "action": "error", "id": "", "teamId": "" }, { "key": 0, "action": "error", "id": "", "teamId": "" }, { "key": "#", "action": "error", "id": "", "teamId": "" }];
      } else if (id == "record") {
        this.callkey = [{ "key": 1, "action": "error", "id": "", "teamId": "" }, { "key": 2, "action": "error", "id": "", "teamId": "" }, { "key": 3, "action": "error", "id": "", "teamId": "" }, { "key": 4, "action": "error", "id": "", "teamId": "" }, { "key": 5, "action": "error", "id": "", "teamId": "" }, { "key": 6, "action": "error", "id": "", "teamId": "" }, { "key": 7, "action": "error", "id": "", "teamId": "" }, { "key": 8, "action": "error", "id": "", "teamId": "" }, { "key": 9, "action": "error", "id": "", "teamId": "" }, { "key": '*', "action": "recordgo", "id": "", "teamId": "" }, { "key": 0, "action": "error", "id": "", "teamId": "" }, { "key": "#", "action": "recordend", "id": "", "teamId": "" }];
      } else {
        this.callkey = [{ "key": 1, "action": "error", "id": "", "teamId": "" }, { "key": 2, "action": "error", "id": "", "teamId": "" }, { "key": 3, "action": "error", "id": "", "teamId": "" }, { "key": 4, "action": "error", "id": "", "teamId": "" }, { "key": 5, "action": "error", "id": "", "teamId": "" }, { "key": 6, "action": "error", "id": "", "teamId": "" }, { "key": 7, "action": "error", "id": "", "teamId": "" }, { "key": 8, "action": "error", "id": "", "teamId": "" }, { "key": 9, "action": "error", "id": "", "teamId": "" }, { "key": '*', "action": "error", "id": "", "teamId": "" }, { "key": 0, "action": "error", "id": "", "teamId": "" }, { "key": "#", "action": "error", "id": "", "teamId": "" }];
      }
    }
  },
  mounted: function mounted() {
    var vm = this;
    //vm.timechange(3700);
    this.md5 = sessionStorage.md5;
    //this.getSatisfySetting();
    this.boxBodyColor = localStorage.boxBodyColor;
    vm.callconnect();
    console.log(vm.$store.state.im.socket);
  },
  beforeMount: function beforeMount() {
    this.md5 = sessionStorage.md5;
    var vm = this;
    //获取基础配置
    __WEBPACK_IMPORTED_MODULE_5__utils_request_js__["a" /* default */].get(this.baseVisitorUrl + '/visitor/call-center/ivr/basic?visitorMd5Code=' + vm.md5).then(function (resp) {
      var data = resp.data;
      if (data.code == 1) {
        console.log(data.data);
        data.data.forEach(function (element, index) {
          if (element.type == 1) {
            vm.waitvideo = element.voicePath;
          } else if (element.type == 4) {
            vm.errorvideo = element.voicePath;
          } else if (element.type == 5) {
            if (element.playVoice == 1) {
              var line = document.getElementById("modevoice");
              line.src = element.voicePath;
            }
          } else if (element.type == 2) {
            var noservice = document.getElementById('noservice');
            noservice.src = element.voicePath;
          } else if (element.type == 3) {
            vm.linevideo = element.voicePath;
            vm.linetime = element.queueTime;
            vm.linemmax = element.retryCount;
          }
        });
      } else {
        console.log('提示', '请求code码为' + data.code);
      }
    }, function (errorMessage) {
      vm.$message.error('网络异常，请稍后再试');
    });
  }
});

/***/ }),

/***/ "DwWh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E3qV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TEXT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IMAGE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return WORK_ORDER_TYPE; });
/* unused harmony export FILE_TYPE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EVENT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VIDEO_TYPE; });
/**
 * Created by wushaoyong on 2017/4/18.
 */
var TEXT_TYPE = 'TEXT';
var IMAGE_TYPE = 'IMAGE';
var WORK_ORDER_TYPE = 'WORK_ORDER';
var FILE_TYPE = 'FILE';
var EVENT_TYPE = 'EVENT';
var VIDEO_TYPE = 'VIDEO';

/***/ }),

/***/ "EcNG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ehbv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Eo27":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "IM_top",
    style: ({
      backgroundColor: _vm.boxBodyColor
    })
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.displayMode == 2) ? _c('img', {
    staticClass: "title_img",
    attrs: {
      "src": _vm.logoUrl,
      "alt": "公司logo"
    }
  }) : _c('p', {
    staticClass: "title_2"
  }, [(_vm.companyName == '') ? _c('span') : (_vm.companyName.length > 10) ? _c('el-tooltip', {
    attrs: {
      "content": _vm.companyName,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.companyName.substring(0, 10) + '...'))])]) : _c('span', [_vm._v(_vm._s(_vm.companyName))])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "首页",
      "name": "0"
    }
  }, [_vm._v("首页")])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "order_text",
    on: {
      "click": _vm.toWorkOrder
    }
  }, [_vm._v("我的单据")]), _vm._v(" "), _c('img', {
    staticClass: "order_img",
    attrs: {
      "src": _vm.imgUrl + 'im_logo.png',
      "height": "18px",
      "alt": "单据"
    },
    on: {
      "click": _vm.toWorkOrder
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.callis),
      expression: "callis"
    }],
    staticClass: "order_text",
    on: {
      "click": _vm.callgo
    }
  }, [_vm._v("客服电话")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.callis),
      expression: "callis"
    }],
    staticClass: "order_img",
    attrs: {
      "height": "18px",
      "src": "/pc/static/assets/callbtn.png"
    },
    on: {
      "click": _vm.callgo
    }
  })])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FxON":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_faqPage_vue__ = __webpack_require__("9CKP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cec12342_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_faqPage_vue__ = __webpack_require__("Ubvr");
function injectStyle (ssrContext) {
  __webpack_require__("aFQi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_faqPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cec12342_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_faqPage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fy+z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__url_js__ = __webpack_require__("vpRr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_request_js__ = __webpack_require__("vLgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workorder_top_vue__ = __webpack_require__("3XGK");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'workaccount',
  components: {
    top: __WEBPACK_IMPORTED_MODULE_2__workorder_top_vue__["a" /* default */]
  },
  data: function data() {
    return {
      kefuis: false,
      quesstionis: false,
      classis: false,
      allquestion: ["暂无问题"],
      allclass: ["暂无问题类"],
      questionclass: ["账号类"],
      topclass: "",
      basurl: __WEBPACK_IMPORTED_MODULE_0__url_js__["a" /* baseurl */],
      md5: "",
      boxBodyColor: '',
      logoUrl: '',
      companyName: '',
      displayMode: ''
    };
  },
  mounted: function mounted() {
    var vm = this;
    vm.boxBodyColor = sessionStorage.getItem('boxBodyColor');
    vm.companyName = sessionStorage.getItem('companyName');
    //console.log(vm.companyName)
    vm.logoUrl = sessionStorage.getItem('logoUrl');
    vm.displayMode = sessionStorage.getItem('displayMode');
    this.md5 = sessionStorage.getItem("md5");
    this.getdata();
    //判断客服是否显示
    __WEBPACK_IMPORTED_MODULE_1__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/product/conf/showOnlineService?visitorMd5Code=' + this.md5).then(function (response) {
      if (response.data.code == 1) {
        vm.kefuis = true;
      }
    });
  },

  watch: {
    '$route': 'getdata'
  },
  methods: {
    //判断跳转页面
    kefugo: function kefugo() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_1__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/product/conf/redirectToOnlineService?visitorMd5Code=' + this.md5).then(function (response) {
        //console.log(response)

        if (response.data.code == 1) {
          var obj = response.data.data;

          if (obj.imStatus == "waiting") {
            vm.$router.replace({ path: 'imLineUp' });
            //window.location.href="#/imLineUp";
          } else if (obj.imStatus == "chatting") {
            vm.$router.replace({ path: 'imSession' });
            //window.location.href="#/imSession";
          } else {
            if (obj.target == 1) {
              //window.location.href="#/spirit";
              vm.$router.replace({ path: 'spirit' });
              console.log('已经跳转了');
            }
            if (obj.target == 2) {
              vm.$router.replace({ path: 'imDirectory' });
              //window.location.href="#/imDirectory";
            }
          }
        }
      });
    },

    //导航条
    nav: function nav(name) {
      sessionStorage.setItem("navname", name);
    },

    //  classnav(name){
    //   sessionStorage.setItem("navname", name)
    //   sessionStorage.setItem("classname", name)
    // },
    //获取数据
    getdata: function getdata() {
      var vm = this;
      vm.allquestion = [];
      vm.allclass = [];
      vm.topclass = "";
      vm.questionclass = [];
      var href = window.location.href.split("?id=")[1];
      var arr = href.split("&");
      console.log(arr);
      //console.log(arr)
      if (arr[1] == "question=") {
        this.quesstionis = true;
        __WEBPACK_IMPORTED_MODULE_1__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/listWorkOrdersByType/' + arr[0] + '?visitorMd5Code=' + this.md5).then(function (response) {
          if (response.data.code == 1) {
            console.log(response.data);
            vm.questionclass.push(sessionStorage.getItem("navname"));
            vm.topclass = sessionStorage.getItem("navname");
            response.data.data.forEach(function (element, index) {
              vm.allquestion.push(element);
            });
          }
        });
      }
      if (arr[1] == "class=") {
        this.classis = true;
        __WEBPACK_IMPORTED_MODULE_1__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/workOrderType/' + arr[0] + '?visitorMd5Code=' + this.md5).then(function (response) {
          if (response.data.code == 1) {
            //console.log(response.data)
            vm.questionclass.push(sessionStorage.getItem("navname"));
            vm.topclass = sessionStorage.getItem("navname");
            response.data.data.forEach(function (element, index) {
              vm.allclass.push(element);
            });
          }
        });
      }
    }
  }
});

/***/ }),

/***/ "GKiq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GpRe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workerorderindex"
  }, [_c('top'), _vm._v(" "), _c('div', {
    staticClass: "nav"
  }, [_c('router-link', {
    staticStyle: {
      "color": "rgb(31, 55, 61)"
    },
    attrs: {
      "to": {
        path: '/workerorderindex'
      }
    }
  }, [_c('span', [_vm._v("首页")])]), _vm._v(" "), _c('router-link', {
    staticClass: "btna color",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "to": {
        path: '/myorder'
      }
    }
  }, [_vm._v("我的工单")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.hotquestion), function(item) {
    return _c('p', [(item.showNote) ? _c('router-link', {
      attrs: {
        "to": {
          path: '/workinformation',
          query: {
            'id': item.orderId
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.nav(item.orderName)
        }
      }
    }, [_vm._v(_vm._s(item.orderName))]) : _c('router-link', {
      attrs: {
        "to": {
          path: '/workcommit?',
          query: {
            'id': item.orderId
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.nav(item.orderName)
        }
      }
    }, [_vm._v(_vm._s(item.orderName))])], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.allquestion), function(item) {
    return _c('p', [(item.type == 0) ? _c('router-link', {
      attrs: {
        "to": {
          path: '/workaccount?',
          query: {
            'id': item.id,
            'class': ''
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.nav(item.name)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e(), _vm._v(" "), (item.type == 1) ? _c('router-link', {
      attrs: {
        "to": {
          path: '/workaccount?',
          query: {
            'id': item.id,
            'question': ''
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.nav(item.name)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()], 1)
  })], 2)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__("C8UV")
    }
  }), _vm._v(" "), _c('span', [_vm._v("热点问题")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__("nSh+")
    }
  }), _vm._v(" "), _c('span', [_vm._v("全部问题分类")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_im__ = __webpack_require__("TLUi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_question__ = __webpack_require__("njBE");





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  state: {
    home: 0, // 主页/入口： 1.精灵、2.IM、3.工单首页、4.我的工单
    imStatus: null, // IM会话的状态: 1.waiting 2.chatting
    imEntranceMode: 0, // 1.统一入口 2.多入口
    companyName: "" // 公司名称
  },
  actions: {},
  mutations: {
    setHome: function setHome(state, obj) {
      state.home = obj.home;
    },
    setImStatus: function setImStatus(state, obj) {
      state.imStatus = obj.status;
    },
    setEntranceMode: function setEntranceMode(state, obj) {
      state.imEntranceMode = obj.imEntranceMode;
    },
    setCompanyName: function setCompanyName(state, companyName) {
      state.companyName = companyName;
    }
  },
  getters: {
    home: function home(state) {
      return state.home;
    },
    imStatus: function imStatus(state) {
      return state.imStatus;
    },
    getCompanyName: function getCompanyName(state) {
      return state.companyName;
    },
    imEntranceMode: function imEntranceMode(state) {
      console.error("get imEntranceMode : " + state.imEntranceMode);
      return state.imEntranceMode;
    }
  },
  modules: {
    im: __WEBPACK_IMPORTED_MODULE_2__modules_im__["a" /* default */],
    question: __WEBPACK_IMPORTED_MODULE_3__modules_question__["a" /* default */]
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "IjaA":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ImIQ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAA4CAYAAABNGP5yAAAAAXNSR0IArs4c6QAAFkVJREFUaEPNWwmYXFWV/u/bX72q6u7qvUOSTkKTZEjYArgEJAlIwqpjcAFRFg0foCATAhgM0CwDjMFxARQXhtFhDNvoN4IioqK44GAQPkZQQPaks/RaXXu95c6ce++rqu5sJITMVNJfdVVXVb/zn3P+859zbjP8P7o9x3nyb1sLnlY10hmbdw8VeZtuWkHa4MPDlXAzt/zctCiZP7yHFffWZbO99UF7+jmc8+RDW4P5+XJ4RLlcXVINw4OrIaZWI64HYQS6QF3ToDMErsFe0zW23rH03zia/tTy4FfPsL4TK3v6u+l9/2cADAzwxO+Dyllj5erHCuVggc9Mr1ipIAx8BGEIcA4uLo/uAQ0Mmq7BMEzYlgUjrI4nbP2JjqS7bvk0517GWHlPgNjnAHDOtYcHw6VbxotrRvL+4RXoVrlUQkhGN1wN52T2xFsMScQBXddhOw5sHpaaHOuJ3kxi9dIu64+MCbze8m2fAvAy501/fKO4cut49bJcNXRLlQpiQ4VxnK5eXn/Niu0CIbGi1zBGUaGj2bFGO5LmjUtnpe7oYCz/VhHYZwD8fpzPeXGw8NWRYnj86HgBIQ+locrSuts4wGPzdmAGvUQYT++X72SaBs+x0ZYwf9jhWZ9Z3utteisg7BMAnhjlvS8Ml+4eKocLR8fGEdFFixyf4OoJ1zsBkAlUJUyP/V9HUKIA17XRmTB/dFBb84qFXWzrrkB4xwFYP87b/jpUuWtTrnLyaDaHqOb2hlDfTpjXL7xOhNu72BiOxtfblon2hH3vkp6WTx/YsfN0eEcB4Pwx4/6NC28ZGCt/bvPwmAh34XdhsPzVtW9jEBiD5LGdXVrDz+OXNVAffevYVtiRNG787Py2axljMt+2c3tHAbjvjeoFg/nyrRuGsrofRCJxJ5NbAxbScJnYYHQvHjf6dtLlNlJFQ1aItxkGTI2V07Zz6hVHtD66zwH4xWhp+uvDeOT1ofzs8XyhnvP17N3Gz+T7GCL6jjHpabonTSDMV8CoRztNcd00EfmV32qmfurNR08f3acRcM/G4mUbRoIvvrl5CFS3eURGcEgSIDsZQAaKkJcRrwmrhcm15yQQ8i3iWflfPbFzGCiK/IgjCqJPf3XpzDvfcQB4P7TvL+azXthaPioy/etHxv0phaIvABDMzyJoZgjN9sHsAIbFhdHCYAJCoy9Ao3t6XoFTAyQGowZInSoaoZCASU2haTqyxfLz3a65sH/xjLHJILxtDuDr15s3vbZgVqEanDowVP7AaCE6oFgJvCCE61cDhAFTxsuQ1jXANBksi8N0fLgtZTjJAIbNYegKCMYECLouUIAmgJCu1yakRoM5CsjaMzGFaAwVP6xkK8F53z1l9vf2GgD8fyP22nXVw0ZK0ZmDY9VzRnJIlyo+ypUAYRQhEnEvWV+W/YbHEXlGg2XosC0Njhsg2VYWYLhuJLxGANBrNF2CQdEggIijgslOIU4ZlSNxokywk5kWRrK5e6c+dc8Z/f39cRLW37JTJtnOD+/8Ge959s1y/1CBLx/OaZnxbA5+EAhSI0MFs8dhrx6L51XEEjbiytXPdJ3AYEilOZKtBSTbS3AsXTQ/ZDTd60YdiDglRJoIBKhqTKoWCh16XjNMlIqlv+YZO/6upfu/2WjSbqUAZfEN9/vHbBj2/3kwzw4dGaugQh1cKC2mf+R5TppeeV0CUld9wm+1Tk+wYU0O64zkLEMyU0bzfjkkPGqFddEOCxAoGhQoIiJUVaDUqhOjAqVGlFImRyEvlgK+7BvLZv5mjwAggvtCX/WTW8dxy5ZstXU0W6IPFcZFFPLKYAmAFDh14+tRIQFQhUCWg1ooSpUIOKaOdFOAlmlZeE0RTALBICAYdEOlBZPRoTBoqBSTiFG9xnIS4H7xjJsXzVi32wD09/druemXXzRUNG7eOlp28sUyogiTAIi9L0ueBCRqSAlpeE0NqizYnuKjCmnqGlIeR8t+WTR1+DB1EwZ5X0UCpY3ghriCxOWx4V7VSsEbtpuAHYVXXn1Uz811F7zFgcjF38yflQvM27eMVb1CoQSa05D3ydvC++peRgMQRBxBwBGFSv1xDjHjiDh0A9DrhV0qvtpjpQ1UQBuUEl6I9lljaGqhKqGDDKdoMAQnxCBoqmzKj4rJMTaPHpuui5SOL135rq4rGqXxLjng7C/nFsEy7x3LBx3ZXFmUNLJLAhBJbwsQImF4qczRkgRaPaDZBdKudPvweIShXIQtYxwjeQ7Xppymmk8Xr0AQLB+LHCmWSCd4qSp6Zo/DS2owdQOGQSAoYqRIoH8NgqoGQkOVMG0HGc+4dcmh7ZcezpjfQBE7rgHHrt7Q2t2ZeajKjXePjuYQCOMjRCGE18OwDkA1jKADWDjHwNFzGQ7tBdqbG8of4xgai/Bffwnw0JNV/O75ALpFnlReJG8KFSTVTr3HYdA4h9eWQ++cCmzLgCkiQIdm0DBERUKtPBLpKW5QZYcANi0HbZ5x66WHtl/K3hoA/dppay+9yrLd/pHRcQQq5IMoEuFMHo8B8IMQTQkdl5xs4b2zQxhahEpVEmN8o/Sg67IthnwxwoN/qGDtfUUEmgHbNlS91wRjC0XYoHmJOIOqj46ZWUyfRakgQRDEaChiJFIUfNCYBqq7YICbSKLF4jetWnDHGsbqWmCHKXBS/8g8L2k/Xg2jlkKxCh4BIXmdRwgDBQCFfcjhmhxXf8TFYb1VUNdXm/I09PmNMz4SqRT+33+0iJvuLcJO2LBsswEE2RiQQXGJ8H2OSMvjwCNLSCV1mIYJk9LAlCAI8aRSqJ5RTLQbdBnp5iZ0evrFFx7YcutbqgInXJf9RmuLc/7QSEGFO+l5SXhBHAFRhFI5wvlLbXzkPQRGKBWgEkR0T0wtybFhxsNJEjMUywE+8+URPPkKiSAHpkmRoCIg5oaYEhhDsVBBd18W02YCpmHAMokPdBimrA5CPdL0WAqEGiFSBDU3JXlP2vn7FXPS/7lLAA7+zKYD585q+mXZDztKJV8YQMQXS1wSPvR9ucoxNcNw85kGOtIB/EDqgrg204h781ARumagsz0hirwUTfLmWMB9j47jhnUFMMuB5TqCExj1BIITGHhDbovKoo9j7oISPM+AbZowTB2mqUhRgEbvk/wvZDN9r+tocszBvvbmpaf3eU/vEoBFa0b7e9qda7L5CgIKaUF4Kuw5RYBk/nwxxOJ5Oq7/mC68GXuewvvPz23FlTc+i79tYtBsF0ceksE/ruwTxBgHA6XCcDbA8jVbkQ0tJBIudMsQpY54gDwqPpORX2XrXCpUMPOQMbS3a7BsRYimAZ1AEAsUSYoEtpDBjMGwbWQcff0H5nQtm5tmwzsH4ISX7A8u6v6x5TjH5nM5hIQ6hXAIkf8yBWQFqPohPvoeAxcsYyiU6lOnXK6IFSt/i8efAfT2ZlAJCiKGiz/UiVVntUlQ1dRHYxwnrRrAm1kDiaQLw7ak5CUjCARSLaI2KkKLONIdY5h6QAW2acGyiA8kAKKiKIUYl0IqLG7CQ2dKv+9zB3V8dHLN24YE91+x6cDD5jQ9EnFMKZakzq/VfiV6KBpobRWFIc5douPsxToK5VAoP9LlL708giVn/AFBphuul4BuGPADhnOPb8bnz24R741TxdCBk1dtxGsjOhLJBEzHknKXAFBWCMkbyzfO4HllTJs/Chp+WnFZNOOSKt8rZTJ1nQwJ10Grq9+2ckHXRbsE4Jgrsyd0tNoP+YGvVSqBUnnE/jHzSxFEHEBR4FkBrEoR5UIZgR8IUKgtfm0wgG6YwphqwNHbauKOy7qwX0e9PaZrzBUjnHr5AEaqBjwvISOAeEDNBIQmICJVMUBtVSoRoaNvCMkUg2masMh48UVpQK20rB8iBTSZAsz3H09o3kn9izsmLE22iYATrs1dkGpOfr1cyApSkzJXkaBKgUYd4PshKiUflWIFvh8g9CkSODRdSt+KzzEto+GWC9tw4AyGqi/bcXqN62h48FfjWP0vo4h0G45LKSBBkxEgiUzOymQSEBAJh6NzxgiSmQAWASDSwIRuMRiTARAg0GfpQRiEp39l6cwHdsIBXFvan7upJeNdXsjl4CuyI31PGkBwgSBEpQgDioJQhHRYDRFUQxEVQiJzKYb+boqB689OY2aPBCM2njwT+BEuXLsFv/5LgHRTApZtSxIUo7GGFFAAiGaKGhsT6O7NItVRkstS04AZRwApxAYeEBWBMeimhSAIntXD8P23LN2/tjCZFAE/sY+/+qjbW9sSnxofz0nNL/S+bHCEDiAyVDJYpEJIEyAJCg/o5/RFxoaY0syw9rw0+rpDlKqNgxguBiAP/DyLK+8chZlw4bi2IkDZ7lI5I8/Lbk/6LJ6j0Hu7puaQ7i5IPWCRKNJhWHJPSADQbIFUUAwAvd+wTGhMv/zm901ZG0fBJABedRZ/oek73Z2pj2fH87L0ibBXEUB5L0Cp9wEUAYIPqPFTJOlXOVjEcdNZHo6ZH6FUqZMemUEG/PR341j9zWGUNBtuwoFhUgibYmYoyp8CQIipSd2NqRMAeTRNyQlZPAEAXXJArAobJ82GYVA4vNni2YtWH9H5ikyrxlvvq86SM5u/1d2e/MQYAaDyXwBAEpgeq0aosQ0WfUEMDKnDEsf7DzJw3ZkmhV1tOBKn8789OIQv3jOGwHTgeY4IT6oU8bCjnvf16bAYKothEqUAQ8d+OTT15FUEUAo0dIlCFhORUhWIx2Zypmg6NtciftcNR/WsYIxFkyJgvXnc1X1fbct4F+TyOVkCBQhKBaq+XgIjUyOKSP4qcOh1YQSDMXx+uY33HxwKtdgokB58bASrbh9EZDlIplxYlg2dJLCY9Ej2n0B8tTZXiSIiT1tD537jSHbtOAVqEVADgCKJegcTpoYRz/aOW31Ey9PbVIHj1oz2t7Smrynkx2sVQA45qLujCGC1/j8mRRENghi5ILaWBMPdqxKwWFmd8pAj8b+9XsJpl7+CPFyk0i5MIj3TEiUsVn6ylZXMH8/3G+d9BGfK1dDdOwarpaQiwBJpZDqmLH8ksoQmoXRq2DsocO2Ei5TJbjv2sPaV2wJw1ei5qeamO6ulbK0FliQoVWAc6pLpJ06FSCEG1Qhzp2j49kUOSEiRN+l1xOy33j2AtfePItWchJNIwKSct0ww0cjIww5yOKJmAmofEJ8MkfNUhtYmhp5Zw+CuL+RzKukiYbLnwohvZBo6dKbNYKbVRKM1ilACpMYlxCm6js60vWG/Ke1HbAPAIZ8dXDR9SuJhjtChGb+c+MQcIAkwngCJFFBDUZEuIYfvRzhmnoHrTteFVI7DnxTfp65+Bb94LkCqiQBwRQnTauNvud8Xed4w/4/XhXEFoM/r7TKQ6RuE65poa0r8Ke05X5+Rannk4we5g996aigzVKx2B1EwRTf0+QH4gjCMDqlGmBbwSNc1jREZ9jTbL/a1tR69DQCdZ7w+893zWn6m6casYomGnzK0w5q3ZWkU09+aNiA9ILUBVYDjD9Zx/cdN+CR5Fc+aBseJF7yAZzZqIgJsUfNpBiDb2Fjx1XeF9VWpAEWRNQ1LDz5Az3fNLT7R3pz4dpfrPXrOoS3brLwk8GD3b3jTeXk05aRZscuvWgsqgT/PNDSrJemsO/uA9PptAOhd9KozZ0nmIdtxji0X1SygBgCRHElZSXpi4VmLAAmMX42wfwdVAY78yBhQGhHrMcNL4zs/LWE0sOC41PtbQvQI2SrCvwEEoXsbxmJK11MkZtI2jjnIu2rtuU03TNb1e/J4uxOhoz8/8o32Nu/8Qr4gwlqIIFp6CC83REC8ExARoSqFH2E8F6LdKuO0w4tIGnlsHRzHg4+X8fxYBqm2tAh/SwAgtz/CWLqSeBQmCnTDdFSMdeRzs6e4Y8fN7zjyc6exl/bE4F02Q/SCxWtGv9PWmpRqULW+siOkCtDAAapBkvNBSYjEATT7+PKKBHo7A0HDQRBiYFMeV966Eb952UK6OaVkrwSgsfTFTUzDrifeoiGRSGDBTONfV588cn5fX9/bOiC5AyUIzPjUwPTD+lI/57qxfz5fVHN+VQLjcbjyvAj/uC8QhBihWua46CQHH14YTpgP0pDkiafH8Mkbh5HMpOE4DvR4DlgLf9XyCOfTNKjRXxq6M3bp4JnOKV87v/kXe8P72ypBcH3JNWP97S3JNbnxvDBAkmCEkEvvi0lwvPCMtUGcAiGpwAj3Xu6hq7kiVGMNacaxadDHiSs3giU9uI4L3VbTHyUR4xFWfBqkYagM13XQ28b/44PTu88855w9OxW6PdAmYPzeizfPy3R6v7ZMLZMv0BJElr2AVlw1qavILybASdWhWIpw9yUuprdXxfA0vtHk59UBHydeNoBEU1Kc8jTseAOsyQMj22405DEhpqM9rW+d12ufcsfFbU/uLe9PjADO2aIvjH5vSpd35vCYZP9a56caong2QLoiFkLxRlj0CFxWgdMXGjh/GcQghMiRVKBtAF+7P4vbf0wDTTn6ogGG2AOooUe805KznHiDzpC0NT6jzbzsB9d1f2lvGj8BgMMu2vKhWVO9f6+GkVMq++IKai2wYHgpeqjjkwDIdbiMDDngiJclGjg+8T4NHzmKIZUAxgsR1j1awrceLqHKZeOi0TxfDD+VDhDDz8m1nxofA11ecNvC5PRL+/tZ9Z0B4JSBxLLDEz9qbvaOzWapDVZlLTaK9v1qNkheJqPlyQ8FgNoExxWClhgaB2a0h2h2IgxlQ7y0IYQfaWKELcbeiv3jyY8wrKH2EwlSi5yxq788cbZ22uoLt3/K6+0CIjjgyEuGPjhtauIB3w/0UoP8lXv/uPY3hH3D7l9EhTgQMXFZStsjkQJqWaKLUxxyqFULe1H7lQ5Qvbk4asEYLMNAixP+7NBec8XXLul54+0auqP3s/1P+EN6xhGzf5DJJI7NjkvhI3b/ZLhad8tDD/VxmPww9Rx9p1KgvilWMrnhsAS9KGZ1eQhS3mp7QPWYaxpMjaM1gfvnd3mX3HZF+8A7Zbz4/e/5h63LOjq9h6PQR6VKvb3Kd9riqPwmIUMTXx5GkW3wsmVqfjnUmmhhQRMhwQHyUJAgwvhAVHxcJj4LVEdgokmS8OQUxzP5cEeK3fjhOeHXzzlnxh79EcTuAMbed8XQJzOZ1HcLJSpbMpx9v4KwWikFIR+z9Wg0Yekv2Ab/U5MTPRmGxT8nm1vCsm9+eNNQ9by8H84NYBt+UAVT5wTqB6Xi8z/yzFDjeaD4IjkjMjRh8kqhOcEe6W6Jblh3Ve8zu/uHD7tjdONr2bn/NNizpaB9JVuszOU8KrEImz0LLyXd6Lm2tPHsqlMK/70j2XnXD3nzT/48eNaWrL+8EvIFAdxE1a+C098CyNIg+YEiXh0Ako/lDo+OvFi8vNnU+ZPT26x191zz4gOMLZY7tn10E8nIH3vMWPn0/M45XVblvBfTY6wfu3UR9z3Gk/f9fOCgImfvqkZ8STXgh5QqfEo1AqOKEmta4jtb54GlsxctI3rK0PB42tSffMD6xPOs/1e79Tv3Fj7b7Qb39MNJtF17O/eeG3wtmUymM36lNKNc4c2VMNJsk/meaw0y5r5RGN06duIBRm5f5PiubPkfHzImG89qCQUAAAAASUVORK5CYII="

/***/ }),

/***/ "InYd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_url_js__ = __webpack_require__("vpRr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isOrder: {
      type: Boolean,
      default: false
    },
    iskf: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      basicUrl: __WEBPACK_IMPORTED_MODULE_0__components_url_js__["a" /* baseurl */],
      boxBodyColor: '',
      limitVipLevel: '',
      visitorVipLevel: '',
      logoUrl: '',
      companyName: '',
      displayMode: '',
      imgUrl: '/pc/static/assets/',
      visitorMd5Code: '',
      customPicture: '',
      defaultPictureNo: '',
      headPictureUrl: '',
      spiritSrc: '',
      callis: false,
      activeName: '0',
      homeType: ''
      //msg: '服务器繁忙，请稍后再试'
    };
  },

  methods: {
    handleClick: function handleClick() {
      var url = sessionStorage.getItem('indexUrl');
      var md5 = sessionStorage.getItem('md5');
      if (!url) {
        return;
      }
      this.$router.push({
        path: url,
        query: {
          v: md5
        }
      });
    },
    workOrder: function workOrder() {
      // 点击我的单据日志埋点
      if (this.homeType == 5) {
        this.$Points.point({ code: '1001', type: '4' });
      }
      this.$router.replace({ path: 'myorder' });
    },
    callgo: function callgo() {
      var userAgent = checkBrowser();
      var changeis = true;
      if (userAgent == '谷歌') {
        changeis = true;
        var banben = getChromeVersion();
        console.log('浏览器版本：' + banben);
        if (banben < 52) {
          changeis = false;
        }
      } else {
        changeis = false;
      }
      if (changeis) {
        window.location.href = '#/callcenter';
      } else {
        if (userAgent != "Safari") {
          this.$message({
            message: '目前呼叫只支持Chrome浏览器，版本号 52以上~',
            type: 'warning'
          });
        } else {
          alert('目前呼叫只支持Chrome浏览器，版本号 52以上~');
        }
      }
    },

    /*定位到最新的消息位置*/
    intoIm: function intoIm() {
      this.$emit('intoIm');
    }
  },
  mounted: function mounted() {
    var userAgent = navigator.userAgent;

    this.visitorMd5Code = sessionStorage.getItem('md5');
    this.boxBodyColor = sessionStorage.getItem('boxBodyColor');
    this.companyName = sessionStorage.getItem('companyName');

    this.logoUrl = sessionStorage.getItem('logoUrl');
    this.displayMode = sessionStorage.getItem('displayMode');

    this.customPicture = sessionStorage.getItem('customPicture');
    this.defaultPictureNo = sessionStorage.getItem('defaultPictureNo');
    this.headPictureUrl = sessionStorage.getItem('headPictureUrl');
    this.homeType = sessionStorage.getItem('redirectTarget');
    if (this.customPicture == 'true') {
      this.spiritSrc = this.headPictureUrl;
    } else {
      if (this.defaultPictureNo == 2) {
        this.spiritSrc = '/pc/static/assets/spirit2.png';
      } else if (this.defaultPictureNo == 3) {
        this.spiritSrc = '/pc/static/assets/spirit3.png';
      } else {
        this.spiritSrc = '/pc/static/assets/spirit1.png';
      }
    }
  }
});

/***/ }),

/***/ "J/XN":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAvCAYAAABzJ5OsAAAEA0lEQVRogcWaz2tcVRTHP3dS6o/QtCmJpFJtTVuL4M8opSCSUkUCFRexVqRBrZIuuih0Y0E3ARf+AxXBjYoLUdAGsnFhhRYqVagtKIiCWlOx2oZUwRSbmnxc3JlkMpnkvpnJzPsu5557zue89+6be895gQalPgj0Aw8DdwN3AbeVmUwBfwAXgG+BM8CJEMJEo7HrkrpFfVMdtz7NqCfUV9T2VkE/oB5XZ+uErqar6htqZ7Og16jHVhi6Un+qQ2rIypU0VHcCHwKbK4ZmgXPAaeAH4DLwH9AGdAA9wL3Ao8CmrEDAF8CLIYTfaphTFfyAOl12dWbVUfUZdW0Nfrapr6mXMt6FCbW/EfCjFQ4/UrfW7TD6XK0Oq79nSGBa3VdPkINlTs6rOxqBruK/w7iGUppR99fieKA4SfVtdfVKglfE2qtey3AHdmdx1mN83lQPNwu6ImafeiWRwBV1+UVvXIyqw60AL4vbp04lEvhKbVvKwVNFo5FWgpfFH0rAqx6pNjGo59SxHLjLOd5NwP+jbqictMf4D9edE3eJo0udTCTwVuWkMfXlnJgXSH01AT+t3l4y7iw+MoWcuQFQ15levCMl4+fUF/JFXij1gwT8uBoKwH3Ax3kDV+iTxPgdQF8B+DmE8G8LgGrRyQw2AwXg+2aT1KoQwlUgtSV+AnV9K4BqlXo68dxfXxVCmCwa3wI8BnQTDxdnQwjmyH85MR7fjuqg8xuykr5We5vPWF3qocSVP4W6y/ktcKV+slWn+8Xw7cX41TSj7kI9lcjwUB7wxQR6i09AuSbUwZLBjQT88bzgi3xBfUTdrz5pXJtzg9cT8KdzZF9S6voC8GXC7s5WwNSh7QXg84TRRptVzWpM9xSAzzIY7moySE1SbwZ6C8A3wMWE/WDzkWrSPmLFGdSRxKKdUtflyxulFoy1pHWlA8g7wI1l5twKtLSisIxeAi6GEP6a+8V0BWtS7coNOTJ2G8/aeyoHNhhP58vpvXyw5xjHjEfWxdVt9UgCXnUoB+7ydfn0UgZtxsrUcppS+1oMPlyMPZoy3GS22mFLElAPF2NOqD1ZJux2YVOhmq6pe5sIfZOxSq1xCzxQy+T9Lr3PL9cxtWOFwXcY3+UlHazHybMZ7oDGTsewDdby1a3GDky5jjbisN/FR8SldEl9Xd1Wg/+1xh7XqAu7jdPqgeXmZmobqhuB94F0h2JevxI7hd8RO+B/EzuIq4gd8u3ETuFDlA7T87oAPB9COFNDvKVlPNEMGf/hmqVZ4xpasyLQVZLoNHasr64w9Kfq/U2BrpJEu/HbgRNmeytV07jxG4Yt9TBkbpUnEukCHgd2Egu3m4kd8PKyyWXgF+BH4CxwMoRwvpG4/wOXUZ+u22uEfAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "JEjz":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "KGqH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_question__ = __webpack_require__("Ozlq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_top_vue__ = __webpack_require__("CWUh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Top: __WEBPACK_IMPORTED_MODULE_2__common_top_vue__["a" /* default */]
  },
  data: function data() {
    return {
      accountList: [],
      questionName: '',
      homeType: -1
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    chatType: 'chatType'
  })),
  created: function created() {
    this.init();
    this.homeType = sessionStorage.getItem('redirectTarget');
  },

  methods: {
    init: function init() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__api_question__["a" /* default */].getTypeDetails({ visitorMd5Code: this.$route.query.v, id: this.$route.query.id }, function (res) {
        if (res.code === 1) {
          _this.accountList = res.data.children;
          _this.questionName = res.data.questionName;
        }
      });
    },
    itemClick: function itemClick(item) {
      var _this2 = this;

      this.$store.dispatch({
        type: 'getEnable',
        visitorMd5Code: this.$route.query.v
      }).then(function (res) {
        if (_this2.homeType == 5) {
          _this2.$Points.point({ code: '1001', type: '3', id: item.id });
        }
        switch (item.type) {
          // 外链
          case 1:
            location.href = item.skipUrl || item.url;
            break;
          case 2:
            if (item.isAi) {
              if (_this2.$route.query.ailink == 'spirit') {
                _this2.$router.push({
                  path: '/spirit',
                  query: {
                    id: item.id,
                    v: _this2.$route.query.v,
                    source: _this2.$route.query.source,
                    chatType: _this2.chatType,
                    questionName: item.questionName
                  }
                });
              } else if (_this2.$route.query.ailink == 'imChat') {
                _this2.$router.push({
                  path: '/imChat',
                  query: {
                    id: item.id,
                    v: _this2.$route.query.v,
                    source: _this2.$route.query.source,
                    chatType: _this2.chatType,
                    questionName: item.questionName
                  }
                });
              }
            } else {
              _this2.$router.push({
                path: '/faqPage',
                query: {
                  type: 'type',
                  id: item.id,
                  v: _this2.$route.query.v
                }
              });
            }
            break;
          // 工单
          case 4:
            sessionStorage.setItem("navname", '二级页面');
            if (item.showNote) {
              _this2.$router.push({
                path: '/workinformation',
                query: {
                  name: item.workerOrderName,
                  source: 'type',
                  id: item.workerOrderId,
                  v: _this2.$route.query.v
                }
              });
            } else {
              _this2.$router.push({
                path: '/workcommit',
                query: {
                  name: item.workerOrderName,
                  id: item.workerOrderId,
                  source: _this2.$route.query.source,
                  v: _this2.$route.query.v
                }
              });
            }
            break;
        }
      });
    }
  }
});

/***/ }),

/***/ "KQ62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__url_js__ = __webpack_require__("vpRr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workorder_top_vue__ = __webpack_require__("3XGK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_request_js__ = __webpack_require__("vLgD");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'workdetail',
  components: {
    top: __WEBPACK_IMPORTED_MODULE_2__workorder_top_vue__["a" /* default */]
  },
  data: function data() {
    return {
      urlb: '',
      commpent: "",
      ping: false,
      basurl: __WEBPACK_IMPORTED_MODULE_1__url_js__["a" /* baseurl */],
      md5: "",
      kefuis: false,
      processInstanceId: '',
      pingjiais: false,
      inforis: false,
      staris: 3,
      mode: 1,
      times: 0,
      starindex: 0,
      orderid: '',
      fromid: '',
      questionclass: "单据处理详情",
      detail: [{ "date": "2017-02-05 14:30", "title": "正在受理", "content": "" }, { "date": "2017-02-05 14:30", "title": "提交成功", "content": "" }], // 默认数据 不要随便修改
      srcurl: [{ "content": "满意", "url": "/pc/static/assets/im_star1_dark.png" }, { "content": "一般", "url": "/pc/static/assets/im_star2_dark.png" }, { "content": "不满意", "url": "/pc/static/assets/im_star3_dark.png" }],
      result: ['bright', 'bright', 'bright', 'bright', 'bright'],
      autitude: ['bright', 'bright', 'bright', 'bright', 'bright'],
      time: ['bright', 'bright', 'bright', 'bright', 'bright'],
      resultindex: 4,
      autitudeindex: 4,
      timeidnex: 4,
      inforlength: false,
      boxBodyColor: '',
      logoUrl: '',
      companyName: '',
      displayMode: ''
    };
  },
  mounted: function mounted() {
    var vm = this;
    vm.boxBodyColor = sessionStorage.getItem('boxBodyColor');
    vm.companyName = sessionStorage.getItem('companyName');
    vm.logoUrl = sessionStorage.getItem('logoUrl');
    vm.displayMode = sessionStorage.getItem('displayMode');
    this.md5 = sessionStorage.getItem("md5");
    this.processInstanceId = location.href.split("?id=")[1];
    __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/workOrderDetail/' + this.processInstanceId + '?visitorMd5Code=' + this.md5).then(function (response) {
      //console.log(response)
      if (response.data.code == 1) {
        var obj = response.data.data;
        vm.orderid = obj.orderInfo.orderId;
        vm.fromid = obj.orderInfo.formId;
        if (obj.orderInfo.replenishStatus == 1) {
          vm.inforis = true;
        } else {
          vm.inforis = false;
        }
        vm.describeTime(obj.orderInfo.startTime);
        if (obj.tasklist.length != 0) {
          vm.describe(obj.tasklist);
        }
      }
    });
    var indexurl = sessionStorage.getItem("indexUrl");
    if (indexurl == 'workerorderindex') {
      vm.urlb = "workerorderindex";
    }
    //判断客服是否显示
    __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/product/conf/showOnlineService?visitorMd5Code=' + this.md5).then(function (response) {
      if (response.data.code == 1) {
        vm.kefuis = true;
      }
    });
  },

  methods: {
    //判断跳转页面
    kefugo: function kefugo() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/product/conf/redirectToOnlineService?visitorMd5Code=' + this.md5).then(function (response) {
        //console.log(response)

        if (response.data.code == 1) {
          var obj = response.data.data;

          if (obj.imStatus == "waiting") {
            vm.$router.replace({ path: 'imLineUp' });
            //window.location.href="#/imLineUp";
          } else if (obj.imStatus == "chatting") {
            vm.$router.replace({ path: 'imSession' });
            //window.location.href="#/imSession";
          } else {
            if (obj.target == 1) {
              //window.location.href="#/spirit";
              vm.$router.replace({ path: 'spirit' });
              console.log('已经跳转了');
            }
            if (obj.target == 2) {
              vm.$router.replace({ path: 'imDirectory' });
              //window.location.href="#/imDirectory";
            }
          }
        }
      });
    },
    commitgo: function commitgo() {
      var obj = {};
      obj.orderid = this.orderid;
      obj.processInstanceId = this.processInstanceId;
      obj.fromid = this.fromid;
      sessionStorage.setItem('butianinfor', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
      window.location.href = "#/commitinfor?butianinfor";
    },
    starcommit: function starcommit() {
      if (this.ping == true) {
        var obj = {};

        obj.mode = this.mode;
        obj.sessionId = this.processInstanceId;
        //obj.basicLevel=this.starindex+1;
        if (this.starindex == 0) {
          obj.basicLevel = 3;
        } else if (this.starindex == 1) {
          obj.basicLevel = 2;
        } else if (this.starindex == 2) {
          obj.basicLevel = 1;
        }
        if (this.mode == 2) {
          obj.processAttitudeScore = this.autitudeindex + 1;
          obj.processDurationScore = this.timeidnex + 1;
          obj.processResultScore = this.resultindex + 1;
        } else {
          obj.processAttitudeScore = 0;
          obj.processDurationScore = 0;
          obj.processResultScore = 0;
        }
        if (this.starindex != 0) {
          if (this.commpent.length > 50) {
            this.inforlength = false;
            this.$message.error('说明最多为50个字符');
          } else {
            this.inforlength = true;
            obj.comment = this.commpent;
          }
        } else {
          this.inforlength = true;
        }

        console.log(obj);
        var vm = this;
        if (this.inforlength == true) {
          __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].post(this.basurl + '/api/visitor/wo/evaluate?visitorMd5Code=' + this.md5, obj).then(function (response) {
            console.log(response);
            if (response.data.code == 1) {
              vm.staris = 2;
              // vm.$alert( '感谢您的评价~~','上传成功', {confirmButtonText: '确定'})
            } else if (response.data.code == 400) {
              vm.$message.error('说明最多50个字符');
            }
          });
        }
      }

      if (this.ping == false) {
        this.$message({
          message: '请对我们的服务做出评价哟！',
          type: 'warning'
        });
      }
    },
    service: function service(index) {
      this.ping = true;
      this.starindex = index;
      //console.log(this.starindex);
      this.srcurl.forEach(function (item, i) {
        if (item.url.indexOf("bright") > -1) {
          item.url = item.url.replace("bright", "dark");
        }
        var spanid = document.getElementById('service' + i);
        spanid.style.color = '#cccccc';
      });
      this.srcurl[index].url = this.srcurl[index].url.replace("dark", "bright");
      var sid = document.getElementById('service' + index);
      sid.style.color = '#52db91';
      if (index > 0 && this.mode == 2) {
        this.pingjiais = true;
      } else {
        this.pingjiais = false;
      }
    },
    star: function star(cls, index) {
      var vm = this;
      if (cls == "result") {
        this.resultindex = index;
      }
      if (cls == "autitude") {
        this.autitudeindex = index;
      }
      if (cls == "time") {
        this.timeidnex = index;
      }

      this.result.forEach(function (item, i) {
        vm.$set(vm[cls], i, "dark");
      });
      for (var j = 0; j <= index; j++) {
        this.$set(this[cls], j, "bright");
      }
    },

    // 重置默认步骤的时间为当前单据生成时间
    describeTime: function describeTime(time) {
      var vm = this;
      vm.detail.forEach(function (element, index) {
        element.date = time;
      });
    },
    describe: function describe(arr) {
      var vm = this;
      var l = arr.length;
      var star = false;
      for (var i = l - 1; i >= 0; i--) {
        var obj = {};
        var element = arr[i];
        obj.content = element.comments;
        obj.date = element.startTime;
        if (element.type == "AddCommentReply") {
          obj.title = "受理中";
        }
        if (element.type == "AddCommentNext") {
          obj.title = "下一步";
        }
        if (element.type == "AddCommentReplyEnd") {
          obj.title = "受理完成";
          star = true;
        };
        if (element.type == "AddCommentReply" || element.type == "AddCommentNext" || element.type == "AddCommentReplyEnd") {
          vm.detail.unshift(obj);
        }
      }
      if (star == true) {
        this.stargo();
      }
    },
    stargo: function stargo() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/evaluateInfo/' + this.processInstanceId + '?visitorMd5Code=' + this.md5).then(function (response) {
        //console.log(response)
        if (response.data.code == 1) {
          vm.mode = response.data.data.mode;
          //console.log(vm.mode)
          vm.times = response.data.data.times;
          if (vm.times == 0) {
            vm.staris = 1;
          } else {
            vm.staris = 2;
          }
        }
      });
    },
    hisback: function hisback() {
      var vm = this;
      var indexurl = sessionStorage.getItem("indexUrl");
      var imEntranceMode = sessionStorage.getItem("imEntranceMode");
      console.log(indexurl);
      if (indexurl == 'aiInteractive') {
        window.location.href = "#/aiInteractive?v=" + this.md5;
        vm.urlb = "aiInteractive?v=" + this.md5;
      } else if (indexurl == 'workerorderindex') {
        window.location.href = "#/workerorderindex";
        vm.urlb = "workerorderindex";
      } else {
        __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/im/sessionStatus?visitorMd5Code=' + this.md5).then(function (response) {
          console.log(response);
          var imStatus = '';
          if (response.data.code == 1) {
            imStatus = response.data.data.status;
          }
          console.log(imStatus);
          if ((imStatus === 'ended' || !imStatus || imStatus === '') && indexurl == 'spirit') {
            vm.urlb = "spirit";
            window.location.href = "#/spirit";

            return;
          } else if (imStatus === 'waiting') {
            vm.urlb = "imLineUp";
            window.location.href = "#/imLineUp";

            return;
          } else if (imStatus === 'chatting') {
            vm.urlb = "imSession";
            window.location.href = "#/imSession";

            return;
          } else {
            if (imEntranceMode === 1) {
              vm.urlb = "imLineUp";
              window.location.href = "#/imLineUp";
            } else if (imEntranceMode === 2) {
              vm.urlb = "imDirectory";
              window.location.href = "#/imDirectory";
            }
          }

          console.log(vm.urlb);
        });
      }
    }
  }
});

/***/ }),

/***/ "KYqO":
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.4.0","/home/data/jenkins/workspace/prod-front_rampage-visitor-front-pc"]],"_development":true,"_from":"elliptic@6.4.0","_id":"elliptic@6.4.0","_inBundle":false,"_integrity":"sha1-ysmvh2LIWDYYcAPI3+GT5eLq5d8=","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.4.0","name":"elliptic","escapedName":"elliptic","rawSpec":"6.4.0","saveSpec":null,"fetchSpec":"6.4.0"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.0.tgz","_spec":"6.4.0","_where":"/home/data/jenkins/workspace/prod-front_rampage-visitor-front-pc","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.0"}

/***/ }),

/***/ "L3vZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LVwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inviteselect"
  }, [_c('im-top'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.entranceList), function(item, index) {
    return _c('p', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.setEntrance(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  })], 2)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__("nSh+")
    }
  }), _vm._v(" "), _c('span', [_vm._v("请选择你要咨询的问题类型")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LoGr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lp0V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "imLineUp"
  }, [_c('im-top'), _vm._v(" "), _c('div', {
    staticClass: "text text_top"
  }, [_vm._v("当前所有客服已经达到上限，请耐心等候")]), _vm._v(" "), _c('div', {
    staticClass: "text text_bottom"
  }, [_vm._v("我们很快就来接待您，谢谢")]), _vm._v(" "), _c('div', {
    staticClass: "imgwrap"
  }, [_c('img', {
    staticClass: "errImg",
    attrs: {
      "src": _vm.imgUrl + 'im-acc.png',
      "alt": "无客服"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text innerText"
  }, [_vm._v("当前等待人数")]), _vm._v(" "), _c('span', {
    staticClass: "text innerNum"
  }, [_vm._v(_vm._s(_vm.currentPosition))])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.giveUpInLine
    }
  }, [_vm._v("放弃排队")])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c500e2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("woAb");
function injectStyle (ssrContext) {
  __webpack_require__("8nuq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c500e2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MUwE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spirit_vue__ = __webpack_require__("7LOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8807eac8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_spirit_vue__ = __webpack_require__("D7uF");
function injectStyle (ssrContext) {
  __webpack_require__("rb5t")
  __webpack_require__("gI/3")
  __webpack_require__("piVf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8807eac8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spirit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8807eac8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_spirit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_request_js__ = __webpack_require__("vLgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_dompurify_html__ = __webpack_require__("FdM5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_dompurify_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_dompurify_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_js_buryingPoint_js__ = __webpack_require__("y5mz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_icon_iconfont_css__ = __webpack_require__("7xIN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_icon_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_icon_iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_default_index_css__ = __webpack_require__("q8zI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_video_js_dist_video_js_min_css__ = __webpack_require__("4L8C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_video_js_dist_video_js_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_video_js_dist_video_js_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_polyfill__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.axios = __WEBPACK_IMPORTED_MODULE_5__utils_request_js__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_dompurify_html___default.a, {
  default: {
    ADD_ATTR: ['target'],
    ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|about):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i
  }
  /*hooks: {
    afterSanitizeAttributes: (node, data) => {
      if (node.nodeName && node.nodeName.toLowerCase() === 'a' && !node.hasAttribute('href')) {
        node.setAttribute('href', 'about:blank')
      }
    }
  }*/
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$Points = __WEBPACK_IMPORTED_MODULE_7__assets_js_buryingPoint_js__["a" /* default */];
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "Ntul":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ai-interactive"
  }, [_c('top', {
    attrs: {
      "iskf": true,
      "isOrder": true
    },
    on: {
      "intoIm": _vm.goChat
    }
  }), _vm._v(" "), (_vm.carouselList && _vm.carouselList.length) ? _c('div', {
    staticClass: "top-carousel"
  }, [_c('el-carousel', {
    attrs: {
      "height": "200px",
      "indicator-position": "none"
    }
  }, _vm._l((_vm.carouselList), function(item, index) {
    return _c('el-carousel-item', {
      key: item,
      nativeOn: {
        "click": function($event) {
          _vm.swipeClick(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl
      }
    })])
  }))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ai-left-content"
  }, [_c('div', {
    staticClass: "hot-question"
  }, [_c('div', {
    staticClass: "hot-top-content"
  }, [_vm._m(0), _vm._v(" "), (_vm.total > _vm.hotParams.size) ? _c('div', {
    staticClass: "toggle-content",
    on: {
      "click": _vm.toggles
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-Toggle",
    style: ({
      color: _vm.boxBodyColor
    })
  }), _vm._v(" "), _c('span', {
    style: ({
      color: _vm.boxBodyColor
    })
  }, [_vm._v("换一换")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hot-btm-content"
  }, _vm._l((_vm.hotList), function(item, i) {
    return _c('div', {
      key: item.id,
      staticClass: "hot-item-content"
    }, [_c('div', {
      staticClass: "hot-item",
      on: {
        "click": function($event) {
          _vm.hotClick(item)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._m(1, true)])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "ai-right-content"
  }, [_c('div', {
    staticClass: "question-type"
  }, [_c('div', {
    staticClass: "question-type-content"
  }, [_c('div', {
    staticClass: "type-title"
  }, [_vm._v("全部问题类型")]), _vm._v(" "), _c('div', {
    staticClass: "type-btm-content"
  }, _vm._l((_vm.questionType), function(item, i) {
    return _c('div', {
      key: item.id,
      staticClass: "type-item",
      on: {
        "click": function($event) {
          _vm.itemClick(item)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.questionName))]), _c('i', {
      staticClass: "el-icon-arrow-right"
    })])
  }))])])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hot-title"
  }, [_c('span', [_vm._v("热点问题")]), _c('img', {
    attrs: {
      "src": __webpack_require__("cXrz"),
      "alt": ""
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hot-btm-right"
  }, [_c('span', [_vm._v("查看详情")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__("hZzz"),
      "alt": ""
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O4Gp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workerorderindex"
  }, [_c('top'), _vm._v(" "), _c('div', {
    staticClass: "nav"
  }, [_c('router-link', {
    staticStyle: {
      "color": "rgb(31, 55, 61)"
    },
    attrs: {
      "to": _vm.urlb
    }
  }, [_c('span', {
    on: {
      "click": _vm.hisback
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _vm._l((_vm.questionclass), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "navbread"
    }, [_vm._v(_vm._s('>' + item))])
  }), _vm._v(" "), _c('a', {
    staticClass: "btna color",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "href": "#/myorder"
    }
  }, [_vm._v("我的工单")])], 2), _vm._v(" "), _vm._l((_vm.showdata), function(item, index1) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.contentis),
        expression: "contentis"
      }],
      key: index1,
      staticClass: "content"
    }, [(item.typeId == 12) ? _c('div', [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-select', {
      staticClass: "wid",
      on: {
        "visible-change": function($event) {
          _vm.changedata(item)
        },
        "change": function($event) {
          _vm.datacommit(_vm.gamevalue[item.id], item)
        }
      },
      model: {
        value: (_vm.gamevalue[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.gamevalue, item.id, $$v)
        },
        expression: "gamevalue[item.id]"
      }
    }, _vm._l((_vm.gamearea[item.id]), function(item) {
      return _c('el-option', {
        key: item.label,
        attrs: {
          "label": item.label,
          "value": item.value
        }
      })
    }))], 1) : (item.typeId == 1) ? _c('div', {
      staticClass: "dns"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.dns[item.id], item)
        }
      },
      model: {
        value: (_vm.dns[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.dns, item.id, $$v)
        },
        expression: "dns[item.id]"
      }
    })], 1) : (item.typeId == 5) ? _c('div', {
      staticClass: "dns"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.phonenumver[item.id], item)
        }
      },
      model: {
        value: (_vm.phonenumver[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.phonenumver, item.id, $$v)
        },
        expression: "phonenumver[item.id]"
      }
    })], 1) : (item.typeId == 6) ? _c('div', {
      staticClass: "dns"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.number[item.id], item)
        }
      },
      model: {
        value: (_vm.number[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.number, item.id, $$v)
        },
        expression: "number[item.id]"
      }
    })], 1) : (item.typeId == 7) ? _c('div', {
      staticClass: "dns"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.idcard[item.id], item)
        }
      },
      model: {
        value: (_vm.idcard[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.idcard, item.id, $$v)
        },
        expression: "idcard[item.id]"
      }
    })], 1) : (item.typeId == 8) ? _c('div', {
      staticClass: "dns"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.email[item.id], item)
        }
      },
      model: {
        value: (_vm.email[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.email, item.id, $$v)
        },
        expression: "email[item.id]"
      }
    })], 1) : (item.typeId == 2) ? _c('div', {
      staticClass: "explain"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "type": "textarea",
        "rows": 4,
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.explain[item.id], item)
        }
      },
      model: {
        value: (_vm.explain[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.explain, item.id, $$v)
        },
        expression: "explain[item.id]"
      }
    })], 1) : (item.typeId == 13) ? _c('div', {
      staticClass: "sex"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-radio-group', {
      staticClass: "radio",
      on: {
        "change": function($event) {
          _vm.datacommit(_vm.sex[item.id], item)
        }
      },
      model: {
        value: (_vm.sex[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.sex, item.id, $$v)
        },
        expression: "sex[item.id]"
      }
    }, _vm._l((_vm.sexlabel[item.id]), function(ele, index2) {
      return _c('el-radio', {
        key: index2,
        attrs: {
          "label": ele.value
        }
      }, [_vm._v(_vm._s(ele.value))])
    }))], 1) : (item.typeId == 9) ? _c('div', {
      staticClass: "picture"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('p', {
      staticClass: "pictureclass",
      staticStyle: {
        "width": "300px",
        "float": "left"
      }
    }, [_vm._v("为了帮助您更好的解决问题,请上传相关描述的图片。每张不超过9M，支持jpg、png、bmp、gif")]), _vm._v(" "), _c('el-upload', {
      staticClass: "upload-demo wid",
      attrs: {
        "action": _vm.action,
        "on-success": _vm.handlePreview,
        "on-remove": _vm.handleRemove,
        "before-upload": _vm.beforeload,
        "file-list": _vm.fileList2[item.name],
        "list-type": "picture",
        "withCredentials": true
      }
    }, [(_vm.picid[item.id] == true) ? _c('el-button', {
      staticClass: "color",
      staticStyle: {
        "margin-top": "10px"
      },
      style: ({
        backgroundColor: _vm.boxBodyColor
      }),
      attrs: {
        "id": item.spanid + 'a',
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.datacommit(_vm.fileList2[item.name], item)
        }
      }
    }, [_vm._v(" 添加文件 ")]) : _vm._e()], 1)], 1) : (item.typeId == 14) ? _c('div', {
      staticClass: "city"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-checkbox-group', {
      staticClass: "cityclass",
      attrs: {
        "min": 1
      },
      on: {
        "change": function($event) {
          _vm.datacommit(_vm.checkedCities1[item.id], item)
        }
      },
      model: {
        value: (_vm.checkedCities1[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.checkedCities1, item.id, $$v)
        },
        expression: "checkedCities1[item.id]"
      }
    }, _vm._l((_vm.cities[item.id]), function(city) {
      return _c('el-checkbox', {
        key: city,
        attrs: {
          "label": city
        }
      }, [_vm._v(_vm._s(city))])
    }))], 1) : (item.typeId == 3) ? _c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('div', {
      staticClass: "block"
    }, [_c('el-date-picker', {
      staticClass: "time",
      attrs: {
        "type": "date",
        "placeholder": item.defaultContent,
        "picker-options": _vm.pickerOptions0
      },
      on: {
        "change": function($event) {
          _vm.datacommit(_vm.datetime[item.id], item)
        }
      },
      model: {
        value: (_vm.datetime[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.datetime, item.id, $$v)
        },
        expression: "datetime[item.id]"
      }
    })], 1)]) : (item.typeId == 4) ? _c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('div', {
      staticClass: "block"
    }, [_c('el-time-picker', {
      staticClass: "time",
      attrs: {
        "type": "date",
        "placeholder": item.defaultContent
      },
      on: {
        "change": function($event) {
          _vm.datacommit(_vm.hourtime[item.id], item)
        }
      },
      model: {
        value: (_vm.hourtime[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.hourtime, item.id, $$v)
        },
        expression: "hourtime[item.id]"
      }
    })], 1)]) : (item.typeId == 15) ? _c('div', {
      staticClass: "picture"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('p', {
      staticClass: "pictureclass",
      staticStyle: {
        "width": "300px",
        "float": "left"
      }
    }, [_vm._v("为了帮助您更好的解决问题,请上传相关描述的视频。视频大小不超过500M")]), _vm._v(" "), _c('el-upload', {
      staticClass: "upload-demo wid",
      attrs: {
        "action": _vm.action,
        "on-success": _vm.handleVideoPreview,
        "on-remove": _vm.handleVideoRemove,
        "before-upload": _vm.videoBeforeload,
        "file-list": _vm.fileVideoList[item.id],
        "list-type": "picture",
        "accept": "video/*",
        "withCredentials": true
      }
    }, [(_vm.picid[item.id] == true) ? _c('el-button', {
      staticClass: "color",
      staticStyle: {
        "margin-top": "10px"
      },
      style: ({
        backgroundColor: _vm.boxBodyColor
      }),
      attrs: {
        "id": item.spanid + 'a',
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.datacommit(_vm.fileVideoList[item.id], item)
        }
      }
    }, [_vm._v(" 添加文件 ")]) : _vm._e()], 1)], 1) : (item.typeId == 16) ? _c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('div', {
      staticClass: "block"
    }, [_c('el-date-picker', {
      staticClass: "time",
      attrs: {
        "type": "datetime",
        "value-format": "yyyy-MM-dd HH:mm:ss",
        "placeholder": item.defaultContent || '选择日期时间'
      },
      on: {
        "change": function($event) {
          _vm.datacommit(_vm.datetimes[item.id], item)
        }
      },
      model: {
        value: (_vm.datetimes[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.datetimes, item.id, $$v)
        },
        expression: "datetimes[item.id]"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), ((item.required == true && (item.typeId == 12 || item.typeId == 13 || item.typeId == 14) && (item.enteredValue == '' || item.enteredValue == null)) || (item.required == true && !(item.typeId == 12 || item.typeId == 13 || item.typeId == 14) && (item.enteredValue == '' || item.enteredValue == null))) ? _c('span', {
      staticClass: "error1",
      attrs: {
        "id": item.spanid
      }
    }, [_vm._v("*必填项")]) : _c('span', {
      staticClass: "error1",
      attrs: {
        "id": item.spanid
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "clear": "both"
      }
    })])
  }), _vm._v(" "), (_vm.contentis == true && _vm.btnclass == 1) ? _c('div', {
    staticClass: "btn"
  }, [_c('el-button', {
    staticClass: "color",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.commit
    }
  }, [_vm._v("提交")])], 1) : (_vm.contentis == true && _vm.btnclass == 2) ? _c('div', {
    staticClass: "btn"
  }, [_c('el-button', {
    staticClass: "color",
    staticStyle: {
      "background": "#ccc"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("提交")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.downloadis),
      expression: "downloadis"
    }],
    staticClass: "download"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("J/XN")
    }
  }), _vm._v(" "), _c('p', [_vm._v("正在提交...")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successis),
      expression: "successis"
    }],
    staticClass: "success"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("IjaA")
    }
  }), _vm._v(" "), _c('h4', [_vm._v("提交成功,感谢您的反馈！")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.jishi + '秒之后返回首页'))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.erroris),
      expression: "erroris"
    }],
    staticClass: "success"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("JEjz")
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "error"
  }, [_vm._v("问题反馈失败,请稍后再试！")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.jishi + '秒之后返回首页'))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginis),
      expression: "loginis"
    }],
    staticClass: "login"
  }, [_c('p', [_vm._v("手机号为查看单据处理结果的依据")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("手机号")]), _vm._v(" "), _c('el-input', {
    staticClass: "phonenumber",
    attrs: {
      "placeholder": "请输入手机号码"
    },
    on: {
      "blur": _vm.phonego
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.phoneis))])], 1), _vm._v(" "), _c('div', {
    staticClass: "mat"
  }, [_c('span', [_vm._v("随机码")]), _vm._v(" "), _c('el-input', {
    staticClass: "verify",
    attrs: {
      "placeholder": "短信随机码"
    },
    model: {
      value: (_vm.verify),
      callback: function($$v) {
        _vm.verify = $$v
      },
      expression: "verify"
    }
  }), _vm._v(" "), (_vm.verifyis) ? _c('span', {
    staticClass: "verifybtn",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    on: {
      "click": _vm.verifygo
    }
  }, [_vm._v("获取随机码")]) : _c('span', {
    staticClass: "verifybtn",
    style: ({
      backgroundColor: _vm.boxBodyColor
    })
  }, [_vm._v(_vm._s(_vm.timesecond + "s"))]), _vm._v(".\n         "), _c('p', [_vm._v(_vm._s(_vm.veris))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "color verbtn",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.verifyconfirm
    }
  }, [_vm._v("下一步")])], 1)], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ozlq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_components_url__ = __webpack_require__("vpRr");



var baseUrl = __WEBPACK_IMPORTED_MODULE_2__src_components_url__["a" /* baseurl */] + '/api/visitor/service';
var instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  // baseURL: baseUrl,
  timeout: 10000,
  withCredentials: true
});

/* harmony default export */ __webpack_exports__["a"] = ({
  getCarousel: function getCarousel(visitorMd5Code, callback) {
    instance.get(baseUrl + '/navi/questionTypeAndCarousel?visitorMd5Code=' + visitorMd5Code, { withCredentials: true }).then(function (resp) {
      callback(resp.data);
    }, function (errorMessage) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_element_ui__["MessageBox"])('提示', '网络异常，请稍后再试');
    });
  },
  getHotList: function getHotList(params, callback) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(baseUrl + '/navi/hotIssue?visitorMd5Code=' + params.visitorMd5Code + '&page=' + params.page + '&size=' + params.size, { withCredentials: true }).then(function (resp) {
      callback(resp.data);
    }, function (errorMessage) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_element_ui__["MessageBox"])('提示', '网络异常，请稍后再试');
    });
  },
  getTypeDetails: function getTypeDetails(params, callback) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(baseUrl + '/navi/questionType?visitorMd5Code=' + params.visitorMd5Code + '&id=' + params.id, { withCredentials: true }).then(function (resp) {
      callback(resp.data);
    }, function (errorMessage) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_element_ui__["MessageBox"])('提示', '网络异常，请稍后再试');
    });
  },
  getCrouselDetails: function getCrouselDetails(params, callback) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(baseUrl + '/navi/carousel?visitorMd5Code=' + params.visitorMd5Code + '&id=' + params.id, { withCredentials: true }).then(function (resp) {
      callback(resp.data);
    }, function (errorMessage) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_element_ui__["MessageBox"])('提示', '网络异常，请稍后再试');
    });
  },

  // IM
  getEnable: function getEnable(params, callback) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(baseUrl + '/navi/enable?visitorMd5Code=' + params.visitorMd5Code, { withCredentials: true }).then(function (resp) {
      callback(resp.data);
    }, function (errorMessage) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_element_ui__["MessageBox"])('提示', '网络异常，请稍后再试');
    });
  },

  // 热点
  getHotIssue: function getHotIssue(params, callback) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(baseUrl + '/navi/getHotIssue?visitorMd5Code=' + params.visitorMd5Code + '&id=' + params.id, { withCredentials: true }).then(function (resp) {
      callback(resp.data);
    }, function (errorMessage) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_element_ui__["MessageBox"])('提示', '网络异常，请稍后再试');
    });
  },

  /*
  * code
  * talkId
  * type
  * id
  */
  logPoint: function logPoint(params, callback) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__src_components_url__["a" /* baseurl */] + '/api/visitor/log/click', { params: params }).then(function (resp) {
      callback(resp.body);
    }, function (errorMessage) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_element_ui__["MessageBox"])('提示', '网络异常，请稍后再试');
    });
  }
  // ?id=15&visitorMd5Code=6459b13ac009039c9805e79723d9147f
  // getHotIssue (visitorMd5Code, message,callback) {
  //   axios.post(imUrl + '/autoMessage', message, {params: {visitorMd5Code, visitorMd5Code}}).then(function (resp) {
  //     callback(resp.data)
  //   }, function (errorMessage) {
  //     MessageBox('提示', '网络异常，请稍后再试')
  //   })
  // },

});

/***/ }),

/***/ "PH0M":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAVCAYAAAByrA+0AAABBElEQVQ4jY3SOTMDcRzH4UfotCRxVcaVjBmN3mJGo9d7Y2qvQOGITpPCMeIaCgYJeo1Csb+d2YlkY9v9PLv/2f0ONZvNMwxjGx8GXCWMYhUNlP8DtnCLWqDKIPCOBDc5VC0C0A7UwlKgiSIAnUDXWAw0WQRIv1KCKywEmioC8IkNXGI+0HQRyNAmLjCH0wz1A3l0jtlAM0UAvrCDn0B7g8AY9jGCJ+wWgTEcYgWPWMNzPzCOo4gfIn4Rr+oVH2MZ91jHa3azG5RxgjruIn7LB/kjVaQ/qS5db9Id50E14pp0tYl0xX+uknSVDelKWxG3e8UZOJCusxVn7vSLM/CNZjy5MIZfkWU8kv67YJEAAAAASUVORK5CYII="

/***/ }),

/***/ "PIXh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__url_js__ = __webpack_require__("vpRr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_request_js__ = __webpack_require__("vLgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Constants__ = __webpack_require__("E3qV");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'workcommit',
  data: function data() {
    return {
      paixu: [],
      boxBodyColor: '',
      logoUrl: '',
      companyName: '',
      displayMode: '',
      btnclass: 2,
      btnis: false,
      urlbridge: "",
      videobridge: "",
      fileVideoList: {},
      datetimes: {},
      jishi: 5,
      kefuis: false,
      action: '',
      phone: "",
      phoneis: "",
      veris: '',
      verify: "",
      verifyis: true,
      timesecond: 60,
      basurl: __WEBPACK_IMPORTED_MODULE_1__url_js__["a" /* baseurl */],
      md5: "",
      href: "",
      showdata: [],
      erroris: false,
      successis: false,
      downloadis: false,
      loginis: false,
      contentis: false,
      pickerOptions0: {
        // disabledDate(time) {
        //   return time.getTime() < Date.now() - 8.64e7;
        // }
      },
      commitis: false,
      commitLoading: false,
      datetime: {},
      hourtime: {},
      phonenumver: {},
      number: {},
      idcard: {},
      email: {},
      fileList2: {},
      allquestion: [],
      questionclass: [],
      gamearea: {},
      gamevalue: {},
      dns: {},
      explain: {},
      sex: {},
      sexlabel: {},
      hobbys: [{ value: "运动", is: false }, { value: "宅", is: false }, { value: "电影", is: false }, { value: "美食", is: false }, { value: "DIY", is: false }],
      checkedCities1: {},
      cities: {},
      parmas: [],
      submittable: {},
      picid: {}
    };
  },

  props: ['workOrderId', 'msgId'],
  mounted: function mounted() {
    var vm = this;
    vm.boxBodyColor = sessionStorage.getItem('boxBodyColor');
    vm.companyName = sessionStorage.getItem('companyName');

    vm.logoUrl = sessionStorage.getItem('logoUrl');
    vm.displayMode = sessionStorage.getItem('displayMode');
    this.questionclass = [];
    this.questionclass.push(sessionStorage.getItem("navname"));
    this.questionclass.push("单据提交");
    this.md5 = sessionStorage.getItem("md5");
    //this.href= window.location.href.split("?")[1];
    this.href = this.workOrderId;
    if (this.href == "butianinfor") {
      this.butianinfor();
    } else {
      this.showis();
    }

    //判断客服是否显示
    __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/product/conf/showOnlineService?visitorMd5Code=' + this.md5).then(function (response) {
      if (response.data.code == 1) {
        vm.kefuis = true;
      }
    });
  },

  methods: {
    //判断跳转页面
    kefugo: function kefugo() {
      __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/product/conf/redirectToOnlineService?visitorMd5Code=' + this.md5).then(function (response) {

        if (response.data.code == 1) {
          var obj = response.data.data;

          if (obj.imStatus == " waiting") {

            window.location.href = "#/imLineUp";
          } else if (obj.imStatus == "chatting") {

            window.location.href = "#/imSession";
          } else {
            if (obj.target == 1) {
              window.location.href = "#/spirit";
            }
            if (obj.target == 2) {
              window.location.href = "#/imDirectory";
            }
          }
        }
      });
    },

    //加入判断是否已经添加
    datacommitis: function datacommitis(name, value, id) {
      var vm = this;
      var is = true;
      this.parmas.forEach(function (item, index) {
        if (item.id == name) {
          item.value = value;
          is = false;
          //vm.commitis=true;
          vm.submittable[id] = true;
          document.getElementById(id).innerHTML = " ";
        }
      });
      //console.log(this.parmas)
      return is;
    },

    //改变级联的值
    changedata: function changedata(item, id) {
      var vm = this;
      if (item.parentId != null && item.parentId != "" && item.parentId != undefined && item.parentId != " ") {
        //vm.$set( vm.gamearea,obj.id,arr);
        //vm.$set( vm.gamevalue,obj.id,obj.defaultContent);
        console.log(vm.gamevalue[item.parentId]);
        if (vm.gamevalue[item.parentId] != "") {
          __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/dataDicList/' + item.id + '?visitorMd5Code=' + this.md5 + "&parentId=" + vm.gamevalue[item.parentId]).then(function (response) {
            if (response.data.code == 1) {
              console.log(response);
              // console.log(vm.gamearea[obj.id])
              // console.log(vm.gamearea)
              var arrdata = response.data.data;
              //console.log(arrdata)
              var arr = [];
              arrdata.forEach(function (element, index) {
                var obj = {};
                obj.value = element.id;
                obj.label = element.content;
                arr.push(obj);
              });
              //console.log(arr)
              vm.gamearea[item.id] = [];
              vm.$set(vm.gamearea, item.id, arr);
              vm.$set(vm.gamevalue, item.id, vm.gamevalue[item.id]);
              // console.log(vm.gamearea);
              // console.log(vm.gamevalue)
            }
          });
        }
      }
    },

    //清空父节点
    clearparnt: function clearparnt(item) {
      var vm = this;
      //console.log(item.id);
      this.showdata.forEach(function (element, index) {
        if (element.parentId == item.id) {
          //console.log(element);
          var arr = [];
          //vm.gamearea[element.id]=arr;
          vm.$set(vm.gamearea, element.id, arr);
          vm.$set(vm.gamevalue, element.id, "");
          //console.log(vm.gamearea)
        }
      });
    },

    //收集这个值
    datacommit: function datacommit(value, item) {
      //console.log(e.target,"e.target")
      var typeid = item.typeId;
      //console.log(item.maxLength)
      var length = item.maxLength;
      var require = item.required;
      var name = item.name;
      var spanid = item.spanid;
      if (typeid == 3) {
        var now = new Date(value);
        var year = now.getFullYear();
        var month = (now.getMonth() + 1).toString();
        var day = now.getDate().toString();
        if (month.length == 1) {
          month = "0" + month;
        }
        if (day.length == 1) {
          day = "0" + day;
        }
        value = year + "-" + month + "-" + day;
        //console.log(value)
      }
      if (typeid == 16) {
        var _now = new Date(value);
        var _year = _now.getFullYear();
        var _month = (_now.getMonth() + 1).toString();
        var _day = _now.getDate().toString();
        var hours = _now.getHours();
        var minutes = _now.getMinutes();
        if (_month.length == 1) {
          _month = "0" + _month;
        }
        if (_day.length == 1) {
          _day = "0" + _day;
        }
        if (hours.length == 1) {
          hours = "0" + hours;
        }
        if (minutes.length == 1) {
          minutes = "0" + minutes;
        }
        value = _year + "-" + _month + "-" + _day + " " + hours + ":" + minutes;
      }
      if (typeid == 4) {
        var now = new Date(value);
        var hour = now.getHours();
        var minute = now.getMinutes();
        if (hour < 10) {
          hour = "0" + hour;
        }
        if (minute < 10) {
          minute = "0" + minute;
        }
        value = hour + ":" + minute;
        //console.log(value)
      }
      //console.log(value+"/"+typeid);
      var valueis = false;
      var obj = {};
      //单选和多选框
      if (typeid == 1 || typeid == 2) {
        //console.log(value.replace(/(^s*)|(s*$)/g, ""))
        if (value.length > length || value == undefined || value == '' || value.match(/^[ ]+$/)) {
          valueis = false;
        } else {
          valueis = true;
        }
        console.log(value);
        if (require == false && (value == undefined || value == '' || value == ' ' || value.match(/^[ ]+$/))) {
          valueis = true;
        }
        if (valueis == false) {
          var message = '请输入长度为1~' + length + '字符';
          document.getElementById(spanid).innerHTML = message;
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.id = item.id;
            this.parmas.push(obj);
          }
          this.submittable[spanid] = true;
          document.getElementById(spanid).innerHTML = "";
        }
      }
      //日期框
      if (typeid == 3) {

        if (value == "NaN-NaN-NaN") {
          valueis = false;
        } else {
          valueis = true;
        }
        if (require == false && value == "NaN-NaN-NaN") {
          valueis = true;
        }

        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "*必填项";
          this.submittable[spanid] = false;
          valueis = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.id = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = "";
          }
          valueis = true;
        }
      }
      //时间框判断
      if (typeid == 4) {

        if (value == "NaN:NaN") {
          valueis = false;
        } else {
          valueis = true;
        }
        if (require == false && value == "NaN:NaN") {
          valueis = true;
        }

        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "*必填项";
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.id = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = "";
          }
        }
      }
      if (typeid == 16) {
        if (value == "NaN-NaN-NaN NaN:NaN") {
          valueis = false;
        } else {
          valueis = true;
        }
        if (require == false && value == "NaN-NaN-NaN NaN:NaN") {
          valueis = true;
        }

        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "*必填项";
          this.submittable[spanid] = false;
          valueis = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          console.log(value, is, '=========222==========');
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.id = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = "";
          }
          //  valueis=true;
        }
      }
      // 手机号验证
      if (typeid == 5) {
        var phoneis = /^1\d{10}$/.test(value);
        if (phoneis == false) {
          valueis = false;
        } else {
          valueis = true;
        }
        console.log(value);
        if (require == false && (value == undefined || value == '')) {
          valueis = true;
        }
        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "请输入正确的手机号";
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.id = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = "";
          }
        }
      }
      // 数字文本框
      if (typeid == 6) {
        //alert("jinlai")
        console.log(document.getElementById(spanid).innerHTML, "innerHtml");
        var numberis = /^\d+$/.test(value);
        if (numberis == false) {
          valueis = false;
        } else {
          if (value.length > length) {
            valueis = false;
          } else {
            valueis = true;
          }
        }

        if (require == false && (value == undefined || value == '')) {
          valueis = true;
        }
        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "请输入长度为1~" + length + "的数字";
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.id = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = "";
            //alert("更细吧 ！！")
            console.log(document.getElementById(spanid), "123123123");
          }
        }
      }
      // 身份证文本框

      if (typeid == 7) {
        var idcardis = /^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/.test(value);
        if (idcardis == false) {
          valueis = false;
        } else {
          valueis = true;
        }
        if (require == false && (value == undefined || value == '')) {
          valueis = true;
        }
        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "请输入正确的身份证号";
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.id = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = "";
          }
        }
      }

      //邮箱地址
      if (typeid == 8) {
        var emlis = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/.test(value);
        if (emlis == false) {

          valueis = false;
        } else {
          if (value != undefined) {
            if (value.length > length) {
              valueis = false;
            } else {
              valueis = true;
            }
          }
        }
        console.log(value);
        if (require == false && (value == undefined || value == '')) {
          valueis = true;
        }
        if (length != null) {
          var text = "请输入" + length + "位以内正确的邮箱地址";
        } else {
          var text = "请输入正确的邮箱地址";
        }

        if (valueis == false) {
          document.getElementById(spanid).innerHTML = text;
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.id = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = "";
          }
        }
      }
      //文件上传
      if (typeid == 9) {
        this.urlbridge = item;
        //obj[name]=value;
        //this.parmas.push(obj)
      }
      // 上传视频
      if (typeid == 15) {
        console.log(item, '9999999999999999');
        this.videobridge = item;
      }
      //下拉框
      if (typeid == 12) {
        var vname = "";
        this.gamearea[item.id].forEach(function (element, index) {
          if (element.value == value) {
            vname = element.label;
            value = vname;
          }
        });
        //console.log(value)
        if (value != undefined && value != '') {
          valueis = true;
        } else {
          valueis = false;
        }

        if (require == false) {
          valueis = true;
        }

        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "*必填项";
          this.submittable[spanid] = false;
        } else {
          this.clearparnt(item);
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.id = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = "";
          }
        }
      }
      //单选框
      if (typeid == 13) {
        //console.log(value,"hhhhh")
        if (value != undefined && value != '') {
          valueis = true;
        } else {
          valueis = false;
        }
        if (require == false && value == "") {
          valueis = true;
        }
        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "*必填项";
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.id = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = "";
          }
        }
      }
      //多选框
      if (typeid == 14) {
        //console.log(value)
        if (value.length > 0) {
          valueis = true;
        } else {
          valueis = false;
        }
        if (require == false) {
          valueis = true;
        }
        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "*必填项";
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.id = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = "";
          }
        }
      }

      var comit = true;
      var dataobj = this.submittable;
      //console.log(dataobj)
      for (var key in dataobj) {

        if (dataobj[key] == false) {
          comit = false;
        }
      }
      if (comit == true) {
        this.btnclass = 1;
      }
      // if(valueis==false){

      //   this.commitis=false;
      // }else{
      //   this.commitis=true;
      // }
      //console.log(this.commitis)
    },
    heightlight: function heightlight(index) {
      var is = this.hobbys[index].is;
      if (is) {
        this.hobbys[index].is = false;
      } else {
        this.hobbys[index].is = true;
      }
    },
    videoBeforeload: function videoBeforeload(file) {
      console.log(file);
      var typeis = false;

      // var arr=file.name.split(".");
      var type = file.type;
      //console.log(type)
      if (/^video\/.*$/.test(type)) {
        typeis = true;
      }
      if (typeis == false) {
        this.$message.error('文件格式不正确');
        return false;
      }
      if (file.size / 1024 > 1024 * 500) {
        this.$message.error('文件大于500M');
        return false;
      }
    },
    beforeload: function beforeload(file) {
      console.log(file);
      var typeis = false;

      // var arr=file.name.split(".");
      var type = file.type;
      //console.log(type)
      if (/(gif|jpg|jpeg|bmp|png)$/.test(type)) {
        typeis = true;
      }
      if (typeis == false) {
        this.$message.error('文件格式不正确');
        return false;
      }
      if (file.size / 1024 > 1024 * 9) {
        this.$message.error('文件大于9M');
        return false;
      }
    },
    handleRemove: function handleRemove() {
      var vm = this;
      //alert(1)
      //console.log(this.urlbridge)
      // if(this.urlbridge==""){
      //   this.urlbridge=obj;
      // }
      vm.$set(vm.picid, this.urlbridge.id, true);
      //console.log( this.picid)
      //document.getElementById(this.urlbridge.spanid+"a").style.display ="block";
      if (this.urlbridge.required == true) {
        document.getElementById(this.urlbridge.spanid).innerHTML = "*必填项";
        this.submittable[this.urlbridge.spanid] = false;
      }
      this.urlbridge = " ";
    },
    handleVideoRemove: function handleVideoRemove() {
      var vm = this;
      vm.$set(vm.picid, this.videobridge.id, true);
      //console.log( this.picid)
      //document.getElementById(this.videobridge.spanid+"a").style.display ="block";
      if (this.videobridge.required == true) {
        document.getElementById(this.videobridge.spanid).innerHTML = "*必填项";
        this.submittable[this.videobridge.spanid] = false;
      }
      this.videobridge = " ";
    },
    handlePreview: function handlePreview(response, file, fileList) {
      console.log(this.picid[this.urlbridge.id]);
      console.log(response);
      if (response.code == 1) {
        var vm = this;
        //document.getElementById(this.urlbridge.spanid+"a").style.display ="none";
        vm.$set(vm.picid, this.urlbridge.id, false);
        //this.picid[this.urlbridge.id]=false;
        console.log(this.picid);
        document.getElementById(this.urlbridge.spanid).innerHTML = " ";
        var is = this.datacommitis(this.urlbridge.id, response.data, this.urlbridge.spanid);
        if (is) {
          this.submittable[this.urlbridge.spanid] = true;
          var obj = {};
          obj.name = this.urlbridge.name;
          obj.id = this.urlbridge.id;
          obj.value = response.data;
          this.parmas.push(obj);
          var comit = true;
          var dataobj = this.submittable;
          console.log(dataobj);
          for (var key in dataobj) {

            if (dataobj[key] == false) {
              comit = false;
            }
          }
          if (comit == true) {
            this.btnclass = 1;
          }
        }
      }
    },
    handleVideoPreview: function handleVideoPreview(response, file, fileList) {
      console.log(this.picid[this.videobridge.id]);
      console.log(response);
      if (response.code == 1) {
        var vm = this;
        //document.getElementById(this.videobridge.spanid+"a").style.display ="none";
        vm.$set(vm.picid, this.videobridge.id, false);
        //this.picid[this.videobridge.id]=false;
        console.log(this.picid);
        document.getElementById(this.videobridge.spanid).innerHTML = " ";
        var is = this.datacommitis(this.videobridge.id, response.data, this.videobridge.spanid);
        if (is) {
          this.submittable[this.videobridge.spanid] = true;
          var obj = {};
          obj.name = this.videobridge.name;
          obj.id = this.videobridge.id;
          obj.value = response.data;
          this.parmas.push(obj);
          var comit = true;
          var dataobj = this.submittable;
          console.log(dataobj);
          for (var key in dataobj) {

            if (dataobj[key] == false) {
              comit = false;
            }
          }
          if (comit == true) {
            this.btnclass = 1;
          }
        }
      }
    },
    commit: function commit() {
      var vm = this;
      var comit = true;
      var dataobj = this.submittable;
      vm.commitLoading = true; // 设置提交按钮为 loading 状态
      console.log(this.parmas);
      for (var key in dataobj) {

        if (dataobj[key] == false) {
          comit = false;
        }
      }

      if (comit == true) {
        var obj = {};
        obj.orderId = this.href;
        var arr = [];

        this.parmas.forEach(function (element, index) {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(element.value) == "object") {
            var str = element.value.join(",");
            element.value = str;
          }
        });
        //排序
        var l = this.parmas.length;
        this.paixu.forEach(function (element, index) {
          var haveis = false;
          for (var i = 0; i < l; i++) {
            if (vm.parmas[i].id == element.id) {
              var obj = {};
              obj.fieldId = vm.parmas[i].id;
              obj.name = vm.parmas[i].name;
              obj.value = vm.parmas[i].value;
              haveis = true;
              arr.push(obj);
            }
          }
          if (haveis == false) {
            if (element.typeId == 14) {
              var obj2 = {};
              obj2.fieldId = element.id;
              obj2.name = element.name;
              obj2.value = element.defaultContent;
              arr.push(obj2);
            } else {
              var obj = {};
              obj.fieldId = element.id;
              obj.name = element.name;
              obj.value = "";
              arr.push(obj);
            }
          }
        });

        obj.variables = arr;
        // console.log(this.parmas)
        // console.log(this.paixu)
        console.log(obj.variables);
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].post(this.basurl + '/api/visitor/wo/submitOrder?visitorMd5Code=' + this.md5, obj).then(function (response) {
          vm.commitLoading = false; // 提交后恢复提交按钮的状态
          if (response.data.code == 1) {
            var _obj = {};
            console.log(response.data.data, "123123");
            var content = response.data.data.orderName;

            __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].post(vm.basurl + '/api/visitor/im/confirmEvent/' + vm.msgId + '?visitorMd5Code=' + vm.md5, _obj).then(function (response) {
              if (response.data.code == 1) {
                vm.successis = true;
                vm.contentis = false;
                vm.$store.dispatch({
                  type: 'workOrderSubmittied',
                  workOrderId: vm.workOrderId,
                  orderName: content,
                  router: vm.$router,
                  visitorMd5Code: sessionStorage.md5,
                  msgId: vm.msgId
                });
                // vm.$store.commit('addMessageContentToMessageList', {
                //             type: Constants.TEXT_TYPE,
                //             data: '您已提交了工单: ' + content,
                //             // seq: imMsgHeader.seqOrigin,
                //             // sessionId: imMsgHeader.sessionId,
                //             // msgId: imMsgHeader.msgId,
                //             // sendFrom: imMsgHeader.fromId,
                //             userNickName: vm.$store.state.im.userNickNamePool[vm.$store.state.im.currentUserId]
                // })
              }
            });
          } else if (response.data.code == 401) {
            console.log("401");
            vm.loginis = true;
            vm.contentis = false;
          } else if (response.data.code == 400) {
            vm.erroris = true;
            vm.contentis = false;
            var tme = setInterval(function () {
              vm.jishi = vm.jishi - 1;
              if (vm.jishi == 0) {
                window.location.reload();
                clearInterval(tme);
              }
            }, 1000);
          }
        });
      } else {
        this.$message({
          message: '数据填写错误',
          type: 'warning'
        });
        vm.commitLoading = false; // 提交失败后恢复提交按钮的状态
      }

      // window.location.href="/#/workdetail"
    },

    //
    butianinfor: function butianinfor() {
      var vm = this;
      var obj = JSON.parse(sessionStorage.getItem('butianinfor'));
      __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/processInstanceFields/' + obj.processInstanceId + '?visitorMd5Code=' + this.md5).then(function (response) {
        if (response.data.code = 1) {
          vm.show(response.data, 2);
        };
      });
      //console.log(obj)
    },

    //展示数据
    show: function show(data, index) {
      var arrda = data.data;
      var vm = this;
      arrda.forEach(function (item, index) {
        vm.paixu.push(item);
        item.spanid = vm.workOrderId + index + Number(new Date());
        if (item.typeId == 9 || item.typeId == 15) {
          vm.$set(vm.picid, item.id, true);
          //console.log(vm.picid)
        }
        if (item.required == true && (item.typeId == 12 || item.typeId == 13 || item.typeId == 14) && item.defaultContent == '' || item.required == true && !(item.typeId == 12 || item.typeId == 13 || item.typeId == 14)) {
          vm.submittable[item.spanid] = false;
        } else {
          vm.submittable[item.spanid] = true;
        }
        vm.showdata.push(item);
        vm.datacollect(item);
      });
      //console.log(this.submittable)
      //console.log(arrda,"555")
      //console.log(vm.paixu)
    },

    //判断是否授权
    showis: function showis() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/getFields/' + this.href + '?visitorMd5Code=' + this.md5).then(function (response) {
        var da = response.data;
        console.log(da, "da");

        if (da.code == 1) {
          vm.loginis = false;
          // vm.successis = true;
          vm.contentis = true;

          vm.show(da, 1);
        } else if (da.code == 401) {
          vm.contentis = false;
          vm.loginis = true;
        }
      });
    },

    //手机验证
    verifyconfirm: function verifyconfirm() {
      //console.log( this.verify)
      var vm = this;
      vm.veris = "";
      if (this.verify != "" && this.btnis == true) {
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].post(this.basurl + '/api/visitor/wo/msgCaptchaValid?visitorMd5Code=' + this.md5 + "&phoneNum=" + this.phone + "&code=" + this.verify).then(function (response) {
          if (response.data.code == 1) {
            // vm.showis();
            vm.veris = "";
            vm.loginis = false;
            vm.commit();
          } else if (response.data.code == 0) {
            vm.veris = "验证码已过期请重新获取";
          } else if (response.data.code == 4032) {
            this.$message.error('获取验证码过于频繁');
          } else {
            vm.veris = "验证码填写错误";
          }
        });
      } else {
        vm.veris = "请获取验证码";
      }
    },
    verifygo: function verifygo() {
      var vm = this;
      if (this.phone == '') {
        this.phoneis = "手机号不能为空";
      }
      if (this.phoneis != "手机号格式错误" && this.phoneis != "手机号不能为空") {
        this.btnis = true;
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/msgCaptcha?visitorMd5Code=' + this.md5 + "&phoneNum=" + this.phone).then(function (response) {
          //console.log(response)
          if (response.data.code == 1) {
            vm.verifyis = false;
            var timer = setInterval(function () {
              vm.timesecond = vm.timesecond - 1;
              if (vm.timesecond == 0) {
                clearInterval(timer);
                vm.verifyis = true;
                vm.timesecond = 60;
              }
            }, 1000);
          } else if (response.data.code == 4032) {
            vm.$message.error('验证码获取过于频繁');
          } else if (response.data.code == 4504) {
            vm.$message.error('验证码已过期请重新获取');
          }
        });
      }
    },
    phonego: function phonego() {
      var phonenumis = /^1\d{10}$/.test(this.phone);
      //console.log(phonenumis)
      if (phonenumis == false) {
        this.phoneis = "手机号格式错误";
      } else {
        this.phoneis = "";
      }
    },

    // 设置相关的数据值，并且有值的时候更新一下提示语
    setMapData: function setMapData(data, key, value, dataObj) {
      var _this = this;

      this.$set(data, key, value);
      if (value != null && value != undefined && value != '') {
        setTimeout(function () {
          _this.datacommit(value, dataObj);
        }, 0);
      }
    },
    datacollect: function datacollect(obj) {
      var vm = this;
      if (obj.parentId == null) {
        obj.parentId = " ";
      }
      if (obj.typeId == 12) {
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/dataDicList/' + obj.id + '?visitorMd5Code=' + this.md5 + "&parentId=" + obj.parentId).then(function (response) {
          if (response.data.code == 1) {

            // console.log(vm.gamearea[obj.id])
            // console.log(vm.gamearea)
            var arrdata = response.data.data;
            var arr = [];
            //console.log(arrdata)
            arrdata.forEach(function (element, index) {
              var obj = {};
              obj.value = element.id;
              obj.label = element.content;
              arr.push(obj);
            });
            //console.log(arr)
            vm.$set(vm.gamearea, obj.id, arr);
            // vm.$set( vm.gamevalue,obj.id,obj.defaultContent);
            vm.setMapData(vm.gamevalue, obj.id, obj.enteredValue || obj.defaultContent, obj);
            //console.log(vm.gamearea);
            //console.log(vm.gamevalue)
          } else {
            console.log('拉取数据失败');
          }
        });
      } else if (obj.typeId == 1) {
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/dataDicList/' + obj.id + '?visitorMd5Code=' + this.md5 + "&parentId=" + obj.parentId).then(function (response) {
          if (response.data.code == 1) {

            //  var arrdata=response.data.data;
            //  console.log(arrdata)
            //  var arr=[];
            // arrdata.forEach( function(element, index) {
            //   var obj={};
            //   arr.push(obj)
            // });
            //console.log(arr)
            //console.log(vm.gamevalue)
            //vm.$set( vm.dns,obj.id,obj.defaultContent);
            vm.setMapData(vm.dns, obj.id, obj.enteredValue || obj.defaultContent, obj);
          } else {
            console.log('拉取数据失败');
          }
        });
      } else if (obj.typeId == 2) {
        //vm.$set( vm.explain,obj.id,obj.defaultContent);
        vm.setMapData(vm.explain, obj.id, obj.enteredValue || obj.defaultContent, obj);
      } else if (obj.typeId == 3) {
        // 日期
        console.log(obj.enteredValue, obj.defaultContent, '=========999========');
        //vm.$set( vm.datetime,obj.id,obj.defaultContent);
        var timeVal = '';
        if (/^\d{4}-\d{1,2}-\d{1,2}/.test(obj.enteredValue || obj.defaultContent)) {
          timeVal = obj.enteredValue || obj.defaultContent;
        }
        vm.setMapData(vm.datetime, obj.id, timeVal, obj);
      } else if (obj.typeId == 4) {
        //console.log(obj.defaultContent+":00")
        //vm.$set( vm.hourtime,obj.id,"");
      } else if (obj.typeId == 5) {

        //vm.$set( vm.phonenumver,obj.id,obj.defaultContent);
        vm.setMapData(vm.phonenumver, obj.id, obj.enteredValue || obj.defaultContent, obj);
      } else if (obj.typeId == 6) {
        vm.setMapData(vm.number, obj.id, obj.enteredValue || obj.defaultContent, obj);
        //vm.$set( vm.number,obj.id,obj.defaultContent);
      } else if (obj.typeId == 7) {
        vm.setMapData(vm.idcard, obj.id, obj.enteredValue || obj.defaultContent, obj);
        // vm.$set( vm.idcard,obj.id,obj.defaultContent);
      } else if (obj.typeId == 8) {
        vm.setMapData(vm.email, obj.id, obj.enteredValue || obj.defaultContent, obj);
        // vm.$set( vm.email,obj.id,obj.defaultContent);
      } else if (obj.typeId == 14) {
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/dataDicList/' + obj.id + '?visitorMd5Code=' + this.md5 + "&parentId=" + obj.parentId).then(function (response) {
          if (response.data.code == 1) {

            var arrdata = response.data.data;
            //返回数据有问题
            console.log(obj.defaultContent);

            if (obj.defaultContent.split(",").length > 1) {
              var arrd = obj.defaultContent.split(",");
            } else {
              var arrd = [];
              arrd.push(obj.defaultContent.split(",")[0]);
            }

            var arr = [];
            var arr1 = [];
            var defaultContentid = true;
            var l = arrdata.length;
            arrd.forEach(function (element, index) {

              var addis = false;
              for (var i = 0; i < l; i++) {
                if (arrdata[i].content == element) {
                  addis = true;
                }
              }
              if (addis == false) {
                defaultContentid = false;
              }
              arr1.push(element);
            });
            if (defaultContentid == false) {
              arr1 = [];
            }
            arrdata.forEach(function (element, index) {
              arr.push(element.content);
            });
            vm.$set(vm.checkedCities1, obj.id, arr1);
            vm.$set(vm.cities, obj.id, arr);
          } else {
            console.log('拉取数据失败');
          }
        });
      } else if (obj.typeId == 13) {

        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/dataDicList/' + obj.id + '?visitorMd5Code=' + this.md5 + "&parentId=" + obj.parentId).then(function (response) {
          if (response.data.code == 1) {

            var arrdata = response.data.data;
            //console.log(arrdata);
            var arr = [];
            var defaultContentid = false;
            console.log(obj.defaultContent, 8989);
            arrdata.forEach(function (element, index) {
              var obj1 = {};
              obj1.value = element.content;
              obj1.label = element.content;
              arr.push(obj1);
              //console.log(element.content)
              if (obj.defaultContent == element.content) {
                defaultContentid = true;
              }
            });
            //console.log(arr)
            if (defaultContentid == false) {
              obj.defaultContent = "";
            }
            console.log(obj.defaultContent, 39);
            vm.$set(vm.sexlabel, obj.id, arr);
            vm.$set(vm.sex, obj.id, obj.defaultContent);
          } else {
            console.log('拉取数据失败');
          }
        });
      } else if (obj.typeId == 9 || obj.typeId == 15) {
        var arr = [];
        this.action = this.basurl + '/api/visitor/wo/fileUpload?visitorMd5Code=' + this.md5;
        // var arro={};
        //  arro.url=obj.defaultContent;
        // if(arro.url !=""){
        //    this.picid[obj.id]=false;
        // }else{
        //   this.picid[obj.id]=true;
        // }
        // arro.name='file.jpg';

        // if(arro.url!=""){
        //   arr.push(arro)
        // }
        if (obj.typeId == 9) {
          vm.$set(vm.fileList2, obj.name, arr);
        } else {
          vm.$set(vm.fileVideoList, obj.name, arr);
        }
        // vm.$set( vm.fileList2,obj.name,arr);
        //console.log(vm.fileList2)
      } else if (obj.typeId == 16) {
        // 日期+时间
        //vm.$set( vm.datetime,obj.id,obj.defaultContent);
        // console.log(obj.enteredValue || obj.defaultContent, '=========999========')
        var _timeVal = '';
        if (/^\d{4}-\d{1,2}-\d{1,2} \d{1,2}:\d{1,2}/.test(obj.enteredValue || obj.defaultContent)) {
          _timeVal = obj.enteredValue || obj.defaultContent;
        }
        vm.setMapData(vm.datetimes, obj.id, _timeVal, obj);
      }
    }
  }
});

/***/ }),

/***/ "QABr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imDirectory_vue__ = __webpack_require__("+bWh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2563607e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_imDirectory_vue__ = __webpack_require__("oWpW");
function injectStyle (ssrContext) {
  __webpack_require__("zcCe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2563607e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imDirectory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2563607e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_imDirectory_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QDfD":
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ "QFDR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QTu+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__url_js__ = __webpack_require__("vpRr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__workorder_top_vue__ = __webpack_require__("3XGK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_request_js__ = __webpack_require__("vLgD");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'workinformation',
  components: {
    top: __WEBPACK_IMPORTED_MODULE_1__workorder_top_vue__["a" /* default */]
  },
  data: function data() {
    return {
      kefuis: false,
      questionclass: ["测试"],
      basurl: __WEBPACK_IMPORTED_MODULE_0__url_js__["a" /* baseurl */],
      text: "",
      md5: "",
      href: "",
      indexUrl: '',
      boxBodyColor: '',
      logoUrl: '',
      companyName: '',
      displayMode: ''
    };
  },
  mounted: function mounted() {
    var vm = this;
    vm.boxBodyColor = sessionStorage.getItem('boxBodyColor');
    vm.companyName = sessionStorage.getItem('companyName');
    vm.logoUrl = sessionStorage.getItem('logoUrl');
    vm.displayMode = sessionStorage.getItem('displayMode');
    this.md5 = sessionStorage.getItem("md5");
    this.indexUrl = sessionStorage.getItem('indexUrl');
    if (this.indexUrl) {
      this.indexUrl += '?v=' + this.md5;
    }
    this.questionclass = [];
    // this.questionclass.push(sessionStorage.getItem("navname"));
    // this.questionclass.push("单据说明")
    setTimeout(function () {
      console.log(sessionStorage.getItem("navname"));
      vm.questionclass.push(sessionStorage.getItem("navname"));
      vm.questionclass.push("单据说明");
    }, 100);
    this.href = this.$route.query.id;

    __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/workOrderDesc/' + this.href + '?visitorMd5Code=' + this.md5).then(function (response) {
      if (response.data.code == 1) {
        vm.text = response.data.data.note;
      }
    });
    //判断客服是否显示
    __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/product/conf/showOnlineService?visitorMd5Code=' + this.md5).then(function (response) {
      if (response.data.code == 1) {
        vm.kefuis = true;
      }
    });
  },

  methods: {
    commit: function commit() {
      this.$router.replace({
        path: 'workcommit',
        query: {
          "id": this.href,
          source: this.$route.query.source
        }
      });
      //window.location.href="#/workcommit?id="+this.href;
    },

    //判断跳转页面
    kefugo: function kefugo() {
      __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/product/conf/redirectToOnlineService?visitorMd5Code=' + this.md5).then(function (response) {
        //console.log(response)

        if (response.data.code == 1) {
          var obj = response.data.data;

          if (obj.imStatus == " waiting") {

            window.location.href = "#/imLineUp";
          } else if (obj.imStatus == "chatting") {

            window.location.href = "#/imSession";
          } else {
            if (obj.target == 1) {
              window.location.href = "#/spirit";
            }
            if (obj.target == 2) {
              window.location.href = "#/imDirectory";
            }
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "QbQc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [(_vm.notifyTitle) ? _c('div', {
    staticClass: "notify-container"
  }, [_c('div', {
    staticClass: "header-box"
  }, [_c('span', {
    staticClass: "notify-text"
  }, [_vm._v(_vm._s(_vm.notifyTitle))]), _vm._v(" "), _c('span', {
    staticClass: "notify-time"
  }, [_vm._v(_vm._s(_vm.notifyStartTime))])]), _vm._v(" "), _c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    directives: [{
      name: "dompurify-html",
      rawName: "v-dompurify-html",
      value: (_vm.notifyContent),
      expression: "notifyContent"
    }],
    attrs: {
      "id": "notify-content"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "footer-box"
  }, [_c('span', {
    staticClass: "btn",
    on: {
      "click": _vm.cancelWait
    }
  }, [_vm._v("离开")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    class: [_vm.countDown !== 0 ? 'disable' : 'ok'],
    style: ({
      'background': _vm.countDown !== 0 ? '#ccc' : _vm.boxBodyColor
    }),
    on: {
      "click": _vm.jumpTo
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.countDown !== 0),
      expression: "countDown!==0"
    }]
  }, [_vm._v(_vm._s(_vm.countDown) + "s ")]), _vm._v(" "), _c('span', [_vm._v("进入")])])])]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RGur":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__url_js__ = __webpack_require__("vpRr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__workorder_top_vue__ = __webpack_require__("3XGK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_request_js__ = __webpack_require__("vLgD");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'myorder',
  components: {
    top: __WEBPACK_IMPORTED_MODULE_1__workorder_top_vue__["a" /* default */]
  },
  data: function data() {
    return {
      urlb: '',
      boxBodyColor: '',
      logoUrl: '',
      companyName: '',
      displayMode: '',
      btnis: false,
      kefuis: false,
      phone: "",
      phoneis: "",
      veris: '',
      verify: "",
      verifyis: true,
      timesecond: 60,
      questionclass: "我的工单",
      orderdata: [],
      basurl: __WEBPACK_IMPORTED_MODULE_0__url_js__["a" /* baseurl */],
      md5: "",
      loginis: true,
      contentis: false,
      noGetListShow: false,
      page: 1
    };
  },
  mounted: function mounted() {
    var vm = this;
    vm.boxBodyColor = sessionStorage.getItem('boxBodyColor');
    vm.companyName = sessionStorage.getItem('companyName');

    vm.logoUrl = sessionStorage.getItem('logoUrl');
    vm.displayMode = sessionStorage.getItem('displayMode');
    this.href = window.location.href.split("?")[1];
    this.md5 = sessionStorage.getItem("md5");
    this.showis();
    //判断客服是否显示
    __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/product/conf/showOnlineService?visitorMd5Code=' + this.md5).then(function (response) {
      if (response.data.code == 1) {
        vm.kefuis = true;
      }
    });
    var indexurl = sessionStorage.getItem("indexUrl");
    if (indexurl == 'workerorderindex') {
      vm.urlb = "workerorderindex";
    } else if (indexurl == 'aiInteractive') {
      vm.urlb = "aiInteractive?v=" + this.md5;
    }
  },

  methods: {
    block: function block(index) {
      var dom = document.getElementById("d" + index);
      dom.style.display = 'block';
    },
    none: function none(index) {
      var dom = document.getElementById("d" + index);
      dom.style.display = 'none';
    },
    sessitem: function sessitem(data) {
      sessionStorage.setItem("butianitem", data);
    },
    reversedMessage: function reversedMessage(string) {
      var arr = string.split("");
      var rstring = "";
      if (arr.length <= 5) {
        rstring = string;
      } else {
        for (var i = 0; i < 5; i++) {
          rstring = rstring + arr[i];
        };
        rstring = rstring + "...";
      }
      return rstring;
    },

    //判断跳转页面

    kefugo: function kefugo() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/product/conf/redirectToOnlineService?visitorMd5Code=' + this.md5).then(function (response) {
        //console.log(response)
        if (response.data.code == 1) {
          var obj = response.data.data;

          if (obj.imStatus == "waiting") {
            vm.$router.replace({ path: 'imLineUp' });
            //window.location.href="#/imLineUp";
          } else if (obj.imStatus == "chatting") {
            vm.$router.replace({ path: 'imSession' });
            //window.location.href="#/imSession";
          } else {
            if (obj.target == 1) {
              //window.location.href="#/spirit";
              vm.$router.replace({ path: 'spirit' });
              console.log('已经跳转了');
            }
            if (obj.target == 2) {
              vm.$router.replace({ path: 'imDirectory' });
              //window.location.href="#/imDirectory";
            }
          }
        }
      });
    },

    //判断是否授权
    showis: function showis() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/workOrderList?visitorMd5Code=' + this.md5 + '&page=1&size=50').then(function (response) {
        var da = response.data;
        //console.log(da)
        if (da.code == 1) {
          vm.showdata();
          vm.loginis = false;
          vm.contentis = true;
        } else if (da.code == 401) {
          vm.contentis = false;
          vm.loginis = true;
        }
      });
    },
    showdata: function showdata() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/workOrderList?visitorMd5Code=' + this.md5 + '&page=1&size=50').then(function (response) {

        if (response.data.code == 1) {
          response.data.data.forEach(function (element, index) {
            vm.orderdata.push(element);
          });

          if (vm.orderdata.length > 0) {
            vm.noGetListShow = false;
          } else {
            vm.noGetListShow = true;
          }
        }
      });
    },
    phonego: function phonego() {
      var phonenumis = /^1\d{10}$/.test(this.phone);
      //console.log(phonenumis)
      if (phonenumis == false) {
        this.phoneis = "手机号格式错误";
      } else {
        this.phoneis = "";
      }
    },

    //手机验证
    verifyconfirm: function verifyconfirm() {
      //console.log( this.verify)
      var vm = this;
      vm.veris = "";
      if (this.verify != "" && this.btnis == true) {
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].post(this.basurl + '/api/visitor/wo/msgCaptchaValid?visitorMd5Code=' + this.md5 + "&phoneNum=" + this.phone + "&code=" + this.verify).then(function (response) {
          if (response.data.code == 1) {
            vm.showis();
            vm.veris = "";
          } else if (response.data.code == 0) {
            vm.veris = "验证码已过期请重新获取";
          } else if (response.data.code == 4032) {
            this.$message.error('获取验证码过于频繁');
          } else {

            vm.veris = "验证码填写错误";
          }
        });
      } else {
        vm.veris = "请获取验证码";
      }
    },
    verifygo: function verifygo() {
      var vm = this;
      if (this.phone == '') {
        this.phoneis = "手机号不能为空";
      }
      if (this.phoneis != "手机号格式错误" && this.phoneis != "手机号不能为空") {
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/msgCaptcha?visitorMd5Code=' + this.md5 + "&phoneNum=" + this.phone).then(function (response) {
          console.log(response);
          vm.btnis = true;
          if (response.data.code == 1) {
            vm.verifyis = false;
            var timer = setInterval(function () {
              vm.timesecond = vm.timesecond - 1;
              if (vm.timesecond == 0) {
                clearInterval(timer);
                vm.verifyis = true;
                vm.timesecond = 60;
              }
            }, 1000);
          } else if (response.data.code == 4032) {
            vm.$message.error('验证码获取过于频繁');
          } else if (response.data.code == 4504) {
            vm.$message.error('验证码已过期请重新获取');
          }
        });
      }
    },
    hisback: function hisback() {
      var vm = this;
      var indexurl = sessionStorage.getItem("indexUrl");
      console.log(indexurl);
      var imEntranceMode = sessionStorage.getItem("imEntranceMode");
      console.log(imEntranceMode);
      if (indexurl == 'aiInteractive') {
        window.location.href = "#/aiInteractive?v=" + this.md5;
        vm.urlb = "aiInteractive?v=" + this.md5;
      } else if (indexurl == 'workerorderindex') {
        window.location.href = "#/workerorderindex";
        vm.urlb = "workerorderindex";
      } else {
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/im/sessionStatus?visitorMd5Code=' + this.md5).then(function (response) {
          console.log(response);
          var imStatus = '';
          if (response.data.code == 1) {
            imStatus = response.data.data.status;
          }
          console.log(imStatus);
          if ((imStatus === 'ended' || !imStatus || imStatus === '') && indexurl == 'spirit') {
            vm.urlb = "spirit";
            window.location.href = "#/spirit";

            return;
          } else if (imStatus === 'waiting') {
            vm.urlb = "imLineUp";
            window.location.href = "#/imLineUp";

            return;
          } else if (imStatus === 'chatting') {
            vm.urlb = "imSession";
            window.location.href = "#/imSession";

            return;
          } else {
            if (imEntranceMode === 1) {
              vm.urlb = "imLineUp";
              window.location.href = "#/imLineUp";
            } else if (imEntranceMode === 2) {
              vm.urlb = "imDirectory";
              window.location.href = "#/imDirectory";
            }
          }

          console.log(vm.urlb);
        });
      }
    },
    scorllBottom: function scorllBottom(event) {
      var vm = this;
      var event = event || window.event;
      if (event.target.scrollTop + 620 >= event.target.scrollHeight) {

        vm.page = vm.page + 1;
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/workOrderList?visitorMd5Code=' + this.md5 + '&page=' + vm.page + '&size=50').then(function (response) {

          if (response.data.code == 1) {

            response.data.data.forEach(function (element, index) {
              vm.orderdata.push(element);
            });

            if (vm.orderdata.length > 0) {
              vm.noGetListShow = false;
            } else {
              vm.noGetListShow = true;
            }
          }
        });
      }
    }
  }
});

/***/ }),

/***/ "Rxg0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "videoArea"
  }, [_c('video', {
    ref: "videoPlayer",
    staticClass: "video-js vjs-nofull",
    attrs: {
      "controls": "",
      "preload": "auto"
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TLUi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_imApi__ = __webpack_require__("g1nd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_socket_io_client__ = __webpack_require__("DmT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_socket_io_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Constants__ = __webpack_require__("E3qV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_request_js__ = __webpack_require__("vLgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lrz__ = __webpack_require__("U7mS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lrz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lrz__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_components_url__ = __webpack_require__("vpRr");


/**
 * reated by ShangXiaoyang on 2017/9/13
 */









var websocktUrl = "https://mc.one.cn?username=";

var imageRex = /^image\/(jpeg|jpg|png|gif|bmp)$/;
var videoRex = /^video\/.*$/;
var superUrlRegExp = /(http|https|ftp)?(?::\/\/)?(?:\w+)(?=\.)(?:[\w\.]+)(?:[\w&?+=%\-\/\.]+)?/g;

var state = {
  entranceList: [], // 访客接口列表
  entranceId: null, //
  currentPosition: null, // 当前排队位置
  timer: {}, // 获取当前排队位置的计时器
  messageList: [], // 对话内容列表
  socket: {}, // 和后端简历的websocket对象
  autoReplyConfig: {}, // 自动消息
  sessionNoReplyTimer: {}, //会话超时倒计时

  visitorNoReplyTimer: {}, // 访客未回复倒计时

  userNoReplyTimer: {}, //客服未回复倒计时
  newSession: false, // 设置是否是新会话
  userNickNamePool: {}, // 客服名称和Id的前端缓存 数据结构: {1001: '小静静', 1002: '小亮亮'}
  uniqueMsgMap: {}, // 去重容器
  satisfyMode: null, // 满意度版本(1.基础版 2.问卷版)
  showSatisfySettingFlag: false, // 显示满意度评价
  currentUserId: null, // 当前客服昵称
  currentUserNickName: '', // 当前客服昵称
  infor: [],
  endis: true

};
var processLinkMessage = function processLinkMessage(text, sendFrom) {
  // 处理HTMl
  if (sendFrom == sessionStorage.getItem("md5")) return text; // 如果sendFrom等于sessionStorage.md5则说明是玩家用户则不用转换http为a标签
  var httpRegExp = /^(http:\/\/|https:\/\/)/;
  text = text.replace(superUrlRegExp, function ($url) {
    var matchText = $url.match(httpRegExp);
    console.log('发现url:' + $url + ' 是否具有http开头的匹配结果: ' + matchText);
    if (matchText === null) {
      return "<a href='http://" + $url + "' target='_blank'>" + $url + "</a>";
    } else {
      return "<a href='" + $url + "' target='_blank'>" + $url + "</a>";
    }
  });
  return text;
};
// file => url
function getObjectURL(file) {
  var url = null;
  if (window.createObjectURL != undefined) {
    // basic
    url = window.createObjectURL(file);
  } else if (window.webkitURL != undefined) {
    // webkit or chrome
    url = window.webkitURL.createObjectURL(file);
  } else if (window.URL != undefined) {
    // mozilla(firefox)
    url = window.URL.createObjectURL(file);
  }
  return url;
}
var setVideoCoverLoading = false;
// 获取视频封面
function getVideoCover(file, videoUrl, time, callback) {
  // 防止生成重复
  if (setVideoCoverLoading) return false;
  var video = document.createElement('video');
  var canvas = document.createElement('canvas');
  video.src = videoUrl;
  video.style = 'display:none';
  canvas.style = 'display:none';
  document.body.appendChild(video);
  document.body.appendChild(canvas);
  var timer = setTimeout(function () {
    // const video = this.$refs.submissionVideo; // 获取视频 dom
    // const canvas = this.$refs.submissionCanvas; // 获取canvas dom
    var context = canvas.getContext('2d');
    if (!video.readyState) {
      console.error('视频尚未加载完成，无法捕获封面');
      return;
    }
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    video.currentTime = time; // 获取指定时间点的封面
    setVideoCoverLoading = true;
    // 监听视频播放时间，获取封面
    video.addEventListener('seeked', function () {
      context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
      var coverImageDataUrl = canvas.toDataURL('image/png');
      var blob = dataURLtoBlob(coverImageDataUrl);
      var newName = file.name;
      var newFile = blobToFile(blob, newName);
      // 调用后端上传接口
      // upload(newFile, 0, newName, url => {
      //   this.submitVideoFrom.cover_url = url;
      // });
      callback(getObjectURL(newFile));
      var times = setTimeout(function () {
        video.remove();
        canvas.remove();
        setVideoCoverLoading = false;
        clearTimeout(times);
      }, 300);
      // 将base64转换为blob
      function dataURLtoBlob(dataurl) {
        var arr = dataurl.split(',');
        var mime = arr[0].match(/:(.*?);/)[1];
        var bstr = window.atob(arr[1]);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
      }
      // 将blob转换为file
      function blobToFile(theBlob, fileName) {
        theBlob.lastModifiedDate = new Date();
        theBlob.name = fileName;
        return theBlob;
      }
    }, { once: true });
    clearTimeout(timer);
  }, 50);
}
var getters = {
  currentPosition11: function currentPosition11(state) {
    return state.currentPosition;
  },
  messageList: function messageList(state) {
    return state.messageList;
  },
  satisfyMode: function satisfyMode(state) {
    return state.satisfyMode;
  },
  showSatisfySettingFlag: function showSatisfySettingFlag(state) {
    return state.showSatisfySettingFlag;
  },
  getEntranceList: function getEntranceList(state) {
    return state.entranceList;
  },
  getEntranceId: function getEntranceId(state) {
    return state.entranceId;
  },
  inforchange: function inforchange(state) {
    return state.infor;
  },
  endclass: function endclass(state) {
    return state.endis;
  },
  getsocket: function getsocket(state) {
    return state.socket;
  }
};
var actions = {
  createSocket: function createSocket(_ref, obj) {
    var dispatch = _ref.dispatch,
        commit = _ref.commit,
        state = _ref.state;
    // 建立socket连接
    state.uniqueMsgMap = {}; // 去重容器清空
    if (state.socket instanceof __WEBPACK_IMPORTED_MODULE_3_socket_io_client__["Socket"]) {
      // 如果已经存在了就断开原来的链接
      state.socket.disconnect();
      state.socket = '';
      console.log("存在socket连接,断开现有连接");
      // 断开
      // return;
    }
    var locdat = '';
    if (sessionStorage.getItem("locdatpc")) {
      locdat = sessionStorage.getItem("locdatpc");
    } else {
      locdat = new Date();
      locdat = locdat.getTime();
      sessionStorage.setItem("locdatpc", locdat);
    }
    state.socket = __WEBPACK_IMPORTED_MODULE_3_socket_io_client__["connect"](websocktUrl + obj.visitorMd5Code + "&uuid=" + locdat, { "multiplex": false }, { forceNew: true }, { reconnectionDelay: 100 }, { reconnection: true }, { reconnectionAttempts: 50 }, { autoConnect: true });

    socketgo();
    // var timew=new Date().getTime();

    // sessionStorage.setItem("socketconnecttime", timew);
    var a = 1;
    //测试 链接时间
    var timelong = setInterval(function () {
      if (a <= 5) {
        if (state.socket.connected) {
          clearInterval(timelong);
          console.log('-------------------检测可以建立链接-------------------');
          channelok();
        }
        a++;
      } else {
        console.log('链接不通');
        state.socket.disconnect();
        state.socket = __WEBPACK_IMPORTED_MODULE_3_socket_io_client__["connect"](websocktUrl + obj.visitorMd5Code + "&uuid=" + locdat, { transports: ['polling'] }, { forceNew: true }, { reconnectionDelay: 100 }, { reconnection: true }, { reconnectionAttempts: 50 }, { autoConnect: true });
        socketgo();
        console.log('改为轮询模式');
        clearInterval(timelong);
      }
    }, 1000);

    function channelok() {
      console.log('------------------检测通道----------------');
      //控制次数
      var ctimes = 1;
      //通道ok
      var channelis = false;
      state.socket.emit("ping_", 0);
      console.log('第一次发送ping包');

      var goping = setInterval(function () {
        ctimes = ctimes + 1;
        if (ctimes <= 3) {
          state.socket.emit("ping_", 0);
          console.log('第' + ctimes + '次发送ping包');
        } else {
          console.log('通道不通');
          state.socket.disconnect();
          state.socket = __WEBPACK_IMPORTED_MODULE_3_socket_io_client__["connect"](websocktUrl + obj.visitorMd5Code + "&uuid=" + locdat, { transports: ['polling'] }, { forceNew: true }, { reconnectionDelay: 100 }, { reconnection: true }, { reconnectionAttempts: 50 }, { autoConnect: true });
          socketgo();
          console.log('改为轮询模式');
          clearInterval(goping);
        }
      }, 2000);

      state.socket.on("pong_", function (data) {
        if (data == 1) {
          channelis = true;
          clearInterval(goping);
          console.log('------------------通道ok的----------------');
        }
      });
    }

    // //测试 链接时间
    // if(sessionStorage.getItem("timelong")){
    //   console.log("清除之前的timelong定时器")
    //   clearInterval(sessionStorage.getItem("timelong"));
    // }
    // var timelong=setInterval(function(){
    //   if(state.socket instanceof Socket){
    //       console.log("ok链接没有断开ok")
    //   }else{
    //     var nowtime=new Date().getTime();
    //     var contime = sessionStorage.getItem("socketconnecttime")
    //     if(nowtime-contime >= 300000){
    //      Message({
    //               message: '连接异常，请检查您的网络设置!',
    //               type: 'error'
    //             })
    //     }
    //   }
    // },300000)
    //  sessionStorage.setItem("timelong",timelong);
    //轮询socket链接状态检测

    // if(sessionStorage.getItem("sockettimer")){
    //   console.log("清除之前的sockettimer定时器")
    //   clearInterval(sessionStorage.getItem("sockettimer"));
    // }
    // var sockettimer=setInterval(function(){
    //     axios.get(Urls.baseurl +'/api/visitor/im/connection/status?visitorMd5Code='+obj.visitorMd5Code).then(function (response) {
    //       console.log("检测是否断开连接")
    //       if(response.data.code === 0){
    //         console.log("检测到断开连接");
    //         var timew=new Date().getTime();
    //         //sessionStorage.setItem("socketconnecttime", timew);
    //         //state.socket = io.connect(websocktUrl + obj.visitorMd5Code,{"multiplex":false},{forceNew: true},{reconnectionDelay:100},{reconnection:true},{reconnectionAttempts:50},{autoConnect:true})
    //         location.reload();
    //         console.log("http重新连接")
    //       }else{
    //         console.log("检测没有断开连接")
    //       }

    //     })
    // },60000);
    //sessionStorage.setItem("sockettimer",sockettimer);
    //检测socket的链接状态
    // state.socket.on('disconnect', function (reason) {
    //     console.log('------------------   检测到断开了socket原因为'+reason);
    //     var timew=new Date().getTime();
    //     sessionStorage.setItem("socketconnecttime", timew);


    // })

    //state.socket = io.connect(websocktUrl + obj.visitorMd5Code,{"multiplex":false},{forceNew: true},{reconnectionDelay:100},{reconnection:true},{reconnectionAttempts:50},{autoConnect:true})
    state.socket.on('connect', function (data) {
      console.info('------------------   连接后socket.cookie:' + state.socket.cookie);
      console.info('------------------ data:' + data);
      var path = obj.path;
    });
    function socketgo() {
      state.socket.on(obj.visitorMd5Code, function (data) {
        // 获取推送来的数据
        console.log('socket io chatEvent');
        console.log(data, "socket推送消息");

        if (data) {

          if (data == 'T') {
            console.log(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"]);
            __WEBPACK_IMPORTED_MODULE_5_element_ui__["MessageBox"].alert('已在其他设备登录，点击确认重新登录', '提示', {
              confirmButtonText: '确定',
              callback: function callback(action) {
                location.reload();
              }
            });
          } else if (data.imMsgHeader.applicationType) {
            var imMsgHeader = data.imMsgHeader;
            var head = imMsgHeader.head ? state.imHttp + imMsgHeader.head : '/pc/static/assets/service_pic@2x.png';
            var restime = data.imMsgProperty.createdTime;
            // 确认消息
            var confirmData = {
              sessionId: imMsgHeader.sessionId,
              timeStamp: Date.parse(new Date()),
              msgId: imMsgHeader.msgId,
              userId: obj.visitorMd5Code,
              head: head
            };
            state.socket.emit('confirmEvent', confirmData);
            // 检验是否重复
            var hasContain = state.uniqueMsgMap[imMsgHeader.sessionId + '_' + imMsgHeader.msgId];
            if (hasContain && imMsgHeader.applicationType[1] != 'IM_MESSAGE_REVOKE') {
              console.error('已经包含了会话:' + imMsgHeader.sessionId + '中的消息:' + imMsgHeader.msgId);
              return;
            }
            if (imMsgHeader && imMsgHeader.applicationType[0] === 'imQueueAppType' && imMsgHeader.applicationType[1] === 'QUEUE_NOTIFY' /*排队成功通知*/) {
                commit({
                  type: 'setImStatus',
                  status: 'chatting'
                });
                state.newSession = true;
                sessionStorage.setItem('newSession', true);
                obj.router.replace({ path: '/imSession', query: { v: obj.visitorMd5Code } });

                localStorage.removeItem('visitTime');
                localStorage.removeItem('userTime');
                localStorage.removeItem('sessionTime');

                console.log('设置本会话为新的session');
                clearInterval(state.timer);
              } else if (imMsgHeader && imMsgHeader.applicationType[0] === 'imChatAppType' && imMsgHeader.applicationType[1] === 'IM_CHAT') {
              // 聊天消息
              var imMsgBody = data.imMsgBody;
              if (imMsgBody && imMsgBody.content && imMsgBody.content.length > 0) {
                var timechange = function timechange(timestamp) {
                  var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                  var Y = date.getFullYear() + '-';
                  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                  var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '';
                  return Y + M + D;
                };
                // obj.time = this.timechange(obj.time)


                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(imMsgBody.content), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    console.log("=====打印推送的聊天消息start======");
                    console.log(item.msgContent.content);
                    console.log("=====打印推送的聊天消息end======");
                    var sessionId = data.imMsgHeader.sessionId;
                    var msgId = data.imMsgHeader.msgId;
                    state.uniqueMsgMap[sessionId + '_' + msgId] = sessionId + '_' + msgId;
                    //console.log(item,"推送")

                    commit('addMessageContentToMessageList', {
                      type: item.msgType,
                      data: item.msgType === 'TEXT' ? item.msgContent.content : item.msgContent.url,
                      seq: imMsgHeader.seqOrigin,
                      sessionId: imMsgHeader.sessionId,
                      msgId: imMsgHeader.msgId,
                      sendFrom: imMsgHeader.fromId,
                      head: head,
                      userNickName: state.userNickNamePool[imMsgHeader.fromId],
                      time: restime
                    });
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }

                state.uniqueMsgMap[imMsgHeader.sessionId + '_' + imMsgHeader.msgId] = true;
                clearTimeout(state.userNoReplyTimerOut);
                clearInterval(state.userNoReplyTimer);
                clearInterval(state.userFun);

                localStorage.removeItem('sessionTime');
                localStorage.setItem('session', state.autoReplyConfig.sessionTimeout);
                localStorage.setItem('visit', state.autoReplyConfig.visitorTimeout);

                if (window.location.href.indexOf("/imSession") != -1) {
                  localStorage.removeItem('sessionTime');
                  dispatch('resetSessionNoReplyTimer', obj.visitorMd5Code);

                  localStorage.removeItem('visitTime');
                  dispatch('resetVisitorNoReplyTimer', obj.visitorMd5Code);
                }

                var imMsg = data;
                var obj1 = {};
                obj1.id = imMsg.imMsgHeader.sessionId;
                obj1.time = imMsg.imMsgProperty.createdTime ? imMsg.imMsgProperty.createdTime : new Date().getTime();
                obj1.time = timechange(obj1.time);
                obj1.name = imMsg.imMsgHeader.fromName ? imMsg.imMsgHeader.fromName : '访客';

                var imMsgType = imMsg.imMsgBody.content[0].msgType;
                //console.log(imMsg,'jjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjj')
                switch (imMsgType) {
                  case 'TEXT':
                    obj1.content = imMsg.imMsgBody.content[0].msgContent.content + " ";
                    break;
                  case 'EVENT':
                    obj1.content = imMsg.imMsgBody.content[0].msgContent.content + " ";
                    break;
                  case 'IMAGE':
                    obj1.content = "你收到一张图片。";
                    break;
                  default:

                }
                dispatch('infortx', obj1);
              }
            } else if (imMsgHeader && imMsgHeader.applicationType[0] === 'imSessionAppType' && (imMsgHeader.applicationType[1] === 'SESSION_TERMINATE' || imMsgHeader.applicationType[1] === 'SESSION_TERMINATE_TIMEOUT')) {
              console.log("收到关闭会话通知");
              console.log(data.imMsgBody);
              console.log('发送关闭消息的客服Id: ' + imMsgHeader.fromId);
              console.log('发送关闭消息的客服名称: ' + state.userNickNamePool[imMsgHeader.fromId]);
              console.log('发送关闭会话消息: ' + state.autoReplyConfig.finishedMsg);
              console.log('清空 state.userNoReplyTimer: ' + state.userNoReplyTimer);
              console.log('清空 state.visitorNoReplyTimer: ' + state.visitorNoReplyTimer);

              state.endis = false;
              sessionStorage.setItem("inviteis", false);
              commit({
                type: 'setImStatus',
                status: 'ended'
              });

              var _sessionId = data.imMsgHeader.sessionId;
              var _msgId = data.imMsgHeader.msgId;
              state.uniqueMsgMap[_sessionId + '_' + _msgId] = _sessionId + '_' + _msgId;

              clearInterval(state.userNoReplyTimer);
              clearTimeout(state.userNoReplyTimerOut);
              clearInterval(state.userFun);
              localStorage.removeItem('userTime');

              clearInterval(state.visitorNoReplyTimer);
              clearTimeout(state.visitorNoReplyTimerOut);
              clearInterval(state.visitorFun);
              localStorage.removeItem('visitTime');

              localStorage.removeItem('sessionTime');
              clearInterval(state.sessionNoReplyTimer);

              commit('sendFinishedMsg', obj.visitorMd5Code);
              if (imMsgHeader.applicationType[1] === 'SESSION_TERMINATE_TIMEOUT') {
                //console.log('自动结束开始发各种东西')
                //commit('sendFinishedMsg', obj.visitorMd5Code);
                commit("setShowSatisfySettingFlag", true);
                dispatch("getSatisfySettting", { visitorMd5Code: obj.visitorMd5Code });
                clearInterval(state.userNoReplyTimer);
                clearInterval(state.visitorNoReplyTimer);
                clearInterval(state.sessionNoReplyTimer);
              }
            } else if (imMsgHeader && imMsgHeader.applicationType[0] === 'imChatAppType' && imMsgHeader.applicationType[1] === 'EVALUATE_NOTIFY' /*评价通知*/) {
                console.log('收到评价通知: ');
                //console.log(data.imMsgBody);
                dispatch("getSatisfySettting", { visitorMd5Code: obj.visitorMd5Code });
                commit("setShowSatisfySettingFlag", true);
                // imApi.confirmEvent(imMsgHeader.msgId, obj.visitorMd5Code, function (body) {
                //     console.log('确认事件的返回值:'+body.code)
                // })

                clearTimeout(state.userNoReplyTimerOut);
                clearInterval(state.userNoReplyTimer);
                clearInterval(state.userFun);

                localStorage.removeItem('sessionTime');
                localStorage.setItem('session', state.autoReplyConfig.sessionTimeout);
                localStorage.setItem('visit', state.autoReplyConfig.visitorTimeout);

                if (window.location.href.indexOf("/imSession") != -1) {
                  localStorage.removeItem('sessionTime');
                  dispatch('resetSessionNoReplyTimer', obj.visitorMd5Code);

                  localStorage.removeItem('visitTime');
                  dispatch('resetVisitorNoReplyTimer', obj.visitorMd5Code);
                }
              } else if (imMsgHeader && imMsgHeader.applicationType[0] === 'imChatAppType' && imMsgHeader.applicationType[1] === 'WORKORDER_NOTIFY' /*工单推送通知(显示工单)*/) {
                console.log('收到工单推送通知: ');
                console.log(data.imMsgBody);
                if (data.imMsgBody && data.imMsgBody.content) {
                  var msgContent = data.imMsgBody.content[0].msgContent;
                  console.log(msgContent, "msgContent");
                  console.log('收到工单推送的工单Id: ' + msgContent.id);
                  var _sessionId2 = imMsgHeader.sessionId;
                  var _msgId2 = imMsgHeader.msgId;
                  state.uniqueMsgMap[_sessionId2 + '_' + _msgId2] = _sessionId2 + '_' + _msgId2;
                  commit('sendWorkOrderMessage', { workOrderId: msgContent.id, msgId: imMsgHeader.msgId, head: head, time: restime });

                  clearTimeout(state.userNoReplyTimerOut);
                  clearInterval(state.userNoReplyTimer);
                  clearInterval(state.userFun);

                  localStorage.removeItem('sessionTime');
                  localStorage.setItem('session', state.autoReplyConfig.sessionTimeout);
                  localStorage.setItem('visit', state.autoReplyConfig.visitorTimeout);

                  if (window.location.href.indexOf("/imSession") != -1) {
                    localStorage.removeItem('sessionTime');
                    dispatch('resetSessionNoReplyTimer', obj.visitorMd5Code);

                    localStorage.removeItem('visitTime');
                    dispatch('resetVisitorNoReplyTimer', obj.visitorMd5Code);
                  }
                } else {
                  console.log('无法获取工单ID');
                }
                console.error('注意收到工单推送的时候是不要确认收到的。要提交之后才算是确认收到。');
              } else if (imMsgHeader && imMsgHeader.applicationType[0] === 'imChatAppType' && imMsgHeader.applicationType[1] === 'SERVICE_NOTIFY' /*会话转接or介入*/) {
                console.log(data.imMsgBody, "会话转接or介入");

                var _msgContent = data.imMsgBody.content[0].msgContent.content;
                var _imMsgHeader = data.imMsgHeader;
                var _imMsgBody = data.imMsgBody;
                var _sessionId3 = _imMsgHeader.sessionId;
                var _msgId3 = _imMsgHeader.msgId;
                state.uniqueMsgMap[_sessionId3 + '_' + _msgId3] = _sessionId3 + '_' + _msgId3;
                state.head = head;
                state.currentUserId = _imMsgBody.content[0].msgContent.userId;
                state.currentUserNickName = _imMsgBody.content[0].msgContent.userNickName;
                state.userNickNamePool[_imMsgBody.content[0].msgContent.userId] = _imMsgBody.content[0].msgContent.userNickName;
                commit('addMessageContentToMessageList', {
                  data: _msgContent,
                  // type:imMsgBody.content[0].msgType,
                  type: "TEXT",
                  seq: _imMsgHeader.seqOrigin,
                  sessionId: _imMsgHeader.sessionId,
                  head: head,
                  //userNickName: data.imMsgBody.content[0].msgContent.userNickName,
                  // sendFrom: Number(imMsgBody.content[0].msgContent.userNickName),
                  // userNickName: state.userNickNamePool[Number(imMsgBody.content[0].msgContent.userId)],
                  sendFrom: _imMsgHeader.fromId,
                  userNickName: state.userNickNamePool[_imMsgBody.content[0].msgContent.userId],
                  time: restime
                });

                clearTimeout(state.userNoReplyTimerOut);
                clearInterval(state.userNoReplyTimer);
                clearInterval(state.userFun);

                localStorage.removeItem('sessionTime');
                localStorage.setItem('session', state.autoReplyConfig.sessionTimeout);
                localStorage.setItem('visit', state.autoReplyConfig.visitorTimeout);

                if (window.location.href.indexOf("/imSession") != -1) {
                  localStorage.removeItem('sessionTime');
                  dispatch('resetSessionNoReplyTimer', obj.visitorMd5Code);

                  localStorage.removeItem('visitTime');
                  dispatch('resetVisitorNoReplyTimer', obj.visitorMd5Code);
                }
              } else if (imMsgHeader && imMsgHeader.applicationType[0] === 'imChatAppType' && imMsgHeader.applicationType[1] === 'IM_MESSAGE_REVOKE' /*消息撤回*/) {
                // dosomething
                var _msgId4 = imMsgHeader.msgId;
                var createdTime = restime;
                commit('revokeMessageList', { msgId: _msgId4, createdTime: createdTime });
              }
          }
        }
      });
    }
  },
  infortx: function infortx(_ref2, obj1) {
    var commit = _ref2.commit,
        state = _ref2.state;

    if (window.location.href.indexOf("/#/imSession") == -1) {
      var audio = document.getElementById("audioPlay");
      audio.play();

      var title1 = document.getElementsByTagName('title')[0];
      title1.innerHTML = '您有新消息:' + obj1.content;
      if (sessionStorage.getItem("addtime")) {
        clearInterval(sessionStorage.getItem("addtime"));
      }
      var timer = setInterval(function () {

        var title = title1.innerHTML;
        var fristchar = title.charAt(0); //在从中取第一个字符；(charAt)
        var rightstr = title.substring(1, title.length); //结束位置必须是title.length;
        title1.innerHTML = rightstr + fristchar;
      }, 400);
      sessionStorage.setItem("addtime", timer);
      state.infor.push(obj1);
      setTimeout(function () {
        var nowindex = 0;
        state.infor.forEach(function (element, index) {
          if (element.id == obj1.id) {
            nowindex = index;
          }
        });
        state.infor.splice(nowindex, 1);
      }, 3000);
    }
  },
  entrance: function entrance(_ref3, obj) {
    var commit = _ref3.commit,
        state = _ref3.state;
    // 获取入口
    var visitorMd5Code = obj.visitorMd5Code;
    __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].entrance(visitorMd5Code, function (res) {
      console.log(res, "获取入口");
      if (res.data.mode === 1) {
        obj.router.replace({ path: '/imLineUp', query: { v: visitorMd5Code, errType: "costomerErr" } });
      } else if (res.data.mode === 2) {
        console.log(obj.router);
        if (obj.inviteis) {
          console.log('主动邀请');
        } else {
          obj.router.replace({ path: '/imDirectory', query: { v: visitorMd5Code, errType: "costomerErr" } });
        }

        commit("setEntranceList", res.data.entranceList);
      }
    });
  },
  enterQueue: function enterQueue(_ref4, obj) {
    var commit = _ref4.commit,
        state = _ref4.state;
    // 排队
    var entranceId = obj.entranceId;
    var visitorMd5Code = obj.visitorMd5Code;
    var vm = obj.vm;
    clearInterval(state.timer);
    __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].queryEnterQueue(visitorMd5Code, entranceId, function (res) {
      console.log(res.code);
      if (res.code === 1) {
        obj.router.replace({ path: '/imLineUp', query: { v: visitorMd5Code, errType: "costomerErr" } });
      } else if (res.code === 2028) {
        obj.router.replace({ path: '/serviceError', query: { v: visitorMd5Code, errType: "costomerErr" } });
      }
    });
  },
  startCurrentPositionTimer: function startCurrentPositionTimer(_ref5, obj) {
    var commit = _ref5.commit,
        state = _ref5.state;
    // 获取当前排队位置
    var visitorMd5Code = obj.visitorMd5Code;
    var entranceId = obj.entranceId;
    console.log(entranceId, "entranceId-im");
    var router = obj.router;
    var objData = {
      visitorMd5Code: visitorMd5Code,
      entranceId: entranceId ? entranceId : ""
    };
    clearInterval(state.timer);
    __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].getPositionAndSessionStatus(objData, function (res) {
      if (res.code === 1) {
        var data = res.data;
        if (data.position === -1) {
          //data.position === null;
          //  console.log(state.timer)
          clearInterval(state.timer);
          if (data.sessionStatus === 'chatting') {
            //   console.log('是这跳的吗')
            //   state.newSession = true
            // sessionStorage.setItem('newSession',true)
            router.replace({ path: '/imSession', query: { v: visitorMd5Code } });
          }
        }
        commit('setCurrentPosition', data.position);
      } else if (res.code === 4208) {
        console.error('无法获取到IM会话，或者会话已经过期');
        commit('setCurrentPosition', null); // 从-1切换过来的一个过渡。设置为null
        return;
      }
    });
    state.timer = setInterval(__WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].getPositionAndSessionStatus, 3000, objData, function (res) {
      //console.log("你去轮训")
      if (res.code === 1) {
        var data = res.data;
        if (data.position === -1) {
          clearInterval(state.timer);
          if (data.sessionStatus === 'chatting') {
            console.log('还有这');
            // state.newSession = true
            // sessionStorage.setItem('newSession',true)
            router.replace({ path: '/imSession', query: { v: visitorMd5Code } });
          }
        }
        commit('setCurrentPosition', data.position);
      } else if (res.code === 4208) {
        console.error('无法获取到IM会话，或者会话已经过期');
        return;
      }
    });
  },
  resetSessionNoReplyTimer: function resetSessionNoReplyTimer(_ref6, visitorMd5Code) {
    var dispatch = _ref6.dispatch,
        commit = _ref6.commit,
        state = _ref6.state;


    if (!state.autoReplyConfig.sessionTimeoutMsg || !state.autoReplyConfig.sessionTimeoutFlag) return;
    clearInterval(state.sessionNoReplyTimer);
    var timeout = state.autoReplyConfig.sessionTimeout;
    if (localStorage.getItem('sessionTime') && state.autoReplyConfig.sessionTimeout != JSON.parse(localStorage.getItem('sessionTime')).time && visitorMd5Code == JSON.parse(localStorage.getItem('sessionTime')).id) {
      timeout = JSON.parse(localStorage.getItem('sessionTime')).time;
    } else {
      timeout = state.autoReplyConfig.sessionTimeout;
    }

    var timerFunction = function timerFunction() {
      timeout--;
      console.log('会话超时关闭', timeout);
      if (timeout == 60) {
        var timechange = function timechange(timestamp) {
          var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
          var Y = date.getFullYear() + '-';
          var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
          var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '';
          return Y + M + D;
        };

        __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].sendAutoMessage(visitorMd5Code, {
          type: 3,
          toId: state.currentUserId,
          toName: state.userNickNamePool[state.currentUserId],
          // head:state.head,
          content: state.autoReplyConfig.sessionTimeoutMsg
        }, function (res) {
          if (res.code === 1) {
            commit('addMessageContentToMessageList', {
              type: __WEBPACK_IMPORTED_MODULE_4__common_Constants__["a" /* TEXT_TYPE */],
              data: state.autoReplyConfig.sessionTimeoutMsg,
              sendFrom: state.currentUserId,
              head: state.head,
              userNickName: state.userNickNamePool[state.currentUserId],
              time: res.timestamp
            });
          }
        });

        var obj1 = {
          "content": state.autoReplyConfig.sessionTimeoutMsg,
          "name": state.userNickNamePool[state.currentUserId]
        };
        console.log('是resetSessionNoReplyTimer的问题吗');
        obj1.id = new Date().getTime();
        obj1.time = timechange(obj1.id);
        dispatch("infortx", obj1);
        console.log('不是resetSessionNoReplyTimer的问题吗');
      }
      if (timeout == 0) {
        /*结束会话*/
        // state.endis=false;
        // sessionStorage.setItem("inviteis", false);
        // imApi.getOverSession(visitorMd5Code, body => {
        //   if (body.code === 1) {
        //     if(state.autoReplyConfig.popCsr){
        //       console.log('jinqumei')
        //       commit("setShowSatisfySettingFlag", true);
        //       dispatch("getSatisfySettting", {visitorMd5Code:visitorMd5Code});
        //     }
        //     commit('sendFinishedMsg', visitorMd5Code)
        //     clearInterval(state.userNoReplyTimer)
        //     clearInterval(state.visitorNoReplyTimer)
        //     clearInterval(state.sessionNoReplyTimer)
        //   }
        // })
      }
      state.sessionTime = timeout;
      //新存的
      localStorage.setItem('session', timeout);
    };
    state.sessionNoReplyTimer = setInterval(timerFunction, 1000);
  },
  resetVisitorNoReplyTimer: function resetVisitorNoReplyTimer(_ref7, visitorMd5Code) {
    var dispatch = _ref7.dispatch,
        commit = _ref7.commit,
        state = _ref7.state;


    if (!state.autoReplyConfig.visitorTimeoutMsg || !state.autoReplyConfig.visitorTimeoutFlag) return;
    clearInterval(state.visitorNoReplyTimer);
    clearInterval(state.visitorFun);
    var timeout = state.autoReplyConfig.visitorTimeout,
        visitTime = '';
    if (localStorage.getItem('visitTime') && state.autoReplyConfig.visitTime != JSON.parse(localStorage.getItem('visitTime')).time && visitorMd5Code == JSON.parse(localStorage.getItem('visitTime')).id) {
      visitTime = JSON.parse(localStorage.getItem('visitTime')).time;
    } else {
      visitTime = state.autoReplyConfig.visitorTimeout;
    }

    state.visitorFun = setInterval(function () {
      visitTime--;
      if (visitTime == 0) {
        visitTime = state.autoReplyConfig.visitorTimeout;
      }
      state.visitTime = visitTime;
      //新存的
      localStorage.setItem('visit', visitTime);
      console.log(state.visitTime, '访客计时');
    }, 1000);

    var timerFunction = function timerFunction() {
      __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].sendAutoMessage(visitorMd5Code, {
        type: 1,
        toId: state.currentUserId,
        toName: state.userNickNamePool[state.currentUserId],
        // head:state.head,
        content: state.autoReplyConfig.visitorTimeoutMsg
      }, function (res) {
        if (res.code === 1) {
          commit('addMessageContentToMessageList', {
            type: __WEBPACK_IMPORTED_MODULE_4__common_Constants__["a" /* TEXT_TYPE */],
            data: state.autoReplyConfig.visitorTimeoutMsg,
            sendFrom: state.currentUserId,
            head: state.head,
            userNickName: state.userNickNamePool[state.currentUserId],
            time: res.timestamp
          });
        }
      });

      function timechange(timestamp) {
        var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '';
        return Y + M + D;
      }
      var obj1 = {
        "content": state.autoReplyConfig.visitorTimeoutMsg,
        "name": state.userNickNamePool[state.currentUserId]
      };
      obj1.id = Number(new Date());
      obj1.time = timechange(obj1.id);
      dispatch("infortx", obj1);
    };

    console.log('访客不回复超时时间: ' + timeout + '秒');
    if (!(timeout > 1)) {
      // MessageBox('提示', '访客回复超时时间小于1秒')
      timeout = 20;
    }
    if (localStorage.getItem('visitTime') && visitorMd5Code == JSON.parse(localStorage.getItem('visitTime')).id && state.autoReplyConfig.visitorTimeout != JSON.parse(localStorage.getItem('visitTime')).time && !state.visitTimeYes) {
      state.visitTimeYes = true;
      state.visitorNoReplyTimer = setInterval(timerFunction, JSON.parse(localStorage.getItem('visitTime')).time * 1000);
      state.visitorNoReplyTimerOut = setTimeout(function () {
        clearInterval(state.visitorNoReplyTimer);
        state.visitorNoReplyTimer = setInterval(timerFunction, timeout * 1000);
      }, JSON.parse(localStorage.getItem('visitTime')).time * 1000);
    } else {
      state.visitorNoReplyTimer = setInterval(timerFunction, timeout * 1000);
    }
  },
  resetUserNoReplyTimer: function resetUserNoReplyTimer(_ref8, visitorMd5Code) {
    var dispatch = _ref8.dispatch,
        commit = _ref8.commit,
        state = _ref8.state;


    if (!state.autoReplyConfig.userTimeoutMsg || !state.autoReplyConfig.userTimeoutFlag) return;
    if (state.userNoReplyTimer) {
      clearInterval(state.userNoReplyTimer);
    }
    clearInterval(state.userFun);

    var timeout = state.autoReplyConfig.userTimeout,
        userTime = '';

    if (localStorage.getItem('userTime') && state.autoReplyConfig.userTimeout != JSON.parse(localStorage.getItem('userTime')).time && visitorMd5Code == JSON.parse(localStorage.getItem('userTime')).id) {
      userTime = JSON.parse(localStorage.getItem('userTime')).time;
    } else {
      userTime = state.autoReplyConfig.userTimeout;
    }

    state.userFun = setInterval(function () {
      userTime--;
      if (userTime == 0) {
        userTime = state.autoReplyConfig.userTimeout;
      }
      state.userTime = userTime;
      //新存的
      localStorage.setItem('user', userTime);
      console.log(state.userTime, '客服计时');
    }, 1000);

    var timerFunction = function timerFunction() {
      __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].sendAutoMessage(visitorMd5Code, {
        type: 2,
        toId: state.currentUserId,
        toName: state.userNickNamePool[state.currentUserId],
        // head:state.head,
        content: state.autoReplyConfig.userTimeoutMsg
      }, function (res) {
        if (res.code === 1) {
          commit('addMessageContentToMessageList', {
            type: __WEBPACK_IMPORTED_MODULE_4__common_Constants__["a" /* TEXT_TYPE */],
            data: state.autoReplyConfig.userTimeoutMsg,
            sendFrom: state.currentUserId,
            head: state.head,
            userNickName: state.userNickNamePool[state.currentUserId],
            time: res.timestamp
          });
        }
      });

      function timechange(timestamp) {
        var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '';
        return Y + M + D;
      }
      var obj1 = {
        "content": state.autoReplyConfig.userTimeoutMsg,
        "name": state.userNickNamePool[state.currentUserId]
      };
      console.log('是resetUserNoReplyTimer的问题吗');
      obj1.id = new Date().getTime();
      obj1.time = timechange(obj1.id);
      dispatch("infortx", obj1);
      console.log('不是resetUserNoReplyTimer的问题吗');
    };

    if (!(timeout > 1)) {
      // Message('提示', '客服回复超时时间小于1秒')
      timeout = 20;
    }
    if (localStorage.getItem('userTime') && visitorMd5Code == JSON.parse(localStorage.getItem('userTime')).id && state.autoReplyConfig.userTimeout != JSON.parse(localStorage.getItem('userTime')).time && !state.userTimeYes) {
      state.userTimeYes = true;
      state.userNoReplyTimer = setInterval(timerFunction, JSON.parse(localStorage.getItem('userTime')).time * 1000);
      state.userNoReplyTimerOut = setTimeout(function () {
        clearInterval(state.userNoReplyTimer);
        state.userNoReplyTimer = setInterval(timerFunction, timeout * 1000);
      }, JSON.parse(localStorage.getItem('userTime')).time * 1000);
    } else {
      state.userNoReplyTimer = setInterval(timerFunction, timeout * 1000);
    }
  },
  getLastMessage: function getLastMessage(_ref9, obj) {
    var commit = _ref9.commit,
        state = _ref9.state;

    var visitorMd5Code = obj.visitorMd5Code;
    var offsetSeq = obj.offsetSeq;
    var sessionId = obj.sessionId;
    if (!offsetSeq) state.messageList = [];
    var router = obj.router;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].lastMessage(visitorMd5Code, offsetSeq, sessionId, function (res) {
        if (res.code === 1) {
          var data = res.data;
          var imMsgRecords = data.imMsgRecords;

          state.userNickNamePool[data.currentSessionUserId] = data.currentSessionUserNickName;
          state.currentUserId = Number(data.currentSessionUserId);
          state.head = data.currentSessionUserHead ? data.currentSessionUserHead.head ? data.currentSessionUserHead.head : '/static/assets/service_pic@2x.png' : '/static/assets/service_pic@2x.png';

          imMsgRecords.forEach(function (item, index) {
            var imMsgRecord = imMsgRecords[index].imMsgRecord;
            var seq = imMsgRecords[index].seq;
            var userNickName = imMsgRecords[index].userNickName ? imMsgRecords[index].userNickName : state.userNickNamePool[state.currentUserId];
            var head = imMsgRecord.head ? imMsgRecord.head : '/pc/static/assets/service_pic@2x.png';
            // 初始化 去重容器
            var sessionId = imMsgRecord.sessionId;
            var msgId = imMsgRecord.msgId;
            state.uniqueMsgMap[sessionId + '_' + msgId] = sessionId + '_' + msgId;
            /**
             * 添加历史记录到messageList
             */
            if (imMsgRecord.contents[0].msgType === 'EVENT') {
              // 事件流
              console.log("=============applicationType=" + imMsgRecord.applicationType);
              if (imMsgRecords[index].toDo === true && imMsgRecord.applicationType === "EVALUATE_NOTIFY") {
                // 评价
                commit('unshiftEventMessage', {
                  workOrderId: imMsgRecord.contents[0].msgContent.id,
                  msgId: imMsgRecord.msgId,
                  content: imMsgRecord.contents[0].msgContent.content,
                  head: head, seq: seq,
                  sessionId: imMsgRecord.sessionId });
              } else if (imMsgRecords[index].toDo === true && imMsgRecord.applicationType === 'WORKORDER_NOTIFY') {
                commit('unshiftWorkOrderMessage', { workOrderId: imMsgRecord.contents[0].msgContent.id,
                  msgId: imMsgRecord.msgId,
                  content: imMsgRecord.contents[0].msgContent.content,
                  toDo: imMsgRecords[index].toDo,
                  head: head,
                  seq: seq,
                  sessionId: imMsgRecord.sessionId,
                  time: imMsgRecord.createdAt
                });
              } else if (imMsgRecords[index].toDo === null && imMsgRecord.applicationType === 'WORKORDER_COMFIRM') {
                commit('unshiftMessageContentToMessageList', {
                  workOrderId: imMsgRecord.contents[0].msgContent.id,
                  msgId: imMsgRecord.msgId,
                  data: '您已提交了工单: ' + imMsgRecord.contents[0].msgContent.content.split(" ")[1],
                  toDo: imMsgRecords[index].toDo,
                  type: __WEBPACK_IMPORTED_MODULE_4__common_Constants__["a" /* TEXT_TYPE */],
                  userNickName: userNickName,
                  seq: seq,
                  head: head,
                  sessionId: imMsgRecord.sessionId,
                  time: imMsgRecord.createdAt
                });
              } else if (imMsgRecords[index].toDo === null && imMsgRecord.applicationType === 'SERVICE_NOTIFY' /*会话转接or介入*/) {
                  console.log(data.imMsgBody, "会话转接or介入");
                  commit('unshiftMessageContentToMessageList', {
                    data: imMsgRecord.contents[0].msgContent.content,
                    // type:imMsgBody.content[0].msgType,
                    type: 'TEXT',
                    seq: imMsgRecord.seq,
                    sessionId: imMsgRecord.sessionId,
                    //userNickName: data.imMsgBody.content[0].msgContent.userNickName,
                    // sendFrom: Number(imMsgBody.content[0].msgContent.userNickName),
                    // userNickName: state.userNickNamePool[Number(imMsgBody.content[0].msgContent.userId)],
                    sendFrom: imMsgRecord.sendFrom,
                    userNickName: userNickName,
                    head: head,
                    time: imMsgRecord.createdAt
                  });
                }
            } else {
              console.log("==============msgType不是EVENT===========");
              commit('unshiftMessageContentToMessageList', {
                type: imMsgRecord.contents[0].msgType,
                data: imMsgRecord.contents[0].msgType === 'TEXT' || imMsgRecord.contents[0].msgType === 'EVENT' ? imMsgRecord.contents[0].msgContent.content : imMsgRecord.contents[0].msgContent.url,
                imgSrc: imMsgRecord.contents[0].msgContent.url,
                sessionId: imMsgRecord.sessionId,
                seq: seq,
                sendFrom: imMsgRecord.sendFrom,
                userNickName: userNickName,
                head: head,
                revoked: imMsgRecord.revoked || false,
                time: imMsgRecord.revoked ? imMsgRecord.revokeTime : imMsgRecord.createdAt
              });
            }
          });
        }
        resolve();
      });
    });
  },
  cancelWait: function cancelWait(_ref10, obj) {
    var commit = _ref10.commit,
        state = _ref10.state;

    var visitorMd5Code = obj.visitorMd5Code;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].cancelWait(visitorMd5Code, function (res) {
        if (res.code === 1) {}
        resolve();
      });
    });
  },
  workOrderSubmittied: function workOrderSubmittied(_ref11, obj) {
    var dispatch = _ref11.dispatch,
        commit = _ref11.commit,
        state = _ref11.state;

    var visitorMd5Code = obj.visitorMd5Code;
    var workOrderId = obj.workOrderId;
    var orderName = obj.orderName;
    __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].workOrderSubmittied(visitorMd5Code, workOrderId, orderName, function (body) {
      if (body.code === 1) {
        state.messageList.forEach(function (element, index) {
          if (element.msgId == obj.msgId) {
            element.type = "TEXT";
            element.data = "您已提交了工单:" + obj.orderName;
          }
        });

        localStorage.removeItem('userTime');
        dispatch('resetUserNoReplyTimer', visitorMd5Code); // 重置 访客无响应 定时器


        clearInterval(state.visitorNoReplyTimer);
        clearTimeout(state.visitorNoReplyTimerOut);
        clearInterval(state.visitorFun);

        localStorage.removeItem('sessionTime');
        dispatch('resetSessionNoReplyTimer', visitorMd5Code); // 重置 访客无响应 定时器
      }
    });
  },
  getHttp: function getHttp(_ref12, obj) {
    var dispatch = _ref12.dispatch,
        commit = _ref12.commit,
        state = _ref12.state;

    var visitorMd5Code = obj.visitorMd5Code;
    __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].getHttp(visitorMd5Code, function (body) {
      if (body.code === 1) {
        var data = body.data.imagePrefix;
        commit('setHttp', data);
      }
    });
  },
  getAutoReply: function getAutoReply(_ref13, obj) {
    var dispatch = _ref13.dispatch,
        commit = _ref13.commit,
        state = _ref13.state;

    var visitorMd5Code = obj.visitorMd5Code;

    __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].getSessionStatus(visitorMd5Code, function (body) {
      console.log('-----------------获取自动消息--------');
      console.log(body);
      if (body.code === 1) {
        var status = body.data.status;
        if (status == 'ended') {
          sessionStorage.setItem("inviteis", false);
          state.endis = false;
        }
        console.log('重连之后获取到会话状态: ' + status);
        if (status !== 'chatting') {
          clearInterval(state.userNoReplyTimer);
          clearInterval(state.userFun);
          clearInterval(state.visitorNoReplyTimer);
          clearInterval(state.visitorFun);
          clearInterval(state.sessionNoReplyTimer);
        } else {
          __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].getAutoReply(visitorMd5Code, function (body) {
            if (body.code === 1) {
              var data = body.data;
              commit('setAutoReplyConfig', data);
              console.log('是否发送欢迎语：' + sessionStorage.getItem('newSession'));
              if (sessionStorage.getItem('newSession') == 'true') {
                // 每一个会话只有一个欢迎语
                state.newSession = false;
                sessionStorage.setItem('newSession', false);
                commit('sendWelComeMessage', visitorMd5Code);

                if (data.userTimeoutFlag === true) {
                  localStorage.removeItem('userTime');
                  dispatch('resetUserNoReplyTimer', visitorMd5Code);
                }
                if (data.visitorTimeoutFlag === true) {
                  localStorage.removeItem('visitTime');
                  dispatch('resetVisitorNoReplyTimer', visitorMd5Code);
                }
                if (data.sessionTimeoutFlag === true) {
                  localStorage.removeItem('sessionTime');
                  dispatch('resetSessionNoReplyTimer', visitorMd5Code);
                }
              } else {

                if (data.sessionTimeoutFlag === true) {
                  dispatch('resetSessionNoReplyTimer', visitorMd5Code);
                }

                for (var i = state.messageList.length - 1; i >= 0; i--) {
                  if (state.messageList[i].sendFrom == visitorMd5Code) {

                    if (data.userTimeoutFlag === true) {

                      dispatch('resetUserNoReplyTimer', visitorMd5Code);
                    }

                    return;
                  } else if (state.messageList[i].sendFrom != visitorMd5Code && state.messageList[i].sendFrom != '0') {

                    if (data.visitorTimeoutFlag === true) {
                      dispatch('resetVisitorNoReplyTimer', visitorMd5Code);
                    }
                    return;
                  } else if (state.messageList[i].sendFrom == '0' && state.messageList.every(function (item, index) {
                    return item.sendFrom == '0';
                  })) {

                    dispatch('resetUserNoReplyTimer', visitorMd5Code);
                    dispatch('resetVisitorNoReplyTimer', visitorMd5Code);

                    return;
                  }
                }
              }
            }
          });
        }
      }
    });
  },
  sendMessage: function sendMessage(_ref14, obj) {
    var dispatch = _ref14.dispatch,
        commit = _ref14.commit,
        state = _ref14.state;

    var content = obj.content;
    var contentType = obj.contentType;
    var visitorMd5Code = obj.visitorMd5Code;
    var vm = this;

    localStorage.removeItem('userTime');
    dispatch('resetUserNoReplyTimer', visitorMd5Code); // 重置 访客无响应 定时器
    if (state.visitorNoReplyTimer) {
      clearInterval(state.visitorNoReplyTimer);
    }
    clearTimeout(state.visitorNoReplyTimerOut);
    clearInterval(state.visitorFun);

    localStorage.removeItem('sessionTime');
    dispatch('resetSessionNoReplyTimer', visitorMd5Code); // 重置 访客无响应 定时器

    if (content && content.trim()) {
      __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].sendMessage(visitorMd5Code, { content: content, contentType: contentType }, function (res) {
        if (res.code === 1) {
          console.log(res.data, "发送消息回执");
          var messageItem = {
            data: content,
            type: contentType,
            sendFrom: visitorMd5Code,
            time: res.data.currentTime,
            signId: obj.signId,
            status: 'success'
            //seq: res.data.seq,
            //sessionId: res.data.sessionId
          };
          if (res.data.connected == false) {
            location.reload();
          }
          if ((contentType == __WEBPACK_IMPORTED_MODULE_4__common_Constants__["b" /* IMAGE_TYPE */] || contentType == __WEBPACK_IMPORTED_MODULE_4__common_Constants__["c" /* VIDEO_TYPE */]) && obj.signId) {
            commit('cptMsg', messageItem);
          } else {
            commit('addMessageContentToMessageList', messageItem);
          }
          // commit('addMessageContentToMessageList', messageItem);
          setTimeout(function () {
            var chat = document.getElementsByClassName('chat')[0];
            chat.scrollTop = chat.scrollHeight;
          }, 100);
        }
        if (res.code === 4208) {
          clearInterval(state.userNoReplyTimer);
          clearInterval(state.userFun);
          clearInterval(state.visitorNoReplyTimer);
          clearInterval(state.visitorFun);
          clearInterval(state.sessionNoReplyTimer);
          state.endis = false;
          sessionStorage.setItem("inviteis", false);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"])({
            message: '会话已过期，请重新排队',
            type: 'warning'
          });
        }
      });
    }
  },
  getSatisfySettting: function getSatisfySettting(_ref15, obj) {
    var dispath = _ref15.dispath,
        commit = _ref15.commit,
        state = _ref15.state;

    var visitorMd5Code = obj.visitorMd5Code;
    __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].satisfySetting(visitorMd5Code, function (res) {

      if (res.code === 1) {
        console.log("hdsjhsjhsjhjshsjhj");
        console.log(res.data.mode);
        console.log(res);
        if (res.data.mode === 1) {
          commit('setSatisfySetting', res.data.mode);
        } else if (res.data.mode === 2) {

          commit('setSatisfySetting', res.data.mode);
        }
      }
    });
  },
  evaluate: function evaluate(_ref16, obj) {
    var dispatch = _ref16.dispatch,
        commit = _ref16.commit,
        state = _ref16.state;

    var visitorMd5Code = obj.visitorMd5Code;
    __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].evaluate(obj, function (res) {
      if (res.code === 1) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"])({ showClose: true, message: '评价成功', type: 'success' });
        commit("setShowSatisfySettingFlag", false);

        __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].getSessionStatus(visitorMd5Code, function (body) {
          if (body.code === 1) {
            var status = body.data.status;
            if (status == 'chatting') {
              localStorage.removeItem('userTime');
              dispatch('resetUserNoReplyTimer', visitorMd5Code); // 重置 访客无响应 定时器
              if (state.visitorNoReplyTimer) {
                clearInterval(state.visitorNoReplyTimer);
              }
              clearTimeout(state.visitorNoReplyTimerOut);
              clearInterval(state.visitorFun);

              localStorage.removeItem('sessionTime');
              dispatch('resetSessionNoReplyTimer', visitorMd5Code); // 重置 访客无响应 定时器
            } else {
              if (state.visitorNoReplyTimer) {
                clearInterval(state.visitorNoReplyTimer);
              }
              clearTimeout(state.visitorNoReplyTimerOut);
              clearInterval(state.visitorFun);
            }
          }
        });
      } else if (res.code = 4214) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"])({ showClose: true, message: '您已经评价过了！', type: 'warning' });
      } else if (res.code = 4029) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"])({ showClose: true, message: '请对我们的服务做出评价哟！', type: 'warning' });
      } else if (res.code = 4030) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"])({ showClose: true, message: '需要评价处理时长', type: 'warning' });
      } else if (res.code = 4031) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"])({ showClose: true, message: '需要评价处理结果', type: 'warning' });
      } else if (res.code = 4221) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"])({ showClose: true, message: '会话不存在', type: 'warning' });
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"])({ showClose: true, message: '评价失败', type: 'warning' });
      }
    });
  },
  sendTransientMessage: function sendTransientMessage(_ref17, obj) {
    var dispath = _ref17.dispath,
        commit = _ref17.commit,
        state = _ref17.state;
    // 实时消息
    var visitorMd5Code = obj.visitorMd5Code;
    var data = {
      visitorMd5Code: visitorMd5Code,
      form: {
        content: obj.content,
        contentType: obj.contentType
      }
    };
    __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].sendTransientMessage(data, function (res) {});
  },
  uploadVideo: function uploadVideo(_ref18, obj) {
    var dispatch = _ref18.dispatch,
        commit = _ref18.commit;

    var visitorMd5Code = obj.visitorMd5Code;
    var file = obj.file;
    console.log('file999：', file);
    if (!file) return;
    if (file.size / 1024 > 512000) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"])({
        type: 'warning',
        message: "最大只允许发送500M视频"
      });
      return;
    }
    // TODO 文件类型也得判断
    if (!file.type.match(videoRex)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"])({
        type: 'warning',
        message: "目前只支持mp4/avi/wmv/mov格式的视频"
      });
      return;
    }
    var videoUrl = getObjectURL(new Blob([file]));
    getVideoCover(file, videoUrl, 1, function (url) {
      var messageItem = {
        data: url,
        type: __WEBPACK_IMPORTED_MODULE_4__common_Constants__["c" /* VIDEO_TYPE */],
        sendFrom: visitorMd5Code,
        seq: '',
        sessionId: '',
        signId: obj.signId,
        status: 'loading',
        time: obj.ctm
      };
      commit('addMessageContentToMessageList', messageItem);
      // 处理成功会执行
      var formData = new FormData();
      formData.append('file', file);
      __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].sendImgMsg(visitorMd5Code, formData, function (body) {
        if (body.code === 1) {
          var videoSrc = body.data;
          console.log('视频地址: ' + videoSrc);
          if (!videoSrc) return;
          console.log('setTimeout');
          dispatch({
            type: 'sendMessage',
            contentType: __WEBPACK_IMPORTED_MODULE_4__common_Constants__["c" /* VIDEO_TYPE */],
            content: videoSrc,
            visitorMd5Code: visitorMd5Code,
            signId: obj.signId
          });
          state.uniqueMsgMap[body.data.sessionId + '_' + body.data.msgId] = true;
        } else if (body.code === 4012) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_element_ui__["MessageBox"])('提示', '目前只支持mp4/avi/wmv/mov格式的视频');
          return;
        } else if (body.code === 4013) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_element_ui__["MessageBox"])('提示', '最大只允许发送5M视频');
          return;
        }
      });
    });
  },
  sendImgMsg: function sendImgMsg(_ref19, obj) {
    var dispatch = _ref19.dispatch,
        commit = _ref19.commit,
        state = _ref19.state;

    var visitorMd5Code = obj.visitorMd5Code;
    console.log(obj.file, "file");
    var file = obj.file;
    if (!file) return;
    console.log(file.size, file.type, "file.size, file.type");
    if (file.type.match(videoRex)) {
      dispatch('uploadVideo', obj);
      obj.callback && obj.callback();
      return;
    }
    if (file.size / 1024 > 1024 * 9) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"])({
        type: 'warning',
        message: "最大只允许发送9M图片"
      });
      return;
    }
    // 判断文件类型
    if (!file.type.match(imageRex)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"])({
        type: 'warning',
        message: "目前只支持jpg/png/bmp/gif格式的图片"
      });
      return;
    }
    var messageItem = {
      data: getObjectURL(file),
      type: __WEBPACK_IMPORTED_MODULE_4__common_Constants__["b" /* IMAGE_TYPE */],
      sendFrom: visitorMd5Code,
      seq: '',
      sessionId: '',
      signId: obj.signId,
      status: 'loading',
      time: obj.ctm
    };
    commit('addMessageContentToMessageList', messageItem);
    // let formData = new FormData();
    // formData.append('file',file);
    __WEBPACK_IMPORTED_MODULE_7_lrz___default()(file).then(function (rst) {
      __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].sendImgMsg(visitorMd5Code, rst.formData, function (res) {
        // 添加一个回调函数用来清空file的input的值 // 清空image选择框的值
        obj.callback && obj.callback();
        if (res.code === 1) {
          var imgSrc = res.data;
          if (!imgSrc) return;
          dispatch({
            type: 'sendMessage',
            contentType: __WEBPACK_IMPORTED_MODULE_4__common_Constants__["b" /* IMAGE_TYPE */],
            content: imgSrc,
            visitorMd5Code: visitorMd5Code,
            signId: obj.signId
          });
        } else if (body.code === 4012) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"])({
            type: 'warning',
            message: "目前只支持jpg/png/bmp/gif格式的图片"
          });
          return;
        } else if (body.code === 4013) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"])({
            type: 'warning',
            message: "最大只允许发送9M图片"
          });
          return;
        }
      });
    });
  },
  initUserPool: function initUserPool(_ref20, obj) {
    var dispatch = _ref20.dispatch,
        commit = _ref20.commit,
        state = _ref20.state;

    var visitorMd5Code = obj.visitorMd5Code;
    __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].getUserNickNames(visitorMd5Code, function (body) {
      if (body.code === 1) {
        commit('initUserPool', body.data);
      }
    });
  }
};
var mutations = {
  cptMsg: function cptMsg(state, obj) {
    state.messageList.forEach(function (item) {
      if (item.signId == obj.signId) {
        item.data = obj.data;
        item.status = 'success';
      }
    });
  },
  initUserPool: function initUserPool(state, data) {
    state.userNickNamePool = data;
  },
  setEntranceId: function setEntranceId(state, entranceId) {

    state.entranceId = Number(entranceId);
  },
  setEntranceList: function setEntranceList(state, entranceList) {
    state.entranceList = entranceList;
  },
  setShowSatisfySettingFlag: function setShowSatisfySettingFlag(state, showSatisfySettingFlag) {
    state.showSatisfySettingFlag = showSatisfySettingFlag;
  },
  setCurrentPosition: function setCurrentPosition(state, currentPosition) {
    console.log('setCurrentPosition');
    console.log(currentPosition);
    state.currentPosition = currentPosition;
  },
  setSatisfySetting: function setSatisfySetting(state, satisfyMode) {
    console.log('satisfyMode');
    console.log(satisfyMode);
    state.satisfyMode = satisfyMode;
  },
  setAutoReplyConfig: function setAutoReplyConfig(state, autoReplyConfig) {
    state.autoReplyConfig = autoReplyConfig;
  },
  setHttp: function setHttp(state, autoReplyConfig) {
    state.imHttp = autoReplyConfig;
  },
  addMessageContentToMessageList: function addMessageContentToMessageList(state, messageContent) {
    if (messageContent.type === __WEBPACK_IMPORTED_MODULE_4__common_Constants__["a" /* TEXT_TYPE */]) {
      messageContent.data = processLinkMessage(messageContent.data, messageContent.sendFrom);
    }
    console.log(messageContent, "messagecontent");
    state.messageList.push(messageContent);

    setTimeout(function () {
      var chat = document.getElementsByClassName('chat')[0]; //  为啥这么处理
      if (chat) {
        chat.scrollTop = chat.scrollHeight;
      }
    }, 100);
  },
  revokeMessageList: function revokeMessageList(state, data) {
    var msgId = data.msgId,
        createdTime = data.createdTime;

    state.messageList.forEach(function (item) {
      if (item.msgId == msgId) {
        item.revoked = true;
        item.time = createdTime;
      }
    });
  },
  unshiftMessageContentToMessageList: function unshiftMessageContentToMessageList(state, messageContent) {
    if (messageContent.type === __WEBPACK_IMPORTED_MODULE_4__common_Constants__["a" /* TEXT_TYPE */]) {
      messageContent.data = processLinkMessage(messageContent.data, messageContent.sendFrom);
    }
    state.messageList.unshift(messageContent);
    setTimeout(function () {
      var chat = document.getElementsByClassName('chat')[0];
      //chat.scrollTop = chat.scrollHeight;
      chat.scrollTop = chat.scrollTop + 40;
    }, 100);
  },
  sendWelComeMessage: function sendWelComeMessage(state, visitorMd5Code) {
    if (sessionStorage.getItem('inviteis') == 'true') {
      console.log('----------发送邀请语-------');
      __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].getinvitations(visitorMd5Code, function (res) {
        var invitations = res.data.invitations;
        __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].sendAutoMessage(visitorMd5Code, {
          type: 4,
          content: invitations,
          toId: state.currentUserId,
          toName: state.userNickNamePool[state.currentUserId]
          // head:state.head
        }, function (res) {
          if (res.code === 1) {
            state.messageList.push({
              type: __WEBPACK_IMPORTED_MODULE_4__common_Constants__["a" /* TEXT_TYPE */],
              data: invitations,
              sendFrom: state.currentUserId,
              userNickName: state.userNickNamePool[state.currentUserId],
              head: state.head,
              time: res.timestamp
            });
          }
        });

        setTimeout(function () {
          var chat = document.getElementsByClassName('chat')[0];
          chat.scrollTop = chat.scrollHeight;
        }, 100);
      });
    } else {
      if (state.autoReplyConfig.welcomeMsg && state.autoReplyConfig.welcomeMsg.length > 0) __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].sendAutoMessage(visitorMd5Code, {
        type: 4,
        content: state.autoReplyConfig.welcomeMsg,
        toId: state.currentUserId,
        toName: state.userNickNamePool[state.currentUserId]
        // head:state.head
      }, function (res) {
        if (res.code === 1) {
          state.messageList.push({
            type: __WEBPACK_IMPORTED_MODULE_4__common_Constants__["a" /* TEXT_TYPE */],
            data: state.autoReplyConfig.welcomeMsg,
            sendFrom: state.currentUserId,
            userNickName: state.userNickNamePool[state.currentUserId],
            head: state.head,
            time: res.timestamp
          });
        }
      });

      setTimeout(function () {
        var chat = document.getElementsByClassName('chat')[0];
        chat.scrollTop = chat.scrollHeight;
      }, 100);
    }
  },
  sendWorkOrderMessage: function sendWorkOrderMessage(state, obj) {
    console.log('sendWorkOrderMessage, 工单ID: ' + obj.workOrderId);

    if (obj.workOrderId) {
      state.messageList.push({
        type: __WEBPACK_IMPORTED_MODULE_4__common_Constants__["d" /* WORK_ORDER_TYPE */],
        data: obj.workOrderId,
        sendFrom: state.currentUserId,
        userNickName: state.userNickNamePool[state.currentUserId],
        msgId: obj.msgId,
        head: obj.head,
        time: obj.time
      });
    }
    // else if(obj.data){
    //     state.messageList.push({
    //         type: Constants.TEXT_TYPE,
    //         data: obj.workOrderId ? obj.workOrderId : obj.data,
    //         sendFrom: state.currentUserId,
    //         userNickName: state.userNickNamePool[state.currentUserId],
    //         msgId: obj.msgId
    //     })
    // }

    setTimeout(function () {
      var chat = document.getElementsByClassName('chat')[0];
      chat.scrollTop = chat.scrollHeight;
    }, 100);
  },
  unshiftWorkOrderMessage: function unshiftWorkOrderMessage(state, obj) {
    state.messageList.unshift({
      type: __WEBPACK_IMPORTED_MODULE_4__common_Constants__["d" /* WORK_ORDER_TYPE */],
      data: Number(obj.workOrderId),
      sendFrom: state.currentUserId,
      userNickName: state.userNickNamePool[state.currentUserId],
      msgId: obj.msgId,
      head: obj.head,
      seq: obj.seq,
      sessionId: obj.sessionId,
      time: obj.time
    });
    setTimeout(function () {
      var chat = document.getElementsByClassName('chat')[0];
      //chat.scrollTop = chat.scrollHeight;
      chat.scrollTop = chat.scrollTop + 40;
    }, 100);
  },
  unshiftEventMessage: function unshiftEventMessage(state, obj) {
    state.messageList.unshift({
      type: __WEBPACK_IMPORTED_MODULE_4__common_Constants__["e" /* EVENT_TYPE */],
      data: obj.workOrderId ? obj.workOrderId : obj.content,
      sendFrom: state.currentUserId,
      userNickName: state.userNickNamePool[state.currentUserId],
      msgId: obj.msgId,
      head: state.head,
      seq: obj.seq,
      sessionId: obj.sessionId
    });
    setTimeout(function () {
      var chat = document.getElementsByClassName('chat')[0];
      chat.scrollTop = chat.scrollHeight;
    }, 100);
  },
  sendFinishedMsg: function sendFinishedMsg(state, visitorMd5Code) {
    if (state.autoReplyConfig.finishedMsg && state.autoReplyConfig.finishedMsg.length > 0) {
      __WEBPACK_IMPORTED_MODULE_2__api_imApi__["a" /* default */].sendAutoMessage(visitorMd5Code, {
        type: 4,
        toId: state.currentUserId,
        toName: state.userNickNamePool[state.currentUserId],
        content: state.autoReplyConfig.finishedMsg
        // head:state.head,
      }, function (res) {
        if (res.code === 1) {
          state.messageList.push({
            type: 'TEXT',
            data: state.autoReplyConfig.finishedMsg,
            sendFrom: state.currentUserId,
            userNickName: state.userNickNamePool[state.currentUserId],
            head: state.head,
            time: res.timestamp
          });
        }
      });
      setTimeout(function () {
        var chat = document.getElementsByClassName('chat')[0];
        chat.scrollTop = chat.scrollHeight;
      }, 100);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "TQb4":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "U8ot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ua5X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workerorderindex"
  }, [_c('top'), _vm._v(" "), _c('div', {
    staticClass: "nav"
  }, [_c('router-link', {
    staticStyle: {
      "color": "rgb(31, 55, 61)"
    },
    attrs: {
      "to": _vm.urlb
    }
  }, [_c('span', {
    on: {
      "click": _vm.hisback
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('span', {
    staticClass: "navbread"
  }, [_vm._v(_vm._s('>' + _vm.questionclass))]), _vm._v(" "), _c('a', {
    staticClass: "btna color",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "href": "#/myorder"
    }
  }, [_vm._v("我的工单")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("工单编号:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.processInstanceId))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inforis),
      expression: "inforis"
    }]
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("补填信息:")]), _vm._v(" "), _c('span', [_vm._v("请您点击【补填信息】按钮进行单据填补")]), _vm._v(" "), _c('el-button', {
    staticClass: "color btn",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.commitgo
    }
  }, [_vm._v("补填信息")])], 1), _vm._v(" "), (_vm.staris == 1) ? _c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("服务评价:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("请您对本次的服务做出评价")]), _vm._v(" "), _c('div', {
    staticClass: "service"
  }, [_vm._l((_vm.srcurl), function(item, index) {
    return _c('p', {
      on: {
        "click": function($event) {
          _vm.service(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.url
      }
    }), _vm._v(" "), _c('span', {
      attrs: {
        "id": 'service' + index
      }
    }, [_vm._v(_vm._s(item.content))])])
  }), _vm._v(" "), _c('aside', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pingjiais),
      expression: "pingjiais"
    }],
    staticClass: "pingjia"
  }, [_c('ul', [_c('span', [_vm._v("处理结果:")]), _vm._v(" "), _vm._l((_vm.result), function(item, index) {
    return _c('span', {
      on: {
        "click": function($event) {
          _vm.star('result', index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": '/pc/static/assets/im_star_' + item + '.png'
      }
    })])
  })], 2), _vm._v(" "), _c('ul', [_c('span', [_vm._v("服务态度:")]), _vm._v(" "), _vm._l((_vm.autitude), function(item, index) {
    return _c('span', {
      on: {
        "click": function($event) {
          _vm.star('autitude', index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": '/pc/static/assets/im_star_' + item + '.png'
      }
    })])
  })], 2), _vm._v(" "), _c('ul', [_c('span', [_vm._v("处理时长:")]), _vm._v(" "), _vm._l((_vm.time), function(item, index) {
    return _c('span', {
      on: {
        "click": function($event) {
          _vm.star('time', index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": '/pc/static/assets/im_star_' + item + '.png'
      }
    })])
  })], 2), _vm._v(" "), _c('ul', {
    staticStyle: {
      "height": "180px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v("说明:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commpent),
      expression: "commpent"
    }],
    staticClass: "explain",
    attrs: {
      "placeholder": "您的建议就是我们奋斗的目标"
    },
    domProps: {
      "value": (_vm.commpent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commpent = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "clear": "both",
      "display": "block"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "color submit",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.starcommit
    }
  }, [_vm._v("提交")])], 2)]) : (_vm.staris == 2) ? _c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("服务评价:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff864a"
    }
  }, [_vm._v("感谢您对本次的服务做出评价")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("处理进度:")]), _vm._v(" "), _c('div', {
    staticClass: "detailright"
  }, _vm._l((_vm.detail), function(item, index) {
    return _c('div', {
      staticClass: "detailcontent"
    }, [(index == 0) ? _c('span', {
      staticClass: "orangepot"
    }) : _c('span', {
      staticClass: "pot"
    }), _vm._v(" "), _c('p', {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.date))]), _vm._v(" "), (index != 0) ? _c('p', {
      staticClass: "content"
    }, [_vm._v(_vm._s(item.title))]) : _c('p', {
      staticClass: "contenting"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (index != 0) ? _c('p', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (item.content),
        expression: "item.content"
      }],
      staticClass: "content"
    }) : _c('p', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (item.content),
        expression: "item.content"
      }],
      staticClass: "contenting"
    })])
  }))])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ubvr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-page"
  }, [_c('Top'), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WJAN":
/***/ (function(module, exports) {

(function (exports) {
    //公共方法
    var Util = {
        //初始化
        init: function init() {
            navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mediaDevices.getUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;

            window.AudioContext = window.AudioContext || window.webkitAudioContext;
        },
        //日志
        log: function log() {
            console.log.apply(console, arguments);
        }
    };
    //构造函数
    var Recorder = function Recorder(config) {

        var _this = this;
        config = config || {}; //初始化配置对象
        config.sampleRate = config.sampleRate || 44100; //采样频率，默认为44100Hz(标准MP3采样率)
        config.bitRate = config.bitRate || 128; //比特率，默认为128kbps(标准MP3质量)

        Util.init();

        if (navigator.getUserMedia) {

            navigator.getUserMedia({
                audio: true //配置对象
            }, function (stream) {
                //成功回调
                //alert(1)
                var context = new AudioContext(),
                    microphone = context.createMediaStreamSource(stream),
                    //媒体流音频源
                processor = context.createScriptProcessor(16384, 1, 1),
                    //js音频处理器
                successCallback,
                    errorCallback;

                config.sampleRate = context.sampleRate;

                processor.onaudioprocess = function (event) {
                    //监听音频录制过程
                    var array = event.inputBuffer.getChannelData(0);
                    realTimeWorker.postMessage({ cmd: 'encode', buf: array });
                };

                var realTimeWorker = new Worker('/pc/static/video/worker.js'); //开启后台线程
                realTimeWorker.onmessage = function (e) {
                    //主线程监听后台线程，实时通信
                    switch (e.data.cmd) {
                        case 'init':
                            Util.log('初始化成功');
                            if (config.success) {
                                config.success();
                            }
                            break;
                        case 'end':
                            if (successCallback) {
                                var blob = new Blob(e.data.buf, { type: 'audio/mp3' });
                                successCallback(blob);
                                console.log('--------音频文件-----');
                                //console.log(blob)
                                Util.log('MP3大小：' + blob.size + '%cB', 'color:#0000EE');
                            }
                            break;
                        case 'error':
                            Util.log('错误信息：' + e.data.error);
                            if (errorCallback) {
                                errorCallback(e.data.error);
                            }
                            break;
                        default:
                            Util.log('未知信息：' + e.data);
                    }
                };
                //接口列表
                //开始录音
                _this.start = function () {
                    if (processor && microphone) {
                        microphone.connect(processor);
                        processor.connect(context.destination);
                        Util.log('开始录音');
                    }
                };
                //结束录音
                _this.stop = function () {
                    if (processor && microphone) {
                        microphone.disconnect();
                        processor.disconnect();
                        Util.log('录音结束');
                    }
                };
                //获取blob格式录音文件
                _this.getBlob = function (onSuccess, onError) {
                    successCallback = onSuccess;
                    errorCallback = onError;
                    realTimeWorker.postMessage({ cmd: 'finish' });
                };

                realTimeWorker.postMessage({
                    cmd: 'init',
                    config: {
                        sampleRate: config.sampleRate,
                        bitRate: config.bitRate
                    }
                });
            }, function (error) {
                //失败回调
                var msg;
                console.log(error);
                switch (error.code || error.name) {
                    case 'PermissionDeniedError':
                    case 'PERMISSION_DENIED':
                    case 'NotAllowedError':
                        msg = '用户拒绝访问麦克风';
                        break;
                    case 'NOT_SUPPORTED_ERROR':
                    case 'NotSupportedError':
                        msg = '浏览器不支持麦克风';
                        break;
                    case 'MANDATORY_UNSATISFIED_ERROR':
                    case 'MandatoryUnsatisfiedError':
                        msg = '找不到麦克风设备';
                        break;
                    default:
                        msg = '无法打开麦克风，异常信息:' + (error.code || error.name);
                        break;
                }
                Util.log(msg);
                if (config.error) {
                    config.error(msg);
                }
            });
        } else {
            Util.log('当前浏览器不支持录音功能');
            if (config.fix) {
                config.fix('当前浏览器不支持录音功能');
            }
        }
    };
    //模块接口
    exports.Recorder = Recorder;
})(window);

/***/ }),

/***/ "XSa7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ImagePreview',
  data: function data() {
    return {
      closed: false
    };
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: [String, Number],
      default: '600px'
    },
    imagePreviewUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    styleClass: function styleClass() {
      var style = {};
      if (this.width) {
        style.width = this.width;
      }
      return style;
    }
  },
  methods: {
    close: function close() {
      console.log(1111);
      this.$emit('update:visible', false);
      this.$emit('close');
    }
  }
});

/***/ }),

/***/ "Xm1c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-top",
    style: ({
      backgroundColor: _vm.boxBodyColor
    })
  }, [(_vm.displayMode == 2) ? _c('img', {
    attrs: {
      "src": _vm.logoUrl,
      "alt": "公司logo"
    }
  }) : _c('p', {
    staticClass: "companyName"
  }, [(_vm.companyName == '') ? _c('span') : (_vm.companyName.length > 10) ? _c('el-tooltip', {
    attrs: {
      "content": _vm.companyName,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.companyName.substring(0, 10) + '...'))])]) : _c('span', [_vm._v(_vm._s(_vm.companyName))])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "首页",
      "name": "0"
    }
  }, [_vm._v("首页")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "orderAndService"
  }, [_c('img', {
    staticClass: "order-logo",
    attrs: {
      "src": _vm.imgUrl + 'im_logo.png',
      "alt": "单据logo"
    },
    on: {
      "click": _vm.workOrder
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "order",
    on: {
      "click": _vm.workOrder
    }
  }, [_vm._v("我的单据")]), _vm._v(" "), (_vm.iskf) ? _c('div', {
    staticClass: "im-content",
    on: {
      "click": _vm.intoIm
    }
  }, [_c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__("+cQD"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "order"
  }, [_vm._v("在线客服")])]) : _vm._e()])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_workorder_workerorderindex__ = __webpack_require__("+55Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_workorder_workinformation__ = __webpack_require__("oHe/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_workorder_workacconnt__ = __webpack_require__("0snm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_im_serviceError__ = __webpack_require__("cf29");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_workorder_workcommit__ = __webpack_require__("tO83");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_workorder_workdetail__ = __webpack_require__("/HIr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_workorder_butianinfor__ = __webpack_require__("yh2X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_im_inviteselect__ = __webpack_require__("gPP5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_im_imDirectory__ = __webpack_require__("QABr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_im_imLineUp__ = __webpack_require__("oLrh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_im_loginMobile__ = __webpack_require__("ixHi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_im_imSession__ = __webpack_require__("heFm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_workorder_myorder__ = __webpack_require__("jFDJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_im_beatis__ = __webpack_require__("4pyB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Hello__ = __webpack_require__("qSdX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_spirit_spirit__ = __webpack_require__("MUwE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_callcenter_callcenter__ = __webpack_require__("n9ej");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_question_aiInteractive__ = __webpack_require__("lDzE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_question_faqPage__ = __webpack_require__("FxON");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_question_receipt__ = __webpack_require__("ZPYt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_question_imChat__ = __webpack_require__("vsLA");
























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'hello',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Hello__["a" /* default */]
  }, {
    path: '/callcenter',
    name: 'callcenter',
    component: __WEBPACK_IMPORTED_MODULE_18__components_callcenter_callcenter__["a" /* default */]
  }, {
    path: '/commitinfor',
    name: 'commitinfor',
    component: __WEBPACK_IMPORTED_MODULE_8__components_workorder_butianinfor__["a" /* default */]
  }, {
    path: '/workinformation',
    name: 'workinformation',
    component: __WEBPACK_IMPORTED_MODULE_3__components_workorder_workinformation__["a" /* default */]
  }, {
    path: '/workerorderindex',
    name: 'workerorderindex',
    component: __WEBPACK_IMPORTED_MODULE_2__components_workorder_workerorderindex__["a" /* default */]
  }, {
    path: '/workaccount',
    name: 'workaccount',
    component: __WEBPACK_IMPORTED_MODULE_4__components_workorder_workacconnt__["a" /* default */]
  }, {
    path: '/workcommit',
    name: 'workcommit',
    component: __WEBPACK_IMPORTED_MODULE_6__components_workorder_workcommit__["a" /* default */]
  }, {
    path: '/workdetail',
    name: 'workdetail',
    component: __WEBPACK_IMPORTED_MODULE_7__components_workorder_workdetail__["a" /* default */]
  }, {
    path: '/beatis',
    name: 'beatis',
    component: __WEBPACK_IMPORTED_MODULE_15__components_im_beatis__["a" /* default */]
  }, { // 服务器连接错误
    path: '/serviceError',
    name: 'ServiceError',
    component: __WEBPACK_IMPORTED_MODULE_5__components_im_serviceError__["a" /* default */]
  }, { // im 目录
    path: '/imDirectory',
    name: 'ImDirectory',
    component: __WEBPACK_IMPORTED_MODULE_10__components_im_imDirectory__["a" /* default */]
  }, { // im 目录
    path: '/inviteselect',
    name: 'inviteselect',
    component: __WEBPACK_IMPORTED_MODULE_9__components_im_inviteselect__["a" /* default */]
  }, { // im 排队
    path: '/imLineUp',
    name: 'IMLineUp',
    component: __WEBPACK_IMPORTED_MODULE_11__components_im_imLineUp__["a" /* default */]
  }, { // 登陆
    path: '/loginMobile',
    name: 'LoginMobile',
    component: __WEBPACK_IMPORTED_MODULE_12__components_im_loginMobile__["a" /* default */]
  }, { // 会话
    path: '/imSession',
    name: 'ImSession',
    component: __WEBPACK_IMPORTED_MODULE_13__components_im_imSession__["a" /* default */]
  }, {
    path: '/myorder',
    name: 'myorder',
    component: __WEBPACK_IMPORTED_MODULE_14__components_workorder_myorder__["a" /* default */]
  }, {
    path: '/spirit',
    name: 'spirit',
    component: __WEBPACK_IMPORTED_MODULE_17__components_spirit_spirit__["a" /* default */]
  }, {
    path: '/aiInteractive',
    name: 'AiInteractive',
    component: __WEBPACK_IMPORTED_MODULE_19__components_question_aiInteractive__["a" /* default */]
  }, {
    path: '/faqPage',
    name: 'FaqPage',
    component: __WEBPACK_IMPORTED_MODULE_20__components_question_faqPage__["a" /* default */]
  }, {
    path: '/receipt',
    name: 'Receipt',
    component: __WEBPACK_IMPORTED_MODULE_21__components_question_receipt__["a" /* default */]
  }, {
    path: '/imChat',
    name: 'imChat',
    component: __WEBPACK_IMPORTED_MODULE_22__components_question_imChat__["a" /* default */]
  }]
}));

/***/ }),

/***/ "YbuA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__im_IMTop_vue__ = __webpack_require__("dU9P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_imApi__ = __webpack_require__("g1nd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_url__ = __webpack_require__("vpRr");

//
//
//
//
//
//
//
//
//
//
//
//
//
//





//import * as ImgUrl from '../../../static/assets'

var imUrl = __WEBPACK_IMPORTED_MODULE_4__components_url__["a" /* baseurl */] + '/api/visitor/im';
var woUrl = __WEBPACK_IMPORTED_MODULE_4__components_url__["a" /* baseurl */] + '/api/visitor/wo';
var url = __WEBPACK_IMPORTED_MODULE_4__components_url__["a" /* baseurl */] + '/api/visitor';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IMLineUp',
  components: {
    imTop: __WEBPACK_IMPORTED_MODULE_2__im_IMTop_vue__["a" /* default */]
  },
  data: function data() {
    return {
      boxBodyColor: '',
      imgUrl: '/pc/static/assets/',
      msgNum: 16,
      visitorMd5Code: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    currentPosition: 'currentPosition11',
    // existUser: 'existUser',
    // home: 'home',
    endis: 'endclass'
  })),

  watch: {
    '$route': 'renderPage'
  },
  mounted: function mounted() {
    this.$store.state.im.endis = true;
    var gois = true;
    var userAgent = navigator.userAgent;
    if (userAgent.indexOf("Windows") > -1) {
      if (/Safari/.test(navigator.userAgent) && !/Chrome/.test(userAgent)) {
        console.log(userAgent);
        gois = false;
      }
    }
    if (gois) {
      this.boxBodyColor = sessionStorage.getItem('boxBodyColor');
      this.visitorMd5Code = sessionStorage.md5;
      this.renderPage();
    } else {
      this.$router.push('/beatis');
    }
  },

  methods: {
    renderPage: function renderPage() {

      var entranceId = sessionStorage.entranceId ? sessionStorage.entranceId : "";
      //alert(entranceId);
      var visitorMd5Code = sessionStorage.md5; //
      var vm = this;
      // this.$store.dispatch({
      //   type:'entrance',
      //   router: vm.$router,
      //   visitorMd5Code: visitorMd5Code
      // })
      // 创建socket 如果存在链接则忽略
      this.$store.dispatch({
        type: 'createSocket',
        router: vm.$router,
        visitorMd5Code: visitorMd5Code
      });
      // 获取当前IM会话状态
      __WEBPACK_IMPORTED_MODULE_3__api_imApi__["a" /* default */].getSessionStatus(visitorMd5Code, function (res) {
        console.log(res, "获取当前IM会话状态");

        if (res.code === 1) {
          // 会话未创建  或者  会话已结束
          var status = res.data.status;
          //  vm.$store.commit('setCurrentPosition', res.data.data);
          if (res.data.status == 'waiting') {
            console.log('im会话状态为 排队中');
            // 持续去后台拉取当前排队的数据
            console.log("你快去");
            // vm.$store.dispatch({
            //     type: 'startCurrentPositionTimer',
            //     router: vm.$router,
            //     entranceId: entranceId,
            //     visitorMd5Code: visitorMd5Code,
            // })
          } else if (status === 'chatting') {
            console.log('im会话状态为 聊天中');
            vm.$router.replace({ path: '/imSession', query: { v: visitorMd5Code } });
          } else {
            console.log('im会话未创建 现在开始排队');
            vm.$store.dispatch({
              type: 'enterQueue',
              entranceId: entranceId,
              router: vm.$router,
              visitorMd5Code: visitorMd5Code
            });
          }
        } else {
          // 会话未创建，开始排队
          console.log('im会话未创建 现在开始排队');
          vm.$store.dispatch({
            type: 'enterQueue',
            entranceId: entranceId,
            router: vm.$router,
            visitorMd5Code: visitorMd5Code
          });
        }
        // // 持续去后台拉取当前排队的数据
        // console.log("你快去");
        vm.$store.dispatch({
          type: 'startCurrentPositionTimer',
          router: vm.$router,
          entranceId: entranceId,
          visitorMd5Code: visitorMd5Code
        });
      });
    },
    giveUpInLine: function giveUpInLine() {
      var _this = this;

      // sessionStorage.removeItem("imEntranceMode")
      clearInterval(this.$store.state.im.timer);
      var vm = this;
      var visitorMd5Code = sessionStorage.md5;
      this.$store.dispatch({
        type: 'cancelWait',
        router: vm.$router,
        visitorMd5Code: visitorMd5Code
      }).then(function () {
        var isWorkOrder = sessionStorage.redirectTarget;
        console.log(isWorkOrder, "isWorkOrder");
        if (isWorkOrder == 5) {
          _this.$router.replace({ path: '/aiInteractive', query: { v: visitorMd5Code } });
        } else if (isWorkOrder == 3) {
          console.log("跳转到工单");
          _this.$router.replace({ path: '/workerorderindex' });
        } else {
          // alert("guanbi")
          var CloseWebPage = function CloseWebPage() {
            if (navigator.userAgent.indexOf("MSIE") > 0) {
              if (navigator.userAgent.indexOf("MSIE 6.0") > 0) {
                window.opener = null;
                window.location.href = "about:blank";
                window.close();
              } else {
                window.open('', '_top');
                window.location.href = "about:blank";
                window.top.close();
              }
            } else if (navigator.userAgent.indexOf("Firefox") > 0) {
              window.location.href = 'about:blank ';
            } else {
              window.opener = null;
              window.open('', '_self', '');
              window.location.href = "about:blank";
              window.close();
            }
          };

          console.log("关闭页面");
          setTimeout(function () {
            CloseWebPage();
          }, 400);
        }
      });
    }
  }
});

/***/ }),

/***/ "ZPYt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_receipt_vue__ = __webpack_require__("KGqH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4cdef5c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_receipt_vue__ = __webpack_require__("c+ye");
function injectStyle (ssrContext) {
  __webpack_require__("3bJ7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f4cdef5c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_receipt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4cdef5c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_receipt_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Za7Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aFQi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aFUI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__url_js__ = __webpack_require__("vpRr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_request_js__ = __webpack_require__("vLgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workorder_top_vue__ = __webpack_require__("3XGK");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'workerorderindex',
  components: {
    top: __WEBPACK_IMPORTED_MODULE_2__workorder_top_vue__["a" /* default */]
  },
  data: function data() {
    return {
      kefuis: false,
      hotquestion: ['无'],
      allquestion: ["无"],
      basurl: __WEBPACK_IMPORTED_MODULE_0__url_js__["a" /* baseurl */],
      boxBodyColor: '',
      logoUrl: '',
      companyName: '',
      displayMode: '',
      md5: ""
    };
  },
  mounted: function mounted() {
    var vm = this;
    vm.boxBodyColor = sessionStorage.getItem('boxBodyColor');
    vm.companyName = sessionStorage.getItem('companyName');
    vm.logoUrl = sessionStorage.getItem('logoUrl');
    vm.displayMode = sessionStorage.getItem('displayMode');
    this.md5 = sessionStorage.getItem("md5");
    //获取热点问题
    __WEBPACK_IMPORTED_MODULE_1__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/hotQuestions?visitorMd5Code=' + this.md5).then(function (response) {
      if (response.data.code == 1) {
        vm.hotquestion = [];
        response.data.data.forEach(function (element, index) {
          vm.hotquestion.push(element);
        });
      }
    });
    //获取全部问题分类
    __WEBPACK_IMPORTED_MODULE_1__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/workOrderType/0?visitorMd5Code=' + this.md5).then(function (response) {

      if (response.data.code == 1) {
        vm.allquestion = [];
        response.data.data.forEach(function (element, index) {
          vm.allquestion.push(element);
        });
      }
    });

    //判断客服是否显示
    __WEBPACK_IMPORTED_MODULE_1__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/product/conf/showOnlineService?visitorMd5Code=' + this.md5).then(function (response) {
      if (response.data.code == 1) {
        vm.kefuis = true;
      }
    });
  },

  methods: {
    nav: function nav(name) {
      sessionStorage.setItem("navname", name);
      console.log(name);
    },

    //判断跳转页面
    kefugo: function kefugo() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_1__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/product/conf/redirectToOnlineService?visitorMd5Code=' + this.md5).then(function (response) {
        //console.log(response)

        if (response.data.code == 1) {
          var obj = response.data.data;

          if (obj.imStatus == "waiting") {
            vm.$router.replace({ path: 'imLineUp' });
            //window.location.href="#/imLineUp";
          } else if (obj.imStatus == "chatting") {
            vm.$router.replace({ path: 'imSession' });
            //window.location.href="#/imSession";
          } else {
            if (obj.target == 1) {
              //window.location.href="#/spirit";
              vm.$router.replace({ path: 'spirit' });
              console.log('已经跳转了');
            }
            if (obj.target == 2) {
              vm.$router.replace({ path: 'imDirectory' });
              //window.location.href="#/imDirectory";
            }
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "aSGR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "callall"
  }, [_c('div', {
    staticClass: "calltop"
  }, [_c('span', {
    staticClass: "callbtn",
    on: {
      "click": function($event) {
        _vm.callcut('cut')
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("呼叫")])]), _vm._v(" "), _c('div', {
    staticClass: "callstyle"
  }, [_vm._v("\n    " + _vm._s(_vm.callstyle) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "calltime"
  }, [_vm._v("\n    " + _vm._s(_vm.calltime) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "callnum"
  }, [_vm._v("\n    " + _vm._s(_vm.callnum) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "keyword"
  }, _vm._l((_vm.callkey), function(item, index) {
    return _c('span', {
      class: {
        'mid': (item.key == 2 || item.key == 5 || item.key == 8 || item.key == 0)
      },
      attrs: {
        "keys": index,
        "id": 'cd' + item.key
      },
      on: {
        "touchstart": function($event) {
          _vm.cdown('cd' + item.key)
        },
        "touchend": function($event) {
          _vm.cup('cd' + item.key)
        },
        "click": function($event) {
          _vm.keygo(item.voicePath, item.key, item.action, item.id, item.teamId, item)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.key) + "\n    ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "callclose"
  }, [(_vm.callis) ? _c('img', {
    attrs: {
      "src": "/pc/static/assets/callcut.png"
    },
    on: {
      "click": function($event) {
        _vm.callcut('cut')
      }
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/assets/callclose.png"
    },
    on: {
      "click": function($event) {
        _vm.callcut('no')
      }
    }
  })]), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "remoteAudioMedia",
      "autoplay": ""
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "ding",
      "src": "/pc/static/video/ding.mp3",
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "linevideo",
      "src": _vm.linevideo,
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "callvideov",
      "src": _vm.callvideosrc,
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "waitvideo",
      "src": _vm.waitvideo,
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "errorvideo",
      "src": _vm.errorvideo,
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "quesvideo",
      "src": _vm.quesvideo,
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "noservice",
      "src": _vm.noservicevideo,
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "modevoice",
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "robotreplace",
      "src": "/pc/static/video/robotreplace.mp3",
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "answerwrong",
      "src": "/pc/static/video/answerlwrong.mp3",
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "robotreplace",
      "src": "/pc/static/video/robotreplace.mp3",
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "phoneanswer",
      "src": "/pc/static/video/robotreplace.mp3",
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "noanswer",
      "src": "/pc/static/video/noanewer.mp3",
      "hidden": "true"
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bU6g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workerorderindex"
  }, [_c('top'), _vm._v(" "), _c('div', {
    staticClass: "nav"
  }, [_c('router-link', {
    staticStyle: {
      "color": "rgb(31, 55, 61)"
    },
    attrs: {
      "to": {
        path: _vm.indexUrl
      }
    }
  }, [_c('span', [_vm._v("首页")])]), _vm._v(" "), _vm._l((_vm.questionclass), function(item) {
    return _c('span', {
      staticClass: "navbread"
    }, [_vm._v(_vm._s('>' + item))])
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btna color",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "to": {
        path: '/myorder'
      }
    }
  }, [_vm._v("我的工单")])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "dompurify-html",
      rawName: "v-dompurify-html",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "content"
  }), _vm._v(" "), _c('el-button', {
    staticClass: "color btn",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.commit
    }
  }, [_vm._v("下一步")])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c+ye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "receipt"
  }, [_c('top'), _vm._v(" "), _c('div', {
    staticClass: "receipt-content"
  }, [_c('div', {
    staticClass: "hot-question"
  }, [_c('div', {
    staticClass: "hot-top-content"
  }, [_c('div', {
    staticClass: "hot-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.questionName))])])]), _vm._v(" "), _c('div', {
    staticClass: "hot-btm-content"
  }, _vm._l((_vm.accountList), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "hot-item-content"
    }, [_c('div', {
      staticClass: "hot-item",
      on: {
        "click": function($event) {
          _vm.itemClick(item)
        }
      }
    }, [_c('img', {
      staticClass: "img-icon",
      attrs: {
        "src": __webpack_require__("ImIQ"),
        "alt": ""
      }
    }), _c('span', [_vm._v(_vm._s(item.questionName))]), _c('img', {
      staticClass: "img-icon item-right",
      attrs: {
        "src": __webpack_require__("hZzz"),
        "alt": ""
      }
    })])])
  }))])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cXrz":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "cf29":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_serviceError_vue__ = __webpack_require__("yenz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a01152a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_serviceError_vue__ = __webpack_require__("6Qys");
function injectStyle (ssrContext) {
  __webpack_require__("U8ot")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a01152a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_serviceError_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a01152a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_serviceError_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "csJw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      boxBodyColor: '',
      logoUrl: '',
      companyName: '',
      displayMode: '',
      imgUrl: '/pc/static/assets/',
      //msg: '服务器繁忙，请稍后再试'
      callis: false,
      activeName: '0'
    };
  },
  mounted: function mounted() {
    var vm = this;
    vm.boxBodyColor = sessionStorage.getItem('boxBodyColor');
    vm.companyName = sessionStorage.getItem('companyName');

    vm.logoUrl = sessionStorage.getItem('logoUrl');
    vm.displayMode = sessionStorage.getItem('displayMode');
    if (sessionStorage.getItem('callCenterEnable') == 'true') {

      this.callis = true;
    }
  },

  methods: {
    handleClick: function handleClick() {
      var url = sessionStorage.getItem('indexUrl');
      var md5 = sessionStorage.getItem('md5');
      if (!url) {
        return;
      }
      this.$router.push({
        path: url,
        query: {
          v: md5
        }
      });
    },
    toWorkOrder: function toWorkOrder() {
      this.$router.replace({ path: '/myorder' });
    },
    callgo: function callgo() {

      var userAgent = checkBrowser();
      var changeis = true;
      if (userAgent == '谷歌') {
        changeis = true;
        var banben = getChromeVersion();
        console.log('浏览器版本：' + banben);
        if (banben < 52) {
          changeis = false;
        }
      } else {
        changeis = false;
      }
      if (changeis) {
        window.location.href = '#/callcenter';
      } else {
        if (userAgent != "Safari") {
          this.$message({
            message: '目前呼叫只支持Chrome浏览器，版本号 52以上~',
            type: 'warning'
          });
        } else {
          alert('目前呼叫只支持Chrome浏览器，版本号 52以上~');
        }
      }
    }
  }
});

/***/ }),

/***/ "dDjB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dGe0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dU9P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IMTop_vue__ = __webpack_require__("csJw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63b340ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_IMTop_vue__ = __webpack_require__("Eo27");
function injectStyle (ssrContext) {
  __webpack_require__("z++E")
  __webpack_require__("LoGr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63b340ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IMTop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63b340ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_IMTop_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dn9p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ejIc":
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ "ft5R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IMTop_vue__ = __webpack_require__("dU9P");
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    imTop: __WEBPACK_IMPORTED_MODULE_0__IMTop_vue__["a" /* default */]
  },
  data: function data() {
    return {
      imgUrl: '/pc/static/assets/',
      msgErr: '服务器繁忙，请稍后再试',
      msgService: '暂无服务的客服，请稍后再试',
      errType: ""
    };
  },
  mounted: function mounted() {
    //this.errType = this.$route.query.errType;
    //this.randerPage();
  },

  methods: {
    randerPage: function randerPage() {}
  }
});

/***/ }),

/***/ "g1nd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_request_js__ = __webpack_require__("vLgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_url__ = __webpack_require__("vpRr");







var imUrl = __WEBPACK_IMPORTED_MODULE_4__src_components_url__["a" /* baseurl */] + '/api/visitor/im';
var woUrl = __WEBPACK_IMPORTED_MODULE_4__src_components_url__["a" /* baseurl */] + '/api/visitor/wo';
var baseurl = __WEBPACK_IMPORTED_MODULE_4__src_components_url__["a" /* baseurl */];
/* harmony default export */ __webpack_exports__["a"] = ({
    getUserNickNames: function getUserNickNames(visitorMd5Code, callback) {
        var vm = this;
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(imUrl + '/nickNamePool?visitorMd5Code=' + visitorMd5Code).then(function (response) {
            console.log(response, "获取入口response");
            callback(response.data);
        }, function (err) {
            console.log(err);
        });
    },
    getHttp: function getHttp(visitorMd5Code, callback) {
        var vm = this;
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(imUrl + '/image-prefix?visitorMd5Code=' + visitorMd5Code).then(function (response) {
            console.log(response, "获取入口response");
            callback(response.data);
        }, function (err) {
            console.log(err);
        });
    },
    getOverSession: function getOverSession(visitorMd5Code, callback) {
        var vm = this;
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(imUrl + '/session-timeout?visitorMd5Code=' + visitorMd5Code).then(function (response) {
            console.log(response, "获取入口response");
            callback(response.data);
        }, function (err) {
            console.log(err);
        });
    },
    entrance: function entrance(visitorMd5Code, callback) {
        var vm = this;
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(imUrl + '/entrance?visitorMd5Code=' + visitorMd5Code).then(function (response) {
            console.log(response, "获取入口response");
            callback(response.data);
        }, function (err) {
            console.log(err);
        });
    },
    queryEnterQueue: function queryEnterQueue(visitorMd5Code, entranceId, callback) {
        // 访客排队
        var vm = this;
        //let params = entranceId ? {entranceId: entranceId} : {}
        //console.log(visitorMd5Code, entranceId, callback,"queryEnterQueue")
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(imUrl + '/inLine?visitorMd5Code=' + visitorMd5Code + '&entranceId=' + entranceId).then(function (response) {
            // Message({
            //     showClose: true,
            //     message: '访客排队response',
            //     type: 'success'
            // });
            console.log(response, "访客排队response");
            callback(response.data);
        }, function (err) {
            console.log(err);
        });
    },
    getSessionStatus: function getSessionStatus(visitorMd5Code, callback) {
        // 获取当前IM会话状态
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(imUrl + '/sessionStatus?visitorMd5Code=' + visitorMd5Code).then(function (response) {

            console.log(response, "获取当前IM会话状态response");
            callback(response.data);
        }, function (err) {
            console.log(err);
        });
    },
    getPositionAndSessionStatus: function getPositionAndSessionStatus(obj, callback) {
        // 获取访客当前位置
        //console.log(obj,"obj");
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(imUrl + '/getPositionAndSessionStatus?visitorMd5Code=' + obj.visitorMd5Code).then(function (response) {

            console.log(response, "获取当前排队位置");
            callback(response.data);
            // commit('SET_PROJECT_LIST', { list: response.data })
        }, function (err) {
            console.log(err);
        });
    },
    cancelWait: function cancelWait(visitorMd5Code, callback) {
        // 取消排队
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(imUrl + '/cancelWait?visitorMd5Code=' + visitorMd5Code).then(function (response) {

            console.log(response, "取消排队");
            callback(response.data);
        }, function (err) {
            console.log(err);
        });
    },
    lastMessage: function lastMessage(visitorMd5Code, offsetSeq, sessionId, callback) {
        // 获取聊天记录
        var md5 = visitorMd5Code ? visitorMd5Code : '';
        var seq = offsetSeq ? offsetSeq : '';
        var id = sessionId ? sessionId : '';
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(imUrl + '/lastMessage?visitorMd5Code=' + md5 + '&offsetSeq=' + seq + '&sessionId=' + id).then(function (response) {

            //console.log(response, "获取聊天记录");
            callback(response.data);
        }, function (err) {
            console.log(err);
        });
    },
    getAutoReply: function getAutoReply(visitorMd5Code, callback) {
        // let body = {
        //   "code": 1,
        //   "message": "OK",
        //   "data": {
        //     "id": 1000,
        //     "gmtCreate": "2017-02-16 08:40:44",
        //     "gmtModified": "2017-04-18 10:14:16",
        //     "comId": 1000,
        //     "welcomeMsg": "你终于来了11",
        //     "finishedMsg": "下次再来二二二v地方大幅度地方的fdfdfdfd11111221111",
        //     "visitorTimeout": 60,
        //     "visitorTimeoutMsg": "访客很久没有说话了呀！",
        //     "userTimeout": 62,
        //     "userTimeoutMsg": "客服吃饭去了呀",
        //     "forceIssueType": false,
        //     "popCsr": false,
        //     "visitorTimeoutFlag": true,
        //     "userTimeoutFlag": false
        //   }
        // }
        // setTimeout(() => callback(body), 100)

        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(imUrl + '/getAutoReply?visitorMd5Code=' + visitorMd5Code).then(function (response) {
            console.log(response, "获取自动聊天消息");
            callback(response.data);
        }, function (err) {
            console.log(err);
        });
    },
    sendMessage: function sendMessage(visitorMd5Code, obj, callback) {
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].post(imUrl + '/imMessage?visitorMd5Code=' + visitorMd5Code, obj).then(function (response) {
            console.log(response, "向后台发送消息");
            callback(response.data);
        }, function (err) {
            console.log(err);
        });
    },
    sendAutoMessage: function sendAutoMessage(visitorMd5Code, obj, callback) {
        console.log(obj, '自动消息请求');
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].post(imUrl + '/autoMessage?visitorMd5Code=' + visitorMd5Code, obj).then(function (response) {
            console.log(response, "向后台发送自动消息");
            callback(response.data);
        }, function (err) {
            console.log(err);
        });
    },
    satisfySetting: function satisfySetting(visitorMd5Code, callback) {
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(imUrl + '/satisfySetting?visitorMd5Code=' + visitorMd5Code).then(function (response) {

            console.log(response, "获取满意度蛇者");
            callback(response.data);
        }, function (err) {
            console.log(err);
        });
    },
    workOrderSubmittied: function workOrderSubmittied(visitorMd5Code, workOrderId, orderName, callback) {
        var obj = {};
        orderName = encodeURI(orderName);
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].post(imUrl + '/workOrderSubmitted/' + workOrderId + '?visitorMd5Code=' + visitorMd5Code + '&orderName=' + orderName, obj).then(function (response) {
            console.log(response, "工单提交成功通知");
            callback(response.data);
        }, function (err) {
            console.log(err);
        });
    },
    evaluate: function evaluate(obj, callback) {
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].post(imUrl + '/evaluate?visitorMd5Code=' + obj.visitorMd5Code, obj.form).then(function (response) {
            console.log(response, "发送满意度评价");
            callback(response.data);
        }, function (err) {
            console.log(err);
        });
    },
    getinvitations: function getinvitations(visitorMd5Code, callback) {
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(baseurl + '/api/visitor/initiative-invite/invitations?visitorMd5Code=' + visitorMd5Code).then(function (response) {
            callback(response.data);
        }, function (errorMessage) {
            console.log(errorMessage);
        });
    },
    sendTransientMessage: function sendTransientMessage(obj, callback) {
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].post(imUrl + '/transientMessage?visitorMd5Code=' + obj.visitorMd5Code, obj.form).then(function (response) {
            console.log(response, "正在输入的消息");
            callback(response.data);
        }, function (err) {
            console.log(err);
        });
    },
    sendImgMsg: function sendImgMsg(visitorMd5Code, formData, callback) {
        console.log(formData);
        __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].post(imUrl + '/fileUpload?visitorMd5Code=' + visitorMd5Code, formData).then(function (response) {
            console.log(response, "发送图片消息");
            callback(response.data);
        }, function (err) {
            console.log(err);
        });
    }
});

/***/ }),

/***/ "gI/3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gPP5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inviteselect_vue__ = __webpack_require__("i4ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_630a3d46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_inviteselect_vue__ = __webpack_require__("LVwr");
function injectStyle (ssrContext) {
  __webpack_require__("AKmP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-630a3d46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inviteselect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_630a3d46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_inviteselect_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hZzz":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAoCAYAAACrUDmFAAAAAXNSR0IArs4c6QAABA1JREFUaEPdml1v21QYx8+xY8dxXkoWhMQkOkh6wXY/8SlGyzp2xRWfYbysG3l3qdqyjTvQ7iaB1lbt4LuAkAaCRutamtQdjpPYju3zoJP3pFmzJNV23Nxaic9P/+c8//P8TzA65x/MDB8ARhkURQgRlEIawhjOYm1sAALgi/nqLc2RlhAACfDW8tHl4AN0E7vTQjIBOHvfjKsvuN+rjiBRIJ4DEhOMXDEpZ6ZVkgnAxD1trvhf4DfdEfxtxTgMJCpYK2pKujsNJBOACADHl8uPdmvhzwh0l+TjCIn6rLUSCiyhNCaTlCsbgHTlafDFBW2zUIssuIA766KQMz57XUX+25NAsgNIIQHw+3n9lz0zdM0ZhOStdRUHxoZkC7CpJHeJr2zvm/KCDVynKnkM5ILPWi2lpaVx9iR7gC3I93z6zr9GcL4XkjaeC4KhHF2RM69qIWwCdpTUt5+bwQWnR8lxIdkFbO/JXPnXZ1bomjsMMiWnRpUr24AtJeOivlWohj7p7a5UyRhvrpUygdunQbIPSCE3gY//qT8u1EKLfRaCgUTE+nfH4P/6ZRbiDcAOpPa4UIsMQBISEaz7xyjw5TBI7wB2fXJnzwzN9/kkppD2vWPk/2oQ0luA7e4qVLaf14J9kA2fFOtrpaS/b092AQFwTDEuRrAZw654JrPYJGfHUd+pI4QEZHN1EH84qMsfEUAdBg4DRAVDUa/I6bZPNh8C4Heyxq2KI6QdwJ0T/aiXvennNvAc9ADS9XCIwNuBeqboSjlark3AZYhJhvu36fKRN73os3i/xLm66RoJ9G24dD4BeadiOma8C3iOSrSZBljpIkhKt0Rb+9ArTcZHbN7mxR8PDPkqQd0m04o6ssXLcr6/yZxF4b+u30gDN8vrT/YHZkZqE28NiTi85YN0IM6Vn+xZ4Y9PDMS++qqaOjkregeQnkef6hsFI3R9SKSxpqb6Db5dUN4A3AQ+8Vf5591q+NOTcMOV8w4gAE4o+sauEboxOC5FBWNFTcmnxopsK0jjxLy2UzAj871wjW7pN7LFu3LWuwMvAJ7NVzb3reCiQ7oxYgNOtDLFDyXlVXIZNhWkcLnK1kFdXrRJT7LWjPT7fG6UO7EHSOGUysaBGbxh9yjXDIDry2pKSo4qy15otgAB8AdKZeuZEbzeP9CCOyPaK2pS/GYcOArKDiC1gqfaT7tG5OZA7uLOCBY18TvjwrEDCIDnFO3hP0bk8yE+N9UNExMKzq0eJg4rUXp91rgfpB/aLaM+SzlKSSOzz9MaDROA764bl8oa/0fVFQINOJp5ika6mJTzk5Qle02GXmHnql9ojv8OIETCgp09dAPfT3JdNqgmEwq2cyGUQbHWnxBeTKucd86io5x8xPP/AXt1K0fQ4XYjAAAAAElFTkSuQmCC"

/***/ }),

/***/ "heFm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imSession_vue__ = __webpack_require__("8nZP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3924966a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_imSession_vue__ = __webpack_require__("9Xsi");
function injectStyle (ssrContext) {
  __webpack_require__("L3vZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3924966a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imSession_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3924966a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_imSession_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i4ja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__im_IMTop_vue__ = __webpack_require__("dU9P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_url_js__ = __webpack_require__("vpRr");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inviteselect',
  components: {
    imTop: __WEBPACK_IMPORTED_MODULE_1__im_IMTop_vue__["a" /* default */]
  },
  data: function data() {
    return {

      basicUrl: __WEBPACK_IMPORTED_MODULE_3__components_url_js__["a" /* baseurl */]
      //allquestion:["账号类","充值类","被盗类","咨询类"],
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    entranceList: 'getEntranceList'
  })),
  mounted: function mounted() {
    var gois = true;
    var userAgent = navigator.userAgent;
    if (userAgent.indexOf("Windows") > -1) {
      if (/Safari/.test(navigator.userAgent) && !/Chrome/.test(userAgent)) {
        console.log(userAgent);
        gois = false;
      }
    }
    if (gois) {
      this.renderPage();
    } else {
      this.$router.push('/beatis');
    }
  },

  methods: {
    renderPage: function renderPage() {
      var vm = this;
      var visitorMd5Code = sessionStorage.md5; //
      this.$store.dispatch({
        type: 'entrance',
        router: vm.$router,
        visitorMd5Code: visitorMd5Code,
        inviteis: true
      });
    },
    setEntrance: function setEntrance(entranceId) {
      var vm = this;
      vm.axios.get(this.basicUrl + '/api/visitor/initiative-invite/auto?visitorMd5Code=' + sessionStorage.md5 + '&entranceId=' + entranceId).then(function (resp) {
        var data = resp.data;
        if (data.code == 1) {
          if (data.data.position == '0') {
            sessionStorage.setItem('indexUrl', 'imSession');
            sessionStorage.setItem('newSession', true);
            sessionStorage.setItem("inviteis", true);
            vm.$router.replace({ path: '/imSession', query: { v: vm.visitorMd5Code } });
          } else {
            vm.$router.replace({ path: '/ServiceError', query: { v: vm.visitorMd5Code, errType: 'costomerErr' } });
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "ihcS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "image-preview__wrapper"
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "el-icon-close"
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-box",
    style: (_vm.styleClass)
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.visible) ? _c('div', {
    staticClass: "image-box__inner"
  }, [_c('img', {
    attrs: {
      "src": _vm.imagePreviewUrl
    }
  })]) : _vm._e()])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ixHi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loginMobile_vue__ = __webpack_require__("0lWQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cb45e83_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_loginMobile_vue__ = __webpack_require__("w6V+");
function injectStyle (ssrContext) {
  __webpack_require__("dn9p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7cb45e83"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loginMobile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cb45e83_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_loginMobile_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jFDJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myorder_vue__ = __webpack_require__("RGur");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55d9b086_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_myorder_vue__ = __webpack_require__("9Nd4");
function injectStyle (ssrContext) {
  __webpack_require__("ysEq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55d9b086"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myorder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55d9b086_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_myorder_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jnP+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import imTop from '../imTop/IMTop.vue'


/* harmony default export */ __webpack_exports__["a"] = ({
    //   components:{
    //     imTop
    //   },
    data: function data() {
        return {
            imgUrl: "/pc/static/assets/",
            evaluationArr1: [{ text: '不满意', starImg: "_dark.png", number: 3 }, { text: '一般', starImg: "_dark.png", number: 2 }, { text: '满意', starImg: "_dark.png", number: 1 }],
            evaluationArr2: [{ name: '处理结果', starImg: ['_bright.png', '_bright.png', '_bright.png', '_bright.png', '_bright.png'], num: 5 }, { name: '服务态度', starImg: ['_bright.png', '_bright.png', '_bright.png', '_bright.png', '_bright.png'], num: 5 }, { name: '处理时长', starImg: ['_bright.png', '_bright.png', '_bright.png', '_bright.png', '_bright.png'], num: 5 }],
            textarea: '',
            basicLevel: null,
            processAttitudeScore: 5,
            processDurationScore: 5,
            processResultScore: 5,
            boxBodyColor: ''
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        satisfyMode: 'satisfyMode',
        showSatisfySettingFlag: 'showSatisfySettingFlag'
    })),
    mounted: function mounted() {
        this.boxBodyColor = sessionStorage.getItem('boxBodyColor');
    },

    methods: {
        mouseClick: function mouseClick(index) {
            this.basicLevel = index + 1;
            console.log(this.basicLevel, "level");
            if (index === 0) this.evaluationArr1 = [{ text: '不满意', starImg: "_bright.png" }, { text: '一般', starImg: "_dark.png" }, { text: '满意', starImg: "_dark.png" }];else if (index === 1) this.evaluationArr1 = [{ text: '不满意', starImg: "_dark.png" }, { text: '一般', starImg: "_bright.png" }, { text: '满意', starImg: "_dark.png" }];else if (index === 2) this.evaluationArr1 = [{ text: '不满意', starImg: "_dark.png" }, { text: '一般', starImg: "_dark.png" }, { text: '满意', starImg: "_bright.png" }];
        },
        mouseClick2: function mouseClick2(objIndex, imgIndex) {
            var data = this.evaluationArr2;
            data[objIndex].num = imgIndex + 1;
            data[objIndex].starImg = ['_dark.png', '_dark.png', '_dark.png', '_dark.png', '_dark.png'];
            data[objIndex].starImg.forEach(function (item, index) {
                if (index <= imgIndex) {
                    data[objIndex].starImg.splice(index, 1, '_bright.png');
                }
            });
            this.$set(this.evaluationArr2, objIndex, data[objIndex]);
            // 统一data
            this.processResultScore = data[0].num;
            this.processAttitudeScore = data[1].num;
            this.processDurationScore = data[2].num;
        },
        returnMask: function returnMask() {
            this.$store.commit("setShowSatisfySettingFlag", false);
            this.$store.commit("setSatisfySetting", null);
        },
        submit: function submit() {
            console.log(this.satisfyMode);
            if (this.satisfyMode === 1) {
                var form = {
                    basicLevel: this.basicLevel,
                    comment: "",
                    mode: this.satisfyMode,
                    processAttitudeScore: this.processAttitudeScore,
                    processDurationScore: this.processDurationScore,
                    processResultScore: this.processResultScore
                };
            } else {
                if (this.basicLevel === 3) {
                    var form = {
                        basicLevel: this.basicLevel,
                        comment: "",
                        mode: this.satisfyMode,
                        processAttitudeScore: this.processAttitudeScore,
                        processDurationScore: this.processDurationScore,
                        processResultScore: this.processResultScore
                    };
                } else {
                    var form = {
                        basicLevel: this.basicLevel,
                        comment: this.textarea,
                        mode: this.satisfyMode,
                        processAttitudeScore: this.processAttitudeScore,
                        processDurationScore: this.processDurationScore,
                        processResultScore: this.processResultScore
                    };
                }
            }

            // console.log(form,"确认提交");
            if (this.textarea.length > 50 && this.basicLevel != 3) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_element_ui__["Message"])({ showClose: true, message: '说明不能超过50个字', type: 'warning' });
                return;
            } else if (this.basicLevel === null) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_element_ui__["Message"])({ showClose: true, message: '请对我们的服务做出评价哟！', type: 'warning' });
                return;
            }
            this.$store.dispatch({
                type: 'evaluate',
                visitorMd5Code: sessionStorage.md5,
                form: form
            });
        }
    }
});

/***/ }),

/***/ "kqno":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lDzE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aiInteractive_vue__ = __webpack_require__("m6dm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_191ca598_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_aiInteractive_vue__ = __webpack_require__("Ntul");
function injectStyle (ssrContext) {
  __webpack_require__("nMDu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-191ca598"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aiInteractive_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_191ca598_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_aiInteractive_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lLIs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_md5__ = __webpack_require__("NC6I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__url_js__ = __webpack_require__("vpRr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_request_js__ = __webpack_require__("vLgD");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "top",
  data: function data() {
    return {
      boxBodyColor: '',
      displayMode: '',
      logoUrl: '',
      companyName: '',
      kefuis: false,
      md5: '',
      basurl: __WEBPACK_IMPORTED_MODULE_1__url_js__["a" /* baseurl */],
      callis: false
    };
  },
  mounted: function mounted() {
    var vm = this;
    vm.boxBodyColor = sessionStorage.getItem('boxBodyColor');
    vm.companyName = sessionStorage.getItem('companyName');
    vm.logoUrl = sessionStorage.getItem('logoUrl');
    vm.displayMode = sessionStorage.getItem('displayMode');
    this.href = window.location.href.split("?")[1];
    this.md5 = sessionStorage.getItem("md5");
    //判断客服是否显示
    __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/product/conf/showOnlineService?visitorMd5Code=' + this.md5).then(function (response) {
      if (response.data.code == 1) {
        vm.kefuis = true;
      }
    });

    if (sessionStorage.getItem('callCenterEnable') == 'true') {

      this.callis = true;
    }
  },

  methods: {
    callgo: function callgo() {

      var userAgent = checkBrowser();
      var changeis = true;
      if (userAgent == '谷歌') {
        changeis = true;
        var banben = getChromeVersion();
        console.log('浏览器版本：' + banben);
        if (banben < 52) {
          changeis = false;
        }
      } else {
        changeis = false;
      }
      if (changeis) {
        window.location.href = '#/callcenter';
      } else {
        if (userAgent != "Safari") {
          this.$message({
            message: '目前呼叫只支持Chrome浏览器，版本号 52以上~',
            type: 'warning'
          });
        } else {
          alert('目前呼叫只支持Chrome浏览器，版本号 52以上~');
        }
      }
    },

    //判断跳转页面


    kefugo: function kefugo() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_2__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/product/conf/redirectToOnlineService?visitorMd5Code=' + this.md5).then(function (response) {
        //console.log(response)
        if (response.data.code == 1) {
          var obj = response.data.data;

          if (obj.imStatus == "waiting") {
            vm.$router.replace({ path: 'imLineUp' });
            //window.location.href="#/imLineUp";
          } else if (obj.imStatus == "chatting") {
            vm.$router.replace({ path: 'imSession' });
            //window.location.href="#/imSession";
          } else {
            if (obj.target == 1) {
              //window.location.href="#/spirit";
              vm.$router.replace({ path: 'spirit' });
              console.log('已经跳转了');
            }
            if (obj.target == 2) {
              vm.$router.replace({ path: 'imDirectory' });
              //window.location.href="#/imDirectory";
            }
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "m6dm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_question__ = __webpack_require__("Ozlq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_top_vue__ = __webpack_require__("CWUh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_url_js__ = __webpack_require__("vpRr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import 'swiper/swiper.css'




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'aiInteractive',
  components: {
    Top: __WEBPACK_IMPORTED_MODULE_2__common_top_vue__["a" /* default */]
  },
  data: function data() {
    return {
      // swiperOption: {
      //   loop: true,
      //   autoplay: {
      //     delay: 3000,
      //     stopOnLastSlide: false,
      //     disableOnInteraction: false
      //   },
      //   // 显示分页
      //   pagination: {
      //     el: ".swiper-pagination",
      //     clickable: true //允许分页点击跳转
      //   },
      //   // 设置点击箭头
      //   navigation: {
      //     nextEl: ".swiper-button-next",
      //     prevEl: ".swiper-button-prev"
      //   }
      // },
      basicUrl: __WEBPACK_IMPORTED_MODULE_3__components_url_js__["a" /* baseurl */],
      hotParams: {
        page: 1,
        size: 6
      },
      hotList: [],
      totalPages: 0,
      total: 0,
      carouselList: [],
      currentIndex: 0,
      questionType: [],
      isIm: false,
      isSpirit: false,
      boxBodyColor: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
    model: 'model',
    chatType: 'chatType'
  })),
  created: function created() {
    this.boxBodyColor = sessionStorage.getItem('boxBodyColor');
    this.init();
    this.getHotList();
    // this.getImStatus()
  },

  methods: {
    init: function init() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__api_question__["a" /* default */].getCarousel(this.$route.query.v, function (res) {
        if (res.code === 1) {
          _this.carouselList = res.data.carousel;
          _this.questionType = res.data.questionType;
        }
      });
    },
    getImStatus: function getImStatus() {
      // Api.getEnable({visitorMd5Code: this.$route.query.v}, res => {
      //   if (res.code === 1) {
      //     this.isIm = res.data.im
      //     this.isSpirit = res.data.spirit
      //   }
      // })
    },
    getHotList: function getHotList() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__api_question__["a" /* default */].getHotList(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        visitorMd5Code: this.$route.query.v
      }, this.hotParams), function (res) {
        if (res.code === 1) {
          _this2.hotList = res.data.content;
          _this2.totalPages = res.data.totalPages;
          _this2.total = res.data.total;
        }
      });
    },
    toggles: function toggles() {
      if (this.total <= this.hotParams.size) {
        return;
      }
      this.hotList = [];
      if (this.totalPages > this.hotParams.page) {
        this.hotParams.page++;
        this.getHotList();
      } else {
        this.hotParams.page = 1;
        this.getHotList();
      }
    },
    handleChange: function handleChange(index) {
      this.currentIndex = index;
    },
    swipeClick: function swipeClick(item) {
      // 点击轮播图日志埋点
      this.$Points.point({ code: '1001', type: '2', id: item.id });
      switch (item.action) {
        // 外链
        case 1:
          location.href = item.skipUrl;
          break;
        case 2:
          this.$router.push({
            path: '/faqPage',
            query: {
              type: 'swipe',
              id: item.id,
              v: this.$route.query.v
            }
          });
          break;
      }
    },
    commonChat: function commonChat(source, item) {
      var obj = {};
      switch (this.model) {
        case 1:
          obj = {
            path: '/spirit',
            query: {
              v: this.$route.query.v,
              chatType: true,
              id: item && item.id ? item.id : ''
            }
          };
          break;
        case 2:
          if (!source) {
            if (this.chatType) {
              obj = {
                path: '/imSession',
                query: {
                  v: this.$route.query.v
                }
              };
            } else {
              obj = {
                path: '/imLineUp',
                query: {
                  v: this.$route.query.v
                }
              };
            }
          } else {
            obj = {
              path: '/imChat',
              query: {
                v: this.$route.query.v,
                id: item && item.id ? item.id : '',
                chatType: this.chatType
              }
            };
          }
          break;
        case 3:
          if (!source) {
            if (this.chatType) {
              obj = {
                path: '/imSession',
                query: {
                  v: this.$route.query.v
                }
              };
            } else {
              obj = {
                path: '/spirit',
                query: {
                  v: this.$route.query.v
                }
              };
            }
          } else {
            obj = {
              path: '/spirit',
              query: {
                v: this.$route.query.v,
                chatType: this.chatType,
                id: item && item.id ? item.id : ''
              }
            };
          }
          break;
      }
      if (source) {
        obj.query.source = source;
      }
      this.$router.push(obj);
    },
    goChat: function goChat() {
      var _this3 = this;

      // 点击客服日志埋点
      this.$Points.point({ code: '1001', type: '5' });
      this.$store.dispatch({
        type: 'getEnable',
        visitorMd5Code: this.$route.query.v
      }).then(function (res) {
        _this3.commonChat();
      });
    },

    // 热点问题
    hotClick: function hotClick(item) {
      var _this4 = this;

      // 点击热点日志埋点
      this.$Points.point({ code: '1001', type: '1', id: item.id });
      this.$store.dispatch({
        type: 'getEnable',
        visitorMd5Code: this.$route.query.v
      }).then(function (res) {
        _this4.commonChat('hot', item);
      });
    },
    itemClick: function itemClick(item) {
      var _this5 = this;

      // 点击问题类型日志埋点
      this.$Points.point({ code: '1001', type: '3', id: item.id });
      this.$store.dispatch({
        type: 'getEnable',
        visitorMd5Code: this.$route.query.v
      }).then(function (res) {
        switch (item.type) {
          // 外链
          case 1:
            location.href = item.url;
            break;
          case 2:
            if (item.isAi) {
              _this5.commonChat('type', item);
            } else {
              _this5.$router.push({
                path: '/faqPage',
                query: {
                  id: item.id,
                  v: _this5.$route.query.v,
                  type: 'type'
                }
              });
            }
            break;
          case 3:
            var ailink = '';
            if (_this5.model == 2) {
              ailink = 'imChat';
            } else {
              ailink = 'spirit';
            }
            _this5.$router.push({
              path: '/receipt',
              query: {
                id: item.id,
                v: _this5.$route.query.v,
                source: 'type',
                chatType: _this5.chatType,
                ailink: ailink
              }
            });
            break;
          // 工单
          case 4:
            if (item.showNote) {
              _this5.$router.push({
                path: '/workinformation',
                query: {
                  name: item.workerOrderName,
                  source: 'type',
                  id: item.workerOrderId,
                  v: _this5.$route.query.v
                }
              });
            } else {
              _this5.$router.push({
                path: '/workcommit',
                query: {
                  name: item.workerOrderName,
                  source: 'type',
                  id: item.workerOrderId,
                  v: _this5.$route.query.v
                }
              });
            }
            break;
        }
      });
    }
  }
});

/***/ }),

/***/ "maGq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n9ej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_callcenter_vue__ = __webpack_require__("DYJm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59fda95c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_callcenter_vue__ = __webpack_require__("aSGR");
function injectStyle (ssrContext) {
  __webpack_require__("dDjB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59fda95c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_callcenter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59fda95c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_callcenter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nMDu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nSh+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAABz0lEQVRIibXWv2sTYRzH8VfOOoaKIHQUXLoEiotcUwSXRuIiPYV2j50c3bLqqItbyOZglohTh6JbaxBBIhnsH9ChCA4l4iJSh+fAa2juLm36Xg6+z/O9z/PcfX9VGoc1OVQQYwNrWMZiunaMA+zhHQZxNzmZ+qIcoSZeYCXvJBmGaMfdZKesUBUdbJYUmKSH7bibjLPGaGLTEvYvICL13R+0+kvThKrYRe5PK0kNu4NWv3qWUGdOIlmxzqRQU/Hn+o5rQiRWcAUfC3w2B61+kxAMFXyVH10/cCc92N3U9gF/8Q03cnyHuL0g5ElRCD/Hb3zGzdQ2SEWf4H2O7wriSEjGIl7hU0ZEesCGcKMiNiIh44tYwK0p9jKsRUJZOQ8vsYPrJfYuR/7XrrL8FKL0GR4IQVHEYtmrZ3mIL3iNp2WdIqEKz8IvIRBKi+A4Ekr9ZXMQCf1kFu4pF6lZ9iqNw9qqULHL8id9Xp3Bpx4JGT6cwekxHmFqN51giEGUOrRnELqPVaGwlqEdd5OTbId962IN7yx6cTfZ4nQ/2sZojiKj9J0mhcZYn5PYCOvZuWFyZjhCXRgwzksP9bibHGWNZ5WgMbbwxiWPW6fWzWmA/AflUGzAo7GK2wAAAABJRU5ErkJggg=="

/***/ }),

/***/ "njBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_question__ = __webpack_require__("Ozlq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);




var state = {
  chatType: null,
  model: null
};
var getters = {
  chatType: function chatType() {
    return state.chatType;
  },
  model: function model() {
    return state.model;
  }
};
var actions = {
  getEnable: function getEnable(_ref, object) {
    var commit = _ref.commit,
        state = _ref.state;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api_question__["a" /* default */].getEnable({ visitorMd5Code: object.visitorMd5Code }, function (res) {
        if (res.code === 1) {
          commit('setChatType', res.data.chatType);
          commit('setModel', res.data.model);
          resolve(res.data);
        } else {
          Toast(res.data.message);
        }
      });
    });
  }
};

var mutations = {
  setChatType: function setChatType(state, chatType) {
    state.chatType = chatType;
  },
  setModel: function setModel(state, model) {
    state.model = model;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "nu1k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_video_js__ = __webpack_require__("63pp");
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      player: null,
      isShow: false
    };
  },

  props: {
    src: {
      type: String,
      default: ''
    }
  },
  watch: {
    src: {
      handler: function handler(url) {
        var _this = this;

        console.log(url, 999);
        this.$nextTick(function () {
          _this.videoChange(url);
        });
      },

      immediate: true
    }
  },
  methods: {
    // 实例化播放器
    createVideo: function createVideo() {
      var options = {
        autoplay: false,
        controls: true,
        sources: [{
          src: this.src + '?rnd=' + new Date()
        }],
        html5: {
          nativeTextTracks: false
        }
      };
      var vm = this;
      vm.isShow = false;
      this.player = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_video_js__["a" /* default */])(this.$refs.videoPlayer, options, function onPlayerReady() {
        console.log('onPlayerReady', this);
        var timer = setTimeout(function () {
          vm.isShow = true;
          clearTimeout(timer);
        }, 200);
      });
    },

    // 关闭声音
    puse: function puse() {
      this.player.pause(); //暂停
      this.player.currentTime(0); //复位
    },
    videoChange: function videoChange(url) {
      var _this2 = this;

      if (this.player) {
        setTimeout(function () {
          url && _this2.player.src({ src: url });
        }, 100);
      } else {
        url && this.createVideo();
      }
    }
  },
  mounted: function mounted() {
    this.createVideo();
  }
});

/***/ }),

/***/ "oHe/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_workinformation_vue__ = __webpack_require__("QTu+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ece76d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_workinformation_vue__ = __webpack_require__("bU6g");
function injectStyle (ssrContext) {
  __webpack_require__("Ehbv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ece76d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_workinformation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ece76d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_workinformation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oLrh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imLineUp_vue__ = __webpack_require__("YbuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0fc85ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_imLineUp_vue__ = __webpack_require__("Lp0V");
function injectStyle (ssrContext) {
  __webpack_require__("sYrP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a0fc85ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imLineUp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0fc85ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_imLineUp_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oWpW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "imDirectory"
  }, [_c('im-top'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.entranceList), function(item, index) {
    return _c('p', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.setEntrance(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  })], 2)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__("nSh+")
    }
  }), _vm._v(" "), _c('span', [_vm._v("请选择你要咨询的问题类型")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ojib":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spirit"
  }, [_c('header', {
    style: ({
      backgroundColor: _vm.boxBodyColor
    })
  }, [(_vm.displayMode == 2) ? _c('img', {
    attrs: {
      "src": _vm.logoUrl,
      "alt": "公司logo"
    }
  }) : _c('p', {
    staticClass: "companyName"
  }, [(_vm.companyName == '') ? _c('span') : (_vm.companyName.length > 10) ? _c('el-tooltip', {
    attrs: {
      "content": _vm.companyName,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.companyName.substring(0, 10) + '...'))])]) : _c('span', [_vm._v(_vm._s(_vm.companyName))])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "首页",
      "name": "0"
    }
  }, [_vm._v("首页")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "orderAndService"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.callis),
      expression: "callis"
    }],
    attrs: {
      "src": _vm.imgUrl + 'callbtn.png',
      "alt": "客服电话logo"
    },
    on: {
      "click": _vm.callgo
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.callis),
      expression: "callis"
    }],
    staticClass: "order",
    on: {
      "click": _vm.callgo
    }
  }, [_vm._v("客服电话")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imgUrl + 'im_logo.png',
      "alt": "单据logo"
    },
    on: {
      "click": _vm.workOrder
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "order",
    on: {
      "click": _vm.workOrder
    }
  }, [_vm._v("我的单据")]), _vm._v(" "), (_vm.vip && _vm.turnToIm && _vm.visitorVipLevel != null && _vm.limitVipLevel != null && _vm.visitorVipLevel >= _vm.limitVipLevel) ? _c('img', {
    attrs: {
      "src": _vm.imgUrl + 'im_service.png',
      "alt": "在线客服logo"
    },
    on: {
      "click": _vm.intoIm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vip && _vm.turnToIm && _vm.visitorVipLevel != null && _vm.limitVipLevel != null && _vm.visitorVipLevel >= _vm.limitVipLevel) ? _c('span', {
    staticClass: "order",
    on: {
      "click": _vm.intoIm
    }
  }, [_vm._v("在线客服")]) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "chat"
  }, [_vm._l((_vm.spiritSession), function(item, index) {
    return [(item.type == 1) ? _c('div', {
      staticClass: "service"
    }, [_c('div', {
      staticClass: "serviceImg"
    }, [_c('img', {
      attrs: {
        "src": _vm.spiritSrc,
        "alt": "系统头像"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "serviceSession"
    }, [_c('span', {
      staticClass: "sessionSpan"
    }), _vm._v(" "), _c('div', {
      staticClass: "chatText"
    }, [_c('div', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (item.content),
        expression: "item.content"
      }],
      staticClass: "sessionDiv"
    }), _vm._v(" "), (item.evaluateShow) ? _c('p', {
      staticClass: "sessionBar"
    }) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (item.type == 2) ? _c('div', {
      staticClass: "user"
    }, [_c('span', {
      staticClass: "sessionUser"
    }), _vm._v(" "), _c('div', {
      staticClass: "userSession"
    }, [_c('div', {
      staticClass: "userText"
    }, _vm._l((item.content), function(i) {
      return _c('p', [_vm._v(_vm._s(i))])
    }))]), _vm._v(" "), _vm._m(0, true)]) : _vm._e()]
  })], 2), _vm._v(" "), _c('footer', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chatContent),
      expression: "chatContent"
    }],
    staticClass: "chatContent",
    attrs: {
      "maxlength": "140"
    },
    domProps: {
      "value": (_vm.chatContent)
    },
    on: {
      "keydown": function($event) {
        _vm.sendMsg(_vm.chatContent, $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.chatContent = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "send"
  }, [_c('span', [_vm._v("按下Ctrl+Enter换行")]), _vm._v(" "), _c('el-button', {
    staticClass: "sendBtn",
    style: ({
      backgroundColor: _vm.boxBodyColor,
      borderColor: _vm.boxBodyColor
    }),
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.getTopFive(_vm.chatContent)
      }
    }
  }, [_vm._v("发送")])], 1)])])]), _vm._v(" "), (_vm.showImgMask && (_vm.geen == -1)) ? _c('div', {
    staticClass: "imgMask",
    on: {
      "click": function($event) {
        _vm.magnify(_vm.imgMasksrc)
      },
      "mousewheel": function($event) {
        _vm.bbimg()
      }
    }
  }, [_c('img', {
    ref: "img",
    attrs: {
      "src": _vm.imgMasksrc,
      "alt": "放大图"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.stopImg($event)
      }
    }
  })]) : (_vm.showImgMask && (_vm.geen > -1)) ? _c('div', {
    staticClass: "imgMask",
    on: {
      "click": function($event) {
        _vm.magnify(_vm.imgMasksrc)
      },
      "DOMMouseScroll": function($event) {
        _vm.bbimg2()
      }
    }
  }, [_c('img', {
    ref: "img",
    attrs: {
      "src": _vm.imgMasksrc,
      "alt": "放大图"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.stopImg($event)
      }
    }
  })]) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "userImg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("TQb4"),
      "alt": "用户头像"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pMZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_md5__ = __webpack_require__("NC6I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_url_js__ = __webpack_require__("vpRr");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




Date.prototype.format = function (format) {
  var o = {
    "M+": this.getMonth() + 1, //month
    "d+": this.getDate(), //day
    "h+": this.getHours(), //hour
    "m+": this.getMinutes(), //minute
    "s+": this.getSeconds(), //second
    "q+": Math.floor((this.getMonth() + 3) / 3), //quarter
    "S": this.getMilliseconds() //millisecond
  };

  if (/(y+)/i.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }

  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return format;
};

var vm = {};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  data: function data() {
    vm = this;
    return {
      basicUrl: __WEBPACK_IMPORTED_MODULE_3__components_url_js__["a" /* baseurl */],
      visitorMd5Code: '',
      redirectTarget: '',
      imEntranceMode: '',
      status: '',
      notifyTitle: "",
      notifyStartTime: '',
      notifyContent: "",
      countDown: 3,
      timer: null,
      boxBodyColor: ""
    };
  },
  mounted: function mounted() {
    this.initConfig(1);
  },

  methods: {
    initConfig: function initConfig(customFlag) {
      var obj = {};
      var os = this.getOs();
      obj.os = os;
      console.log(window.location.href, '看看url');

      var a = decodeURI(window.location.href, 'utf-8');
      console.log(window.location.href, typeof a === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(a), os, 'ssss');
      var serviceKey = a.split('?')[1].split('&')[0].split('=')[1];
      var secretKey = a.split('?')[1].split('&')[1].split('=')[1];
      var boxBodyColor = a.split('?')[1].split('&')[2].split('=')[1];
      this.boxBodyColor = boxBodyColor || "#009588";
      var companyName = a.split('?')[1].split('&')[3].split('=')[1];
      var logoUrl = a.split('?')[1].split('&')[4].split('=')[1];
      if (logoUrl == '') {
        logoUrl = 'https://visitor.one.cn/pc/static/assets/logo.png';
      }
      var displayMode = a.split('?')[1].split('&')[5].split('=')[1];
      console.log(displayMode);
      var account = '';
      var vip = '';
      var extendInfo = '';

      if (a.split('?')[1].split('&').length > 6 && a.split('?')[1].split('&').length != 7) {

        if (a.split('?')[1].split('&')[6].split('=')[1] != 'null') {
          account = decodeURIComponent(a.split('?')[1].split('&')[6].split('=')[1]);
          obj.account = account;
        } else {
          obj.account = '';
        }

        if (a.split('?')[1].split('&')[7].split('=')[1] != 'null') {
          vip = a.split('?')[1].split('&')[7].split('=')[1];
          obj.vip = vip + '';
        } else {
          obj.vip = '';
        }
        if (a.split('?')[1].split('&')[8].split('=')[1] != 'null') {

          extendInfo = encodeURI(a.split('?')[1].split('&')[8].split('=')[1]);
        }
      } else {
        obj.account = '';
        obj.vip = '';
      }

      sessionStorage.setItem("thisuserinfo", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
      sessionStorage.setItem('boxBodyColor', boxBodyColor);

      sessionStorage.setItem('companyName', companyName);

      sessionStorage.setItem('logoUrl', logoUrl);
      sessionStorage.setItem('displayMode', displayMode);

      //console.log(account,'zhendefan')
      console.log(extendInfo, typeof extendInfo === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(extendInfo));

      var date = Date.parse(new Date());

      var code = __WEBPACK_IMPORTED_MODULE_2_js_md5___default()(serviceKey + secretKey + 5 + os + date);

      function zhyi(a) {
        //console.log(a);
        var b = a.replace(/~/g, '%7E');
        //console.log(b);

        return b;
      }

      var ss = 'account=' + encodeURI(account) + '&os=' + os + '&platform=5' + '&vipLevel=' + vip + '&serviceKey=' + serviceKey + '&currentTime=' + date + '&code=' + code;
      // +'&extendInfo='+extendInfo
      var abc = encodeURIComponent(ss);
      console.log('--------------------------------------');
      console.log(ss);
      console.log('--------------------------------------');
      console.log(zhyi(abc));
      console.log('--------------------------------------');
      var sign = __WEBPACK_IMPORTED_MODULE_2_js_md5___default()(zhyi(abc));
      vm.axios.get(vm.basicUrl + '/api/v2/visitor/index?serviceKey=' + serviceKey + '&platform=5&os=' + os + '&code=' + code + '&currentTime=' + date + '&account=' + encodeURI(account) + '&vipLevel=' + vip + '&extendInfo=' + extendInfo + '&sign=' + sign).then(function (response) {
        if (response.data.code == 1) {
          vm.visitorMd5Code = response.data.data.visitorMd5Code;
          if (response.data.data.visitorStyle) {
            vm.boxBodyColor = response.data.data.visitorStyle.boxBodyColor;
            console.log("this.boxBodyColor:" + vm.boxBodyColor);
          }
          if (customFlag == 1) {
            vm.asyncGetNotify(vm.visitorMd5Code);
          } else {
            sessionStorage.setItem('md5', vm.visitorMd5Code);

            vm.redirectTarget = response.data.data.redirectTarget;
            sessionStorage.setItem('redirectTarget', vm.redirectTarget);

            if (vm.redirectTarget == 5) {
              // 首次进入页面埋点
              vm.$Points.point({ code: '1000' });
            }

            vm.imEntranceMode = response.data.data.imEntranceMode;

            sessionStorage.setItem('imEntranceMode', vm.imEntranceMode);
            sessionStorage.setItem('callCenterEnable', response.data.data.callCenterEnable);
            vm.status = response.data.data.status;

            var customPicture = null;
            var defaultPictureNo = null;
            var headPictureUrl = null;
            if (response.data.data.robotHead) {
              customPicture = response.data.data.robotHead.customPicture;
              defaultPictureNo = response.data.data.robotHead.defaultPictureNo;
              headPictureUrl = response.data.data.robotHead.headPictureUrl;
            } else {
              customPicture = false;
              defaultPictureNo = 1;
              headPictureUrl = null;
            }
            sessionStorage.setItem('customPicture', customPicture);
            sessionStorage.setItem('defaultPictureNo', defaultPictureNo);
            sessionStorage.setItem('headPictureUrl', headPictureUrl);

            if (a.indexOf("handinviteis=1") > -1 || a.indexOf("inviteis=1") > -1) {
              console.log('-----------------邀请进入的----------');
              sessionStorage.setItem("inviteis", true);
              sessionStorage.setItem('newSession', true);
            }

            if (a.indexOf("handinviteis=1") > -1) {
              console.log('=================手动邀请会话================');
              sessionStorage.setItem('indexUrl', 'imSession');
              sessionStorage.setItem("inviteis", true);
              sessionStorage.setItem('newSession', true);
              vm.$router.replace({ path: '/imSession', query: { v: vm.visitorMd5Code } });
              return;
            }

            if (vm.status === 'chatting') {
              sessionStorage.setItem('indexUrl', 'imSession');
              vm.$router.replace({ path: 'imSession' });
              return;
            }
            if (a.indexOf("inviteis=1") > -1) {
              console.log('=================主动邀请会话================');
              if (vm.imEntranceMode === 1) {
                console.log('統一入口');
                vm.axios.get(vm.basicUrl + '/api/visitor/initiative-invite/auto?visitorMd5Code=' + vm.visitorMd5Code + '&entranceId=').then(function (resp) {
                  var data = resp.data;
                  if (data.code == 1) {

                    if (data.data.position == '0') {
                      sessionStorage.setItem('indexUrl', 'imSession');
                      sessionStorage.setItem("inviteis", true);
                      sessionStorage.setItem('newSession', true);
                      vm.$router.replace({ path: '/imSession', query: { v: vm.visitorMd5Code } });
                    } else {
                      vm.$router.replace({ path: '/ServiceError', query: { v: vm.visitorMd5Code, errType: 'costomerErr' } });
                    }
                  } else if (data.code == 4211) {
                    sessionStorage.setItem("inviteis", false);
                    sessionStorage.setItem('newSession', false);
                    vm.$router.replace({ path: '/imSession', query: { v: vm.visitorMd5Code } });
                  }
                });
              } else if (vm.imEntranceMode === 2) {
                console.log('多入口');
                sessionStorage.setItem('indexUrl', 'inviteselect');
                vm.$router.replace({ path: 'inviteselect' });
              }
              return;
            }
            if (vm.redirectTarget === 5) {
              sessionStorage.setItem('indexUrl', 'aiInteractive');
              console.log('跳转到人撒旦法萨芬萨达工客服：', vm.visitorMd5Code);
              vm.$router.replace({ path: 'aiInteractive', query: { v: vm.visitorMd5Code } });
              return;
            }
            if (vm.redirectTarget === 3) {
              sessionStorage.setItem('indexUrl', 'workerorderindex');
              vm.$router.replace({ path: 'workerorderindex' });
              return;
            }

            if (vm.status === 'waiting') {
              sessionStorage.setItem('indexUrl', 'imLineUp');
              vm.$router.replace({ path: 'imLineUp' });
              return;
            }

            if (vm.redirectTarget === 2) {
              if (vm.imEntranceMode === 1) {
                console.log('統一入口');
                sessionStorage.setItem('indexUrl', 'imLineUp');
                vm.$router.replace({ path: 'imLineUp' });
              } else if (vm.imEntranceMode === 2) {
                console.log('多入口');
                sessionStorage.setItem('indexUrl', 'imDirectory');
                vm.$router.replace({ path: 'imDirectory' });
              } else {
                console.error('未知入口');
              }
            } else if (vm.redirectTarget === 1) {
              sessionStorage.setItem('indexUrl', 'spirit');
              vm.$router.replace({ path: 'spirit' });
            } else if (vm.redirectTarget === 4) {
              sessionStorage.setItem('indexUrl', 'myorder');
              vm.$router.replace({ path: 'myorder' });
            }
          }
        } else {}
      }, function (response) {
        console.info(response);
      });
    },
    asyncGetNotify: function asyncGetNotify(visitorMd5Code) {
      var _this = this;

      this.axios.get("/api/visitor/notify", { params: { 'visitorMd5Code': visitorMd5Code } }).then(function (res) {
        if (res.data.code === 1) {
          var data = res.data.data;
          if (data) {
            _this.notifyTitle = data.title;
            _this.notifyStartTime = data.startTime;
            _this.notifyStartTime = new Date(parseInt(_this.notifyStartTime)).format("yyyy-MM-dd hh:mm:ss");
            _this.notifyContent = data.content;
            _this.timer = setInterval(function () {
              if (_this.countDown > 0) {
                _this.countDown--;
              } else {
                if (_this.timer) clearInterval(_this.timer);
              }
            }, 1000);
          } else {
            _this.initConfig(2);
          }
        } else {
          _this.$message.error(res.data.message);
        }
      });
    },

    //点击“进入”按钮
    jumpTo: function jumpTo() {
      if (this.countDown > 0) return;
      this.initConfig(2);
    },

    //点击“离开”按钮
    cancelWait: function cancelWait() {
      window.close();
      /*if (window.rampage){
        console.log('SDK浏览器，关闭页面')
        window.rampage.actionClose()
      }else if(window.ReactNativeWebView){
        console.log('大神sdk关闭页面')
        window.ReactNativeWebView.postMessage('closekf');
      } else if(window.webkit){
        console.log('--------webkit--------')
        window.webkit.messageHandlers.CloseCurrentVC.postMessage(null)
      }else if(window.WeixinJSBridge) {
        console.log('微信浏览器，关闭页面')
        WeixinJSBridge.call('closeWindow')
      }else {
        window.close()
        // window.history.back();
      }*/
      /* this.axios.get(vm.basicUrl + '/api/visitor/im/cancelWait?visitorMd5Code='+this.visitorMd5Code).then((res) => {
         if(res.data.code===1) {
           // 主页为精灵或者IM既退出页面
           if (window.rampage){
             console.log('SDK浏览器，关闭页面')
             window.rampage.actionClose()
           }else if(window.ReactNativeWebView){
             console.log('大神sdk关闭页面')
             window.ReactNativeWebView.postMessage('closekf');
           } else if(window.webkit){
             console.log('--------webkit--------')
             window.webkit.messageHandlers.CloseCurrentVC.postMessage(null)
           }else if( window.WeixinJSBridge) {
             console.log('微信浏览器，关闭页面')
             WeixinJSBridge.call('closeWindow')
           }else {
             window.history.back();
           }
         }else {
           this.$message.error('取消排队失败，请稍后再试')
         }
       }, (err) => {
         console.log(err)
         window.history.back();
       })*/
    },
    getOs: function getOs() {
      var sUserAgent = navigator.userAgent;
      console.log(navigator.platform, navigator);
      var isWin = navigator.platform == "Win32" || navigator.platform == "Windows" || navigator.platform == "Win64";
      var isMac = navigator.platform == "Mac68K" || navigator.platform == "MacPPC" || navigator.platform == "Macintosh" || navigator.platform == "MacIntel";
      var isLinux = String(navigator.platform).indexOf("Linux") > -1;
      var isAndroid = sUserAgent.indexOf('Android') > -1 || sUserAgent.indexOf('Linux') > -1;
      var isIPhone = sUserAgent.indexOf('iPhone') > -1;
      var isWindowsPhone = sUserAgent.indexOf('Windows Phone') > -1;

      if (isIPhone) return 1;
      if (isAndroid) return 2;
      if (isWindowsPhone) return 3;

      if (isMac) return 5;
      if (isWin) return 6;
      if (isLinux) return 7;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  }
});

/***/ }),

/***/ "piVf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q8zI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qRQU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qSdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__("pMZz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5ce6202_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__("QbQc");
function injectStyle (ssrContext) {
  __webpack_require__("AW1S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f5ce6202"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5ce6202_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qpkx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__url_js__ = __webpack_require__("vpRr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workorder_top_vue__ = __webpack_require__("3XGK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_request_js__ = __webpack_require__("vLgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_index_js__ = __webpack_require__("0xDb");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'commitinfor',
  components: {
    top: __WEBPACK_IMPORTED_MODULE_2__workorder_top_vue__["a" /* default */]
  },
  data: function data() {
    return {
      paixu: [],
      boxBodyColor: '',
      logoUrl: '',
      companyName: '',
      displayMode: '',
      btnclass: 2,
      btnis: false,
      urlb: '',
      urlbridge: "",
      datetimes: {},
      jishi: 5,
      kefuis: false,
      action: '',
      phone: "",
      phoneis: "",
      veris: '',
      verify: "",
      verifyis: true,
      timesecond: 60,
      basurl: __WEBPACK_IMPORTED_MODULE_1__url_js__["a" /* baseurl */],
      md5: "",
      href: "",
      showdata: [],
      erroris: false,
      successis: false,
      downloadis: false,
      loginis: false,
      contentis: true,
      pickerOptions0: {
        // disabledDate(time) {
        //   return time.getTime() < Date.now() - 8.64e7;
        // }
      },
      commitis: false,
      datetime: {},
      hourtime: {},
      phonenumver: {},
      number: {},
      idcard: {},
      email: {},
      fileList2: {},
      allquestion: [],
      questionclass: [],
      gamearea: {},
      gamevalue: {},
      fileVideoList: {},
      dns: {},
      explain: {},
      sex: {},
      sexlabel: {},
      hobbys: [{ value: "运动", is: false }, { value: "宅", is: false }, { value: "电影", is: false }, { value: "美食", is: false }, { value: "DIY", is: false }],
      checkedCities1: { "id": ['上海'] },
      cities: {},
      parmas: [],
      submittable: {},
      picid: {}
    };
  },
  mounted: function mounted() {
    var vm = this;
    this.questionclass = [];
    this.questionclass.push(sessionStorage.getItem("butianitem"));
    this.questionclass.push("单据提交");
    this.md5 = sessionStorage.getItem("md5");
    this.href = window.location.href.split("?")[1];
    this.butianinfor();
    vm.boxBodyColor = sessionStorage.getItem('boxBodyColor');
    vm.companyName = sessionStorage.getItem('companyName');
    //console.log(vm.companyName)
    vm.logoUrl = sessionStorage.getItem('logoUrl');
    vm.displayMode = sessionStorage.getItem('displayMode');

    //判断客服是否显示
    __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/product/conf/showOnlineService?visitorMd5Code=' + this.md5).then(function (response) {
      if (response.data.code == 1) {
        vm.kefuis = true;
      }
    });
  },

  methods: {
    //判断跳转页面
    kefugo: function kefugo() {
      __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/product/conf/redirectToOnlineService?visitorMd5Code=' + this.md5).then(function (response) {

        if (response.data.code == 1) {
          var obj = response.data.data;

          if (obj.imStatus == " waiting") {

            window.location.href = "#/imLineUp";
          } else if (obj.imStatus == "chatting") {

            window.location.href = "#/imSession";
          } else {
            if (obj.target == 1) {
              window.location.href = "#/spirit";
            }
            if (obj.target == 2) {
              window.location.href = "#/imDirectory";
            }
          }
        }
      });
    },
    hisback: function hisback() {
      var vm = this;
      var indexurl = sessionStorage.getItem("indexUrl");
      console.log(indexurl);
      var imEntranceMode = sessionStorage.getItem("imEntranceMode");
      console.log(imEntranceMode);
      if (indexurl == 'aiInteractive') {
        window.location.href = "#/aiInteractive?v=" + this.md5;
        vm.urlb = "aiInteractive?v=" + this.md5;
      } else if (indexurl == 'workerorderindex') {
        window.location.href = "#/workerorderindex";
        vm.urlb = "workerorderindex";
      } else {
        __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/im/sessionStatus?visitorMd5Code=' + this.md5).then(function (response) {
          console.log(response);
          var imStatus = '';
          if (response.data.code == 1) {
            imStatus = response.data.data.status;
          }
          console.log(imStatus);
          if ((imStatus === 'ended' || !imStatus || imStatus === '') && indexurl == 'spirit') {
            vm.urlb = "spirit";
            window.location.href = "#/spirit";

            return;
          } else if (imStatus === 'waiting') {
            vm.urlb = "imLineUp";
            window.location.href = "#/imLineUp";

            return;
          } else if (imStatus === 'chatting') {
            vm.urlb = "imSession";
            window.location.href = "#/imSession";

            return;
          } else {
            if (imEntranceMode === 1) {
              vm.urlb = "imLineUp";
              window.location.href = "#/imLineUp";
            } else if (imEntranceMode === 2) {
              vm.urlb = "imDirectory";
              window.location.href = "#/imDirectory";
            }
          }

          console.log(vm.urlb);
        });
      }
    },

    // 视频处理
    videoBeforeload: function videoBeforeload(file) {
      var typeis = false;

      // var arr=file.name.split(".");
      var type = file.type;
      //console.log(type)
      if (/^video\/.*$/.test(type)) {
        typeis = true;
      }
      if (typeis == false) {
        this.$message.error('文件格式不正确');
        return false;
      }
      if (file.size / 1024 > 1024 * 500) {
        this.$message.error('文件大于500M');
        return false;
      }
    },
    handleVideoRemove: function handleVideoRemove() {
      var vm = this;
      vm.$set(vm.picid, this.videobridge.id, true);
      //console.log( this.picid)
      //document.getElementById(this.videobridge.spanid+"a").style.display ="block";
      this.$set(this.fileVideoList, this.videobridge.id, []);
      if (this.videobridge.required == true) {
        document.getElementById(this.videobridge.spanid).innerHTML = "*必填项";
        this.submittable[this.videobridge.spanid] = false;
      }
      this.videobridge = " ";
      // this.btnclass=2;
    },
    handlePreview: function handlePreview(response, file, fileList) {
      if (response.code == 1) {
        var vm = this;
        //document.getElementById(this.urlbridge.spanid+"a").style.display ="none";
        vm.$set(vm.picid, this.urlbridge.id, false);
        //this.picid[this.urlbridge.id]=false;
        console.log(this.picid);
        document.getElementById(this.urlbridge.spanid).innerHTML = " ";
        var is = this.datacommitis(this.urlbridge.id, response.data, this.urlbridge.spanid);
        if (is) {
          this.submittable[this.urlbridge.spanid] = true;
          var obj = {};
          obj.name = this.urlbridge.name;
          obj.id = this.urlbridge.id;
          obj.fieldId = this.urlbridge.id;
          obj.value = response.data;
          this.parmas.push(obj);
          var comit = true;
          var dataobj = this.submittable;
          console.log(dataobj);
          for (var key in dataobj) {

            if (dataobj[key] == false) {
              comit = false;
            }
          }
          if (comit == true) {
            this.btnclass = 1;
          }
        }
      }
    },
    handleVideoPreview: function handleVideoPreview(response, file, fileList) {
      console.log(this.picid[this.videobridge.id]);
      console.log(response);
      if (response.code == 1) {
        var vm = this;
        //document.getElementById(this.videobridge.spanid+"a").style.display ="none";
        vm.$set(vm.picid, this.videobridge.id, false);
        //this.picid[this.videobridge.id]=false;
        document.getElementById(this.videobridge.spanid).innerHTML = " ";
        var is = this.datacommitis(this.videobridge.id, response.data, this.videobridge.spanid);
        var obj = {};
        obj.name = this.videobridge.name;
        obj.id = this.videobridge.id;
        obj.fieldId = this.videobridge.id;
        obj.type = response.data.type;
        obj.value = response.data;
        obj.url = response.data && response.data.split('?') ? response.data.split('?')[0] + '?x-oss-process=video/snapshot,t_1,f_jpg,m_fast,ar_auto' : '';
        this.$set(this.fileVideoList, this.videobridge.id, [obj]);
        if (is) {
          this.submittable[this.videobridge.spanid] = true;
          this.parmas.push(obj);
          var comit = true;
          var dataobj = this.submittable;
          for (var key in dataobj) {

            if (dataobj[key] == false) {
              comit = false;
            }
          }
          if (comit == true) {
            this.btnclass = 1;
          }
        }
      }
    },

    //加入判断是否已经添加
    datacommitis: function datacommitis(name, value, id) {
      var vm = this;
      var is = true;
      //console.log(value)
      this.parmas.forEach(function (item, index) {
        if (item.fieldId == name) {
          item.value = value;
          is = false;
          //vm.commitis=true;
          vm.submittable[id] = true;
          document.getElementById(id).innerHTML = " ";
        }
      });
      //console.log(this.parmas)
      return is;
    },

    //改变级联的值
    changedata: function changedata(item, dat) {
      //console.log(dat,44444444444)
      var vm = this;
      var changeis = false;
      if (item.parentId != null && item.parentId != "" && item.parentId != undefined && item.parentId != " ") {
        changeis = true;
      }
      if (changeis) {
        if (vm.gamevalue[item.parentId] != "") {
          __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/dataDicList/' + item.id + '?visitorMd5Code=' + this.md5 + "&parentId=" + vm.gamevalue[item.parentId]).then(function (response) {
            if (response.data.code == 1) {
              // console.log(vm.gamearea[obj.id])
              //console.log(vm.gamearea)
              var arrdata = response.data.data;
              console.log(arrdata);
              var arr = [];
              var id = "";
              arrdata.forEach(function (element, index) {
                var obj = {};
                obj.value = element.id;
                obj.label = element.content;
                arr.push(obj);
                if (dat == element.content) {
                  id = element.id;
                }
              });
              //console.log(arr)
              vm.gamearea[item.id] = [];
              vm.$set(vm.gamearea, item.id, arr);
              if (dat != undefined) {
                vm.$set(vm.gamevalue, item.id, id);
                vm.showdata.forEach(function (element, index) {
                  if (element.parentId == item.id) {
                    if (element.enteredValue) {
                      console.log(element.enteredValue);
                      vm.changedata(element, element.enteredValue);
                    }
                  }
                });
              } else {
                vm.$set(vm.gamevalue, item.id, vm.gamevalue[item.id]);
              }
            }
          });
        }
      }
    },

    //清空父节点
    clearparnt: function clearparnt(item) {
      var vm = this;
      //console.log(item.id);
      this.showdata.forEach(function (element, index) {
        if (element.parentId == item.id) {
          //console.log(element);
          var arr = [];
          vm.$set(vm.gamearea, element.id, arr);
          vm.$set(vm.gamevalue, element.id, "");
        }
      });
    },

    //收集这个值
    datacommit: function datacommit(value, item) {
      var typeid = item.typeId;
      var length = item.maxLength;
      var require = item.required;
      var name = item.name;
      var spanid = item.spanid;
      if (typeid == 3) {
        var now = new Date(value);
        var year = now.getFullYear();
        var month = (now.getMonth() + 1).toString();
        var day = now.getDate().toString();
        if (month.length == 1) {
          month = "0" + month;
        }
        if (day.length == 1) {
          day = "0" + day;
        }
        value = year + "-" + month + "-" + day;
        //console.log(value)
      }
      if (typeid == 4) {
        //console.log(value,6667)
        var now = new Date(value);
        var hour = now.getHours();
        var minute = now.getMinutes();
        if (hour < 10) {
          hour = "0" + hour;
        }
        if (minute < 10) {
          minute = "0" + minute;
        }
        value = hour + ":" + minute;
        //console.log(value)
      }
      //console.log(value+"/"+typeid);
      var valueis = false;
      var obj = {};
      //单选和多选框
      if (typeid == 1 || typeid == 2) {

        if (value.length > length || value == undefined || value == '' || value.match(/^[ ]+$/)) {
          valueis = false;
        } else {
          valueis = true;
        }

        if (require == false && (value == undefined || value == '' || value.match(/^[ ]+$/))) {
          valueis = true;
        }
        if (valueis == false) {
          var message = '请输入长度为1~' + length + '字符';
          document.getElementById(spanid).innerHTML = message;
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.fieldId = item.id;
            obj.name = name;
            obj.value = value;
            this.parmas.push(obj);
          }
          this.submittable[spanid] = true;
          document.getElementById(spanid).innerHTML = " ";
        }
      }
      //日期框
      if (typeid == 3) {

        if (value == "NaN-NaN-NaN") {
          valueis = false;
        } else {
          valueis = true;
        }
        if (require == false && value == "NaN-NaN-NaN") {
          valueis = true;
        }

        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "*必填项";
          this.submittable[spanid] = false;
          valueis = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.fieldId = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = " ";
          }
          valueis = true;
        }
      }
      //时间框判断
      if (typeid == 4) {
        console.log(value, '笑嘻嘻222');
        if (value == "NaN:NaN") {
          value = '';
        } else {
          valueis = true;
        }
        if (require == false) {
          valueis = true;
        }

        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "*必填项";
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            //             if(value=="NaN:NaN"){
            //               obj.value = ''
            //             }else {
            //               obj.value=value;
            //             }
            obj.value = value;
            obj.fieldId = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = " ";
          }
        }
      }
      if (typeid == 16) {
        if (value == "NaN-NaN-NaN NaN:NaN") {
          valueis = false;
        } else {
          valueis = true;
        }
        if (require == false && value == "NaN-NaN-NaN NaN:NaN") {
          valueis = true;
        }

        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "*必填项";
          this.submittable[spanid] = false;
          valueis = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          console.log(value, is, '=========222==========');
          if (is) {
            obj.name = name;
            obj.value = value ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_index_js__["a" /* parseTime */])(value, '{y}-{m}-{d} {h}:{i}:{s}') : '';
            obj.id = item.id;
            obj.fieldId = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = "";
          }
          //  valueis=true;
        }
      }
      // 手机号验证
      if (typeid == 5) {
        var phoneis = /^1\d{10}$/.test(value);
        if (phoneis == false) {
          valueis = false;
        } else {
          valueis = true;
        }
        if (require == false && (value == undefined || value == '')) {
          valueis = true;
        }
        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "请输入正确的手机号";
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.fieldId = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = " ";
          }
        }
      }
      // 数字文本框
      if (typeid == 6) {
        var numberis = /^\d+$/.test(value);
        if (numberis == false) {
          valueis = false;
        } else {
          if (value.length > length) {
            valueis = false;
          } else {
            valueis = true;
          }
        }
        if (require == false && (value == undefined || value == '')) {
          valueis = true;
        }
        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "请输入长度为1~" + length + "的数字";
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.fieldId = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = " ";
          }
        }
      }
      // 身份证文本框

      if (typeid == 7) {
        var idcardis = /^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/.test(value);
        if (idcardis == false) {
          valueis = false;
        } else {
          valueis = true;
        }
        if (require == false && (value == undefined || value == '')) {
          valueis = true;
        }
        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "请输入正确的身份证号";
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.fieldId = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = " ";
          }
        }
      }

      //邮箱地址
      if (typeid == 8) {
        var emlis = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/.test(value);
        if (emlis == false) {
          valueis = false;
        } else {
          valueis = true;
        }
        if (require == false && (value == undefined || value == '')) {
          if (value != undefined) {
            if (value.length > length) {
              valueis = false;
            } else {
              valueis = true;
            }
          }
        }
        if (length != null) {
          var text = "请输入" + length + "位以内正确的邮箱地址";
        } else {
          var text = "请输入正确的邮箱地址";
        }
        if (valueis == false) {
          document.getElementById(spanid).innerHTML = text;
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.fieldId = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = " ";
          }
        }
      }
      //文件上传
      if (typeid == 9) {
        this.urlbridge = item;
        this.fileList2[item.name] = [];
        console.log(this.fileList2[item.name]);
      }
      if (typeid == 15) {
        this.videobridge = item;
      }
      //下拉框
      if (typeid == 12) {
        var vname = "";
        this.gamearea[item.id].forEach(function (element, index) {
          if (element.value == value) {
            vname = element.label;
          }
        });
        value = vname;
        if (value != undefined && value != '') {
          valueis = true;
        } else {
          valueis = false;
        }

        if (require == false && value == "") {
          valueis = true;
        }
        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "*必填项";
          this.submittable[spanid] = false;
        } else {
          this.clearparnt(item);
          //console.log(this.parmas)
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.fieldId = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = " ";
          }
        }
      }
      //单选框
      if (typeid == 13) {
        //console.log(value)
        if (value != undefined && value != '') {
          valueis = true;
        } else {
          valueis = false;
        }
        if (require == false && value == "") {
          valueis = true;
        }
        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "*必填项";
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.fieldId = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
          }
        }
      }
      //多选框
      if (typeid == 14) {
        //console.log(value)
        if (value.length > 0) {
          valueis = true;
        } else {
          valueis = false;
        }
        if (require == false && value.length == 0) {
          valueis = true;
        }
        if (valueis == false) {
          document.getElementById(spanid).innerHTML = "*必填项";
          this.submittable[spanid] = false;
        } else {
          var is = this.datacommitis(item.id, value, spanid);
          if (is) {
            obj.name = name;
            obj.value = value;
            obj.fieldId = item.id;
            this.parmas.push(obj);
            this.submittable[spanid] = true;
            document.getElementById(spanid).innerHTML = " ";
          }
        }
      }

      var comit = true;
      var dataobj = this.submittable;
      console.log(typeid, dataobj, 'iiiooooiii');
      for (var key in dataobj) {

        if (dataobj[key] == false) {
          comit = false;
        }
      }
      if (comit == true) {
        this.btnclass = 1;
      }

      // if(valueis==false){

      //   this.commitis=false;
      // }else{
      //   this.commitis=true;
      // }
      //console.log(this.commitis)
    },
    heightlight: function heightlight(index) {
      var is = this.hobbys[index].is;
      if (is) {
        this.hobbys[index].is = false;
      } else {
        this.hobbys[index].is = true;
      }
    },
    beforeload: function beforeload(file) {
      console.log(file);
      var typeis = false;
      var type = file.type;
      //console.log(type)
      if (/(gif|jpg|jpeg|bmp|png)$/.test(type)) {
        typeis = true;
      }

      if (typeis == false) {

        this.$message.error('文件格式不正确');
        return false;
      }
      if (file.size / 1024 > 1024 * 9) {
        this.$message.error('文件大于9M');
        return false;
      }
    },
    handleRemove: function handleRemove() {
      var vm = this;

      // if(this.urlbridge==""){
      //   this.urlbridge=obj;
      // }
      vm.$set(vm.picid, this.urlbridge.id, true);
      console.log(this.picid);
      //document.getElementById(this.urlbridge.spanid+"a").style.display ="block";
      if (this.urlbridge.required == true) {
        document.getElementById(this.urlbridge.spanid).innerHTML = "*必填项";
        this.submittable[this.urlbridge.spanid] = false;
      }
      this.urlbridge = " ";
    },
    commit: function commit() {
      var vm = this;
      var comit = true;
      var dataobj = this.submittable;
      for (var key in dataobj) {

        if (dataobj[key] == false) {
          comit = false;
        }
      }
      console.log(dataobj, 'iiioo11ooiii');
      this.parmas.forEach(function (element, index) {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(element.value) == "object") {
          var str = element.value.join(",");
          element.value = str;
        }
      });
      console.log(this.parmas, 'zhongre');
      if (comit == true && this.href == "butianinfor") {
        var arr = [];
        var l = this.parmas.length;
        //console.log(this.paixu);
        //console.log(this.parmas)
        console.log(this.paixu, '草草哒');
        this.paixu.forEach(function (element, index) {
          var haveis = false;
          for (var i = 0; i < l; i++) {
            if (vm.parmas[i].fieldId == element.id) {
              var obj = {};
              obj.fieldId = vm.parmas[i].fieldId;
              obj.name = vm.parmas[i].name;
              obj.value = vm.parmas[i].value;
              haveis = true;
              arr.push(obj);
            }
          }
          if (haveis == false) {
            var _obj = {};
            _obj.fieldId = element.id;
            _obj.name = element.name;
            _obj.value = element.enteredValue;
            arr.push(_obj);
          }
        });
        console.log(arr, '提交的东西');
        var obje = JSON.parse(sessionStorage.getItem('butianinfor'));
        __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].post(this.basurl + '/api/visitor/wo/updateOrder/' + obje.orderid + '/' + obje.fromid + '/' + obje.processInstanceId + '?visitorMd5Code=' + this.md5, arr).then(function (response) {
          //   //console.log(response)
          if (response.data.code == 1) {

            if (response.data.message == "OK") {
              vm.successis = true;
              vm.contentis = false;
              var tme = setInterval(function () {
                vm.jishi = vm.jishi - 1;
                if (vm.jishi == 0) {
                  //跳转分类
                  var indexurl = sessionStorage.getItem("indexUrl");
                  var imEntranceMode = sessionStorage.getItem("imEntranceMode");
                  // if (indexurl == 'workerorderindex') {
                  //   //alert(1)
                  //   vm.urlb="workerorderindex"
                  //   window.location.href = "#/workerorderindex"
                  // }
                  if (indexurl) {
                    vm.urlb = indexurl;
                    vm.$router.replace({ path: indexurl, query: { v: vm.md5 } });
                  } else {
                    __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(vm.basurl + '/api/visitor/im/sessionStatus?visitorMd5Code=' + vm.md5).then(function (response) {
                      console.log(response);
                      var imStatus = '';
                      if (response.data.code == 1) {
                        imStatus = response.data.data.status;
                      }
                      console.log(imStatus);
                      if ((imStatus === 'ended' || !imStatus || imStatus === '') && indexurl == 'spirit') {
                        vm.urlb = "spirit";
                        //window.location.href="#/spirit"
                        vm.$router.replace({ path: 'spirit' });
                        return;
                      } else if (imStatus === 'waiting') {
                        vm.urlb = "imLineUp";
                        //window.location.href="#/imLineUp"
                        vm.$router.replace({ path: 'imLineUp' });
                        return;
                      } else if (imStatus === 'chatting') {
                        vm.urlb = "imSession";
                        //window.location.href="#/imSession"
                        vm.$router.replace({ path: 'imSession' });
                        return;
                      } else {
                        if (imEntranceMode === 1) {
                          vm.urlb = "imLineUp";
                          //window.location.href="#/imLineUp"
                          vm.$router.replace({ path: 'imLineUp' });
                        } else if (imEntranceMode === 2) {
                          vm.urlb = "imDirectory";
                          //window.location.href="#/imDirectory"
                          vm.$router.replace({ path: 'imDirectory' });
                        }
                      }

                      console.log(vm.urlb);
                    });
                  }

                  clearInterval(tme);
                }
              }, 1000);
            } else {
              vm.erroris = true;
              vm.contentis = false;
              var tme = setInterval(function () {
                vm.jishi = vm.jishi - 1;
                if (vm.jishi == 0) {
                  console.log(7667676767);
                  var indexurl = sessionStorage.getItem("indexUrl");
                  var imEntranceMode = sessionStorage.getItem("imEntranceMode");
                  console.log(indexurl);
                  if (indexurl == 'workerorderindex') {
                    //alert(1)
                    vm.urlb = "workerorderindex";
                    window.location.href = "#/workerorderindex";
                  } else {
                    __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(vm.basurl + '/api/visitor/im/sessionStatus?visitorMd5Code=' + vm.md5).then(function (response) {
                      console.log(response);
                      var imStatus = '';
                      if (response.data.code == 1) {
                        imStatus = response.data.data.status;
                      }
                      console.log(imStatus);
                      if ((imStatus === 'ended' || !imStatus || imStatus === '') && indexurl == 'spirit') {
                        vm.urlb = "spirit";
                        window.location.href = "#/spirit";

                        return;
                      } else if (imStatus === 'waiting') {
                        vm.urlb = "imLineUp";
                        window.location.href = "#/imLineUp";

                        return;
                      } else if (imStatus === 'chatting') {
                        vm.urlb = "imSession";
                        window.location.href = "#/imSession";

                        return;
                      } else {
                        if (imEntranceMode === 1) {
                          vm.urlb = "imLineUp";
                          window.location.href = "#/imLineUp";
                        } else if (imEntranceMode === 2) {
                          vm.urlb = "imDirectory";
                          window.location.href = "#/imDirectory";
                        }
                      }

                      console.log(vm.urlb);
                    });
                  }
                  clearInterval(tme);
                }
              }, 1000);
            };
          } else if (response.data.code == 400) {
            vm.erroris = true;
            vm.contentis = false;
            var tme = setInterval(function () {
              vm.jishi = vm.jishi - 1;
              if (vm.jishi == 0) {
                window.location.href = "#/myorder";
                clearInterval(tme);
              }
            }, 1000);
          }
        });
      } else {
        this.$message({
          message: '数据填写错误',
          type: 'warning'
        });
      }
    },

    //
    butianinfor: function butianinfor() {
      var vm = this;
      var obj = JSON.parse(sessionStorage.getItem('butianinfor'));
      __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/processInstanceFields/' + obj.processInstanceId + '?visitorMd5Code=' + this.md5).then(function (response) {
        if (response.data.code = 1) {
          vm.show(response.data, 2);
        };
      });
      console.log(obj);
    },

    //展示数据
    show: function show(data, inde) {
      var arrda = data.data;
      var vm = this;
      console.log(arrda, '数据');
      arrda.forEach(function (item, index) {
        vm.paixu.push(item);
        item.spanid = 'ziduan' + index;
        if (item.typeId == 9 || item.typeId == 15) {
          vm.$set(vm.picid, item.id, true);
          console.log(vm.picid);
        }
        if (inde == 1) {
          if (item.required == false) {
            vm.submittable[item.spanid] = true;
          } else {
            vm.submittable[item.spanid] = false;
          }
        }
        if (inde == 2) {
          if (item.required == false) {
            vm.submittable[item.spanid] = true;
          } else {
            if (item.defaultContent || item.enteredValue) {
              vm.submittable[item.spanid] = true;
            } else {
              vm.submittable[item.spanid] = false;
            }
          }
        }
        vm.showdata.push(item);
        vm.datacollect(item);
      });
    },

    //判断是否授权
    showis: function showis() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/formFields/' + this.href + '?visitorMd5Code=' + this.md5).then(function (response) {
        var da = response.data;
        if (da.code == 1) {
          vm.loginis = false;
          vm.contentis = true;
          vm.show(da, 1);
        } else if (da.code == 401) {
          vm.contentis = false;
          vm.loginis = true;
        }
      });
    },

    //手机验证
    verifyconfirm: function verifyconfirm() {
      //console.log( this.verify)
      var vm = this;
      if (this.verify != "" && this.btnis == true) {
        __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].post(this.basurl + '/api/visitor/wo/msgCaptchaValid?visitorMd5Code=' + this.md5 + "&phoneNum=" + this.phone + "&code=" + this.verify).then(function (response) {
          if (response.data.code == 1) {
            vm.showis();
            vm.veris = "";
          } else if (response.data.code == 0) {
            vm.veris = "验证码已过期请重新获取";
          } else if (response.data.code == 4032) {
            vm.$message.error('获取验证码过于频繁');
          } else {

            vm.veris = "验证码填写错误";
          }
        });
      } else {
        vm.veris = "请获取验证码";
      }
    },
    verifygo: function verifygo() {
      var vm = this;
      if (this.phone == '') {
        this.phoneis = "手机号不能为空";
      }
      if (this.phoneis != "手机号格式错误" && this.phoneis != "手机号不能为空") {
        __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/msgCaptcha?visitorMd5Code=' + this.md5 + "&phoneNum=" + this.phone).then(function (response) {
          //console.log(response)
          this.btnis = true;
          if (response.data.code == 1) {
            vm.verifyis = false;
            var timer = setInterval(function () {
              vm.timesecond = vm.timesecond - 1;
              if (vm.timesecond == 0) {
                clearInterval(timer);
                vm.verifyis = true;
              }
            }, 1000);
          } else if (response.data.code == 4032) {
            vm.$message.error('验证码获取过于频繁');
          } else if (response.data.code == 4504) {
            vm.$message.error('验证码已过期请重新获取');
          }
        });
      }
    },
    phonego: function phonego() {
      var phonenumis = /^1\d{10}$/.test(this.phone);
      //console.log(phonenumis)
      if (phonenumis == false) {
        this.phoneis = "手机号格式错误";
      } else {
        this.phoneis = "";
      }
    },

    // 设置相关的数据值，并且有值的时候更新一下提示语
    setMapData: function setMapData(data, key, value, dataObj) {
      var _this = this;

      this.$set(data, key, value);
      console.log('=========================================');
      console.log(data, key, value, dataObj);
      if (value != null && value != undefined && value != '') {
        setTimeout(function () {
          _this.datacommit(value, dataObj);
        }, 0);
      }
    },
    datacollect: function datacollect(obj) {
      var vm = this;
      //console.log(obj)
      if (obj.parentId == null) {
        obj.parentId = " ";
      }
      if (obj.typeId == 12) {
        if (obj.parentId == " ") {
          __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/dataDicList/' + obj.id + '?visitorMd5Code=' + this.md5 + "&parentId=" + obj.parentId).then(function (response) {
            if (response.data.code == 1) {
              console.log(obj, 'xxx');
              // console.log(vm.gamearea[obj.id])
              // console.log(vm.gamearea)
              var arrdata = response.data.data;
              var arr = [];
              var id = "";
              arrdata.forEach(function (element, index) {
                var obj1 = {};
                obj1.value = element.id;
                obj1.label = element.content;
                arr.push(obj1);
                if (element.content == obj.enteredValue) {
                  id = element.id;
                }
              });
              //console.log(arr)
              vm.$set(vm.gamearea, obj.id, arr);
              vm.$set(vm.gamevalue, obj.id, id);
              //alert(1)
              vm.showdata.forEach(function (element, index) {
                if (element.parentId == obj.id) {
                  console.log(element);
                  vm.changedata(element, element.enteredValue);
                }
              });
            } else {

              console.log('拉取数据失败');
            }
          });
        }
        //else{
        //    var arr=[];
        //    vm.$set( vm.gamearea,obj.id,arr);
        //    vm.$set( vm.gamevalue,obj.id,"");
        //    vm.changedata(obj,"first")

        // }
      } else if (obj.typeId == 1) {
        __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/dataDicList/' + obj.id + '?visitorMd5Code=' + this.md5 + "&parentId=" + obj.parentId).then(function (response) {
          if (response.data.code == 1) {

            //  var arrdata=response.data.data;
            //  console.log(arrdata)
            //  var arr=[];
            // arrdata.forEach( function(element, index) {
            //   var obj={};
            //   arr.push(obj)
            // });
            //console.log(arr)
            //console.log(vm.gamevalue)
            vm.$set(vm.dns, obj.id, obj.enteredValue);
          } else {
            console.log('拉取数据失败');
          }
        });
      } else if (obj.typeId == 2) {
        vm.$set(vm.explain, obj.id, obj.enteredValue);
      } else if (obj.typeId == 3) {
        vm.$set(vm.datetime, obj.id, obj.enteredValue);
      } else if (obj.typeId == 4) {
        console.log(obj, '钱');
        if (obj.enteredValue != '') {
          var arr = obj.enteredValue.split(":");
          var time = new Date(10, 1, 30, Number(arr[0]), Number(arr[1]), 0);
          vm.$set(vm.hourtime, obj.id, time);
        } else {
          vm.$set(vm.hourtime, obj.id, '');
        }
      } else if (obj.typeId == 5) {

        vm.$set(vm.phonenumver, obj.id, obj.enteredValue);
      } else if (obj.typeId == 6) {

        vm.$set(vm.number, obj.id, obj.enteredValue);
      } else if (obj.typeId == 7) {

        vm.$set(vm.idcard, obj.id, obj.enteredValue);
      } else if (obj.typeId == 8) {

        vm.$set(vm.email, obj.id, obj.enteredValue);
      } else if (obj.typeId == 14) {
        __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/dataDicList/' + obj.id + '?visitorMd5Code=' + this.md5 + "&parentId=" + obj.parentId).then(function (response) {
          if (response.data.code == 1) {

            var arrdata = response.data.data;
            //返回数据有问题
            //console.log(obj.defaultContent);


            if (obj.enteredValue.split(",").length > 1) {
              var arrd = obj.enteredValue.split(",");
              //eval(obj.defaultContent);
            } else {
              var arrd = [];
              arrd.push(obj.enteredValue.split(",")[0]);
            }
            console.log(arrd);
            var arr = [];
            var arr1 = [];
            var defaultContentid = true;
            var l = arrdata.length;
            arrd.forEach(function (element, index) {

              var addis = false;
              for (var i = 0; i < l; i++) {
                if (arrdata[i].content == element) {
                  addis = true;
                }
              }
              if (addis == false) {
                defaultContentid = false;
              }
              arr1.push(element);
            });
            if (defaultContentid == false) {
              arr1 = [];
            }
            arrdata.forEach(function (element, index) {
              arr.push(element.content);
            });
            vm.$set(vm.checkedCities1, obj.id, arr1);
            vm.$set(vm.cities, obj.id, arr);
          } else {
            console.log('拉取数据失败');
          }
        });
      } else if (obj.typeId == 13) {
        //          var mo=obj.defaultContent;
        __WEBPACK_IMPORTED_MODULE_3__utils_request_js__["a" /* default */].get(this.basurl + '/api/visitor/wo/dataDicList/' + obj.id + '?visitorMd5Code=' + this.md5 + "&parentId=" + obj.parentId).then(function (response) {
          if (response.data.code == 1) {

            var arrdata = response.data.data;
            //console.log(arrdata);
            var arr = [];
            //                    var defaultContentid=false;
            arrdata.forEach(function (element, index) {
              var obj = {};
              obj.value = element.content;
              obj.label = element.content;
              arr.push(obj);
              //console.log(element.defaultContent,66)
              //                      if(mo==element.content){
              //                        defaultContentid=true;
              //                      }
            });
            // console.log(obj.defaultContent)
            //                    if(defaultContentid==false){
            //                      obj.enteredValue="";
            //                    }
            vm.$set(vm.sexlabel, obj.id, arr);
            vm.$set(vm.sex, obj.id, obj.enteredValue);
          } else {
            console.log('拉取数据失败');
          }
        });
      } else if (obj.typeId == 9 || obj.typeId == 15) {
        var arr = [];
        this.action = this.basurl + '/api/visitor/wo/fileUpload?visitorMd5Code=' + this.md5;
        var arro = {};

        this.picid[obj.id] = true;
        if (obj.typeId == 15) {
          arro.url = obj.enteredValue && obj.enteredValue.split('?') ? obj.enteredValue.split('?')[0] + '?x-oss-process=video/snapshot,t_1,f_jpg,m_fast,ar_auto' : '';
          arro.name = 'file.mp4';
        } else {
          arro.url = obj.enteredValue;
          arro.name = 'file.jpg';
        }

        if (arro.url != "") {
          arr.push(arro);
        }
        if (obj.typeId == 15) {
          vm.$set(vm.fileVideoList, obj.id, arr);
        } else {
          vm.$set(vm.fileList2, obj.name, arr);
        }
        // console.log(vm.fileVideoList, 999)
        // vm.$set( vm.fileList2,obj.name,arr);
        //console.log(vm.fileList2)
      } else if (obj.typeId == 16) {
        var timeVal = '';
        if (/^\d{4}-\d{1,2}-\d{1,2} \d{1,2}:\d{1,2}/.test(obj.enteredValue || obj.defaultContent)) {
          timeVal = obj.enteredValue || obj.defaultContent;
        }
        vm.setMapData(vm.datetimes, obj.id, timeVal, obj);
      }
    }
  }
});

/***/ }),

/***/ "rb5t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sSub":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sYrP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tO83":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_workcommit_vue__ = __webpack_require__("Cvyk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03ce5a3d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_workcommit_vue__ = __webpack_require__("0g43");
function injectStyle (ssrContext) {
  __webpack_require__("Za7Y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03ce5a3d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_workcommit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03ce5a3d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_workcommit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ul0r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top color",
    style: ({
      backgroundColor: _vm.boxBodyColor
    })
  }, [(_vm.displayMode == 2) ? _c('img', {
    staticClass: "title_img",
    attrs: {
      "src": _vm.logoUrl,
      "alt": "公司logo"
    }
  }) : _c('p', {
    staticClass: "title_2"
  }, [(_vm.companyName == '' || _vm.companyName == null) ? _c('span') : (_vm.companyName.length > 10) ? _c('el-tooltip', {
    attrs: {
      "content": _vm.companyName,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.companyName.substring(0, 10) + '...'))])]) : _c('span', [_vm._v(_vm._s(_vm.companyName))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.kefuis),
      expression: "kefuis"
    }],
    staticStyle: {
      "margin-right": "20px"
    },
    on: {
      "click": _vm.kefugo
    }
  }, [_vm._v("在线客服")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.kefuis),
      expression: "kefuis"
    }],
    staticClass: "kefu",
    attrs: {
      "height": "18px",
      "src": __webpack_require__("0oZO")
    },
    on: {
      "click": _vm.kefugo
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.callis),
      expression: "callis"
    }],
    staticStyle: {
      "margin-right": "40px"
    },
    on: {
      "click": _vm.callgo
    }
  }, [_vm._v("客服电话")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.callis),
      expression: "callis"
    }],
    staticClass: "kefu1",
    attrs: {
      "height": "18px",
      "src": "/pc/static/assets/callbtn.png"
    },
    on: {
      "click": _vm.callgo
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vHcp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workerorderindex"
  }, [_c('top'), _vm._v(" "), _c('div', {
    staticClass: "nav"
  }, [_c('router-link', {
    staticStyle: {
      "color": "rgb(31, 55, 61)"
    },
    attrs: {
      "to": {
        path: '/workerorderindex'
      }
    }
  }, [_c('span', [_vm._v("首页")])]), _vm._v(" "), _vm._l((_vm.questionclass), function(item) {
    return _c('span', {
      staticClass: "navbread"
    }, [_vm._v(_vm._s('>' + item))])
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btna color",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "to": {
        path: '/myorder'
      }
    }
  }, [_vm._v("我的工单")])], 2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.topclass))])]), _vm._v(" "), _vm._l((_vm.allquestion), function(item, index) {
    return _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.quesstionis),
        expression: "quesstionis"
      }],
      key: index
    }, [(item.showNote) ? _c('router-link', {
      attrs: {
        "to": {
          path: '/workinformation',
          query: {
            'id': item.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.nav(item.name)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('router-link', {
      attrs: {
        "to": {
          path: '/workcommit?',
          query: {
            'id': item.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.nav(item.name)
        }
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), _vm._v(" "), _vm._l((_vm.allclass), function(item, index) {
    return _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.classis),
        expression: "classis"
      }],
      key: index
    }, [(item.type == 0) ? _c('router-link', {
      attrs: {
        "to": {
          path: '/workaccount?',
          query: {
            'id': item.id,
            'class': ''
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.nav(item.name)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e(), _vm._v(" "), (item.type == 1) ? _c('router-link', {
      attrs: {
        "to": {
          path: '/workaccount?',
          query: {
            'id': item.id,
            'question': ''
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.nav(item.name)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()], 1)
  })], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vLgD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



// create an axios instance
var service = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  timeout: 600000, // request timeout
  withCredentials: true
});

// request interceptor
service.interceptors.request.use(function (config) {
  // console.log('-0-0-0-0-0-0-0-0-0---config',config)
  // 统一在这里给url加时间戳
  if (config.url.indexOf('?') > -1 && config.url.indexOf('&t=' == -1)) {
    var time = Number(new Date());
    config.url = config.url + '&t=' + time;
  }
  return config;
}, function (error) {
  // Do something with request error
  console.log(error); // for debug
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),

/***/ "vpRr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return baseurl; });
var baseurls = "https://visitor.one.cn";
if (false) {
  baseurls = '';
}
var baseurl = baseurls;

/***/ }),

/***/ "vsLA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imChat_vue__ = __webpack_require__("/16w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3223a11c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_imChat_vue__ = __webpack_require__("ojib");
function injectStyle (ssrContext) {
  __webpack_require__("6JJR")
  __webpack_require__("dGe0")
  __webpack_require__("EcNG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3223a11c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imChat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3223a11c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_imChat_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vzNC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "maskEvaluation"
  }, [_c('div', {
    staticClass: "evaluationMask"
  }, [_c('div', {
    staticClass: "boom"
  }, [_c('div', {
    staticClass: "top",
    style: ({
      backgroundColor: _vm.boxBodyColor
    })
  }, [_vm._v("您好，您对本次服务满意吗？"), _c('a', {
    staticClass: "close",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', {
    on: {
      "click": _vm.returnMask
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "inner"
  }, _vm._l((_vm.evaluationArr1), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "star_box"
    }, [_c('img', {
      staticClass: "starImg",
      attrs: {
        "src": _vm.imgUrl + 'im_star' + (index + 1) + item.starImg,
        "alt": item
      },
      on: {
        "click": function($event) {
          _vm.mouseClick(index)
        }
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.text))])])
  })), _vm._v(" "), (_vm.satisfyMode === 2 && _vm.basicLevel != 3 && _vm.basicLevel != null) ? _c('div', {
    staticClass: "inner2"
  }, _vm._l((_vm.evaluationArr2), function(objItem, objIndex) {
    return _c('div', {
      key: objIndex,
      staticClass: "star_box2"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(objItem.name))]), _vm._v(" "), _vm._l((objItem.starImg), function(item, index) {
      return _c('span', {
        key: index,
        staticClass: "star",
        on: {
          "click": function($event) {
            _vm.mouseClick2(objIndex, index)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.imgUrl + 'im_star' + item,
          "alt": "星"
        }
      })])
    })], 2)
  })) : _vm._e(), _vm._v(" "), (_vm.satisfyMode === 2 && _vm.basicLevel != 3 && _vm.basicLevel != null) ? _c('div', {
    staticClass: "inner3"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("说明")]), _vm._v(" "), _c('div', {
    staticClass: "text_area"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "您的建议就是我们奋斗的目标",
      "resize": "none"
    },
    model: {
      value: (_vm.textarea),
      callback: function($$v) {
        _vm.textarea = $$v
      },
      expression: "textarea"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('a', {
    staticClass: "chooseTrue chooseBtn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.returnMask
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('a', {
    staticClass: "chooseFalse chooseBtn",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w6V+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginMobile"
  }, [_c('mask-evaluation'), _vm._v(" "), _c('im-top'), _vm._v(" "), _c('div', {
    staticClass: "wrapText"
  }, [_vm._v("手机号为查看单据处理结果的依据")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('div', {
    staticClass: "inputContent"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入手机号码"
    },
    model: {
      value: (_vm.phoneNum),
      callback: function($$v) {
        _vm.phoneNum = $$v
      },
      expression: "phoneNum"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "errText"
  }, [_vm._v("请检查填写的手机号是否正确")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-top": "13px"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("随机码")]), _vm._v(" "), _c('div', {
    staticClass: "inputContent"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "短信随机码"
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("获取短信随机码")])])], 2)], 1)]), _vm._v(" "), _c('a', {
    staticClass: "nextStep",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("下一步")])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "woAb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    attrs: {
      "id": "appInner"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "usertx"
  }, _vm._l((_vm.infor), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "usertxbackground",
      on: {
        "click": function($event) {
          _vm.current(item.id)
        }
      }
    }, [_c('p', {
      staticClass: "usertxp1"
    }, [_c('a', [_vm._v(_vm._s(item.name))]), _c('span', [_vm._v(_vm._s(item.time))])]), _vm._v(" "), _c('p', {
      staticClass: "usertxp2"
    }, [_vm._v(_vm._s(item.content))]), _vm._v(" "), _c('span', {
      staticClass: "userno",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.delinfor(item.id)
        }
      }
    })])
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x4wq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    infor: 'inforchange'
  })),
  data: function data() {
    return {
      beforeUnloadTime: 0,
      unloadTime: 0,
      homeType: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.homeType = sessionStorage.getItem('redirectTarget');
    window.addEventListener('beforeunload', function (e) {
      return _this.beforeunloadHandler(e);
    });
    window.addEventListener('unload', function (e) {
      return _this.unloadHandler(e);
    });
  },
  destroyed: function destroyed() {
    var _this2 = this;

    window.removeEventListener('beforeunload', function (e) {
      return _this2.beforeunloadHandler(e);
    });
    window.removeEventListener('unload', function (e) {
      return _this2.unloadHandler(e);
    });
  },

  methods: {
    beforeunloadHandler: function beforeunloadHandler() {
      this.beforeUnloadTime = new Date().getTime();
    },
    unloadHandler: function unloadHandler(e) {
      this.unloadTime = new Date().getTime() - this.beforeUnloadTime;
      //判断是窗口关闭还是刷新，如果是关闭
      if (this.unloadTime <= 5 && this.homeType == 5) {
        this.$Points.point({ code: '1006' });
      }
    },
    current: function current(id) {
      window.location.href = "#/imSession";
    },
    delinfor: function delinfor(id) {
      var nowindex = 0;
      console.log(this.$store.state.im.infor);
      this.$store.state.im.infor.forEach(function (element, index) {
        if (element.id == id) {
          nowindex = index;
        }
      });
      this.$store.state.im.infor.splice(nowindex, 1);
    }
  }
});

/***/ }),

/***/ "y5mz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_question__ = __webpack_require__("Ozlq");

// 埋点
// code 参数
// 访客触发日志：1000
// 用户点击日志：1001
// 用户发起会话日志：1002
// 用户AI会话结束：1004
// 工单日志：1005

// type 参数
// 用户点击日志：1：热点问题 2：轮播图 3：问题类型 4：我的单据 5：联系客服
// 用户发起会话日志：1：联系客服（首页）2：问答FAQ（热点问题）3：问答FAQ（问题类型）4：人工转AI客服
// 用户AI会话结束：1转人工 2玩家退3转工单 4其他
// 工单日志：1 AI唤起（进入） 2 AI唤起（提交） 3问题分类（进入）4问题分类（提交）


// 获取url参数
// const getUrlParam = (name) => {
//   const url = window.location.href
//     const address = url.split('?');
//     if(address[0] === url){ return '';}
//     const arr = address[1].split('&'),len = arr.length;
//     const obj ={};
//     for (var i = 0;i<len;i++){
//         const ads = arr[i].split('=');
//         obj[ads[0]] = ads[1];
//     }
//     return obj[name] || '';
// }
// 获取talkId
var guid = function guid() {
  return 'xxxxxxxx-xxxx-6xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};
// 只在页面进入时执行一次
var talkId = guid();
// let visitorMd5Code = getUrlParam('v')
var visitorMd5Code = sessionStorage.getItem('md5');
// const Points = class {
//   constructor() {
//     // super()
//   }
//   initPage(params) {
//     console.log(id)
//     console.log(params, 123456)
//   }
// }

var point = function point(params) {
  if (!visitorMd5Code) {
    visitorMd5Code = sessionStorage.getItem('md5');
  }
  __WEBPACK_IMPORTED_MODULE_1__api_question__["a" /* default */].logPoint(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ visitorMd5Code: visitorMd5Code, talkId: talkId }, params), function () {
    console.log('埋点成功');
  });
};
/* harmony default export */ __webpack_exports__["a"] = ({
  talkId: talkId,
  point: point
});

/***/ }),

/***/ "yV2n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yenz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IMTop_vue__ = __webpack_require__("dU9P");
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    imTop: __WEBPACK_IMPORTED_MODULE_0__IMTop_vue__["a" /* default */]
  },
  data: function data() {
    return {
      imgUrl: '/pc/static/assets/',
      msgErr: '服务器繁忙，请稍后再试',
      msgService: '暂无服务的客服，请稍候再试！<br/>人工客服工作时间为每日 8:00-22:00，欢迎在此时段内联系我们～',
      errType: ""
    };
  },
  mounted: function mounted() {
    this.errType = this.$route.query.errType;
    this.randerPage();
  },

  methods: {
    randerPage: function randerPage() {
      clearInterval(this.$store.state.im.timer);
      var entranceId = sessionStorage.entranceId ? sessionStorage.entranceId : "";
      var vm = this;
      var visitorMd5Code = sessionStorage.md5; //
      // this.$store.dispatch({
      //           type: 'enterQueue',
      //           entranceId: entranceId,
      //           router: vm.$router,
      //           visitorMd5Code: visitorMd5Code
      //         })
    }
  }
});

/***/ }),

/***/ "yh2X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_butianinfor_vue__ = __webpack_require__("qpkx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f61c2dec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_butianinfor_vue__ = __webpack_require__("O4Gp");
function injectStyle (ssrContext) {
  __webpack_require__("9isF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f61c2dec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_butianinfor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f61c2dec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_butianinfor_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ysEq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z++E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zcCe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[5]);


// WEBPACK FOOTER //
// static/js/app.5568c5051019bb3839fe.js